/* tslint:disable */
/* eslint-disable */
/**
 * Assets
 * An API for managing assets
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@run.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccessKey
 */
export interface AccessKey {
    /**
     * 
     * @type {AssetMeta}
     * @memberof AccessKey
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {AccessKeySpec}
     * @memberof AccessKey
     */
    'spec': AccessKeySpec;
    /**
     * 
     * @type {AssetUsageInfo}
     * @memberof AccessKey
     */
    'usedBy'?: AssetUsageInfo | null;
    /**
     * 
     * @type {ComplianceInfo}
     * @memberof AccessKey
     */
    'compliance'?: ComplianceInfo | null;
    /**
     * 
     * @type {AssetClusterStatusInfo}
     * @memberof AccessKey
     */
    'status'?: AssetClusterStatusInfo | null;
    /**
     * 
     * @type {ClusterInfo}
     * @memberof AccessKey
     */
    'clusterInfo'?: ClusterInfo | null;
}
/**
 * 
 * @export
 * @interface AccessKeyCreationRequest
 */
export interface AccessKeyCreationRequest {
    /**
     * 
     * @type {AssetCreationRequest}
     * @memberof AccessKeyCreationRequest
     */
    'meta': AssetCreationRequest;
    /**
     * 
     * @type {AccessKeyCreationSpec}
     * @memberof AccessKeyCreationRequest
     */
    'spec': AccessKeyCreationSpec;
}
/**
 * 
 * @export
 * @interface AccessKeyCreationSpec
 */
export interface AccessKeyCreationSpec {
    /**
     * optional name of existing secret in the cluster from which the access key id and secret should be taken. If omitted, you will have to provide those credentials in the accessKeyId and secretAccessKey fields. The provided credentials are encrypted into the control plane database and cloned to a kubernetes secret in the cluster.
     * @type {string}
     * @memberof AccessKeyCreationSpec
     */
    'existingSecretName'?: string | null;
    /**
     * The access key id of the S3-compatible bucket, required only when not using existing secret.
     * @type {string}
     * @memberof AccessKeyCreationSpec
     */
    'accessKeyId'?: string | null;
    /**
     * The secret access key of the S3-compatible bucket, required only when not using existing secret.
     * @type {string}
     * @memberof AccessKeyCreationSpec
     */
    'secretAccessKey'?: string | null;
}
/**
 * 
 * @export
 * @interface AccessKeyListResponse
 */
export interface AccessKeyListResponse {
    /**
     * 
     * @type {Array<AccessKey>}
     * @memberof AccessKeyListResponse
     */
    'entries': Array<AccessKey>;
}
/**
 * 
 * @export
 * @interface AccessKeySpec
 */
export interface AccessKeySpec {
    /**
     * optional name of existing secret in the cluster from which the access key id and secret should be taken. If omitted, you will have to provide those credentials in the accessKeyId and secretAccessKey fields. The provided credentials are encrypted into the control plane database and cloned to a kubernetes secret in the cluster.
     * @type {string}
     * @memberof AccessKeySpec
     */
    'existingSecretName'?: string | null;
    /**
     * The access key id of the S3-compatible bucket, required only when not using existing secret.
     * @type {string}
     * @memberof AccessKeySpec
     */
    'accessKeyId'?: string | null;
    /**
     * The secret access key of the S3-compatible bucket, required only when not using existing secret.
     * @type {string}
     * @memberof AccessKeySpec
     */
    'secretAccessKey'?: string | null;
    /**
     * id of the encryption key which has been used to encrypt an asset\'s data.
     * @type {number}
     * @memberof AccessKeySpec
     */
    'keyId': number;
}
/**
 * 
 * @export
 * @interface AccessKeyToAddOrUpdate
 */
export interface AccessKeyToAddOrUpdate {
    /**
     * The name of the asset.
     * @type {string}
     * @memberof AccessKeyToAddOrUpdate
     */
    'name': string;
    /**
     * 
     * @type {AccessKeySpec}
     * @memberof AccessKeyToAddOrUpdate
     */
    'spec': AccessKeySpec;
    /**
     * The checksum of the asset\'s spec.
     * @type {string}
     * @memberof AccessKeyToAddOrUpdate
     */
    'checksum': string;
}
/**
 * 
 * @export
 * @interface AccessKeyUpdateRequest
 */
export interface AccessKeyUpdateRequest {
    /**
     * 
     * @type {CredentialUpdateRequest}
     * @memberof AccessKeyUpdateRequest
     */
    'meta'?: CredentialUpdateRequest;
}
/**
 * A list of updates that needs to be carried out by the cluster in order to sync its access key assets with the control-plane.
 * @export
 * @interface AccessKeysSyncResponse
 */
export interface AccessKeysSyncResponse {
    /**
     * Access keys that needs to be deleted from the cluster.
     * @type {Array<string>}
     * @memberof AccessKeysSyncResponse
     */
    'toDelete'?: Array<string>;
    /**
     * Access keys that needs to be added to the cluster.
     * @type {Array<AccessKeyToAddOrUpdate>}
     * @memberof AccessKeysSyncResponse
     */
    'toAdd'?: Array<AccessKeyToAddOrUpdate>;
    /**
     * Access keys that needs to be updated at the cluster.
     * @type {Array<AccessKeyToAddOrUpdate>}
     * @memberof AccessKeysSyncResponse
     */
    'toUpdate'?: Array<AccessKeyToAddOrUpdate>;
}
/**
 * 
 * @export
 * @interface AdvancedFlatFields
 */
export interface AdvancedFlatFields {
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof AdvancedFlatFields
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof AdvancedFlatFields
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof AdvancedFlatFields
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof AdvancedFlatFields
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof AdvancedFlatFields
     */
    'restartPolicy'?: RestartPolicy | null;
}
/**
 * 
 * @export
 * @interface AdvancedFlatFieldsRules
 */
export interface AdvancedFlatFieldsRules {
    /**
     * 
     * @type {BooleanRules}
     * @memberof AdvancedFlatFieldsRules
     */
    'terminateAfterPreemption'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AdvancedFlatFieldsRules
     */
    'autoDeletionTimeAfterCompletionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AdvancedFlatFieldsRules
     */
    'terminationGracePeriodSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AdvancedFlatFieldsRules
     */
    'backoffLimit'?: IntegerRules | null;
    /**
     * 
     * @type {RestartPolicyRule}
     * @memberof AdvancedFlatFieldsRules
     */
    'restartPolicy'?: RestartPolicyRule | null;
}
/**
 * 
 * @export
 * @interface AdvancedItemizedFields
 */
export interface AdvancedItemizedFields {
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof AdvancedItemizedFields
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof AdvancedItemizedFields
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof AdvancedItemizedFields
     */
    'tolerations'?: Array<Toleration> | null;
}
/**
 * 
 * @export
 * @interface AdvancedItemizedRules
 */
export interface AdvancedItemizedRules {
    /**
     * 
     * @type {InstancesRules}
     * @memberof AdvancedItemizedRules
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof AdvancedItemizedRules
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof AdvancedItemizedRules
     */
    'tolerations'?: TolerationsRules | null;
}
/**
 * 
 * @export
 * @interface AllowOverQuota
 */
export interface AllowOverQuota {
    /**
     * Whether to allow the workload to exceed the quota of the project.
     * @type {boolean}
     * @memberof AllowOverQuota
     */
    'allowOverQuota'?: boolean | null;
}
/**
 * Annotation details to be populated into the container.
 * @export
 * @interface Annotation
 */
export interface Annotation {
    /**
     * The name of the annotation (mandatory)
     * @type {string}
     * @memberof Annotation
     */
    'name'?: string | null;
    /**
     * The value of the annotation.
     * @type {string}
     * @memberof Annotation
     */
    'value'?: string | null;
    /**
     * Use \'true\' in case the annotation is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof Annotation
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AnnotationsField
 */
export interface AnnotationsField {
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof AnnotationsField
     */
    'annotations'?: Array<Annotation> | null;
}
/**
 * 
 * @export
 * @interface AnnotationsFieldRules
 */
export interface AnnotationsFieldRules {
    /**
     * 
     * @type {InstancesRules}
     * @memberof AnnotationsFieldRules
     */
    'annotations'?: InstancesRules | null;
}
/**
 * 
 * @export
 * @interface ArrayRules
 */
export interface ArrayRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof ArrayRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether this array is mandatory. Mandatory array must include at least one item. default to false.
     * @type {boolean}
     * @memberof ArrayRules
     */
    'required'?: boolean | null;
    /**
     * Set of options that the value of each item of the array must be chosen from.
     * @type {Array<StringOption>}
     * @memberof ArrayRules
     */
    'options'?: Array<StringOption>;
    /**
     * Whether the value of the array, as a whole, is editable. default to false.
     * @type {boolean}
     * @memberof ArrayRules
     */
    'canEdit'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AssetClusterStatusInfo
 */
export interface AssetClusterStatusInfo {
    /**
     * 
     * @type {AssetSyncStatusEnum}
     * @memberof AssetClusterStatusInfo
     */
    'status'?: AssetSyncStatusEnum;
    /**
     * 
     * @type {Array<AssetClusterStatusIssue>}
     * @memberof AssetClusterStatusInfo
     */
    'issues'?: Array<AssetClusterStatusIssue>;
    /**
     * 
     * @type {string}
     * @memberof AssetClusterStatusInfo
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetClusterStatusInfo
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface AssetClusterStatusIssue
 */
export interface AssetClusterStatusIssue {
    /**
     * The id of the cluster, department or project, depending on the scope type.
     * @type {string}
     * @memberof AssetClusterStatusIssue
     */
    'scopeId': string;
    /**
     * 
     * @type {ScopeType}
     * @memberof AssetClusterStatusIssue
     */
    'scopeType': ScopeType;
    /**
     * 
     * @type {AssetClusterStatusIssueEnum}
     * @memberof AssetClusterStatusIssue
     */
    'issue': AssetClusterStatusIssueEnum;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AssetClusterStatusIssueEnum = {
    ReplicationError: 'ReplicationError',
    LostPhase: 'LostPhase',
    NotCreated: 'NotCreated'
} as const;

export type AssetClusterStatusIssueEnum = typeof AssetClusterStatusIssueEnum[keyof typeof AssetClusterStatusIssueEnum];


/**
 * 
 * @export
 * @interface AssetCountResponse
 */
export interface AssetCountResponse {
    /**
     * 
     * @type {number}
     * @memberof AssetCountResponse
     */
    'result': number;
}
/**
 * 
 * @export
 * @interface AssetCreationFields
 */
export interface AssetCreationFields {
    /**
     * 
     * @type {Scope}
     * @memberof AssetCreationFields
     */
    'scope': Scope;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof AssetCreationFields
     */
    'clusterId'?: string | null;
    /**
     * The id of the department. Must be specified for department scoped assets.
     * @type {string}
     * @memberof AssetCreationFields
     */
    'departmentId'?: string | null;
    /**
     * The id of the project. Must be specified for project scoped assets.
     * @type {number}
     * @memberof AssetCreationFields
     */
    'projectId'?: number | null;
    /**
     * The asset will be deleted automatically. This is intended for internal use.
     * @type {boolean}
     * @memberof AssetCreationFields
     */
    'autoDelete'?: boolean | null;
    /**
     * 
     * @type {WorkloadSupportedTypes}
     * @memberof AssetCreationFields
     */
    'workloadSupportedTypes'?: WorkloadSupportedTypes | null;
    /**
     * The asset will be private to the user who created it. supported only for docker registry and generic secrets
     * @type {boolean}
     * @memberof AssetCreationFields
     */
    'private'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AssetCreationRequest
 */
export interface AssetCreationRequest {
    /**
     * The name of the asset.
     * @type {string}
     * @memberof AssetCreationRequest
     */
    'name': string;
    /**
     * The description of the asset.
     * @type {string}
     * @memberof AssetCreationRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {Scope}
     * @memberof AssetCreationRequest
     */
    'scope': Scope;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof AssetCreationRequest
     */
    'clusterId'?: string | null;
    /**
     * The id of the department. Must be specified for department scoped assets.
     * @type {string}
     * @memberof AssetCreationRequest
     */
    'departmentId'?: string | null;
    /**
     * The id of the project. Must be specified for project scoped assets.
     * @type {number}
     * @memberof AssetCreationRequest
     */
    'projectId'?: number | null;
    /**
     * The asset will be deleted automatically. This is intended for internal use.
     * @type {boolean}
     * @memberof AssetCreationRequest
     */
    'autoDelete'?: boolean | null;
    /**
     * 
     * @type {WorkloadSupportedTypes}
     * @memberof AssetCreationRequest
     */
    'workloadSupportedTypes'?: WorkloadSupportedTypes | null;
    /**
     * The asset will be private to the user who created it. supported only for docker registry and generic secrets
     * @type {boolean}
     * @memberof AssetCreationRequest
     */
    'private'?: boolean | null;
}
/**
 * Reference information about a datasource asset.
 * @export
 * @interface AssetDatasourceRef
 */
export interface AssetDatasourceRef {
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof AssetDatasourceRef
     */
    'id': string;
    /**
     * The name of the asset.
     * @type {string}
     * @memberof AssetDatasourceRef
     */
    'name': string;
    /**
     * 
     * @type {AssetKind}
     * @memberof AssetDatasourceRef
     */
    'kind': AssetKind;
    /**
     * 
     * @type {DataSourceOverrides}
     * @memberof AssetDatasourceRef
     */
    'overrides'?: DataSourceOverrides | null;
}
/**
 * 
 * @export
 * @interface AssetFlatRequest
 */
export interface AssetFlatRequest {
    /**
     * 
     * @type {string}
     * @memberof AssetFlatRequest
     */
    'assetId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetFlatRequest
     */
    'assetIds'?: Array<string>;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof AssetFlatRequest
     */
    'clusterId': string;
    /**
     * The id of the project.
     * @type {string}
     * @memberof AssetFlatRequest
     */
    'projectId': string;
    /**
     * 
     * @type {WorkloadType}
     * @memberof AssetFlatRequest
     */
    'workloadType': WorkloadType;
    /**
     * 
     * @type {boolean}
     * @memberof AssetFlatRequest
     */
    'masterSameAsWorker'?: boolean;
}
/**
 * flat representation of an asset, for a given project and workload type
 * @export
 * @interface AssetFlatResponse
 */
export interface AssetFlatResponse {
    /**
     * 
     * @type {SupersetSpec}
     * @memberof AssetFlatResponse
     */
    'worker'?: SupersetSpec;
    /**
     * 
     * @type {MasterSpec}
     * @memberof AssetFlatResponse
     */
    'master'?: MasterSpec | null;
}
/**
 * Asset id and its kind.
 * @export
 * @interface AssetIdAndKind
 */
export interface AssetIdAndKind {
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof AssetIdAndKind
     */
    'id': string;
    /**
     * 
     * @type {AssetKind}
     * @memberof AssetIdAndKind
     */
    'kind': AssetKind;
    /**
     * 
     * @type {DataSourceOverrides}
     * @memberof AssetIdAndKind
     */
    'overrides'?: DataSourceOverrides | null;
}
/**
 * The kind of the asset.
 * @export
 * @enum {string}
 */

export const AssetKind = {
    Compute: 'compute',
    Environment: 'environment',
    AccessKey: 'accessKey',
    DockerRegistry: 'dockerRegistry',
    Password: 'password',
    GenericSecret: 'genericSecret',
    Registry: 'registry',
    S3: 's3',
    Git: 'git',
    Nfs: 'nfs',
    Pvc: 'pvc',
    HostPath: 'hostPath',
    WorkloadTemplate: 'workload-template',
    Model: 'model',
    ConfigMap: 'config-map',
    SecretVolume: 'secret-volume',
    DataVolume: 'data-volume'
} as const;

export type AssetKind = typeof AssetKind[keyof typeof AssetKind];


/**
 * 
 * @export
 * @interface AssetListByIdsResponse
 */
export interface AssetListByIdsResponse {
    /**
     * 
     * @type {Array<AssetMeta>}
     * @memberof AssetListByIdsResponse
     */
    'entries': Array<AssetMeta>;
}
/**
 * 
 * @export
 * @interface AssetMeta
 */
export interface AssetMeta {
    /**
     * The name of the asset.
     * @type {string}
     * @memberof AssetMeta
     */
    'name': string;
    /**
     * The description of the asset.
     * @type {string}
     * @memberof AssetMeta
     */
    'description'?: string | null;
    /**
     * 
     * @type {Scope}
     * @memberof AssetMeta
     */
    'scope': Scope;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof AssetMeta
     */
    'clusterId'?: string | null;
    /**
     * The id of the department. Must be specified for department scoped assets.
     * @type {string}
     * @memberof AssetMeta
     */
    'departmentId'?: string | null;
    /**
     * The id of the project. Must be specified for project scoped assets.
     * @type {number}
     * @memberof AssetMeta
     */
    'projectId'?: number | null;
    /**
     * The asset will be deleted automatically. This is intended for internal use.
     * @type {boolean}
     * @memberof AssetMeta
     */
    'autoDelete'?: boolean | null;
    /**
     * 
     * @type {WorkloadSupportedTypes}
     * @memberof AssetMeta
     */
    'workloadSupportedTypes'?: WorkloadSupportedTypes | null;
    /**
     * The asset will be private to the user who created it. supported only for docker registry and generic secrets
     * @type {boolean}
     * @memberof AssetMeta
     */
    'private'?: boolean | null;
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof AssetMeta
     */
    'id': string;
    /**
     * 
     * @type {AssetKind}
     * @memberof AssetMeta
     */
    'kind': AssetKind;
    /**
     * The id of the tenant.
     * @type {number}
     * @memberof AssetMeta
     */
    'tenantId'?: number | null;
    /**
     * The user who created the asset.
     * @type {string}
     * @memberof AssetMeta
     */
    'createdBy': string;
    /**
     * The time at which the asset were created
     * @type {string}
     * @memberof AssetMeta
     */
    'createdAt': string;
    /**
     * The user who updated the asset.
     * @type {string}
     * @memberof AssetMeta
     */
    'updatedBy': string;
    /**
     * The time at which the asset has been updated
     * @type {string}
     * @memberof AssetMeta
     */
    'updatedAt': string;
    /**
     * Deletion time of the asset (relevant for assets that sync to the cluster)
     * @type {string}
     * @memberof AssetMeta
     */
    'deletedAt'?: string;
    /**
     * The user who deleted the asset
     * @type {string}
     * @memberof AssetMeta
     */
    'deletedBy'?: string;
    /**
     * The name of the project that the asset is associated with, for project scoped assets.
     * @type {string}
     * @memberof AssetMeta
     */
    'projectName'?: string | null;
    /**
     * the value of an update counter of a data in the system.
     * @type {number}
     * @memberof AssetMeta
     */
    'updateCount'?: number;
}
/**
 * 
 * @export
 * @interface AssetMetaForSync
 */
export interface AssetMetaForSync {
    /**
     * 
     * @type {Scope}
     * @memberof AssetMetaForSync
     */
    'scope': Scope;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof AssetMetaForSync
     */
    'clusterId'?: string | null;
    /**
     * The id of the department. Must be specified for department scoped assets.
     * @type {string}
     * @memberof AssetMetaForSync
     */
    'departmentId'?: string | null;
    /**
     * The id of the project. Must be specified for project scoped assets.
     * @type {number}
     * @memberof AssetMetaForSync
     */
    'projectId'?: number | null;
    /**
     * The asset will be deleted automatically. This is intended for internal use.
     * @type {boolean}
     * @memberof AssetMetaForSync
     */
    'autoDelete'?: boolean | null;
    /**
     * 
     * @type {WorkloadSupportedTypes}
     * @memberof AssetMetaForSync
     */
    'workloadSupportedTypes'?: WorkloadSupportedTypes | null;
    /**
     * The asset will be private to the user who created it. supported only for docker registry and generic secrets
     * @type {boolean}
     * @memberof AssetMetaForSync
     */
    'private'?: boolean | null;
    /**
     * The name of the asset.
     * @type {string}
     * @memberof AssetMetaForSync
     */
    'name': string;
    /**
     * The description of the asset.
     * @type {string}
     * @memberof AssetMetaForSync
     */
    'description'?: string | null;
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof AssetMetaForSync
     */
    'id': string;
    /**
     * 
     * @type {AssetKind}
     * @memberof AssetMetaForSync
     */
    'kind': AssetKind;
    /**
     * The name of the asset.
     * @type {string}
     * @memberof AssetMetaForSync
     */
    'prevName'?: string;
}
/**
 * 
 * @export
 * @interface AssetMetaForSyncAllOf
 */
export interface AssetMetaForSyncAllOf {
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof AssetMetaForSyncAllOf
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AssetMetaForSyncAllOf1
 */
export interface AssetMetaForSyncAllOf1 {
    /**
     * 
     * @type {AssetKind}
     * @memberof AssetMetaForSyncAllOf1
     */
    'kind': AssetKind;
}
/**
 * 
 * @export
 * @interface AssetMetaForSyncAllOf2
 */
export interface AssetMetaForSyncAllOf2 {
    /**
     * The name of the asset.
     * @type {string}
     * @memberof AssetMetaForSyncAllOf2
     */
    'prevName'?: string;
}
/**
 * The name of the asset and the checksum of its spec.
 * @export
 * @interface AssetNameAndChecksum
 */
export interface AssetNameAndChecksum {
    /**
     * The name of the asset.
     * @type {string}
     * @memberof AssetNameAndChecksum
     */
    'name': string;
    /**
     * The checksum of the asset\'s spec.
     * @type {string}
     * @memberof AssetNameAndChecksum
     */
    'checksum': string;
}
/**
 * 
 * @export
 * @interface AssetReadOnlyFields
 */
export interface AssetReadOnlyFields {
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof AssetReadOnlyFields
     */
    'id': string;
    /**
     * 
     * @type {AssetKind}
     * @memberof AssetReadOnlyFields
     */
    'kind': AssetKind;
    /**
     * The id of the tenant.
     * @type {number}
     * @memberof AssetReadOnlyFields
     */
    'tenantId'?: number | null;
    /**
     * The user who created the asset.
     * @type {string}
     * @memberof AssetReadOnlyFields
     */
    'createdBy': string;
    /**
     * The time at which the asset were created
     * @type {string}
     * @memberof AssetReadOnlyFields
     */
    'createdAt': string;
    /**
     * The user who updated the asset.
     * @type {string}
     * @memberof AssetReadOnlyFields
     */
    'updatedBy': string;
    /**
     * The time at which the asset has been updated
     * @type {string}
     * @memberof AssetReadOnlyFields
     */
    'updatedAt': string;
    /**
     * Deletion time of the asset (relevant for assets that sync to the cluster)
     * @type {string}
     * @memberof AssetReadOnlyFields
     */
    'deletedAt'?: string;
    /**
     * The user who deleted the asset
     * @type {string}
     * @memberof AssetReadOnlyFields
     */
    'deletedBy'?: string;
    /**
     * The name of the project that the asset is associated with, for project scoped assets.
     * @type {string}
     * @memberof AssetReadOnlyFields
     */
    'projectName'?: string | null;
    /**
     * the value of an update counter of a data in the system.
     * @type {number}
     * @memberof AssetReadOnlyFields
     */
    'updateCount'?: number;
}
/**
 * Reference information about an asset.
 * @export
 * @interface AssetRef
 */
export interface AssetRef {
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof AssetRef
     */
    'id': string;
    /**
     * The name of the asset.
     * @type {string}
     * @memberof AssetRef
     */
    'name': string;
}
/**
 * The status of the asset in the cluster.
 * @export
 * @enum {string}
 */

export const AssetStatus = {
    Ready: 'Ready',
    NotReady: 'Not ready'
} as const;

export type AssetStatus = typeof AssetStatus[keyof typeof AssetStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const AssetSyncStatusEnum = {
    Creating: 'Creating',
    Deleting: 'Deleting',
    Failed: 'Failed',
    DeletionFailed: 'Deletion failed',
    IssuesFound: 'Issues found',
    NoIssuesFound: 'No issues found',
    NoStatus: 'No status',
    Updating: 'Updating'
} as const;

export type AssetSyncStatusEnum = typeof AssetSyncStatusEnum[keyof typeof AssetSyncStatusEnum];


/**
 * 
 * @export
 * @interface AssetUpdatableFields
 */
export interface AssetUpdatableFields {
    /**
     * The name of the asset.
     * @type {string}
     * @memberof AssetUpdatableFields
     */
    'name': string;
    /**
     * The description of the asset.
     * @type {string}
     * @memberof AssetUpdatableFields
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface AssetUpdateRequest
 */
export interface AssetUpdateRequest {
    /**
     * The name of the asset.
     * @type {string}
     * @memberof AssetUpdateRequest
     */
    'name': string;
    /**
     * The description of the asset.
     * @type {string}
     * @memberof AssetUpdateRequest
     */
    'description'?: string | null;
}
/**
 * Details about resources that use the asset.
 * @export
 * @interface AssetUsageInfo
 */
export interface AssetUsageInfo {
    /**
     * workspaces that rely on this asset.
     * @type {Array<WorkloadRefAndStatus>}
     * @memberof AssetUsageInfo
     */
    'workspaces'?: Array<WorkloadRefAndStatus>;
    /**
     * trainings that rely on this asset.
     * @type {Array<WorkloadRefAndStatus>}
     * @memberof AssetUsageInfo
     */
    'trainings'?: Array<WorkloadRefAndStatus>;
    /**
     * distributed trainings that rely on this asset.
     * @type {Array<WorkloadRefAndStatus>}
     * @memberof AssetUsageInfo
     */
    'distributed'?: Array<WorkloadRefAndStatus>;
    /**
     * inferences that rely on this asset.
     * @type {Array<WorkloadRefAndStatus>}
     * @memberof AssetUsageInfo
     */
    'inferences'?: Array<WorkloadRefAndStatus>;
    /**
     * templates that rely on this asset.
     * @type {Array<AssetRef>}
     * @memberof AssetUsageInfo
     */
    'templates'?: Array<AssetRef>;
    /**
     * 
     * @type {AssetsUsageRef}
     * @memberof AssetUsageInfo
     */
    'assets'?: AssetsUsageRef;
}
/**
 * 
 * @export
 * @interface AssetsDefaults
 */
export interface AssetsDefaults {
    /**
     * 
     * @type {DatasourceDefaults}
     * @memberof AssetsDefaults
     */
    'datasources'?: DatasourceDefaults | null;
}
/**
 * Set of assets comprising a workspace or a workspace template.
 * @export
 * @interface AssetsIds
 */
export interface AssetsIds {
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof AssetsIds
     */
    'environment': string;
    /**
     * 
     * @type {string}
     * @memberof AssetsIds
     */
    'compute'?: string | null;
    /**
     * 
     * @type {Array<AssetIdAndKind>}
     * @memberof AssetsIds
     */
    'datasources'?: Array<AssetIdAndKind>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetsIds
     */
    'workloadVolumes'?: Array<string>;
}
/**
 * Reference information about a set of assets. used to describe - assets comprising a workspace - assets comprising a workspace template - assets that use other assets (e.g. s3 asset which uses access key).
 * @export
 * @interface AssetsRef
 */
export interface AssetsRef {
    /**
     * 
     * @type {AssetsRefEnvironment}
     * @memberof AssetsRef
     */
    'environment': AssetsRefEnvironment;
    /**
     * 
     * @type {AssetsRefCompute}
     * @memberof AssetsRef
     */
    'compute'?: AssetsRefCompute | null;
    /**
     * 
     * @type {Array<DatasourceRef>}
     * @memberof AssetsRef
     */
    'datasources'?: Array<DatasourceRef>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetsRef
     */
    'workloadVolumes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AssetsRefCompute
 */
export interface AssetsRefCompute {
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof AssetsRefCompute
     */
    'id': string;
    /**
     * The name of the asset.
     * @type {string}
     * @memberof AssetsRefCompute
     */
    'name': string;
}
/**
 * environment asset.
 * @export
 * @interface AssetsRefEnvironment
 */
export interface AssetsRefEnvironment {
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof AssetsRefEnvironment
     */
    'id': string;
    /**
     * The name of the asset.
     * @type {string}
     * @memberof AssetsRefEnvironment
     */
    'name': string;
    /**
     * the type of tools as defined in the connections of the environment asset.
     * @type {Array<ToolType>}
     * @memberof AssetsRefEnvironment
     */
    'toolTypes'?: Array<ToolType> | null;
}
/**
 * 
 * @export
 * @interface AssetsRefOptional
 */
export interface AssetsRefOptional {
    /**
     * 
     * @type {AssetsRefEnvironment}
     * @memberof AssetsRefOptional
     */
    'environment': AssetsRefEnvironment;
    /**
     * 
     * @type {AssetsRefCompute}
     * @memberof AssetsRefOptional
     */
    'compute'?: AssetsRefCompute | null;
    /**
     * 
     * @type {Array<DatasourceRef>}
     * @memberof AssetsRefOptional
     */
    'datasources'?: Array<DatasourceRef>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetsRefOptional
     */
    'workloadVolumes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AssetsRules
 */
export interface AssetsRules {
    /**
     * 
     * @type {StorageFieldsRules}
     * @memberof AssetsRules
     */
    'datasources'?: StorageFieldsRules | null;
}
/**
 * Reference information about usage of assets by other assets, for example datasources that uses credentials.
 * @export
 * @interface AssetsUsageRef
 */
export interface AssetsUsageRef {
    /**
     * 
     * @type {AssetsUsageRefEnvironment}
     * @memberof AssetsUsageRef
     * @deprecated
     */
    'environment'?: AssetsUsageRefEnvironment | null;
    /**
     * 
     * @type {Array<AssetRef>}
     * @memberof AssetsUsageRef
     */
    'environments'?: Array<AssetRef>;
    /**
     * 
     * @type {AssetsUsageRefCompute}
     * @memberof AssetsUsageRef
     */
    'compute'?: AssetsUsageRefCompute | null;
    /**
     * 
     * @type {Array<AssetRef>}
     * @memberof AssetsUsageRef
     */
    'computes'?: Array<AssetRef>;
    /**
     * 
     * @type {Array<AssetDatasourceRef>}
     * @memberof AssetsUsageRef
     */
    'datasources'?: Array<AssetDatasourceRef>;
}
/**
 * 
 * @export
 * @interface AssetsUsageRefCompute
 */
export interface AssetsUsageRefCompute {
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof AssetsUsageRefCompute
     */
    'id': string;
    /**
     * The name of the asset.
     * @type {string}
     * @memberof AssetsUsageRefCompute
     */
    'name': string;
}
/**
 * environment asset.
 * @export
 * @interface AssetsUsageRefEnvironment
 */
export interface AssetsUsageRefEnvironment {
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof AssetsUsageRefEnvironment
     */
    'id': string;
    /**
     * The name of the asset.
     * @type {string}
     * @memberof AssetsUsageRefEnvironment
     */
    'name': string;
    /**
     * the type of tools as defined in the connections of the environment asset.
     * @type {Array<ToolType>}
     * @memberof AssetsUsageRefEnvironment
     */
    'toolTypes'?: Array<ToolType> | null;
}
/**
 * 
 * @export
 * @interface AttributeDefaults
 */
export interface AttributeDefaults {
    /**
     * 
     * @type {AssetsDefaults}
     * @memberof AttributeDefaults
     */
    'assets'?: AssetsDefaults | null;
    /**
     * 
     * @type {SpecificRunParamAttrDefaults}
     * @memberof AttributeDefaults
     */
    'specificRunParams'?: SpecificRunParamAttrDefaults | null;
}
/**
 * 
 * @export
 * @interface AutoScaling
 */
export interface AutoScaling {
    /**
     * The percentage of metric threshold value to use for autoscaling. Defaults to 70. Applicable only with the \'throughput\' and \'concurrency\' metrics
     * @type {number}
     * @memberof AutoScaling
     */
    'metricThresholdPercentage'?: number | null;
    /**
     * The minimum number of replicas for autoscaling. Defaults to 1. Use 0 to allow scale-to-zero
     * @type {number}
     * @memberof AutoScaling
     */
    'minReplicas'?: number | null;
    /**
     * The maximum number of replicas for autoscaling. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScaling
     */
    'maxReplicas'?: number | null;
    /**
     * The number of replicas to run when initializing the workload for the first time. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScaling
     */
    'initialReplicas'?: number | null;
    /**
     * The number of replicas to run when scaling-up from zero. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScaling
     */
    'activationReplicas'?: number | null;
    /**
     * The maximum number of requests allowed to flow to a single replica at any time. 0 means no limit
     * @type {number}
     * @memberof AutoScaling
     */
    'concurrencyHardLimit'?: number | null;
    /**
     * The minimum amount of time (in seconds) that the last replica will remain active after a scale-to-zero decision. Defaults to 0. Available only if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScaling
     */
    'scaleToZeroRetentionSeconds'?: number | null;
    /**
     * The minimum amount of time (in seconds) that a replica will remain active after a scale-down decision
     * @type {number}
     * @memberof AutoScaling
     */
    'scaleDownDelaySeconds'?: number | null;
    /**
     * The maximum amount of time (in seconds) to wait for the container to become ready
     * @type {number}
     * @memberof AutoScaling
     */
    'initializationTimeoutSeconds'?: number | null;
    /**
     * The metric to use for autoscaling. Mandatory if minReplicas < maxReplicas, except for the special case where minReplicas is set to 0 and maxReplicas is set to 1, as in this case autoscaling decisions are made according to network activity rather than metrics. Use one of the built-in metrics of \'throughput\', \'concurrency\' or \'latency\', or any other available custom metric. Only the \'throughput\' and \'concurrency\' metrics support scale-to-zero
     * @type {string}
     * @memberof AutoScaling
     */
    'metric'?: string | null;
    /**
     * The threshold to use with the specified metric for autoscaling. Mandatory if metric is specified
     * @type {number}
     * @memberof AutoScaling
     */
    'metricThreshold'?: number | null;
}
/**
 * Auto scaling common fields
 * @export
 * @interface AutoScalingCommonFields
 */
export interface AutoScalingCommonFields {
    /**
     * The percentage of metric threshold value to use for autoscaling. Defaults to 70. Applicable only with the \'throughput\' and \'concurrency\' metrics
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'metricThresholdPercentage'?: number | null;
    /**
     * The minimum number of replicas for autoscaling. Defaults to 1. Use 0 to allow scale-to-zero
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'minReplicas'?: number | null;
    /**
     * The maximum number of replicas for autoscaling. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'maxReplicas'?: number | null;
    /**
     * The number of replicas to run when initializing the workload for the first time. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'initialReplicas'?: number | null;
    /**
     * The number of replicas to run when scaling-up from zero. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'activationReplicas'?: number | null;
    /**
     * The maximum number of requests allowed to flow to a single replica at any time. 0 means no limit
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'concurrencyHardLimit'?: number | null;
    /**
     * The minimum amount of time (in seconds) that the last replica will remain active after a scale-to-zero decision. Defaults to 0. Available only if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'scaleToZeroRetentionSeconds'?: number | null;
    /**
     * The minimum amount of time (in seconds) that a replica will remain active after a scale-down decision
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'scaleDownDelaySeconds'?: number | null;
    /**
     * The maximum amount of time (in seconds) to wait for the container to become ready
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'initializationTimeoutSeconds'?: number | null;
}
/**
 * Auto scaling metric fields
 * @export
 * @interface AutoScalingMetricFields
 */
export interface AutoScalingMetricFields {
    /**
     * The metric to use for autoscaling. Mandatory if minReplicas < maxReplicas, except for the special case where minReplicas is set to 0 and maxReplicas is set to 1, as in this case autoscaling decisions are made according to network activity rather than metrics. Use one of the built-in metrics of \'throughput\', \'concurrency\' or \'latency\', or any other available custom metric. Only the \'throughput\' and \'concurrency\' metrics support scale-to-zero
     * @type {string}
     * @memberof AutoScalingMetricFields
     */
    'metric'?: string | null;
    /**
     * The threshold to use with the specified metric for autoscaling. Mandatory if metric is specified
     * @type {number}
     * @memberof AutoScalingMetricFields
     */
    'metricThreshold'?: number | null;
}
/**
 * 
 * @export
 * @interface AutoScalingMetricOptions
 */
export interface AutoScalingMetricOptions {
    /**
     * 
     * @type {Array<AutoScalingMetricOptionsOptionsInner>}
     * @memberof AutoScalingMetricOptions
     */
    'options'?: Array<AutoScalingMetricOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface AutoScalingMetricOptionsOptionsInner
 */
export interface AutoScalingMetricOptionsOptionsInner {
    /**
     * The metric to use for autoscaling. Mandatory if minReplicas < maxReplicas, except for the special case where minReplicas is set to 0 and maxReplicas is set to 1, as in this case autoscaling decisions are made according to network activity rather than metrics. Use one of the built-in metrics of \'throughput\', \'concurrency\' or \'latency\', or any other available custom metric. Only the \'throughput\' and \'concurrency\' metrics support scale-to-zero
     * @type {string}
     * @memberof AutoScalingMetricOptionsOptionsInner
     */
    'value': string | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof AutoScalingMetricOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface AutoScalingMetricRules
 */
export interface AutoScalingMetricRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof AutoScalingMetricRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof AutoScalingMetricRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof AutoScalingMetricRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<AutoScalingMetricOptionsOptionsInner>}
     * @memberof AutoScalingMetricRules
     */
    'options'?: Array<AutoScalingMetricOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface AutoScalingRules
 */
export interface AutoScalingRules {
    /**
     * 
     * @type {NumberRules}
     * @memberof AutoScalingRules
     */
    'metricThresholdPercentage'?: NumberRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'minReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'maxReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'initialReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'activationReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {AutoScalingMetricRules}
     * @memberof AutoScalingRules
     */
    'metric'?: AutoScalingMetricRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'metricThreshold'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'concurrencyHardLimit'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'scaleToZeroRetentionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'scaleDownDelaySeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'initializationTimeoutSeconds'?: IntegerRules | null;
}
/**
 * 
 * @export
 * @interface BooleanRules
 */
export interface BooleanRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof BooleanRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory. default to false.
     * @type {boolean}
     * @memberof BooleanRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable. default to true
     * @type {boolean}
     * @memberof BooleanRules
     */
    'canEdit'?: boolean | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Capability = {
    AuditControl: 'AUDIT_CONTROL',
    AuditRead: 'AUDIT_READ',
    AuditWrite: 'AUDIT_WRITE',
    BlockSuspend: 'BLOCK_SUSPEND',
    Chown: 'CHOWN',
    DacOverride: 'DAC_OVERRIDE',
    DacReadSearch: 'DAC_READ_SEARCH',
    Fowner: 'FOWNER',
    Fsetid: 'FSETID',
    IpcLock: 'IPC_LOCK',
    IpcOwner: 'IPC_OWNER',
    Kill: 'KILL',
    Lease: 'LEASE',
    LinuxImmutable: 'LINUX_IMMUTABLE',
    MacAdmin: 'MAC_ADMIN',
    MacOverride: 'MAC_OVERRIDE',
    Mknod: 'MKNOD',
    NetAdmin: 'NET_ADMIN',
    NetBindService: 'NET_BIND_SERVICE',
    NetBroadcast: 'NET_BROADCAST',
    NetRaw: 'NET_RAW',
    Setgid: 'SETGID',
    Setfcap: 'SETFCAP',
    Setpcap: 'SETPCAP',
    Setuid: 'SETUID',
    SysAdmin: 'SYS_ADMIN',
    SysBoot: 'SYS_BOOT',
    SysChroot: 'SYS_CHROOT',
    SysModule: 'SYS_MODULE',
    SysNice: 'SYS_NICE',
    SysPacct: 'SYS_PACCT',
    SysPtrace: 'SYS_PTRACE',
    SysRawio: 'SYS_RAWIO',
    SysResource: 'SYS_RESOURCE',
    SysTime: 'SYS_TIME',
    SysTtyConfig: 'SYS_TTY_CONFIG',
    Syslog: 'SYSLOG',
    WakeAlarm: 'WAKE_ALARM'
} as const;

export type Capability = typeof Capability[keyof typeof Capability];


/**
 * Claim information for the newly created PVC. The information should not be provided when attempting to use existing PVC.
 * @export
 * @interface ClaimInfo
 */
export interface ClaimInfo {
    /**
     * Requested size for the PVC. Mandatory when existingPvc is false. Recommended sizes: TB/GB/MB/TIB/GIB/MIB
     * @type {string}
     * @memberof ClaimInfo
     */
    'size'?: string | null;
    /**
     * Storage class name to associate with the PVC. This parameter may be omitted if there is a single storage class in the system, or you are using the default storage class. For more information, see [Storage class](https://kubernetes.io/docs/concepts/storage/storage-classes).
     * @type {string}
     * @memberof ClaimInfo
     */
    'storageClass'?: string | null;
    /**
     * 
     * @type {PvcAccessModes}
     * @memberof ClaimInfo
     */
    'accessModes'?: PvcAccessModes | null;
    /**
     * 
     * @type {PvcVolumeMode}
     * @memberof ClaimInfo
     */
    'volumeMode'?: PvcVolumeMode | null;
    /**
     * an optional array of key-values pairs that are written as annotations on the created PVC. the allowed attributes are determined according to the storage class configuration (see k8s-objects-tracker for further info).
     * @type {Array<PvcAddedAttrValue>}
     * @memberof ClaimInfo
     */
    'addedAttrValues'?: Array<PvcAddedAttrValue>;
}
/**
 * 
 * @export
 * @interface ClaimInfoRules
 */
export interface ClaimInfoRules {
    /**
     * 
     * @type {StringRules}
     * @memberof ClaimInfoRules
     */
    'size'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ClaimInfoRules
     */
    'storageClass'?: StringRules | null;
    /**
     * 
     * @type {PvcAccessModesRules}
     * @memberof ClaimInfoRules
     */
    'accessModes'?: PvcAccessModesRules | null;
}
/**
 * Claim information updatable fields.
 * @export
 * @interface ClaimInfoUpdatable
 */
export interface ClaimInfoUpdatable {
    /**
     * Requested size for the PVC. Mandatory when existingPvc is false. Recommended sizes: TB/GB/MB/TIB/GIB/MIB
     * @type {string}
     * @memberof ClaimInfoUpdatable
     */
    'size'?: string | null;
    /**
     * an optional array of key-values pairs that are written as annotations on the created PVC. the allowed attributes are determined according to the storage class configuration (see k8s-objects-tracker for further info).
     * @type {Array<PvcAddedAttrValue>}
     * @memberof ClaimInfoUpdatable
     */
    'addedAttrValues'?: Array<PvcAddedAttrValue>;
}
/**
 * Cluster related information of the asset.
 * @export
 * @interface ClusterInfo
 */
export interface ClusterInfo {
    /**
     * 
     * @type {Array<ClusterResourceInfo>}
     * @memberof ClusterInfo
     */
    'resources'?: Array<ClusterResourceInfo>;
}
/**
 * 
 * @export
 * @interface ClusterResourceInfo
 */
export interface ClusterResourceInfo {
    /**
     * The name of the resource created for the asset in the cluster.
     * @type {string}
     * @memberof ClusterResourceInfo
     */
    'name'?: string | null;
}
/**
 * allow cluster to report about success/failures of sync updates
 * @export
 * @interface ClusterSyncReport
 */
export interface ClusterSyncReport {
    /**
     * 
     * @type {Array<ClusterSyncReportUpdate>}
     * @memberof ClusterSyncReport
     */
    'updates'?: Array<ClusterSyncReportUpdate>;
}
/**
 * success/failure report of a single update attempt of the cluster
 * @export
 * @interface ClusterSyncReportUpdate
 */
export interface ClusterSyncReportUpdate {
    /**
     * a unique id of the entity being updated (asset, workload, policy, etc).
     * @type {string}
     * @memberof ClusterSyncReportUpdate
     */
    'id'?: string;
    /**
     * the value of an update counter of a data in the system.
     * @type {number}
     * @memberof ClusterSyncReportUpdate
     */
    'updateCount'?: number;
    /**
     * the time in which the cluster attempted the update.
     * @type {string}
     * @memberof ClusterSyncReportUpdate
     */
    'updateAttemptTime'?: string;
    /**
     * optional failure message for the case that the update has failed. should be sent null if the update was successful.
     * @type {string}
     * @memberof ClusterSyncReportUpdate
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface CommonFlatFields
 */
export interface CommonFlatFields {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof CommonFlatFields
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof CommonFlatFields
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof CommonFlatFields
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof CommonFlatFields
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof CommonFlatFields
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof CommonFlatFields
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof CommonFlatFields
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof CommonFlatFields
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof CommonFlatFields
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof CommonFlatFields
     */
    'podAffinity'?: PodAffinity | null;
}
/**
 * 
 * @export
 * @interface CommonItemizedFields
 */
export interface CommonItemizedFields {
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariable>}
     * @memberof CommonItemizedFields
     */
    'environmentVariables'?: Array<EnvironmentVariable> | null;
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof CommonItemizedFields
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof CommonItemizedFields
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof CommonItemizedFields
     */
    'tolerations'?: Array<Toleration> | null;
}
/**
 * 
 * @export
 * @interface CommonSecurityFlatFields
 */
export interface CommonSecurityFlatFields {
    /**
     * 
     * @type {UidGidSource}
     * @memberof CommonSecurityFlatFields
     */
    'uidGidSource'?: UidGidSource | null;
    /**
     * Add POSIX capabilities to running containers. Defaults to the default set of capabilities granted by the container runtime.
     * @type {Array<Capability>}
     * @memberof CommonSecurityFlatFields
     */
    'capabilities'?: Array<Capability> | null;
    /**
     * 
     * @type {SeccompProfileType}
     * @memberof CommonSecurityFlatFields
     */
    'seccompProfileType'?: SeccompProfileType | null;
    /**
     * Force the container to run as a non-root user.
     * @type {boolean}
     * @memberof CommonSecurityFlatFields
     */
    'runAsNonRoot'?: boolean | null;
    /**
     * If true, mounts the container\'s root filesystem as read-only.
     * @type {boolean}
     * @memberof CommonSecurityFlatFields
     */
    'readOnlyRootFilesystem'?: boolean | null;
    /**
     * The user id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsUid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof CommonSecurityFlatFields
     */
    'runAsUid'?: number | null;
    /**
     * The group id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsGid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof CommonSecurityFlatFields
     */
    'runAsGid'?: number | null;
    /**
     * Comma separated list of groups that the user running the container belongs to, in addition to the group indicated by runAsGid. Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled. Using an empty string implies reverting the supplementary groups of the image.
     * @type {string}
     * @memberof CommonSecurityFlatFields
     */
    'supplementalGroups'?: string | null;
}
/**
 * Security non overrideable fields. In the context of assets,these are environment asset fields that cannot be overriden in the submit workload request.
 * @export
 * @interface CommonSecurityNonOverridable
 */
export interface CommonSecurityNonOverridable {
    /**
     * 
     * @type {UidGidSource}
     * @memberof CommonSecurityNonOverridable
     */
    'uidGidSource'?: UidGidSource | null;
    /**
     * Add POSIX capabilities to running containers. Defaults to the default set of capabilities granted by the container runtime.
     * @type {Array<Capability>}
     * @memberof CommonSecurityNonOverridable
     */
    'capabilities'?: Array<Capability> | null;
    /**
     * 
     * @type {SeccompProfileType}
     * @memberof CommonSecurityNonOverridable
     */
    'seccompProfileType'?: SeccompProfileType | null;
    /**
     * Force the container to run as a non-root user.
     * @type {boolean}
     * @memberof CommonSecurityNonOverridable
     */
    'runAsNonRoot'?: boolean | null;
    /**
     * If true, mounts the container\'s root filesystem as read-only.
     * @type {boolean}
     * @memberof CommonSecurityNonOverridable
     */
    'readOnlyRootFilesystem'?: boolean | null;
}
/**
 * Security overrideable fields. In the context of assets,these are environment asset fields that can be overriden in the submit workload request.
 * @export
 * @interface CommonSecurityOverridable
 */
export interface CommonSecurityOverridable {
    /**
     * The user id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsUid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof CommonSecurityOverridable
     */
    'runAsUid'?: number | null;
    /**
     * The group id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsGid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof CommonSecurityOverridable
     */
    'runAsGid'?: number | null;
    /**
     * Comma separated list of groups that the user running the container belongs to, in addition to the group indicated by runAsGid. Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled. Using an empty string implies reverting the supplementary groups of the image.
     * @type {string}
     * @memberof CommonSecurityOverridable
     */
    'supplementalGroups'?: string | null;
}
/**
 * Security related fields. When used in assets context, those are environment asset fields that can be override in the submit workload request.
 * @export
 * @interface CommonSecurityOverridableRules
 */
export interface CommonSecurityOverridableRules {
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof CommonSecurityOverridableRules
     */
    'runAsUid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof CommonSecurityOverridableRules
     */
    'runAsGid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {StringRules}
     * @memberof CommonSecurityOverridableRules
     */
    'supplementalGroups'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface CommonStorageFields
 */
export interface CommonStorageFields {
    /**
     * Set of data volumes to use in the workload.
     * @type {Array<DataVolumeInstance>}
     * @memberof CommonStorageFields
     */
    'dataVolume'?: Array<DataVolumeInstance> | null;
    /**
     * Set of pvc persistent volume claims to use in the workload.
     * @type {Array<PvcInstance>}
     * @memberof CommonStorageFields
     */
    'pvc'?: Array<PvcInstance> | null;
    /**
     * Set of host paths to use in the workload.
     * @type {Array<HostPathInstance>}
     * @memberof CommonStorageFields
     */
    'hostPath'?: Array<HostPathInstance> | null;
    /**
     * Set of nfs volumes to use in the workload.
     * @type {Array<NfsInstance>}
     * @memberof CommonStorageFields
     */
    'nfs'?: Array<NfsInstance> | null;
    /**
     * Set of git repositories to use in the workload.
     * @type {Array<GitInstance>}
     * @memberof CommonStorageFields
     */
    'git'?: Array<GitInstance> | null;
    /**
     * Set of config map volumes to use in the workload
     * @type {Array<ConfigMapInstance>}
     * @memberof CommonStorageFields
     */
    'configMapVolume'?: Array<ConfigMapInstance> | null;
    /**
     * Set of secret volumes to use in the workload
     * @type {Array<SecretInstance>}
     * @memberof CommonStorageFields
     */
    'secretVolume'?: Array<SecretInstance> | null;
}
/**
 * 
 * @export
 * @interface CommonStorageFieldsRules
 */
export interface CommonStorageFieldsRules {
    /**
     * 
     * @type {DataVolumesRules}
     * @memberof CommonStorageFieldsRules
     */
    'dataVolume'?: DataVolumesRules | null;
    /**
     * 
     * @type {PvcsRules}
     * @memberof CommonStorageFieldsRules
     */
    'pvc'?: PvcsRules | null;
    /**
     * 
     * @type {HostPathsRules}
     * @memberof CommonStorageFieldsRules
     */
    'hostPath'?: HostPathsRules | null;
    /**
     * 
     * @type {NfssRules}
     * @memberof CommonStorageFieldsRules
     */
    'nfs'?: NfssRules | null;
    /**
     * 
     * @type {GitsRules}
     * @memberof CommonStorageFieldsRules
     */
    'git'?: GitsRules | null;
    /**
     * 
     * @type {ConfigMapsRules}
     * @memberof CommonStorageFieldsRules
     */
    'configMapVolume'?: ConfigMapsRules | null;
    /**
     * 
     * @type {SecretsRules}
     * @memberof CommonStorageFieldsRules
     */
    'secretVolume'?: SecretsRules | null;
}
/**
 * 
 * @export
 * @interface CompletionsField
 */
export interface CompletionsField {
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof CompletionsField
     */
    'completions'?: number | null;
}
/**
 * 
 * @export
 * @interface CompletionsFieldRules
 */
export interface CompletionsFieldRules {
    /**
     * 
     * @type {IntegerRules}
     * @memberof CompletionsFieldRules
     */
    'completions'?: IntegerRules | null;
}
/**
 * Compliance of the asset with creation of workloads in the given project.
 * @export
 * @interface ComplianceInfo
 */
export interface ComplianceInfo {
    /**
     * Whether the asset is imposed on created workloads by the administrator.
     * @type {boolean}
     * @memberof ComplianceInfo
     */
    'imposed'?: boolean;
    /**
     * Whether the asset info complies with creation of workloads in the project.
     * @type {boolean}
     * @memberof ComplianceInfo
     */
    'compliance'?: boolean;
    /**
     * For asset that does not comply, specify one or more reason why.
     * @type {Array<ComplianceInfoReason>}
     * @memberof ComplianceInfo
     */
    'reason'?: Array<ComplianceInfoReason>;
}
/**
 * A reason explaining why the asset does not comply with workloads creation for a given project.
 * @export
 * @interface ComplianceInfoReason
 */
export interface ComplianceInfoReason {
    /**
     * for policy related issues, includes a json path to the field in the policy for which the message applies.
     * @type {string}
     * @memberof ComplianceInfoReason
     */
    'field'?: string | null;
    /**
     * explanation of the reason for rejecting the asset.
     * @type {string}
     * @memberof ComplianceInfoReason
     */
    'details': string;
}
/**
 * 
 * @export
 * @interface ComplianceIssues
 */
export interface ComplianceIssues {
    /**
     * 
     * @type {Array<ComplianceIssuesComplianceIssuesInner>}
     * @memberof ComplianceIssues
     */
    'complianceIssues'?: Array<ComplianceIssuesComplianceIssuesInner>;
}
/**
 * 
 * @export
 * @interface ComplianceIssuesComplianceIssuesInner
 */
export interface ComplianceIssuesComplianceIssuesInner {
    /**
     * 
     * @type {string}
     * @memberof ComplianceIssuesComplianceIssuesInner
     */
    'field': string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceIssuesComplianceIssuesInner
     */
    'details': string;
}
/**
 * 
 * @export
 * @interface Compute
 */
export interface Compute {
    /**
     * 
     * @type {ComputeFields}
     * @memberof Compute
     */
    'compute'?: ComputeFields | null;
}
/**
 * 
 * @export
 * @interface ComputeAsset
 */
export interface ComputeAsset {
    /**
     * 
     * @type {AssetMeta}
     * @memberof ComputeAsset
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {ComputeAssetSpec}
     * @memberof ComputeAsset
     */
    'spec': ComputeAssetSpec;
    /**
     * 
     * @type {AssetUsageInfo}
     * @memberof ComputeAsset
     */
    'usedBy'?: AssetUsageInfo | null;
    /**
     * 
     * @type {UsageTimesInfo}
     * @memberof ComputeAsset
     */
    'usageTimes'?: UsageTimesInfo | null;
    /**
     * 
     * @type {ComplianceInfo}
     * @memberof ComputeAsset
     */
    'compliance'?: ComplianceInfo | null;
}
/**
 * 
 * @export
 * @interface ComputeAssetSpec
 */
export interface ComputeAssetSpec {
    /**
     * Requested number of GPU devices. Currently if more than one device is requested, it is not possible to provide values for gpuMemory, gpuPortion or migProfile [deprecated].
     * @type {number}
     * @memberof ComputeAssetSpec
     */
    'gpuDevicesRequest'?: number | null;
    /**
     * 
     * @type {GpuRequestType}
     * @memberof ComputeAssetSpec
     */
    'gpuRequestType'?: GpuRequestType | null;
    /**
     * Required if and only if gpuRequestType is portion. States the portion of the GPU to allocate for the created workload, per GPU device, between 0 and 1. The default is no allocated GPUs.
     * @type {number}
     * @memberof ComputeAssetSpec
     */
    'gpuPortionRequest'?: number | null;
    /**
     * Limitations on the portion consumed by the workload, per GPU device. The system guarantees The gpuPotionLimit must be no less than the gpuPortionRequest.
     * @type {number}
     * @memberof ComputeAssetSpec
     */
    'gpuPortionLimit'?: number | null;
    /**
     * Required if and only if gpuRequestType is memory. States the GPU memory to allocate for the created workload, per GPU device. Note that the workload will not be scheduled unless the system can guarantee this amount of GPU memory to the workload.
     * @type {string}
     * @memberof ComputeAssetSpec
     */
    'gpuMemoryRequest'?: string | null;
    /**
     * Limitation on the memory consumed by the workload, per GPU device. The system guarantees The gpuMemoryLimit must be no less than gpuMemoryRequest.
     * @type {string}
     * @memberof ComputeAssetSpec
     */
    'gpuMemoryLimit'?: string | null;
    /**
     * 
     * @type {MigProfile}
     * @memberof ComputeAssetSpec
     * @deprecated
     */
    'migProfile'?: MigProfile | null;
    /**
     * CPU units to allocate for the created workload (0.5, 1, .etc). The workload will receive at least this amount of CPU. Note that the workload will not be scheduled unless the system can guarantee this amount of CPUs to the workload.
     * @type {number}
     * @memberof ComputeAssetSpec
     */
    'cpuCoreRequest'?: number | null;
    /**
     * Limitations on the number of CPUs consumed by the workload (0.5, 1, .etc). The system guarantees that this workload will not be able to consume more than this amount of CPUs.
     * @type {number}
     * @memberof ComputeAssetSpec
     */
    'cpuCoreLimit'?: number | null;
    /**
     * The amount of CPU memory to allocate for this workload (1G, 20M, .etc). The workload will receive at least this amount of memory. Note that the workload will not be scheduled unless the system can guarantee this amount of memory to the workload
     * @type {string}
     * @memberof ComputeAssetSpec
     */
    'cpuMemoryRequest'?: string | null;
    /**
     * Limitations on the CPU memory to allocate for this workload (1G, 20M, .etc). The system guarantees that this workload will not be able to consume more than this amount of memory. The workload will receive an error when trying to allocate more memory than this limit.
     * @type {string}
     * @memberof ComputeAssetSpec
     */
    'cpuMemoryLimit'?: string | null;
    /**
     * A large /dev/shm device to mount into a container running the created workload. An shm is a shared file system mounted on RAM.
     * @type {boolean}
     * @memberof ComputeAssetSpec
     */
    'largeShmRequest'?: boolean | null;
    /**
     * Extended resources and their quantity.
     * @type {Array<ExtendedResource>}
     * @memberof ComputeAssetSpec
     */
    'extendedResources'?: Array<ExtendedResource> | null;
}
/**
 * 
 * @export
 * @interface ComputeCreationRequest
 */
export interface ComputeCreationRequest {
    /**
     * 
     * @type {AssetCreationRequest}
     * @memberof ComputeCreationRequest
     */
    'meta': AssetCreationRequest;
    /**
     * 
     * @type {ComputeAssetSpec}
     * @memberof ComputeCreationRequest
     */
    'spec': ComputeAssetSpec;
}
/**
 * 
 * @export
 * @interface ComputeFields
 */
export interface ComputeFields {
    /**
     * Requested number of GPU devices. Currently if more than one device is requested, it is not possible to provide values for gpuMemory, gpuPortion or migProfile [deprecated].
     * @type {number}
     * @memberof ComputeFields
     */
    'gpuDevicesRequest'?: number | null;
    /**
     * 
     * @type {GpuRequestType}
     * @memberof ComputeFields
     */
    'gpuRequestType'?: GpuRequestType | null;
    /**
     * Required if and only if gpuRequestType is portion. States the portion of the GPU to allocate for the created workload, per GPU device, between 0 and 1. The default is no allocated GPUs.
     * @type {number}
     * @memberof ComputeFields
     */
    'gpuPortionRequest'?: number | null;
    /**
     * Limitations on the portion consumed by the workload, per GPU device. The system guarantees The gpuPotionLimit must be no less than the gpuPortionRequest.
     * @type {number}
     * @memberof ComputeFields
     */
    'gpuPortionLimit'?: number | null;
    /**
     * Required if and only if gpuRequestType is memory. States the GPU memory to allocate for the created workload, per GPU device. Note that the workload will not be scheduled unless the system can guarantee this amount of GPU memory to the workload.
     * @type {string}
     * @memberof ComputeFields
     */
    'gpuMemoryRequest'?: string | null;
    /**
     * Limitation on the memory consumed by the workload, per GPU device. The system guarantees The gpuMemoryLimit must be no less than gpuMemoryRequest.
     * @type {string}
     * @memberof ComputeFields
     */
    'gpuMemoryLimit'?: string | null;
    /**
     * 
     * @type {MigProfile}
     * @memberof ComputeFields
     * @deprecated
     */
    'migProfile'?: MigProfile | null;
    /**
     * CPU units to allocate for the created workload (0.5, 1, .etc). The workload will receive at least this amount of CPU. Note that the workload will not be scheduled unless the system can guarantee this amount of CPUs to the workload.
     * @type {number}
     * @memberof ComputeFields
     */
    'cpuCoreRequest'?: number | null;
    /**
     * Limitations on the number of CPUs consumed by the workload (0.5, 1, .etc). The system guarantees that this workload will not be able to consume more than this amount of CPUs.
     * @type {number}
     * @memberof ComputeFields
     */
    'cpuCoreLimit'?: number | null;
    /**
     * The amount of CPU memory to allocate for this workload (1G, 20M, .etc). The workload will receive at least this amount of memory. Note that the workload will not be scheduled unless the system can guarantee this amount of memory to the workload
     * @type {string}
     * @memberof ComputeFields
     */
    'cpuMemoryRequest'?: string | null;
    /**
     * Limitations on the CPU memory to allocate for this workload (1G, 20M, .etc). The system guarantees that this workload will not be able to consume more than this amount of memory. The workload will receive an error when trying to allocate more memory than this limit.
     * @type {string}
     * @memberof ComputeFields
     */
    'cpuMemoryLimit'?: string | null;
    /**
     * A large /dev/shm device to mount into a container running the created workload. An shm is a shared file system mounted on RAM.
     * @type {boolean}
     * @memberof ComputeFields
     */
    'largeShmRequest'?: boolean | null;
    /**
     * Extended resources and their quantity.
     * @type {Array<ExtendedResource>}
     * @memberof ComputeFields
     */
    'extendedResources'?: Array<ExtendedResource> | null;
}
/**
 * 
 * @export
 * @interface ComputeFlatFields
 */
export interface ComputeFlatFields {
    /**
     * Requested number of GPU devices. Currently if more than one device is requested, it is not possible to provide values for gpuMemory, gpuPortion or migProfile [deprecated].
     * @type {number}
     * @memberof ComputeFlatFields
     */
    'gpuDevicesRequest'?: number | null;
    /**
     * 
     * @type {GpuRequestType}
     * @memberof ComputeFlatFields
     */
    'gpuRequestType'?: GpuRequestType | null;
    /**
     * Required if and only if gpuRequestType is portion. States the portion of the GPU to allocate for the created workload, per GPU device, between 0 and 1. The default is no allocated GPUs.
     * @type {number}
     * @memberof ComputeFlatFields
     */
    'gpuPortionRequest'?: number | null;
    /**
     * Limitations on the portion consumed by the workload, per GPU device. The system guarantees The gpuPotionLimit must be no less than the gpuPortionRequest.
     * @type {number}
     * @memberof ComputeFlatFields
     */
    'gpuPortionLimit'?: number | null;
    /**
     * Required if and only if gpuRequestType is memory. States the GPU memory to allocate for the created workload, per GPU device. Note that the workload will not be scheduled unless the system can guarantee this amount of GPU memory to the workload.
     * @type {string}
     * @memberof ComputeFlatFields
     */
    'gpuMemoryRequest'?: string | null;
    /**
     * Limitation on the memory consumed by the workload, per GPU device. The system guarantees The gpuMemoryLimit must be no less than gpuMemoryRequest.
     * @type {string}
     * @memberof ComputeFlatFields
     */
    'gpuMemoryLimit'?: string | null;
    /**
     * 
     * @type {MigProfile}
     * @memberof ComputeFlatFields
     * @deprecated
     */
    'migProfile'?: MigProfile | null;
    /**
     * CPU units to allocate for the created workload (0.5, 1, .etc). The workload will receive at least this amount of CPU. Note that the workload will not be scheduled unless the system can guarantee this amount of CPUs to the workload.
     * @type {number}
     * @memberof ComputeFlatFields
     */
    'cpuCoreRequest'?: number | null;
    /**
     * Limitations on the number of CPUs consumed by the workload (0.5, 1, .etc). The system guarantees that this workload will not be able to consume more than this amount of CPUs.
     * @type {number}
     * @memberof ComputeFlatFields
     */
    'cpuCoreLimit'?: number | null;
    /**
     * The amount of CPU memory to allocate for this workload (1G, 20M, .etc). The workload will receive at least this amount of memory. Note that the workload will not be scheduled unless the system can guarantee this amount of memory to the workload
     * @type {string}
     * @memberof ComputeFlatFields
     */
    'cpuMemoryRequest'?: string | null;
    /**
     * Limitations on the CPU memory to allocate for this workload (1G, 20M, .etc). The system guarantees that this workload will not be able to consume more than this amount of memory. The workload will receive an error when trying to allocate more memory than this limit.
     * @type {string}
     * @memberof ComputeFlatFields
     */
    'cpuMemoryLimit'?: string | null;
    /**
     * A large /dev/shm device to mount into a container running the created workload. An shm is a shared file system mounted on RAM.
     * @type {boolean}
     * @memberof ComputeFlatFields
     */
    'largeShmRequest'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ComputeItemizedFields
 */
export interface ComputeItemizedFields {
    /**
     * Extended resources and their quantity.
     * @type {Array<ExtendedResource>}
     * @memberof ComputeItemizedFields
     */
    'extendedResources'?: Array<ExtendedResource> | null;
}
/**
 * 
 * @export
 * @interface ComputeListResponse
 */
export interface ComputeListResponse {
    /**
     * 
     * @type {Array<ComputeAsset>}
     * @memberof ComputeListResponse
     */
    'entries': Array<ComputeAsset>;
}
/**
 * 
 * @export
 * @interface ComputeUpdateRequest
 */
export interface ComputeUpdateRequest {
    /**
     * 
     * @type {AssetUpdateRequest}
     * @memberof ComputeUpdateRequest
     */
    'meta': AssetUpdateRequest;
    /**
     * 
     * @type {ComputeAssetSpec}
     * @memberof ComputeUpdateRequest
     */
    'spec': ComputeAssetSpec;
}
/**
 * 
 * @export
 * @interface ConfigMap
 */
export interface ConfigMap {
    /**
     * The name of the ConfigMap resource. (mandatory)
     * @type {string}
     * @memberof ConfigMap
     */
    'configMap'?: string | null;
    /**
     * Local path within the workspace to which the ConfigMap will be mapped to. (mandatory)
     * @type {string}
     * @memberof ConfigMap
     */
    'mountPath'?: string | null;
    /**
     * Path within the volume from which the container\'s volume should be mounted.
     * @type {string}
     * @memberof ConfigMap
     */
    'subPath'?: string | null;
}
/**
 * 
 * @export
 * @interface ConfigMapAsset
 */
export interface ConfigMapAsset {
    /**
     * 
     * @type {AssetMeta}
     * @memberof ConfigMapAsset
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {ConfigMapAssetSpec}
     * @memberof ConfigMapAsset
     */
    'spec': ConfigMapAssetSpec;
    /**
     * 
     * @type {AssetUsageInfo}
     * @memberof ConfigMapAsset
     */
    'usedBy'?: AssetUsageInfo | null;
    /**
     * 
     * @type {UsageTimesInfo}
     * @memberof ConfigMapAsset
     */
    'usageTimes'?: UsageTimesInfo | null;
    /**
     * 
     * @type {ComplianceInfo}
     * @memberof ConfigMapAsset
     */
    'compliance'?: ComplianceInfo | null;
    /**
     * 
     * @type {AssetClusterStatusInfo}
     * @memberof ConfigMapAsset
     */
    'status'?: AssetClusterStatusInfo | null;
}
/**
 * 
 * @export
 * @interface ConfigMapAssetSpec
 */
export interface ConfigMapAssetSpec {
    /**
     * The name of the ConfigMap resource. (mandatory)
     * @type {string}
     * @memberof ConfigMapAssetSpec
     */
    'configMap'?: string | null;
    /**
     * Local path within the workspace to which the ConfigMap will be mapped to. (mandatory)
     * @type {string}
     * @memberof ConfigMapAssetSpec
     */
    'mountPath'?: string | null;
    /**
     * Path within the volume from which the container\'s volume should be mounted.
     * @type {string}
     * @memberof ConfigMapAssetSpec
     */
    'subPath'?: string | null;
}
/**
 * 
 * @export
 * @interface ConfigMapCreationRequest
 */
export interface ConfigMapCreationRequest {
    /**
     * 
     * @type {AssetCreationRequest}
     * @memberof ConfigMapCreationRequest
     */
    'meta': AssetCreationRequest;
    /**
     * 
     * @type {ConfigMapAssetSpec}
     * @memberof ConfigMapCreationRequest
     */
    'spec': ConfigMapAssetSpec;
}
/**
 * 
 * @export
 * @interface ConfigMapInstance
 */
export interface ConfigMapInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof ConfigMapInstance
     */
    'name'?: string | null;
    /**
     * The name of the ConfigMap resource. (mandatory)
     * @type {string}
     * @memberof ConfigMapInstance
     */
    'configMap'?: string | null;
    /**
     * Local path within the workspace to which the ConfigMap will be mapped to. (mandatory)
     * @type {string}
     * @memberof ConfigMapInstance
     */
    'mountPath'?: string | null;
    /**
     * Path within the volume from which the container\'s volume should be mounted.
     * @type {string}
     * @memberof ConfigMapInstance
     */
    'subPath'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof ConfigMapInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ConfigMapListResponse
 */
export interface ConfigMapListResponse {
    /**
     * 
     * @type {Array<ConfigMapAsset>}
     * @memberof ConfigMapListResponse
     */
    'entries': Array<ConfigMapAsset>;
}
/**
 * 
 * @export
 * @interface ConfigMapRules
 */
export interface ConfigMapRules {
    /**
     * 
     * @type {StringRules}
     * @memberof ConfigMapRules
     */
    'configMap'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ConfigMapRules
     */
    'mountPath'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ConfigMapRules
     */
    'subPath'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface ConfigMapUpdateRequest
 */
export interface ConfigMapUpdateRequest {
    /**
     * 
     * @type {AssetUpdateRequest}
     * @memberof ConfigMapUpdateRequest
     */
    'meta': AssetUpdateRequest;
}
/**
 * 
 * @export
 * @interface ConfigMapsRules
 */
export interface ConfigMapsRules {
    /**
     * 
     * @type {ConfigMapRules}
     * @memberof ConfigMapsRules
     */
    'attributes'?: ConfigMapRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof ConfigMapsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface Connection
 */
export interface Connection {
    /**
     * A unique name of this connection. This name correlates between the connection information specified at the environment asset, to the information about the connection as specified in SpecificEnv for a specific workspace.
     * @type {string}
     * @memberof Connection
     */
    'name': string;
    /**
     * Internal tools (isExternal=false) are tools that run as part of the container. External tools (isExternal=true) run outside the container, typically in the cloud.
     * @type {boolean}
     * @memberof Connection
     */
    'isExternal'?: boolean;
    /**
     * 
     * @type {InternalToolInfo}
     * @memberof Connection
     */
    'internalToolInfo'?: InternalToolInfo | null;
    /**
     * 
     * @type {ExternalToolInfo}
     * @memberof Connection
     */
    'externalToolInfo'?: ExternalToolInfo | null;
}
/**
 * 
 * @export
 * @interface ConnectivityFields
 */
export interface ConnectivityFields {
    /**
     * Set of container ports that the workload exposes.
     * @type {Array<Port>}
     * @memberof ConnectivityFields
     */
    'ports'?: Array<Port> | null;
    /**
     * Set of container ports that the workload exposes via URLs.
     * @type {Array<ExposedUrl>}
     * @memberof ConnectivityFields
     */
    'exposedUrls'?: Array<ExposedUrl> | null;
    /**
     * Set of URLs that are related to the workload.
     * @type {Array<RelatedUrl>}
     * @memberof ConnectivityFields
     */
    'relatedUrls'?: Array<RelatedUrl> | null;
}
/**
 * Container non Inference overrideable fields. It adds properties which are not allowed for Inference containers
 * @export
 * @interface ContainerNonInferenceNonOverridable
 */
export interface ContainerNonInferenceNonOverridable {
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof ContainerNonInferenceNonOverridable
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof ContainerNonInferenceNonOverridable
     */
    'stdin'?: boolean | null;
}
/**
 * Container non overrideable fields. In the context of assets,these are environment asset fields that cannot be overriden in the submit workload request.
 * @export
 * @interface ContainerNonOverridable
 */
export interface ContainerNonOverridable {
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof ContainerNonOverridable
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof ContainerNonOverridable
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof ContainerNonOverridable
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof ContainerNonOverridable
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof ContainerNonOverridable
     */
    'probes'?: Probes | null;
}
/**
 * Container overrideable fields. In the context of assets,these are environment asset fields that can be overriden in the submit workload request.
 * @export
 * @interface ContainerOverridable
 */
export interface ContainerOverridable {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof ContainerOverridable
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof ContainerOverridable
     */
    'args'?: string | null;
}
/**
 * Container related fields. When used in assets context, those are environment asset fields that can be override in the submit workload request.
 * @export
 * @interface ContainerOverridableRules
 */
export interface ContainerOverridableRules {
    /**
     * 
     * @type {StringRules}
     * @memberof ContainerOverridableRules
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ContainerOverridableRules
     */
    'args'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface CredentialAsset
 */
export interface CredentialAsset {
    /**
     * ID of credentials asset (mandatory)
     * @type {string}
     * @memberof CredentialAsset
     */
    'credentialAssetId'?: string | null;
}
/**
 * The kind of credential used.
 * @export
 * @enum {string}
 */

export const CredentialKind = {
    Password: 'password'
} as const;

export type CredentialKind = typeof CredentialKind[keyof typeof CredentialKind];


/**
 * 
 * @export
 * @interface CredentialUpdatableFields
 */
export interface CredentialUpdatableFields {
    /**
     * The description of the asset.
     * @type {string}
     * @memberof CredentialUpdatableFields
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface CredentialUpdateRequest
 */
export interface CredentialUpdateRequest {
    /**
     * The description of the asset.
     * @type {string}
     * @memberof CredentialUpdateRequest
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface CredentialsListResponse
 */
export interface CredentialsListResponse {
    /**
     * 
     * @type {Array<CredentialsListResponseEntry>}
     * @memberof CredentialsListResponse
     */
    'entries': Array<CredentialsListResponseEntry>;
}
/**
 * 
 * @export
 * @interface CredentialsListResponseAssetSpec
 */
export interface CredentialsListResponseAssetSpec {
    /**
     * 
     * @type {CredentialsListResponseAssetSpecAccessKey}
     * @memberof CredentialsListResponseAssetSpec
     */
    'accessKey'?: CredentialsListResponseAssetSpecAccessKey | null;
    /**
     * 
     * @type {CredentialsListResponseAssetSpecPassword}
     * @memberof CredentialsListResponseAssetSpec
     */
    'password'?: CredentialsListResponseAssetSpecPassword | null;
    /**
     * 
     * @type {CredentialsListResponseAssetSpecDockerRegistry}
     * @memberof CredentialsListResponseAssetSpec
     */
    'dockerRegistry'?: CredentialsListResponseAssetSpecDockerRegistry | null;
    /**
     * 
     * @type {CredentialsListResponseAssetSpecGenericSecret}
     * @memberof CredentialsListResponseAssetSpec
     */
    'genericSecret'?: CredentialsListResponseAssetSpecGenericSecret | null;
}
/**
 * 
 * @export
 * @interface CredentialsListResponseAssetSpecAccessKey
 */
export interface CredentialsListResponseAssetSpecAccessKey {
    /**
     * optional name of existing secret in the cluster from which the access key id and secret should be taken. If omitted, you will have to provide those credentials in the accessKeyId and secretAccessKey fields. The provided credentials are encrypted into the control plane database and cloned to a kubernetes secret in the cluster.
     * @type {string}
     * @memberof CredentialsListResponseAssetSpecAccessKey
     */
    'existingSecretName'?: string | null;
    /**
     * The access key id of the S3-compatible bucket, required only when not using existing secret.
     * @type {string}
     * @memberof CredentialsListResponseAssetSpecAccessKey
     */
    'accessKeyId'?: string | null;
    /**
     * The secret access key of the S3-compatible bucket, required only when not using existing secret.
     * @type {string}
     * @memberof CredentialsListResponseAssetSpecAccessKey
     */
    'secretAccessKey'?: string | null;
    /**
     * id of the encryption key which has been used to encrypt an asset\'s data.
     * @type {number}
     * @memberof CredentialsListResponseAssetSpecAccessKey
     */
    'keyId': number;
}
/**
 * 
 * @export
 * @interface CredentialsListResponseAssetSpecDockerRegistry
 */
export interface CredentialsListResponseAssetSpecDockerRegistry {
    /**
     * optional name of existing secret in the cluster from which the docker registry details should be taken. If omitted, you will have to provide those credentials and url in relevant fields. The provided credentials are encrypted into the control plane database and cloned to a kubernetes secret in the cluster, along with the url.
     * @type {string}
     * @memberof CredentialsListResponseAssetSpecDockerRegistry
     */
    'existingSecretName'?: string | null;
    /**
     * The name of the user, required only when not using existing secret.
     * @type {string}
     * @memberof CredentialsListResponseAssetSpecDockerRegistry
     */
    'user'?: string | null;
    /**
     * The password, required only when not using existing secret.
     * @type {string}
     * @memberof CredentialsListResponseAssetSpecDockerRegistry
     */
    'password'?: string | null;
    /**
     * The url, required only when not using existing secret.
     * @type {string}
     * @memberof CredentialsListResponseAssetSpecDockerRegistry
     */
    'url'?: string | null;
    /**
     * id of the encryption key which has been used to encrypt an asset\'s data.
     * @type {number}
     * @memberof CredentialsListResponseAssetSpecDockerRegistry
     */
    'keyId': number;
}
/**
 * 
 * @export
 * @interface CredentialsListResponseAssetSpecGenericSecret
 */
export interface CredentialsListResponseAssetSpecGenericSecret {
    /**
     * name of existing secret in the cluster from which the general key-value values should be taken.
     * @type {string}
     * @memberof CredentialsListResponseAssetSpecGenericSecret
     */
    'existingSecretName'?: string | null;
    /**
     * Set of key-value pairs to store in the new credential.
     * @type {Array<KeyValuePair>}
     * @memberof CredentialsListResponseAssetSpecGenericSecret
     */
    'keyValuePairs'?: Array<KeyValuePair> | null;
    /**
     * id of the encryption key which has been used to encrypt an asset\'s data.
     * @type {number}
     * @memberof CredentialsListResponseAssetSpecGenericSecret
     */
    'keyId': number;
}
/**
 * 
 * @export
 * @interface CredentialsListResponseAssetSpecPassword
 */
export interface CredentialsListResponseAssetSpecPassword {
    /**
     * optional name of existing secret in the cluster from which the user name and password should be taken. If omitted, you will have to provide those credentials in the user and password fields. The provided credentials are encrypted into the control plane database and cloned to a kubernetes secret in the cluster.
     * @type {string}
     * @memberof CredentialsListResponseAssetSpecPassword
     */
    'existingSecretName'?: string | null;
    /**
     * The name of the user, required only when not using existing secret.
     * @type {string}
     * @memberof CredentialsListResponseAssetSpecPassword
     */
    'user'?: string | null;
    /**
     * The password, required only when not using existing secret.
     * @type {string}
     * @memberof CredentialsListResponseAssetSpecPassword
     */
    'password'?: string | null;
    /**
     * id of the encryption key which has been used to encrypt an asset\'s data.
     * @type {number}
     * @memberof CredentialsListResponseAssetSpecPassword
     */
    'keyId': number;
}
/**
 * 
 * @export
 * @interface CredentialsListResponseEntry
 */
export interface CredentialsListResponseEntry {
    /**
     * 
     * @type {AssetMeta}
     * @memberof CredentialsListResponseEntry
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {CredentialsListResponseAssetSpec}
     * @memberof CredentialsListResponseEntry
     */
    'spec': CredentialsListResponseAssetSpec;
    /**
     * 
     * @type {AssetUsageInfo}
     * @memberof CredentialsListResponseEntry
     */
    'usedBy'?: AssetUsageInfo | null;
    /**
     * 
     * @type {AssetClusterStatusInfo}
     * @memberof CredentialsListResponseEntry
     */
    'status'?: AssetClusterStatusInfo | null;
    /**
     * 
     * @type {ClusterInfo}
     * @memberof CredentialsListResponseEntry
     */
    'clusterInfo'?: ClusterInfo | null;
}
/**
 * 
 * @export
 * @interface CredentialsUpdate
 */
export interface CredentialsUpdate {
    /**
     * 
     * @type {AssetMetaForSync}
     * @memberof CredentialsUpdate
     */
    'meta': AssetMetaForSync;
    /**
     * the value of an update counter of a data in the system.
     * @type {number}
     * @memberof CredentialsUpdate
     */
    'updateCount': number;
    /**
     * the asset has been deleted
     * @type {boolean}
     * @memberof CredentialsUpdate
     */
    'isDeleted'?: boolean | null;
    /**
     * 
     * @type {CredentialsUpdateSpec}
     * @memberof CredentialsUpdate
     */
    'spec'?: CredentialsUpdateSpec;
}
/**
 * 
 * @export
 * @interface CredentialsUpdateSpec
 */
export interface CredentialsUpdateSpec {
    /**
     * 
     * @type {CredentialsUpdateSpecAccessKey}
     * @memberof CredentialsUpdateSpec
     */
    'accessKey'?: CredentialsUpdateSpecAccessKey | null;
    /**
     * 
     * @type {CredentialsUpdateSpecPassword}
     * @memberof CredentialsUpdateSpec
     */
    'password'?: CredentialsUpdateSpecPassword | null;
    /**
     * 
     * @type {CredentialsUpdateSpecGenericSecret}
     * @memberof CredentialsUpdateSpec
     */
    'genericSecret'?: CredentialsUpdateSpecGenericSecret | null;
    /**
     * 
     * @type {CredentialsUpdateSpecDockerRegistry}
     * @memberof CredentialsUpdateSpec
     */
    'dockerRegistry'?: CredentialsUpdateSpecDockerRegistry | null;
}
/**
 * 
 * @export
 * @interface CredentialsUpdateSpecAccessKey
 */
export interface CredentialsUpdateSpecAccessKey {
    /**
     * optional name of existing secret in the cluster from which the access key id and secret should be taken. If omitted, you will have to provide those credentials in the accessKeyId and secretAccessKey fields. The provided credentials are encrypted into the control plane database and cloned to a kubernetes secret in the cluster.
     * @type {string}
     * @memberof CredentialsUpdateSpecAccessKey
     */
    'existingSecretName'?: string | null;
    /**
     * The access key id of the S3-compatible bucket, required only when not using existing secret.
     * @type {string}
     * @memberof CredentialsUpdateSpecAccessKey
     */
    'accessKeyId'?: string | null;
    /**
     * The secret access key of the S3-compatible bucket, required only when not using existing secret.
     * @type {string}
     * @memberof CredentialsUpdateSpecAccessKey
     */
    'secretAccessKey'?: string | null;
}
/**
 * 
 * @export
 * @interface CredentialsUpdateSpecDockerRegistry
 */
export interface CredentialsUpdateSpecDockerRegistry {
    /**
     * optional name of existing secret in the cluster from which the docker registry details should be taken. If omitted, you will have to provide those credentials and url in relevant fields. The provided credentials are encrypted into the control plane database and cloned to a kubernetes secret in the cluster, along with the url.
     * @type {string}
     * @memberof CredentialsUpdateSpecDockerRegistry
     */
    'existingSecretName'?: string | null;
    /**
     * The name of the user, required only when not using existing secret.
     * @type {string}
     * @memberof CredentialsUpdateSpecDockerRegistry
     */
    'user'?: string | null;
    /**
     * The password, required only when not using existing secret.
     * @type {string}
     * @memberof CredentialsUpdateSpecDockerRegistry
     */
    'password'?: string | null;
    /**
     * The url, required only when not using existing secret.
     * @type {string}
     * @memberof CredentialsUpdateSpecDockerRegistry
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface CredentialsUpdateSpecGenericSecret
 */
export interface CredentialsUpdateSpecGenericSecret {
    /**
     * name of existing secret in the cluster from which the general key-value values should be taken.
     * @type {string}
     * @memberof CredentialsUpdateSpecGenericSecret
     */
    'existingSecretName'?: string | null;
    /**
     * Set of key-value pairs to store in the new credential.
     * @type {Array<KeyValuePair>}
     * @memberof CredentialsUpdateSpecGenericSecret
     */
    'keyValuePairs'?: Array<KeyValuePair> | null;
}
/**
 * 
 * @export
 * @interface CredentialsUpdateSpecPassword
 */
export interface CredentialsUpdateSpecPassword {
    /**
     * optional name of existing secret in the cluster from which the user name and password should be taken. If omitted, you will have to provide those credentials in the user and password fields. The provided credentials are encrypted into the control plane database and cloned to a kubernetes secret in the cluster.
     * @type {string}
     * @memberof CredentialsUpdateSpecPassword
     */
    'existingSecretName'?: string | null;
    /**
     * The name of the user, required only when not using existing secret.
     * @type {string}
     * @memberof CredentialsUpdateSpecPassword
     */
    'user'?: string | null;
    /**
     * The password, required only when not using existing secret.
     * @type {string}
     * @memberof CredentialsUpdateSpecPassword
     */
    'password'?: string | null;
}
/**
 * 
 * @export
 * @interface CredentialsUpdatesResp
 */
export interface CredentialsUpdatesResp {
    /**
     * 
     * @type {RequestInfo}
     * @memberof CredentialsUpdatesResp
     */
    'requestInfo'?: RequestInfo;
    /**
     * 
     * @type {ResponseInfo}
     * @memberof CredentialsUpdatesResp
     */
    'responseInfo'?: ResponseInfo;
    /**
     * 
     * @type {SystemInfo}
     * @memberof CredentialsUpdatesResp
     */
    'systemInfo'?: SystemInfo;
    /**
     * 
     * @type {Array<CredentialsUpdate>}
     * @memberof CredentialsUpdatesResp
     */
    'assets'?: Array<CredentialsUpdate>;
}
/**
 * specific fields to override in the data source.
 * @export
 * @interface DataSourceOverrides
 */
export interface DataSourceOverrides {
    /**
     * 
     * @type {string}
     * @memberof DataSourceOverrides
     */
    'containerPath'?: string | null;
}
/**
 * 
 * @export
 * @interface DataVolume
 */
export interface DataVolume {
    /**
     * The unique identifier of the data volume. (mandatory)
     * @type {string}
     * @memberof DataVolume
     */
    'id'?: string | null;
    /**
     * The path where the data volume will be mounted. (mandatory)
     * @type {string}
     * @memberof DataVolume
     */
    'mountPath'?: string | null;
}
/**
 * 
 * @export
 * @interface DataVolumeAssetSpec
 */
export interface DataVolumeAssetSpec {
    /**
     * The unique identifier of the data volume. (mandatory)
     * @type {string}
     * @memberof DataVolumeAssetSpec
     */
    'id'?: string | null;
    /**
     * The name of the PVC that the datavolume is based on
     * @type {string}
     * @memberof DataVolumeAssetSpec
     */
    'originPvcName'?: string | null;
}
/**
 * 
 * @export
 * @interface DataVolumeInstance
 */
export interface DataVolumeInstance {
    /**
     * The unique identifier of the data volume. (mandatory)
     * @type {string}
     * @memberof DataVolumeInstance
     */
    'id'?: string | null;
    /**
     * The path where the data volume will be mounted. (mandatory)
     * @type {string}
     * @memberof DataVolumeInstance
     */
    'mountPath'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof DataVolumeInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DataVolumeRules
 */
export interface DataVolumeRules {
    /**
     * 
     * @type {StringRules}
     * @memberof DataVolumeRules
     */
    'id'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof DataVolumeRules
     */
    'mountPath'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface DataVolumesRules
 */
export interface DataVolumesRules {
    /**
     * 
     * @type {DataVolumeRules}
     * @memberof DataVolumesRules
     */
    'attributes'?: DataVolumeRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof DataVolumesRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface DatasourceDefaults
 */
export interface DatasourceDefaults {
    /**
     * 
     * @type {HostPath}
     * @memberof DatasourceDefaults
     */
    'hostPath'?: HostPath | null;
    /**
     * 
     * @type {Nfs}
     * @memberof DatasourceDefaults
     */
    'nfs'?: Nfs | null;
    /**
     * 
     * @type {Pvc}
     * @memberof DatasourceDefaults
     */
    'pvc'?: Pvc;
    /**
     * 
     * @type {GitCommon}
     * @memberof DatasourceDefaults
     */
    'git'?: GitCommon | null;
    /**
     * 
     * @type {S3Common}
     * @memberof DatasourceDefaults
     */
    's3'?: S3Common | null;
    /**
     * 
     * @type {DataVolume}
     * @memberof DatasourceDefaults
     */
    'dataVolume'?: DataVolume | null;
    /**
     * 
     * @type {ConfigMap}
     * @memberof DatasourceDefaults
     */
    'configMapVolume'?: ConfigMap | null;
    /**
     * 
     * @type {Secret}
     * @memberof DatasourceDefaults
     */
    'secretVolume'?: Secret;
}
/**
 * 
 * @export
 * @interface DatasourceListResponse
 */
export interface DatasourceListResponse {
    /**
     * 
     * @type {Array<DatasourceListResponseEntry>}
     * @memberof DatasourceListResponse
     */
    'entries': Array<DatasourceListResponseEntry>;
}
/**
 * 
 * @export
 * @interface DatasourceListResponseAssetSpec
 */
export interface DatasourceListResponseAssetSpec {
    /**
     * 
     * @type {DatasourceListResponseAssetSpecHostPath}
     * @memberof DatasourceListResponseAssetSpec
     */
    'hostPath'?: DatasourceListResponseAssetSpecHostPath | null;
    /**
     * 
     * @type {DatasourceListResponseAssetSpecNfs}
     * @memberof DatasourceListResponseAssetSpec
     */
    'nfs'?: DatasourceListResponseAssetSpecNfs | null;
    /**
     * 
     * @type {DatasourceListResponseAssetSpecPvc}
     * @memberof DatasourceListResponseAssetSpec
     */
    'pvc'?: DatasourceListResponseAssetSpecPvc | null;
    /**
     * 
     * @type {DatasourceListResponseAssetSpecGit}
     * @memberof DatasourceListResponseAssetSpec
     */
    'git'?: DatasourceListResponseAssetSpecGit | null;
    /**
     * 
     * @type {DatasourceListResponseAssetSpecS3}
     * @memberof DatasourceListResponseAssetSpec
     */
    's3'?: DatasourceListResponseAssetSpecS3 | null;
    /**
     * 
     * @type {DatasourceListResponseAssetSpecConfigMap}
     * @memberof DatasourceListResponseAssetSpec
     */
    'config_map'?: DatasourceListResponseAssetSpecConfigMap | null;
    /**
     * 
     * @type {DatasourceListResponseAssetSpecSecret}
     * @memberof DatasourceListResponseAssetSpec
     */
    'secret'?: DatasourceListResponseAssetSpecSecret | null;
    /**
     * 
     * @type {DatasourceListResponseAssetSpecDataVolume}
     * @memberof DatasourceListResponseAssetSpec
     */
    'dataVolume'?: DatasourceListResponseAssetSpecDataVolume | null;
}
/**
 * 
 * @export
 * @interface DatasourceListResponseAssetSpecConfigMap
 */
export interface DatasourceListResponseAssetSpecConfigMap {
    /**
     * The name of the ConfigMap resource. (mandatory)
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecConfigMap
     */
    'configMap'?: string | null;
    /**
     * Local path within the workspace to which the ConfigMap will be mapped to. (mandatory)
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecConfigMap
     */
    'mountPath'?: string | null;
    /**
     * Path within the volume from which the container\'s volume should be mounted.
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecConfigMap
     */
    'subPath'?: string | null;
}
/**
 * 
 * @export
 * @interface DatasourceListResponseAssetSpecDataVolume
 */
export interface DatasourceListResponseAssetSpecDataVolume {
    /**
     * The unique identifier of the data volume. (mandatory)
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecDataVolume
     */
    'id'?: string | null;
    /**
     * The name of the PVC that the datavolume is based on
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecDataVolume
     */
    'originPvcName'?: string | null;
}
/**
 * 
 * @export
 * @interface DatasourceListResponseAssetSpecGit
 */
export interface DatasourceListResponseAssetSpecGit {
    /**
     * URL to a remote Git repository. The content of this repository will be mapped to the container running the workload. (mandatory)
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecGit
     */
    'repository'?: string | null;
    /**
     * Specific branch to synchronize the repository from.
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecGit
     */
    'branch'?: string | null;
    /**
     * Specific revision to synchronize the repository from.
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecGit
     */
    'revision'?: string | null;
    /**
     * Local path within the workspace to which the Git repository will be mapped (mandatory).
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecGit
     */
    'path'?: string | null;
    /**
     * ID of credentials asset of type password. Needed for non public repository which requires authentication.
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecGit
     */
    'passwordAssetId'?: string | null;
}
/**
 * 
 * @export
 * @interface DatasourceListResponseAssetSpecHostPath
 */
export interface DatasourceListResponseAssetSpecHostPath {
    /**
     * Local path within the controller to which the host volume will be mapped. (mandatory)
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecHostPath
     */
    'path'?: string | null;
    /**
     * Force the volume to be mounted with read-only permissions. Defaults to false.
     * @type {boolean}
     * @memberof DatasourceListResponseAssetSpecHostPath
     */
    'readOnly'?: boolean | null;
    /**
     * The path that the host volume will be mounted to when in use. (mandatory)
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecHostPath
     */
    'mountPath'?: string | null;
    /**
     * 
     * @type {HostPathMountPropagation}
     * @memberof DatasourceListResponseAssetSpecHostPath
     */
    'mountPropagation'?: HostPathMountPropagation | null;
}
/**
 * 
 * @export
 * @interface DatasourceListResponseAssetSpecNfs
 */
export interface DatasourceListResponseAssetSpecNfs {
    /**
     * Path that is exported by the NFS server (mandatory). For more information, see [NFS](https://kubernetes.io/docs/concepts/storage/volumes#nfs).
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecNfs
     */
    'path'?: string | null;
    /**
     * Force the NFS export to be mounted with read-only permissions.
     * @type {boolean}
     * @memberof DatasourceListResponseAssetSpecNfs
     */
    'readOnly'?: boolean | null;
    /**
     * The hostname or IP address of the NFS server. (mandatory)
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecNfs
     */
    'server'?: string | null;
    /**
     * The path that the NFS volume will be mounted to when in use. (mandatory)
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecNfs
     */
    'mountPath'?: string | null;
}
/**
 * 
 * @export
 * @interface DatasourceListResponseAssetSpecPvc
 */
export interface DatasourceListResponseAssetSpecPvc {
    /**
     * Local path within the workspace to which the PVC bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecPvc
     */
    'path'?: string | null;
    /**
     * 
     * @type {ClaimInfo}
     * @memberof DatasourceListResponseAssetSpecPvc
     */
    'claimInfo'?: ClaimInfo | null;
    /**
     * Verify existing PVC. PVC is assumed to exist when set to `true`. If set to `false`, the PVC will be created, if it does not exist.
     * @type {boolean}
     * @memberof DatasourceListResponseAssetSpecPvc
     */
    'existingPvc'?: boolean | null;
    /**
     * Name for the PVC. Allow referencing it across workloads. If not provided, a name based on the workload name and scope will be auto-generated.
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecPvc
     */
    'claimName'?: string | null;
    /**
     * Permit only read access to PVC.
     * @type {boolean}
     * @memberof DatasourceListResponseAssetSpecPvc
     */
    'readOnly'?: boolean | null;
    /**
     * Use `true` to set PVC to ephemeral. If set to `true`, the PVC will be deleted when the workload is stopped. Not supported for inference workloads.
     * @type {boolean}
     * @memberof DatasourceListResponseAssetSpecPvc
     */
    'ephemeral'?: boolean | null;
    /**
     * use `true` to share the PVC data to all projects under the selected scope.
     * @type {boolean}
     * @memberof DatasourceListResponseAssetSpecPvc
     */
    'dataSharing'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DatasourceListResponseAssetSpecS3
 */
export interface DatasourceListResponseAssetSpecS3 {
    /**
     * The name of the bucket. (mandatory)
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecS3
     */
    'bucket'?: string | null;
    /**
     * Local path within the workspace to which the S3 bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecS3
     */
    'path'?: string | null;
    /**
     * The url of the S3 service provider. The default is the URL of the Amazon AWS S3 service.
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecS3
     */
    'url'?: string | null;
    /**
     * ID of credentials asset of type access-key, for private S3 buckets.
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecS3
     */
    'accessKeyAssetId'?: string | null;
}
/**
 * 
 * @export
 * @interface DatasourceListResponseAssetSpecSecret
 */
export interface DatasourceListResponseAssetSpecSecret {
    /**
     * ID of credentials asset (mandatory)
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecSecret
     */
    'credentialAssetId'?: string | null;
    /**
     * Local path within the workspace to which the Secret will be mapped to (mandatory)
     * @type {string}
     * @memberof DatasourceListResponseAssetSpecSecret
     */
    'mountPath'?: string | null;
}
/**
 * 
 * @export
 * @interface DatasourceListResponseEntry
 */
export interface DatasourceListResponseEntry {
    /**
     * 
     * @type {AssetMeta}
     * @memberof DatasourceListResponseEntry
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {DatasourceListResponseAssetSpec}
     * @memberof DatasourceListResponseEntry
     */
    'spec': DatasourceListResponseAssetSpec;
    /**
     * 
     * @type {AssetUsageInfo}
     * @memberof DatasourceListResponseEntry
     */
    'usedBy'?: AssetUsageInfo | null;
    /**
     * 
     * @type {UsageTimesInfo}
     * @memberof DatasourceListResponseEntry
     */
    'usageTimes'?: UsageTimesInfo | null;
    /**
     * 
     * @type {ComplianceInfo}
     * @memberof DatasourceListResponseEntry
     */
    'compliance'?: ComplianceInfo | null;
    /**
     * 
     * @type {AssetClusterStatusInfo}
     * @memberof DatasourceListResponseEntry
     */
    'status'?: AssetClusterStatusInfo | null;
    /**
     * 
     * @type {ClusterInfo}
     * @memberof DatasourceListResponseEntry
     */
    'clusterInfo'?: ClusterInfo | null;
}
/**
 * Reference information about a datasource asset.
 * @export
 * @interface DatasourceRef
 */
export interface DatasourceRef {
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof DatasourceRef
     */
    'id': string;
    /**
     * The name of the asset.
     * @type {string}
     * @memberof DatasourceRef
     */
    'name': string;
    /**
     * 
     * @type {AssetKind}
     * @memberof DatasourceRef
     */
    'kind': AssetKind;
    /**
     * 
     * @type {DataSourceOverrides}
     * @memberof DatasourceRef
     */
    'overrides'?: DataSourceOverrides | null;
}
/**
 * 
 * @export
 * @interface DatasourceUpdate
 */
export interface DatasourceUpdate {
    /**
     * 
     * @type {AssetMetaForSync}
     * @memberof DatasourceUpdate
     */
    'meta': AssetMetaForSync;
    /**
     * the value of an update counter of a data in the system.
     * @type {number}
     * @memberof DatasourceUpdate
     */
    'updateCount': number;
    /**
     * the asset has been deleted
     * @type {boolean}
     * @memberof DatasourceUpdate
     */
    'isDeleted'?: boolean | null;
    /**
     * 
     * @type {DatasourceUpdateSpec}
     * @memberof DatasourceUpdate
     */
    'spec'?: DatasourceUpdateSpec;
}
/**
 * 
 * @export
 * @interface DatasourceUpdateSpec
 */
export interface DatasourceUpdateSpec {
    /**
     * 
     * @type {DatasourceUpdateSpecPvc}
     * @memberof DatasourceUpdateSpec
     */
    'pvc'?: DatasourceUpdateSpecPvc | null;
}
/**
 * 
 * @export
 * @interface DatasourceUpdateSpecPvc
 */
export interface DatasourceUpdateSpecPvc {
    /**
     * Local path within the workspace to which the PVC bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof DatasourceUpdateSpecPvc
     */
    'path'?: string | null;
    /**
     * 
     * @type {ClaimInfo}
     * @memberof DatasourceUpdateSpecPvc
     */
    'claimInfo'?: ClaimInfo | null;
    /**
     * Verify existing PVC. PVC is assumed to exist when set to `true`. If set to `false`, the PVC will be created, if it does not exist.
     * @type {boolean}
     * @memberof DatasourceUpdateSpecPvc
     */
    'existingPvc'?: boolean | null;
    /**
     * Name for the PVC. Allow referencing it across workloads. If not provided, a name based on the workload name and scope will be auto-generated.
     * @type {string}
     * @memberof DatasourceUpdateSpecPvc
     */
    'claimName'?: string | null;
    /**
     * Permit only read access to PVC.
     * @type {boolean}
     * @memberof DatasourceUpdateSpecPvc
     */
    'readOnly'?: boolean | null;
    /**
     * Use `true` to set PVC to ephemeral. If set to `true`, the PVC will be deleted when the workload is stopped. Not supported for inference workloads.
     * @type {boolean}
     * @memberof DatasourceUpdateSpecPvc
     */
    'ephemeral'?: boolean | null;
    /**
     * use `true` to share the PVC data to all projects under the selected scope.
     * @type {boolean}
     * @memberof DatasourceUpdateSpecPvc
     */
    'dataSharing'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DatasourceUpdatesResp
 */
export interface DatasourceUpdatesResp {
    /**
     * 
     * @type {RequestInfo}
     * @memberof DatasourceUpdatesResp
     */
    'requestInfo'?: RequestInfo;
    /**
     * 
     * @type {ResponseInfo}
     * @memberof DatasourceUpdatesResp
     */
    'responseInfo'?: ResponseInfo;
    /**
     * 
     * @type {SystemInfo}
     * @memberof DatasourceUpdatesResp
     */
    'systemInfo'?: SystemInfo;
    /**
     * 
     * @type {Array<DatasourceUpdate>}
     * @memberof DatasourceUpdatesResp
     */
    'assets'?: Array<DatasourceUpdate>;
}
/**
 * 
 * @export
 * @interface DefaultFromRule
 */
export interface DefaultFromRule {
    /**
     * The default of this field is taken from another field, with optional factor. The specified field must belong to the same workload section (compute, security, etc). For itemized field, the value of the field will be taken from the same instance.
     * @type {string}
     * @memberof DefaultFromRule
     */
    'field'?: string | null;
    /**
     * Multiple the value of the fromField by this factor to get the value for this field For example, if factor is 2 and defaultFrom field has value of 8, the calculated default will be determined to be 16.
     * @type {number}
     * @memberof DefaultFromRule
     */
    'factor'?: number | null;
}
/**
 * 
 * @export
 * @interface DisplayedJob
 */
export interface DisplayedJob {
    /**
     * Unique identifier of the job.
     * @type {string}
     * @memberof DisplayedJob
     */
    'JobId'?: string;
    /**
     * Unique identifier of the pod group.
     * @type {string}
     * @memberof DisplayedJob
     */
    'podGroupId'?: string;
    /**
     * The name of the job.
     * @type {string}
     * @memberof DisplayedJob
     */
    'jobName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisplayedJob
     */
    'jobType'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof DisplayedJob
     */
    'clusterId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisplayedJob
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisplayedJob
     */
    'statusTooltip'?: string;
    /**
     * The name of the image executed by the pod.
     * @type {string}
     * @memberof DisplayedJob
     */
    'imageName'?: string;
    /**
     * The owner of the job.
     * @type {string}
     * @memberof DisplayedJob
     */
    'user'?: string;
    /**
     * The project that the pod group belongs to.
     * @type {string}
     * @memberof DisplayedJob
     */
    'project'?: string;
    /**
     * Unique identifier of the node.
     * @type {string}
     * @memberof DisplayedJob
     */
    'nodeId'?: string;
    /**
     * Creation time of the job.
     * @type {string}
     * @memberof DisplayedJob
     */
    'creationTime'?: string;
    /**
     * Completion time of the job.
     * @type {string}
     * @memberof DisplayedJob
     */
    'completionTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisplayedJob
     */
    'totalRuntime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisplayedJob
     */
    'totalWaitTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'lastStatusUpdateTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'msSinceLastStatusUpdate'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'pending'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'running'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'parallelism'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'completions'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'failed'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'succeeded'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'currentAllocatedGPUs'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'currentAllocatedGPUsMemory'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'currentRequestedGPUs'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'totalRequestedGPUs'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'requestedGPUsPerPodGroup'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'requestedGPUsMemoryPerPodGroup'?: number;
    /**
     * 
     * @type {string}
     * @memberof DisplayedJob
     */
    'parentWorkloadName'?: string;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'totalRequestedMemory'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'totalRequestedCPU'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'totalLimitCPU'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayedJob
     */
    'totalLimitMemory'?: number;
    /**
     * Specifies the kind of k8s resource that owns the pod group.
     * @type {number}
     * @memberof DisplayedJob
     */
    'workloadKind'?: number;
    /**
     * 
     * @type {string}
     * @memberof DisplayedJob
     */
    'cliCommand'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisplayedJob
     * @deprecated
     */
    'requestedMigDevices'?: string;
    /**
     * 
     * @type {object}
     * @memberof DisplayedJob
     */
    'dynamicData'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof DisplayedJob
     */
    'existsInCluster'?: boolean;
    /**
     * If true, it indicates that the pod group runs jupyter notebook.
     * @type {boolean}
     * @memberof DisplayedJob
     */
    'isJupyter'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DisplayedJob
     */
    'jobUrl'?: string;
    /**
     * The node pool of the job.
     * @type {string}
     * @memberof DisplayedJob
     */
    'nodePool'?: string;
}
/**
 * Parameters which apply to the master in a distributed training. 
 * @export
 * @interface DistMaster
 */
export interface DistMaster {
    /**
     * 
     * @type {AssetsIds}
     * @memberof DistMaster
     */
    'assets'?: AssetsIds;
    /**
     * 
     * @type {SpecificRunParams}
     * @memberof DistMaster
     */
    'specificEnv'?: SpecificRunParams | null;
}
/**
 * Parameters which apply to distributed training. 
 * @export
 * @interface Distributed
 */
export interface Distributed {
    /**
     * 
     * @type {number}
     * @memberof Distributed
     */
    'numWorkers'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Distributed
     */
    'noMaster'?: boolean | null;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof Distributed
     */
    'distFramework'?: DistributedFramework | null;
    /**
     * 
     * @type {DistMaster}
     * @memberof Distributed
     */
    'master'?: DistMaster | null;
}
/**
 * 
 * @export
 * @interface DistributedAllOf
 */
export interface DistributedAllOf {
    /**
     * 
     * @type {number}
     * @memberof DistributedAllOf
     */
    'numWorkers'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DistributedAllOf
     */
    'noMaster'?: boolean | null;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof DistributedAllOf
     */
    'distFramework'?: DistributedFramework | null;
    /**
     * 
     * @type {DistMaster}
     * @memberof DistributedAllOf
     */
    'master'?: DistMaster | null;
}
/**
 * The policy describes how to deal with pods when the job is finished.
 * @export
 * @enum {string}
 */

export const DistributedCleanPodPolicy = {
    None: 'None',
    All: 'All',
    Running: 'Running'
} as const;

export type DistributedCleanPodPolicy = typeof DistributedCleanPodPolicy[keyof typeof DistributedCleanPodPolicy];


/**
 * 
 * @export
 * @interface DistributedData
 */
export interface DistributedData {
    /**
     * number of worker replicas to process the workload.
     * @type {number}
     * @memberof DistributedData
     */
    'numWorkers': number;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof DistributedData
     */
    'framework'?: DistributedFramework | null;
    /**
     * 
     * @type {DistributedMasterData}
     * @memberof DistributedData
     */
    'master'?: DistributedMasterData | null;
}
/**
 * 
 * @export
 * @interface DistributedFields
 */
export interface DistributedFields {
    /**
     * the number of workers that will be allocated for running the workload.
     * @type {number}
     * @memberof DistributedFields
     */
    'numWorkers'?: number | null;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof DistributedFields
     */
    'distributedFramework'?: DistributedFramework | null;
    /**
     * Specifies the number of slots per worker used in hostfile. Defaults to 1. (applicable only for MPI)
     * @type {number}
     * @memberof DistributedFields
     */
    'slotsPerWorker'?: number | null;
    /**
     * Specifies the directory where SSH keys are mounted. (applicable only for MPI)
     * @type {string}
     * @memberof DistributedFields
     */
    'sshAuthMountPath'?: string | null;
    /**
     * the lower limit for the number of worker pods to which the training job can scale down. (applicable only for PyTorch)
     * @type {number}
     * @memberof DistributedFields
     */
    'minReplicas'?: number | null;
    /**
     * the upper limit for the number of worker pods that can be set by the autoscaler. Cannot be smaller than MinReplicas. (applicable only for PyTorch)
     * @type {number}
     * @memberof DistributedFields
     */
    'maxReplicas'?: number | null;
    /**
     * 
     * @type {DistributedCleanPodPolicy}
     * @memberof DistributedFields
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicy | null;
}
/**
 * The distributed training framework used in the workload.
 * @export
 * @enum {string}
 */

export const DistributedFramework = {
    Mpi: 'MPI',
    PyTorch: 'PyTorch',
    Tf: 'TF',
    XgBoost: 'XGBoost',
    Jax: 'JAX'
} as const;

export type DistributedFramework = typeof DistributedFramework[keyof typeof DistributedFramework];


/**
 * 
 * @export
 * @interface DistributedMaster
 */
export interface DistributedMaster {
    /**
     * if true, indicates that the master should be identical to the worker. In this case assets and specificRunParams should not be provided.
     * @type {boolean}
     * @memberof DistributedMaster
     */
    'sameAsWorker'?: boolean;
    /**
     * 
     * @type {OptionalAssetIds}
     * @memberof DistributedMaster
     */
    'assets'?: OptionalAssetIds | null;
    /**
     * 
     * @type {TrainingSpecificRunParams}
     * @memberof DistributedMaster
     */
    'specificRunParams'?: TrainingSpecificRunParams | null;
}
/**
 * 
 * @export
 * @interface DistributedMasterData
 */
export interface DistributedMasterData {
    /**
     * if true, indicates that the master should be identical to the worker. In this case assets and specificRunParams should not be provided.
     * @type {boolean}
     * @memberof DistributedMasterData
     */
    'sameAsWorker'?: boolean;
    /**
     * 
     * @type {AssetsRefOptional}
     * @memberof DistributedMasterData
     */
    'assets'?: AssetsRefOptional | null;
    /**
     * 
     * @type {TrainingSpecificRunParams}
     * @memberof DistributedMasterData
     */
    'specificRunParams'?: TrainingSpecificRunParams | null;
    /**
     * 
     * @type {PolicyInfo}
     * @memberof DistributedMasterData
     */
    'policyInfo'?: PolicyInfo | null;
}
/**
 * 
 * @export
 * @interface DistributedParams
 */
export interface DistributedParams {
    /**
     * number of worker replicas to process the workload.
     * @type {number}
     * @memberof DistributedParams
     */
    'numWorkers': number;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof DistributedParams
     */
    'framework'?: DistributedFramework | null;
    /**
     * 
     * @type {DistributedMaster}
     * @memberof DistributedParams
     */
    'master'?: DistributedMaster | null;
}
/**
 * 
 * @export
 * @interface DockerRegistry
 */
export interface DockerRegistry {
    /**
     * 
     * @type {AssetMeta}
     * @memberof DockerRegistry
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {DockerRegistrySpec}
     * @memberof DockerRegistry
     */
    'spec': DockerRegistrySpec;
    /**
     * 
     * @type {AssetUsageInfo}
     * @memberof DockerRegistry
     */
    'usedBy'?: AssetUsageInfo | null;
    /**
     * 
     * @type {ComplianceInfo}
     * @memberof DockerRegistry
     */
    'compliance'?: ComplianceInfo | null;
    /**
     * 
     * @type {AssetClusterStatusInfo}
     * @memberof DockerRegistry
     */
    'status'?: AssetClusterStatusInfo | null;
    /**
     * 
     * @type {ClusterInfo}
     * @memberof DockerRegistry
     */
    'clusterInfo'?: ClusterInfo | null;
}
/**
 * 
 * @export
 * @interface DockerRegistryCreationRequest
 */
export interface DockerRegistryCreationRequest {
    /**
     * 
     * @type {AssetCreationRequest}
     * @memberof DockerRegistryCreationRequest
     */
    'meta': AssetCreationRequest;
    /**
     * 
     * @type {DockerRegistryCreationSpec}
     * @memberof DockerRegistryCreationRequest
     */
    'spec': DockerRegistryCreationSpec;
}
/**
 * 
 * @export
 * @interface DockerRegistryCreationSpec
 */
export interface DockerRegistryCreationSpec {
    /**
     * optional name of existing secret in the cluster from which the docker registry details should be taken. If omitted, you will have to provide those credentials and url in relevant fields. The provided credentials are encrypted into the control plane database and cloned to a kubernetes secret in the cluster, along with the url.
     * @type {string}
     * @memberof DockerRegistryCreationSpec
     */
    'existingSecretName'?: string | null;
    /**
     * The name of the user, required only when not using existing secret.
     * @type {string}
     * @memberof DockerRegistryCreationSpec
     */
    'user'?: string | null;
    /**
     * The password, required only when not using existing secret.
     * @type {string}
     * @memberof DockerRegistryCreationSpec
     */
    'password'?: string | null;
    /**
     * The url, required only when not using existing secret.
     * @type {string}
     * @memberof DockerRegistryCreationSpec
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface DockerRegistryListResponse
 */
export interface DockerRegistryListResponse {
    /**
     * 
     * @type {Array<DockerRegistry>}
     * @memberof DockerRegistryListResponse
     */
    'entries': Array<DockerRegistry>;
}
/**
 * 
 * @export
 * @interface DockerRegistrySpec
 */
export interface DockerRegistrySpec {
    /**
     * optional name of existing secret in the cluster from which the docker registry details should be taken. If omitted, you will have to provide those credentials and url in relevant fields. The provided credentials are encrypted into the control plane database and cloned to a kubernetes secret in the cluster, along with the url.
     * @type {string}
     * @memberof DockerRegistrySpec
     */
    'existingSecretName'?: string | null;
    /**
     * The name of the user, required only when not using existing secret.
     * @type {string}
     * @memberof DockerRegistrySpec
     */
    'user'?: string | null;
    /**
     * The password, required only when not using existing secret.
     * @type {string}
     * @memberof DockerRegistrySpec
     */
    'password'?: string | null;
    /**
     * The url, required only when not using existing secret.
     * @type {string}
     * @memberof DockerRegistrySpec
     */
    'url'?: string | null;
    /**
     * id of the encryption key which has been used to encrypt an asset\'s data.
     * @type {number}
     * @memberof DockerRegistrySpec
     */
    'keyId': number;
}
/**
 * A list of updates that needs to be carried out by the cluster in order to sync its docker registry assets with the control-plane.
 * @export
 * @interface DockerRegistrySyncResponse
 */
export interface DockerRegistrySyncResponse {
    /**
     * Docker registries that needs to be deleted from the cluster.
     * @type {Array<string>}
     * @memberof DockerRegistrySyncResponse
     */
    'toDelete'?: Array<string>;
    /**
     * Docker registries that needs to be added to the cluster.
     * @type {Array<DockerRegistryToAddOrUpdate>}
     * @memberof DockerRegistrySyncResponse
     */
    'toAdd'?: Array<DockerRegistryToAddOrUpdate>;
    /**
     * Docker registries that needs to be updated at the cluster.
     * @type {Array<DockerRegistryToAddOrUpdate>}
     * @memberof DockerRegistrySyncResponse
     */
    'toUpdate'?: Array<DockerRegistryToAddOrUpdate>;
}
/**
 * 
 * @export
 * @interface DockerRegistryToAddOrUpdate
 */
export interface DockerRegistryToAddOrUpdate {
    /**
     * The name of the asset.
     * @type {string}
     * @memberof DockerRegistryToAddOrUpdate
     */
    'name': string;
    /**
     * 
     * @type {DockerRegistrySpec}
     * @memberof DockerRegistryToAddOrUpdate
     */
    'spec': DockerRegistrySpec;
    /**
     * The checksum of the asset\'s spec.
     * @type {string}
     * @memberof DockerRegistryToAddOrUpdate
     */
    'checksum': string;
}
/**
 * 
 * @export
 * @interface DockerRegistryUpdateRequest
 */
export interface DockerRegistryUpdateRequest {
    /**
     * 
     * @type {CredentialUpdateRequest}
     * @memberof DockerRegistryUpdateRequest
     */
    'meta'?: CredentialUpdateRequest;
}
/**
 * 
 * @export
 * @interface EncryptionKeyId
 */
export interface EncryptionKeyId {
    /**
     * id of the encryption key which has been used to encrypt an asset\'s data.
     * @type {number}
     * @memberof EncryptionKeyId
     */
    'keyId': number;
}
/**
 * 
 * @export
 * @interface EnvironmentAsset
 */
export interface EnvironmentAsset {
    /**
     * 
     * @type {AssetMeta}
     * @memberof EnvironmentAsset
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {EnvironmentAssetSpec}
     * @memberof EnvironmentAsset
     */
    'spec': EnvironmentAssetSpec;
    /**
     * 
     * @type {AssetUsageInfo}
     * @memberof EnvironmentAsset
     */
    'usedBy'?: AssetUsageInfo | null;
    /**
     * 
     * @type {UsageTimesInfo}
     * @memberof EnvironmentAsset
     */
    'usageTimes'?: UsageTimesInfo | null;
    /**
     * 
     * @type {ComplianceInfo}
     * @memberof EnvironmentAsset
     */
    'compliance'?: ComplianceInfo | null;
    /**
     * 
     * @type {AssetClusterStatusInfo}
     * @memberof EnvironmentAsset
     */
    'status'?: AssetClusterStatusInfo | null;
}
/**
 * Reference information about environment asset.
 * @export
 * @interface EnvironmentAssetRef
 */
export interface EnvironmentAssetRef {
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof EnvironmentAssetRef
     */
    'id': string;
    /**
     * The name of the asset.
     * @type {string}
     * @memberof EnvironmentAssetRef
     */
    'name': string;
    /**
     * the type of tools as defined in the connections of the environment asset.
     * @type {Array<ToolType>}
     * @memberof EnvironmentAssetRef
     */
    'toolTypes'?: Array<ToolType> | null;
}
/**
 * 
 * @export
 * @interface EnvironmentAssetSpec
 */
export interface EnvironmentAssetSpec {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof EnvironmentAssetSpec
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof EnvironmentAssetSpec
     */
    'args'?: string | null;
    /**
     * The user id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsUid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof EnvironmentAssetSpec
     */
    'runAsUid'?: number | null;
    /**
     * The group id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsGid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof EnvironmentAssetSpec
     */
    'runAsGid'?: number | null;
    /**
     * Comma separated list of groups that the user running the container belongs to, in addition to the group indicated by runAsGid. Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled. Using an empty string implies reverting the supplementary groups of the image.
     * @type {string}
     * @memberof EnvironmentAssetSpec
     */
    'supplementalGroups'?: string | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariableOfAsset>}
     * @memberof EnvironmentAssetSpec
     */
    'environmentVariables'?: Array<EnvironmentVariableOfAsset> | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof EnvironmentAssetSpec
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof EnvironmentAssetSpec
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof EnvironmentAssetSpec
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof EnvironmentAssetSpec
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof EnvironmentAssetSpec
     */
    'probes'?: Probes | null;
    /**
     * 
     * @type {UidGidSource}
     * @memberof EnvironmentAssetSpec
     */
    'uidGidSource'?: UidGidSource | null;
    /**
     * Add POSIX capabilities to running containers. Defaults to the default set of capabilities granted by the container runtime.
     * @type {Array<Capability>}
     * @memberof EnvironmentAssetSpec
     */
    'capabilities'?: Array<Capability> | null;
    /**
     * 
     * @type {SeccompProfileType}
     * @memberof EnvironmentAssetSpec
     */
    'seccompProfileType'?: SeccompProfileType | null;
    /**
     * Force the container to run as a non-root user.
     * @type {boolean}
     * @memberof EnvironmentAssetSpec
     */
    'runAsNonRoot'?: boolean | null;
    /**
     * If true, mounts the container\'s root filesystem as read-only.
     * @type {boolean}
     * @memberof EnvironmentAssetSpec
     */
    'readOnlyRootFilesystem'?: boolean | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof EnvironmentAssetSpec
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof EnvironmentAssetSpec
     */
    'stdin'?: boolean | null;
    /**
     * Allow the container running the workload and all launched processes to gain additional privileges after the workload starts. For more information consult the User Identity in Container guide at https://docs.run.ai/admin/runai-setup/config/non-root-containers/
     * @type {boolean}
     * @memberof EnvironmentAssetSpec
     */
    'allowPrivilegeEscalation'?: boolean | null;
    /**
     * Whether to enable host IPC. Defaults to false.
     * @type {boolean}
     * @memberof EnvironmentAssetSpec
     */
    'hostIpc'?: boolean | null;
    /**
     * Whether to enable host networking. Default to false.
     * @type {boolean}
     * @memberof EnvironmentAssetSpec
     */
    'hostNetwork'?: boolean | null;
    /**
     * List of connections that either expose ports from the container (each port is associated with a tool that the container runs), or URL\'s to be used for connecting to an external tool that is related to the action of the container (such as Weights & Biases).
     * @type {Array<Connection>}
     * @memberof EnvironmentAssetSpec
     */
    'connections'?: Array<Connection>;
    /**
     * Allow specifying uid/gid as part of create workspace. This is relevant only for custom uigGidSource.
     * @type {boolean}
     * @memberof EnvironmentAssetSpec
     */
    'overrideUidGidInWorkspace'?: boolean;
    /**
     * Indicates the supported routing method (host-base, path-base or agnostic)
     * @type {string}
     * @memberof EnvironmentAssetSpec
     */
    'routingMethod'?: string;
}
/**
 * 
 * @export
 * @interface EnvironmentCreationRequest
 */
export interface EnvironmentCreationRequest {
    /**
     * 
     * @type {AssetCreationRequest}
     * @memberof EnvironmentCreationRequest
     */
    'meta': AssetCreationRequest;
    /**
     * 
     * @type {EnvironmentAssetSpec}
     * @memberof EnvironmentCreationRequest
     */
    'spec': EnvironmentAssetSpec;
}
/**
 * 
 * @export
 * @interface EnvironmentListResponse
 */
export interface EnvironmentListResponse {
    /**
     * 
     * @type {Array<EnvironmentAsset>}
     * @memberof EnvironmentListResponse
     */
    'entries': Array<EnvironmentAsset>;
}
/**
 * 
 * @export
 * @interface EnvironmentUpdateRequest
 */
export interface EnvironmentUpdateRequest {
    /**
     * 
     * @type {AssetUpdateRequest}
     * @memberof EnvironmentUpdateRequest
     */
    'meta': AssetUpdateRequest;
    /**
     * 
     * @type {EnvironmentAssetSpec}
     * @memberof EnvironmentUpdateRequest
     */
    'spec': EnvironmentAssetSpec;
}
/**
 * Details of an environment variable which is populated into the container.
 * @export
 * @interface EnvironmentVariable
 */
export interface EnvironmentVariable {
    /**
     * The name of the environment variable. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariable
     */
    'name'?: string | null;
    /**
     * The value of the environment variable. (mutually exclusive with secret, configMap and podFieldRef)
     * @type {string}
     * @memberof EnvironmentVariable
     */
    'value'?: string | null;
    /**
     * 
     * @type {EnvironmentVariableSecret}
     * @memberof EnvironmentVariable
     */
    'secret'?: EnvironmentVariableSecret | null;
    /**
     * 
     * @type {EnvironmentVariableConfigMap}
     * @memberof EnvironmentVariable
     */
    'configMap'?: EnvironmentVariableConfigMap | null;
    /**
     * 
     * @type {EnvironmentVariablePodFieldReference}
     * @memberof EnvironmentVariable
     */
    'podFieldRef'?: EnvironmentVariablePodFieldReference | null;
    /**
     * Use \'true\' in case the environment variable is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof EnvironmentVariable
     */
    'exclude'?: boolean | null;
    /**
     * Description of the environment variable.
     * @type {string}
     * @memberof EnvironmentVariable
     */
    'description'?: string | null;
}
/**
 * Details of the configMap and key use to populated the environment variable
 * @export
 * @interface EnvironmentVariableConfigMap
 */
export interface EnvironmentVariableConfigMap {
    /**
     * The name of the config-map resource. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariableConfigMap
     */
    'name'?: string | null;
    /**
     * The key in the config-map resource. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariableConfigMap
     */
    'key'?: string | null;
}
/**
 * Details of the secret and key use to populated the environment variable. (mutually exclusive with value)
 * @export
 * @interface EnvironmentVariableCredential
 */
export interface EnvironmentVariableCredential {
    /**
     * Unique identifier of the asset. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariableCredential
     */
    'assetId'?: string | null;
    /**
     * The key in the secret resource. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariableCredential
     */
    'key'?: string | null;
}
/**
 * Details of an environment variable which is populated into the container.
 * @export
 * @interface EnvironmentVariableOfAsset
 */
export interface EnvironmentVariableOfAsset {
    /**
     * The name of the environment variable. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariableOfAsset
     */
    'name'?: string | null;
    /**
     * The value of the environment variable. (mutually exclusive with credential, configMap and podFieldRef)
     * @type {string}
     * @memberof EnvironmentVariableOfAsset
     */
    'value'?: string | null;
    /**
     * 
     * @type {EnvironmentVariableCredential}
     * @memberof EnvironmentVariableOfAsset
     */
    'credential'?: EnvironmentVariableCredential | null;
    /**
     * 
     * @type {EnvironmentVariableConfigMap}
     * @memberof EnvironmentVariableOfAsset
     */
    'configMap'?: EnvironmentVariableConfigMap | null;
    /**
     * 
     * @type {EnvironmentVariablePodFieldReference}
     * @memberof EnvironmentVariableOfAsset
     */
    'podFieldRef'?: EnvironmentVariablePodFieldReference | null;
    /**
     * Use \'true\' in case the environment variable is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof EnvironmentVariableOfAsset
     */
    'exclude'?: boolean | null;
    /**
     * Description of the environment variable.
     * @type {string}
     * @memberof EnvironmentVariableOfAsset
     */
    'description'?: string | null;
}
/**
 * Details of the filed-reference and key use to populated the environment variable
 * @export
 * @interface EnvironmentVariablePodFieldReference
 */
export interface EnvironmentVariablePodFieldReference {
    /**
     * The field path resource. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariablePodFieldReference
     */
    'path'?: string | null;
}
/**
 * Details of the secret and key use to populated the environment variable
 * @export
 * @interface EnvironmentVariableSecret
 */
export interface EnvironmentVariableSecret {
    /**
     * The name of the secret resource. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariableSecret
     */
    'name'?: string | null;
    /**
     * The key in the secret resource. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariableSecret
     */
    'key'?: string | null;
}
/**
 * 
 * @export
 * @interface EnvironmentVariablesAssetField
 */
export interface EnvironmentVariablesAssetField {
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariableOfAsset>}
     * @memberof EnvironmentVariablesAssetField
     */
    'environmentVariables'?: Array<EnvironmentVariableOfAsset> | null;
}
/**
 * 
 * @export
 * @interface EnvironmentVariablesField
 */
export interface EnvironmentVariablesField {
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariable>}
     * @memberof EnvironmentVariablesField
     */
    'environmentVariables'?: Array<EnvironmentVariable> | null;
}
/**
 * 
 * @export
 * @interface EnvironmentVariablesFieldRules
 */
export interface EnvironmentVariablesFieldRules {
    /**
     * 
     * @type {InstancesRules}
     * @memberof EnvironmentVariablesFieldRules
     */
    'environmentVariables'?: InstancesRules | null;
}
/**
 * 
 * @export
 * @interface ExcludeField
 */
export interface ExcludeField {
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof ExcludeField
     */
    'exclude'?: boolean | null;
}
/**
 * A URL for accessing the workload.
 * @export
 * @interface ExposedUrl
 */
export interface ExposedUrl {
    /**
     * The port that the container running the workload exposes. (mandatory)
     * @type {number}
     * @memberof ExposedUrl
     */
    'container'?: number | null;
    /**
     * The URL for connecting to the container port. If not specified, the URL will be auto-generated by the system..
     * @type {string}
     * @memberof ExposedUrl
     */
    'url'?: string | null;
    /**
     * List of users that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ExposedUrl
     */
    'authorizedUsers'?: Array<string> | null;
    /**
     * List of groups that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ExposedUrl
     */
    'authorizedGroups'?: Array<string> | null;
    /**
     * The tool type that runs on this container port.
     * @type {string}
     * @memberof ExposedUrl
     */
    'toolType'?: string | null;
    /**
     * A name describing the tool that runs on this url.
     * @type {string}
     * @memberof ExposedUrl
     */
    'toolName'?: string | null;
    /**
     * Unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof ExposedUrl
     */
    'name'?: string | null;
    /**
     * Use \'true\' in case the instance is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof ExposedUrl
     */
    'exclude'?: boolean | null;
}
/**
 * Quantity of an extended resource.
 * @export
 * @interface ExtendedResource
 */
export interface ExtendedResource {
    /**
     * The name of the extended resource (mandatory)
     * @type {string}
     * @memberof ExtendedResource
     */
    'resource'?: string | null;
    /**
     * The requested quantity for the resource.
     * @type {string}
     * @memberof ExtendedResource
     */
    'quantity'?: string | null;
    /**
     * Use \'true\' in case the extended resource is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof ExtendedResource
     */
    'exclude'?: boolean | null;
}
/**
 * Information of the external tool.
 * @export
 * @interface ExternalToolInfo
 */
export interface ExternalToolInfo {
    /**
     * 
     * @type {ExternalToolType}
     * @memberof ExternalToolInfo
     */
    'toolType': ExternalToolType;
    /**
     * The external url for connecting to the external tool. The url can include environment variables that will be replaced with the value provided for those variables when the workspace is created.
     * @type {string}
     * @memberof ExternalToolInfo
     */
    'externalUrl': string;
}
/**
 * The type of external tool that is associated with the connection. External tool typically runs in the cloud and require external url for connecting to it.
 * @export
 * @enum {string}
 */

export const ExternalToolType = {
    Wandb: 'wandb',
    Comet: 'comet'
} as const;

export type ExternalToolType = typeof ExternalToolType[keyof typeof ExternalToolType];


/**
 * 
 * @export
 * @interface ExternalUrlInfo
 */
export interface ExternalUrlInfo {
    /**
     * Whether external url is provided in the specific env of the workspace. Default is false, and in this case the external url is auto generated by the system.
     * @type {boolean}
     * @memberof ExternalUrlInfo
     */
    'isCustomUrl'?: boolean;
    /**
     * Default value for the external url. You can override it in the specific env of the workspace. Should be specified for ExternalUrl only.
     * @type {string}
     * @memberof ExternalUrlInfo
     */
    'externalUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface GenericSecret
 */
export interface GenericSecret {
    /**
     * 
     * @type {AssetMeta}
     * @memberof GenericSecret
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {GenericSecretSpec}
     * @memberof GenericSecret
     */
    'spec': GenericSecretSpec;
    /**
     * 
     * @type {AssetUsageInfo}
     * @memberof GenericSecret
     */
    'usedBy'?: AssetUsageInfo | null;
    /**
     * 
     * @type {ComplianceInfo}
     * @memberof GenericSecret
     */
    'compliance'?: ComplianceInfo | null;
    /**
     * 
     * @type {AssetClusterStatusInfo}
     * @memberof GenericSecret
     */
    'status'?: AssetClusterStatusInfo | null;
    /**
     * 
     * @type {ClusterInfo}
     * @memberof GenericSecret
     */
    'clusterInfo'?: ClusterInfo | null;
}
/**
 * 
 * @export
 * @interface GenericSecretCreationRequest
 */
export interface GenericSecretCreationRequest {
    /**
     * 
     * @type {AssetCreationRequest}
     * @memberof GenericSecretCreationRequest
     */
    'meta': AssetCreationRequest;
    /**
     * 
     * @type {GenericSecretCreationSpec}
     * @memberof GenericSecretCreationRequest
     */
    'spec': GenericSecretCreationSpec;
}
/**
 * 
 * @export
 * @interface GenericSecretCreationSpec
 */
export interface GenericSecretCreationSpec {
    /**
     * name of existing secret in the cluster from which the general key-value values should be taken.
     * @type {string}
     * @memberof GenericSecretCreationSpec
     */
    'existingSecretName'?: string | null;
    /**
     * Set of key-value pairs to store in the new credential.
     * @type {Array<KeyValuePair>}
     * @memberof GenericSecretCreationSpec
     */
    'keyValuePairs'?: Array<KeyValuePair> | null;
}
/**
 * 
 * @export
 * @interface GenericSecretListResponse
 */
export interface GenericSecretListResponse {
    /**
     * 
     * @type {Array<GenericSecret>}
     * @memberof GenericSecretListResponse
     */
    'entries': Array<GenericSecret>;
}
/**
 * 
 * @export
 * @interface GenericSecretSpec
 */
export interface GenericSecretSpec {
    /**
     * name of existing secret in the cluster from which the general key-value values should be taken.
     * @type {string}
     * @memberof GenericSecretSpec
     */
    'existingSecretName'?: string | null;
    /**
     * Set of key-value pairs to store in the new credential.
     * @type {Array<KeyValuePair>}
     * @memberof GenericSecretSpec
     */
    'keyValuePairs'?: Array<KeyValuePair> | null;
    /**
     * id of the encryption key which has been used to encrypt an asset\'s data.
     * @type {number}
     * @memberof GenericSecretSpec
     */
    'keyId': number;
}
/**
 * A list of updates that needs to be carried out by the cluster in order to sync its generic secret assets with the control-plane.
 * @export
 * @interface GenericSecretSyncResponse
 */
export interface GenericSecretSyncResponse {
    /**
     * Generic secrets that needs to be deleted from the cluster.
     * @type {Array<string>}
     * @memberof GenericSecretSyncResponse
     */
    'toDelete'?: Array<string>;
    /**
     * Generic secrets that needs to be added to the cluster.
     * @type {Array<GenericSecretToAddOrUpdate>}
     * @memberof GenericSecretSyncResponse
     */
    'toAdd'?: Array<GenericSecretToAddOrUpdate>;
    /**
     * Generic secrets that needs to be updated at the cluster.
     * @type {Array<GenericSecretToAddOrUpdate>}
     * @memberof GenericSecretSyncResponse
     */
    'toUpdate'?: Array<GenericSecretToAddOrUpdate>;
}
/**
 * 
 * @export
 * @interface GenericSecretToAddOrUpdate
 */
export interface GenericSecretToAddOrUpdate {
    /**
     * The name of the asset.
     * @type {string}
     * @memberof GenericSecretToAddOrUpdate
     */
    'name': string;
    /**
     * 
     * @type {GenericSecretSpec}
     * @memberof GenericSecretToAddOrUpdate
     */
    'spec': GenericSecretSpec;
    /**
     * The checksum of the asset\'s spec.
     * @type {string}
     * @memberof GenericSecretToAddOrUpdate
     */
    'checksum': string;
}
/**
 * 
 * @export
 * @interface GenericSecretUpdateRequest
 */
export interface GenericSecretUpdateRequest {
    /**
     * 
     * @type {CredentialUpdateRequest}
     * @memberof GenericSecretUpdateRequest
     */
    'meta'?: CredentialUpdateRequest;
}
/**
 * 
 * @export
 * @interface GitAsset
 */
export interface GitAsset {
    /**
     * 
     * @type {AssetMeta}
     * @memberof GitAsset
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {GitAssetSpec}
     * @memberof GitAsset
     */
    'spec': GitAssetSpec;
    /**
     * 
     * @type {AssetUsageInfo}
     * @memberof GitAsset
     */
    'usedBy'?: AssetUsageInfo | null;
    /**
     * 
     * @type {UsageTimesInfo}
     * @memberof GitAsset
     */
    'usageTimes'?: UsageTimesInfo | null;
    /**
     * 
     * @type {ComplianceInfo}
     * @memberof GitAsset
     */
    'compliance'?: ComplianceInfo | null;
    /**
     * 
     * @type {AssetClusterStatusInfo}
     * @memberof GitAsset
     */
    'status'?: AssetClusterStatusInfo | null;
}
/**
 * 
 * @export
 * @interface GitAssetSpec
 */
export interface GitAssetSpec {
    /**
     * URL to a remote Git repository. The content of this repository will be mapped to the container running the workload. (mandatory)
     * @type {string}
     * @memberof GitAssetSpec
     */
    'repository'?: string | null;
    /**
     * Specific branch to synchronize the repository from.
     * @type {string}
     * @memberof GitAssetSpec
     */
    'branch'?: string | null;
    /**
     * Specific revision to synchronize the repository from.
     * @type {string}
     * @memberof GitAssetSpec
     */
    'revision'?: string | null;
    /**
     * Local path within the workspace to which the Git repository will be mapped (mandatory).
     * @type {string}
     * @memberof GitAssetSpec
     */
    'path'?: string | null;
    /**
     * ID of credentials asset of type password. Needed for non public repository which requires authentication.
     * @type {string}
     * @memberof GitAssetSpec
     */
    'passwordAssetId'?: string | null;
}
/**
 * 
 * @export
 * @interface GitCommon
 */
export interface GitCommon {
    /**
     * URL to a remote Git repository. The content of this repository will be mapped to the container running the workload. (mandatory)
     * @type {string}
     * @memberof GitCommon
     */
    'repository'?: string | null;
    /**
     * Specific branch to synchronize the repository from.
     * @type {string}
     * @memberof GitCommon
     */
    'branch'?: string | null;
    /**
     * Specific revision to synchronize the repository from.
     * @type {string}
     * @memberof GitCommon
     */
    'revision'?: string | null;
    /**
     * Local path within the workspace to which the Git repository will be mapped (mandatory).
     * @type {string}
     * @memberof GitCommon
     */
    'path'?: string | null;
}
/**
 * 
 * @export
 * @interface GitCreationRequest
 */
export interface GitCreationRequest {
    /**
     * 
     * @type {AssetCreationRequest}
     * @memberof GitCreationRequest
     */
    'meta': AssetCreationRequest;
    /**
     * 
     * @type {GitAssetSpec}
     * @memberof GitCreationRequest
     */
    'spec': GitAssetSpec;
}
/**
 * 
 * @export
 * @interface GitInstance
 */
export interface GitInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof GitInstance
     */
    'name'?: string | null;
    /**
     * URL to a remote Git repository. The content of this repository will be mapped to the container running the workload. (mandatory)
     * @type {string}
     * @memberof GitInstance
     */
    'repository'?: string | null;
    /**
     * Specific branch to synchronize the repository from.
     * @type {string}
     * @memberof GitInstance
     */
    'branch'?: string | null;
    /**
     * Specific revision to synchronize the repository from.
     * @type {string}
     * @memberof GitInstance
     */
    'revision'?: string | null;
    /**
     * Local path within the workspace to which the Git repository will be mapped (mandatory).
     * @type {string}
     * @memberof GitInstance
     */
    'path'?: string | null;
    /**
     * Secret containing the credentials of the repository (needed for non public repository which requires authentication).
     * @type {string}
     * @memberof GitInstance
     */
    'passwordSecret'?: string | null;
    /**
     * The key to use for loading the user name from the secret. The default is `User`.
     * @type {string}
     * @memberof GitInstance
     */
    'secretKeyOfUser'?: string | null;
    /**
     * The key to use for loading the password from the secret. The default is `Password`.
     * @type {string}
     * @memberof GitInstance
     */
    'secretKeyOfPassword'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof GitInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface GitListResponse
 */
export interface GitListResponse {
    /**
     * 
     * @type {Array<GitAsset>}
     * @memberof GitListResponse
     */
    'entries': Array<GitAsset>;
}
/**
 * 
 * @export
 * @interface GitPassword
 */
export interface GitPassword {
    /**
     * Secret containing the credentials of the repository (needed for non public repository which requires authentication).
     * @type {string}
     * @memberof GitPassword
     */
    'passwordSecret'?: string | null;
    /**
     * The key to use for loading the user name from the secret. The default is `User`.
     * @type {string}
     * @memberof GitPassword
     */
    'secretKeyOfUser'?: string | null;
    /**
     * The key to use for loading the password from the secret. The default is `Password`.
     * @type {string}
     * @memberof GitPassword
     */
    'secretKeyOfPassword'?: string | null;
}
/**
 * 
 * @export
 * @interface GitPasswordAsset
 */
export interface GitPasswordAsset {
    /**
     * ID of credentials asset of type password. Needed for non public repository which requires authentication.
     * @type {string}
     * @memberof GitPasswordAsset
     */
    'passwordAssetId'?: string | null;
}
/**
 * 
 * @export
 * @interface GitRules
 */
export interface GitRules {
    /**
     * 
     * @type {StringRules}
     * @memberof GitRules
     */
    'repository'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof GitRules
     */
    'branch'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof GitRules
     */
    'revision'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof GitRules
     */
    'path'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface GitUpdateRequest
 */
export interface GitUpdateRequest {
    /**
     * 
     * @type {AssetUpdateRequest}
     * @memberof GitUpdateRequest
     */
    'meta': AssetUpdateRequest;
    /**
     * 
     * @type {GitAssetSpec}
     * @memberof GitUpdateRequest
     */
    'spec': GitAssetSpec;
}
/**
 * 
 * @export
 * @interface GitsRules
 */
export interface GitsRules {
    /**
     * 
     * @type {GitRules}
     * @memberof GitsRules
     */
    'attributes'?: GitRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof GitsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * Sets the unit type for GPU resources requests. Stated in terms of portion, memory or  mig profile [deprecated]. Sets the unit type for other GPU request fields. If `gpuDevicesRequest > 1`, only `portion` is supported. If `gpuDeviceRequest = 1`, the request type can be stated as `portion`, `memory` or `migProfile` [deprecated].
 * @export
 * @enum {string}
 */

export const GpuRequestType = {
    Portion: 'portion',
    Memory: 'memory',
    MigProfile: 'migProfile'
} as const;

export type GpuRequestType = typeof GpuRequestType[keyof typeof GpuRequestType];


/**
 * 
 * @export
 * @interface HostPath
 */
export interface HostPath {
    /**
     * Local path within the controller to which the host volume will be mapped. (mandatory)
     * @type {string}
     * @memberof HostPath
     */
    'path'?: string | null;
    /**
     * Force the volume to be mounted with read-only permissions. Defaults to false.
     * @type {boolean}
     * @memberof HostPath
     */
    'readOnly'?: boolean | null;
    /**
     * The path that the host volume will be mounted to when in use. (mandatory)
     * @type {string}
     * @memberof HostPath
     */
    'mountPath'?: string | null;
    /**
     * 
     * @type {HostPathMountPropagation}
     * @memberof HostPath
     */
    'mountPropagation'?: HostPathMountPropagation | null;
}
/**
 * 
 * @export
 * @interface HostPathAsset
 */
export interface HostPathAsset {
    /**
     * 
     * @type {AssetMeta}
     * @memberof HostPathAsset
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {HostPathSpec}
     * @memberof HostPathAsset
     */
    'spec': HostPathSpec;
    /**
     * 
     * @type {AssetUsageInfo}
     * @memberof HostPathAsset
     */
    'usedBy'?: AssetUsageInfo | null;
    /**
     * 
     * @type {UsageTimesInfo}
     * @memberof HostPathAsset
     */
    'usageTimes'?: UsageTimesInfo | null;
    /**
     * 
     * @type {ComplianceInfo}
     * @memberof HostPathAsset
     */
    'compliance'?: ComplianceInfo | null;
}
/**
 * 
 * @export
 * @interface HostPathCreationRequest
 */
export interface HostPathCreationRequest {
    /**
     * 
     * @type {AssetCreationRequest}
     * @memberof HostPathCreationRequest
     */
    'meta': AssetCreationRequest;
    /**
     * 
     * @type {HostPathSpec}
     * @memberof HostPathCreationRequest
     */
    'spec': HostPathSpec;
}
/**
 * 
 * @export
 * @interface HostPathInstance
 */
export interface HostPathInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof HostPathInstance
     */
    'name'?: string | null;
    /**
     * Local path within the controller to which the host volume will be mapped. (mandatory)
     * @type {string}
     * @memberof HostPathInstance
     */
    'path'?: string | null;
    /**
     * Force the volume to be mounted with read-only permissions. Defaults to false.
     * @type {boolean}
     * @memberof HostPathInstance
     */
    'readOnly'?: boolean | null;
    /**
     * The path that the host volume will be mounted to when in use. (mandatory)
     * @type {string}
     * @memberof HostPathInstance
     */
    'mountPath'?: string | null;
    /**
     * 
     * @type {HostPathMountPropagation}
     * @memberof HostPathInstance
     */
    'mountPropagation'?: HostPathMountPropagation | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof HostPathInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface HostPathListResponse
 */
export interface HostPathListResponse {
    /**
     * 
     * @type {Array<HostPathAsset>}
     * @memberof HostPathListResponse
     */
    'entries': Array<HostPathAsset>;
}
/**
 * Share this volumes mount with other containers. If set to HostToContainer, this volume mount will receive all subsequent mounts that are mounted to this volume or any of its subdirectories. In case of multiple hostPath entries, this field should have the same value for all of them.
 * @export
 * @enum {string}
 */

export const HostPathMountPropagation = {
    None: 'None',
    HostToContainer: 'HostToContainer'
} as const;

export type HostPathMountPropagation = typeof HostPathMountPropagation[keyof typeof HostPathMountPropagation];


/**
 * 
 * @export
 * @interface HostPathMountPropagationOptions
 */
export interface HostPathMountPropagationOptions {
    /**
     * 
     * @type {Array<HostPathMountPropagationOptionsOptionsInner>}
     * @memberof HostPathMountPropagationOptions
     */
    'options'?: Array<HostPathMountPropagationOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface HostPathMountPropagationOptionsOptionsInner
 */
export interface HostPathMountPropagationOptionsOptionsInner {
    /**
     * 
     * @type {HostPathMountPropagation}
     * @memberof HostPathMountPropagationOptionsOptionsInner
     */
    'value': HostPathMountPropagation | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof HostPathMountPropagationOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface HostPathMountPropagationRules
 */
export interface HostPathMountPropagationRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof HostPathMountPropagationRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof HostPathMountPropagationRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof HostPathMountPropagationRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<HostPathMountPropagationOptionsOptionsInner>}
     * @memberof HostPathMountPropagationRules
     */
    'options'?: Array<HostPathMountPropagationOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface HostPathRules
 */
export interface HostPathRules {
    /**
     * 
     * @type {StringRules}
     * @memberof HostPathRules
     */
    'path'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof HostPathRules
     */
    'readOnly'?: BooleanRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof HostPathRules
     */
    'mountPath'?: StringRules | null;
    /**
     * 
     * @type {HostPathMountPropagationRules}
     * @memberof HostPathRules
     */
    'mountPropagation'?: HostPathMountPropagationRules | null;
}
/**
 * 
 * @export
 * @interface HostPathSpec
 */
export interface HostPathSpec {
    /**
     * Local path within the controller to which the host volume will be mapped. (mandatory)
     * @type {string}
     * @memberof HostPathSpec
     */
    'path'?: string | null;
    /**
     * Force the volume to be mounted with read-only permissions. Defaults to false.
     * @type {boolean}
     * @memberof HostPathSpec
     */
    'readOnly'?: boolean | null;
    /**
     * The path that the host volume will be mounted to when in use. (mandatory)
     * @type {string}
     * @memberof HostPathSpec
     */
    'mountPath'?: string | null;
    /**
     * 
     * @type {HostPathMountPropagation}
     * @memberof HostPathSpec
     */
    'mountPropagation'?: HostPathMountPropagation | null;
}
/**
 * 
 * @export
 * @interface HostPathUpdateRequest
 */
export interface HostPathUpdateRequest {
    /**
     * 
     * @type {AssetUpdateRequest}
     * @memberof HostPathUpdateRequest
     */
    'meta': AssetUpdateRequest;
    /**
     * 
     * @type {HostPathSpec}
     * @memberof HostPathUpdateRequest
     */
    'spec': HostPathSpec;
}
/**
 * 
 * @export
 * @interface HostPathsRules
 */
export interface HostPathsRules {
    /**
     * 
     * @type {HostPathRules}
     * @memberof HostPathsRules
     */
    'attributes'?: HostPathRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof HostPathsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface HttpResponse
 */
export interface HttpResponse {
    /**
     * 
     * @type {number}
     * @memberof HttpResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof HttpResponse
     */
    'message': string;
}
/**
 * Information about a Hugging Face model.
 * @export
 * @interface HuggingFaceModelInfo
 */
export interface HuggingFaceModelInfo {
    /**
     * the model name
     * @type {string}
     * @memberof HuggingFaceModelInfo
     */
    'modelName': string;
    /**
     * the pipeline tag of the model
     * @type {string}
     * @memberof HuggingFaceModelInfo
     */
    'pipelineTag'?: string | null;
    /**
     * the list of model architectures
     * @type {Array<string>}
     * @memberof HuggingFaceModelInfo
     */
    'architectures'?: Array<string> | null;
    /**
     * the list of vLLM versions that support this model\'s architecture
     * @type {Array<string>}
     * @memberof HuggingFaceModelInfo
     */
    'vllmSupportingVersions'?: Array<string> | null;
    /**
     * the minimum memory requirements, in MB, for using this model for inference (won\'t be returned if it can\'t be computed for the provided model)
     * @type {number}
     * @memberof HuggingFaceModelInfo
     */
    'minMemoryRequirementsMb'?: number | null;
}
/**
 * Request to get info of a Hugging Face model.
 * @export
 * @interface HuggingFaceModelInfoRequest
 */
export interface HuggingFaceModelInfoRequest {
    /**
     * the model name
     * @type {string}
     * @memberof HuggingFaceModelInfoRequest
     */
    'modelName': string;
    /**
     * the Hugging Face token, required only for gated models
     * @type {string}
     * @memberof HuggingFaceModelInfoRequest
     */
    'hfToken'?: string | null;
    /**
     * whether to request the minimum memory requirements for using this model for inference
     * @type {boolean}
     * @memberof HuggingFaceModelInfoRequest
     */
    'requestMinMemoryRequirements'?: boolean | null;
}
/**
 * Request to get info of a Hugging Face model.
 * @export
 * @interface HuggingFaceModelInfoRequestV2
 */
export interface HuggingFaceModelInfoRequestV2 {
    /**
     * the model name
     * @type {string}
     * @memberof HuggingFaceModelInfoRequestV2
     */
    'modelName': string;
    /**
     * the Hugging Face token, required only for gated models
     * @type {string}
     * @memberof HuggingFaceModelInfoRequestV2
     */
    'hfToken'?: string | null;
}
/**
 * Information about a Hugging Face model.
 * @export
 * @interface HuggingFaceModelInfoV2
 */
export interface HuggingFaceModelInfoV2 {
    /**
     * the model name
     * @type {string}
     * @memberof HuggingFaceModelInfoV2
     */
    'modelName': string;
    /**
     * is the model gated
     * @type {boolean}
     * @memberof HuggingFaceModelInfoV2
     */
    'gated'?: boolean;
    /**
     * is the token authorized for the model
     * @type {boolean}
     * @memberof HuggingFaceModelInfoV2
     */
    'authorized'?: boolean;
    /**
     * is the model a language model
     * @type {boolean}
     * @memberof HuggingFaceModelInfoV2
     */
    'language'?: boolean;
}
/**
 * Image pull policy. Defaults to `Always` if `:latest` tag is specified, otherwise it is `IfNotPresent`.
 * @export
 * @enum {string}
 */

export const ImagePullPolicy = {
    Always: 'Always',
    Never: 'Never',
    IfNotPresent: 'IfNotPresent'
} as const;

export type ImagePullPolicy = typeof ImagePullPolicy[keyof typeof ImagePullPolicy];


/**
 * 
 * @export
 * @interface Inference
 */
export interface Inference {
    /**
     * 
     * @type {WorkloadMetaV1}
     * @memberof Inference
     */
    'meta': WorkloadMetaV1;
    /**
     * 
     * @type {SpecificRunInfoFields}
     * @memberof Inference
     */
    'spec': SpecificRunInfoFields;
    /**
     * An inference workload ready for submission at the cluster. Further details at https://github.com/run-ai/runai/runai-cluster/tree/master/workload-controller/config/crd\"
     * @type {object}
     * @memberof Inference
     */
    'workload'?: object;
    /**
     * 
     * @type {DisplayedJob}
     * @memberof Inference
     */
    'job'?: DisplayedJob;
}
/**
 * Request to submit an inference from a set of assets and an optional set of specific env parameters.
 * @export
 * @interface InferenceCreationRequestV2
 */
export interface InferenceCreationRequestV2 {
    /**
     * 
     * @type {WorkloadCreationMeta}
     * @memberof InferenceCreationRequestV2
     */
    'meta': WorkloadCreationMeta;
    /**
     * 
     * @type {AssetsIds}
     * @memberof InferenceCreationRequestV2
     */
    'assets': AssetsIds;
    /**
     * 
     * @type {InferenceSpecificRunParams}
     * @memberof InferenceCreationRequestV2
     */
    'specificRunParams'?: InferenceSpecificRunParams | null;
}
/**
 * 
 * @export
 * @interface InferenceFields
 */
export interface InferenceFields {
    /**
     * 
     * @type {ServingPort}
     * @memberof InferenceFields
     */
    'servingPort'?: ServingPort | null;
    /**
     * 
     * @type {AutoScaling}
     * @memberof InferenceFields
     */
    'autoscaling'?: AutoScaling | null;
}
/**
 * 
 * @export
 * @interface InferenceFieldsRules
 */
export interface InferenceFieldsRules {
    /**
     * 
     * @type {ServingPortRules}
     * @memberof InferenceFieldsRules
     */
    'servingPort'?: ServingPortRules | null;
    /**
     * 
     * @type {AutoScalingRules}
     * @memberof InferenceFieldsRules
     */
    'autoscaling'?: AutoScalingRules | null;
}
/**
 * 
 * @export
 * @interface InferenceFlatFields
 */
export interface InferenceFlatFields {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof InferenceFlatFields
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof InferenceFlatFields
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof InferenceFlatFields
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof InferenceFlatFields
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof InferenceFlatFields
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof InferenceFlatFields
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof InferenceFlatFields
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof InferenceFlatFields
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof InferenceFlatFields
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof InferenceFlatFields
     */
    'podAffinity'?: PodAffinity | null;
}
/**
 * 
 * @export
 * @interface InferenceSpecificRunParams
 */
export interface InferenceSpecificRunParams {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof InferenceSpecificRunParams
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof InferenceSpecificRunParams
     */
    'args'?: string | null;
    /**
     * The user id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsUid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof InferenceSpecificRunParams
     */
    'runAsUid'?: number | null;
    /**
     * The group id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsGid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof InferenceSpecificRunParams
     */
    'runAsGid'?: number | null;
    /**
     * Comma separated list of groups that the user running the container belongs to, in addition to the group indicated by runAsGid. Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled. Using an empty string implies reverting the supplementary groups of the image.
     * @type {string}
     * @memberof InferenceSpecificRunParams
     */
    'supplementalGroups'?: string | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariableOfAsset>}
     * @memberof InferenceSpecificRunParams
     */
    'environmentVariables'?: Array<EnvironmentVariableOfAsset> | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof InferenceSpecificRunParams
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof InferenceSpecificRunParams
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof InferenceSpecificRunParams
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof InferenceSpecificRunParams
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof InferenceSpecificRunParams
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof InferenceSpecificRunParams
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof InferenceSpecificRunParams
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof InferenceSpecificRunParams
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof InferenceSpecificRunParams
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof InferenceSpecificRunParams
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof InferenceSpecificRunParams
     */
    'tolerations'?: Array<Toleration> | null;
    /**
     * 
     * @type {Array<SpecificRunConnectionInfo>}
     * @memberof InferenceSpecificRunParams
     */
    'connections'?: Array<SpecificRunConnectionInfo> | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof InferenceSpecificRunParams
     */
    'completions'?: number | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof InferenceSpecificRunParams
     */
    'parallelism'?: number | null;
    /**
     * 
     * @type {SpecificRunAutoScalingAutoScaling}
     * @memberof InferenceSpecificRunParams
     */
    'autoScaling'?: SpecificRunAutoScalingAutoScaling | null;
    /**
     * 
     * @type {SpecificRunServingPortAccessServingPortAccess}
     * @memberof InferenceSpecificRunParams
     */
    'servingPortAccess'?: SpecificRunServingPortAccessServingPortAccess | null;
}
/**
 * information about an inference created based on assets.
 * @export
 * @interface InferenceV2
 */
export interface InferenceV2 {
    /**
     * 
     * @type {WorkloadMeta}
     * @memberof InferenceV2
     */
    'meta': WorkloadMeta;
    /**
     * 
     * @type {AssetsRef}
     * @memberof InferenceV2
     */
    'assets': AssetsRef;
    /**
     * 
     * @type {InferenceSpecificRunParams}
     * @memberof InferenceV2
     */
    'specificRunParams'?: InferenceSpecificRunParams | null;
    /**
     * 
     * @type {PolicyInfo}
     * @memberof InferenceV2
     */
    'policyInfo'?: PolicyInfo | null;
}
/**
 * Parameters which apply to the master in a distributed training. 
 * @export
 * @interface InfoDistMaster
 */
export interface InfoDistMaster {
    /**
     * 
     * @type {AssetsRefOptional}
     * @memberof InfoDistMaster
     */
    'assets'?: AssetsRefOptional | null;
    /**
     * 
     * @type {SpecificRunParams}
     * @memberof InfoDistMaster
     */
    'specificEnv'?: SpecificRunParams | null;
}
/**
 * Parameters which apply to distributed training. 
 * @export
 * @interface InfoDistributed
 */
export interface InfoDistributed {
    /**
     * 
     * @type {number}
     * @memberof InfoDistributed
     */
    'numWorkers'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InfoDistributed
     */
    'noMaster'?: boolean | null;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof InfoDistributed
     */
    'distFramework'?: DistributedFramework | null;
    /**
     * 
     * @type {InfoDistMaster}
     * @memberof InfoDistributed
     */
    'master'?: InfoDistMaster | null;
}
/**
 * 
 * @export
 * @interface InfoDistributedAllOf
 */
export interface InfoDistributedAllOf {
    /**
     * 
     * @type {number}
     * @memberof InfoDistributedAllOf
     */
    'numWorkers'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InfoDistributedAllOf
     */
    'noMaster'?: boolean | null;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof InfoDistributedAllOf
     */
    'distFramework'?: DistributedFramework | null;
    /**
     * 
     * @type {InfoDistMaster}
     * @memberof InfoDistributedAllOf
     */
    'master'?: InfoDistMaster | null;
}
/**
 * 
 * @export
 * @interface InstancesRules
 */
export interface InstancesRules {
    /**
     * 
     * @type {ItemRules}
     * @memberof InstancesRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface IntegerRules
 */
export interface IntegerRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof IntegerRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory. default to false.
     * @type {boolean}
     * @memberof IntegerRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable. default to true
     * @type {boolean}
     * @memberof IntegerRules
     */
    'canEdit'?: boolean | null;
    /**
     * The minimum value that the field can be assigned to.
     * @type {number}
     * @memberof IntegerRules
     */
    'min'?: number | null;
    /**
     * The maximum value that the field can be assigned to.
     * @type {number}
     * @memberof IntegerRules
     */
    'max'?: number | null;
    /**
     * The minimal difference between two values the field can be assigned to. For example, min=2, max=10, step=2 implies that the values the field can hold are 2, 4, 6, 8 and 10.
     * @type {number}
     * @memberof IntegerRules
     */
    'step'?: number | null;
    /**
     * 
     * @type {DefaultFromRule}
     * @memberof IntegerRules
     */
    'defaultFrom'?: DefaultFromRule | null;
}
/**
 * 
 * @export
 * @interface IntegerRulesOptional
 */
export interface IntegerRulesOptional {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof IntegerRulesOptional
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the value of the field is editable. default to true
     * @type {boolean}
     * @memberof IntegerRulesOptional
     */
    'canEdit'?: boolean | null;
    /**
     * The minimum value that the field can be assigned to.
     * @type {number}
     * @memberof IntegerRulesOptional
     */
    'min'?: number | null;
    /**
     * The maximum value that the field can be assigned to.
     * @type {number}
     * @memberof IntegerRulesOptional
     */
    'max'?: number | null;
    /**
     * The minimal difference between two values the field can be assigned to. For example, min=2, max=10, step=2 implies that the values the field can hold are 2, 4, 6, 8 and 10.
     * @type {number}
     * @memberof IntegerRulesOptional
     */
    'step'?: number | null;
    /**
     * 
     * @type {DefaultFromRule}
     * @memberof IntegerRulesOptional
     */
    'defaultFrom'?: DefaultFromRule | null;
}
/**
 * The type of connection that exposes the container port.
 * @export
 * @enum {string}
 */

export const InternalConnectionType = {
    LoadBalancer: 'LoadBalancer',
    NodePort: 'NodePort',
    ExternalUrl: 'ExternalUrl',
    ServingPort: 'ServingPort'
} as const;

export type InternalConnectionType = typeof InternalConnectionType[keyof typeof InternalConnectionType];


/**
 * Information of the internal tool.
 * @export
 * @interface InternalToolInfo
 */
export interface InternalToolInfo {
    /**
     * 
     * @type {InternalToolType}
     * @memberof InternalToolInfo
     */
    'toolType': InternalToolType;
    /**
     * 
     * @type {InternalConnectionType}
     * @memberof InternalToolInfo
     */
    'connectionType': InternalConnectionType;
    /**
     * The port within the container that the connection exposes.
     * @type {number}
     * @memberof InternalToolInfo
     */
    'containerPort': number;
    /**
     * 
     * @type {NodePortInfo}
     * @memberof InternalToolInfo
     */
    'nodePortInfo'?: NodePortInfo | null;
    /**
     * 
     * @type {ExternalUrlInfo}
     * @memberof InternalToolInfo
     */
    'externalUrlInfo'?: ExternalUrlInfo | null;
    /**
     * 
     * @type {ServingPortInfo}
     * @memberof InternalToolInfo
     */
    'servingPortInfo'?: ServingPortInfo | null;
}
/**
 * The type of the internal tool. Internal tool runs within the container and exposes ports associated with the tool using NodePort, LoadBalancer or ExternalUrl.
 * @export
 * @enum {string}
 */

export const InternalToolType = {
    JupyterNotebook: 'jupyter-notebook',
    Pycharm: 'pycharm',
    VisualStudioCode: 'visual-studio-code',
    Tensorboard: 'tensorboard',
    Rstudio: 'rstudio',
    Mlflow: 'mlflow',
    Custom: 'custom',
    Matlab: 'matlab',
    ChatbotUi: 'chatbot-ui'
} as const;

export type InternalToolType = typeof InternalToolType[keyof typeof InternalToolType];


/**
 * 
 * @export
 * @interface ItemRules
 */
export interface ItemRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof ItemRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether it is permitted to add items. Default to true.
     * @type {boolean}
     * @memberof ItemRules
     */
    'canAdd'?: boolean | null;
    /**
     * Set of keys for items that are \"locked\", i.e. cannot be removed or deleted.
     * @type {Array<string>}
     * @memberof ItemRules
     */
    'locked'?: Array<string>;
}
/**
 * Details of key-value pair to be stored in the credential.
 * @export
 * @interface KeyValuePair
 */
export interface KeyValuePair {
    /**
     * The key of the secret
     * @type {string}
     * @memberof KeyValuePair
     */
    'key'?: string | null;
    /**
     * The value of the secret.
     * @type {string}
     * @memberof KeyValuePair
     */
    'value'?: string | null;
}
/**
 * Label details to be populated into the container.
 * @export
 * @interface Label
 */
export interface Label {
    /**
     * The name of the label (mandatory)
     * @type {string}
     * @memberof Label
     */
    'name'?: string | null;
    /**
     * The value of the label.
     * @type {string}
     * @memberof Label
     */
    'value'?: string | null;
    /**
     * Use \'true\' in case the label is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof Label
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface LabelsField
 */
export interface LabelsField {
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof LabelsField
     */
    'labels'?: Array<Label> | null;
}
/**
 * 
 * @export
 * @interface LabelsFieldRules
 */
export interface LabelsFieldRules {
    /**
     * 
     * @type {InstancesRules}
     * @memberof LabelsFieldRules
     */
    'labels'?: InstancesRules | null;
}
/**
 * The spec of the master. Should be provided only if masterSpecSameAsWorker is false.
 * @export
 * @interface MasterSpec
 */
export interface MasterSpec {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof MasterSpec
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof MasterSpec
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof MasterSpec
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof MasterSpec
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof MasterSpec
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof MasterSpec
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof MasterSpec
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof MasterSpec
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof MasterSpec
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof MasterSpec
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof MasterSpec
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof MasterSpec
     */
    'stdin'?: boolean | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariable>}
     * @memberof MasterSpec
     */
    'environmentVariables'?: Array<EnvironmentVariable> | null;
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof MasterSpec
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof MasterSpec
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof MasterSpec
     */
    'tolerations'?: Array<Toleration> | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof MasterSpec
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof MasterSpec
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof MasterSpec
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof MasterSpec
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof MasterSpec
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * Set of container ports that the workload exposes.
     * @type {Array<Port>}
     * @memberof MasterSpec
     */
    'ports'?: Array<Port> | null;
    /**
     * Set of container ports that the workload exposes via URLs.
     * @type {Array<ExposedUrl>}
     * @memberof MasterSpec
     */
    'exposedUrls'?: Array<ExposedUrl> | null;
    /**
     * Set of URLs that are related to the workload.
     * @type {Array<RelatedUrl>}
     * @memberof MasterSpec
     */
    'relatedUrls'?: Array<RelatedUrl> | null;
    /**
     * 
     * @type {ComputeFields}
     * @memberof MasterSpec
     */
    'compute'?: ComputeFields | null;
    /**
     * 
     * @type {StorageFields}
     * @memberof MasterSpec
     */
    'storage'?: StorageFields | null;
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof MasterSpec
     */
    'security'?: SecurityFlatFields | null;
}
/**
 * Required only if `gpuRequestType` is `migProfile`. This states the memory profile to be used for the workload running NVIDIA Multi-Instance GPU (MIG) technology.
 * @export
 * @enum {string}
 */

export const MigProfile = {
    _1g5gb: '1g.5gb',
    _1g10gb: '1g.10gb',
    _2g10gb: '2g.10gb',
    _2g20gb: '2g.20gb',
    _3g20gb: '3g.20gb',
    _3g40gb: '3g.40gb',
    _4g20gb: '4g.20gb',
    _4g40gb: '4g.40gb',
    _7g40gb: '7g.40gb',
    _7g80gb: '7g.80gb'
} as const;

export type MigProfile = typeof MigProfile[keyof typeof MigProfile];


/**
 * 
 * @export
 * @interface ModelAsset
 */
export interface ModelAsset {
    /**
     * 
     * @type {AssetMeta}
     * @memberof ModelAsset
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {ModelAssetSpec}
     * @memberof ModelAsset
     */
    'spec': ModelAssetSpec;
    /**
     * 
     * @type {AssetUsageInfo}
     * @memberof ModelAsset
     */
    'usedBy'?: AssetUsageInfo | null;
    /**
     * 
     * @type {UsageTimesInfo}
     * @memberof ModelAsset
     */
    'usageTimes'?: UsageTimesInfo | null;
    /**
     * 
     * @type {ComplianceInfo}
     * @memberof ModelAsset
     */
    'compliance'?: ComplianceInfo | null;
}
/**
 * 
 * @export
 * @interface ModelAssetSpec
 */
export interface ModelAssetSpec {
    /**
     * the title of the model that will be displayed in the UI
     * @type {string}
     * @memberof ModelAssetSpec
     */
    'title'?: string;
    /**
     * the description of the model that will be displayed in the UI
     * @type {string}
     * @memberof ModelAssetSpec
     */
    'description'?: string | null;
    /**
     * the thumbnail of the model that will be displayed in the UI
     * @type {string}
     * @memberof ModelAssetSpec
     */
    'thumbnail'?: string | null;
    /**
     * the huggingface id of the model
     * @type {string}
     * @memberof ModelAssetSpec
     */
    'huggingfaceId'?: string | null;
    /**
     * 
     * @type {AssetsIds}
     * @memberof ModelAssetSpec
     */
    'assets'?: AssetsIds;
    /**
     * the license of the model
     * @type {string}
     * @memberof ModelAssetSpec
     */
    'license'?: string | null;
}
/**
 * 
 * @export
 * @interface ModelCreationRequest
 */
export interface ModelCreationRequest {
    /**
     * 
     * @type {AssetCreationRequest}
     * @memberof ModelCreationRequest
     */
    'meta': AssetCreationRequest;
    /**
     * 
     * @type {ModelAssetSpec}
     * @memberof ModelCreationRequest
     */
    'spec': ModelAssetSpec;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {number}
     * @memberof ModelError
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'details'?: string;
}
/**
 * 
 * @export
 * @interface ModelInference
 */
export interface ModelInference {
    /**
     * 
     * @type {WorkloadMetaV1}
     * @memberof ModelInference
     */
    'meta': WorkloadMetaV1;
    /**
     * 
     * @type {SpecificRunInfoFields}
     * @memberof ModelInference
     */
    'spec': SpecificRunInfoFields;
    /**
     * An inference workload ready for submission at the cluster. Further details at https://github.com/run-ai/runai/runai-cluster/tree/master/workload-controller/config/crd\"
     * @type {object}
     * @memberof ModelInference
     */
    'workload'?: object;
    /**
     * 
     * @type {DisplayedJob}
     * @memberof ModelInference
     */
    'job'?: DisplayedJob;
}
/**
 * 
 * @export
 * @interface ModelInferenceCreationRequest
 */
export interface ModelInferenceCreationRequest {
    /**
     * The name of the workload.
     * @type {string}
     * @memberof ModelInferenceCreationRequest
     */
    'name': string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof ModelInferenceCreationRequest
     */
    'clusterId': string;
    /**
     * The id of the project.
     * @type {number}
     * @memberof ModelInferenceCreationRequest
     */
    'projectId': number;
    /**
     * Namespace of the project in which the workload should be created.
     * @type {string}
     * @memberof ModelInferenceCreationRequest
     */
    'namespace': string;
    /**
     * 
     * @type {ModelInferenceCreationRequestAssets}
     * @memberof ModelInferenceCreationRequest
     */
    'assets'?: ModelInferenceCreationRequestAssets;
    /**
     * The id of the model.
     * @type {string}
     * @memberof ModelInferenceCreationRequest
     */
    'modelId': string;
    /**
     * 
     * @type {SpecificRunParams}
     * @memberof ModelInferenceCreationRequest
     */
    'specificEnv'?: SpecificRunParams | null;
}
/**
 * 
 * @export
 * @interface ModelInferenceCreationRequestAssets
 */
export interface ModelInferenceCreationRequestAssets {
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof ModelInferenceCreationRequestAssets
     */
    'compute': string;
}
/**
 * Request to submit a model-inference from a set of assets and an optional set of specific run parameters.
 * @export
 * @interface ModelInferenceCreationRequestV2
 */
export interface ModelInferenceCreationRequestV2 {
    /**
     * 
     * @type {WorkloadCreationMeta}
     * @memberof ModelInferenceCreationRequestV2
     */
    'meta': WorkloadCreationMeta;
    /**
     * 
     * @type {ModelInferenceCreationRequestV2Assets}
     * @memberof ModelInferenceCreationRequestV2
     */
    'assets': ModelInferenceCreationRequestV2Assets;
    /**
     * 
     * @type {InferenceSpecificRunParams}
     * @memberof ModelInferenceCreationRequestV2
     */
    'specificRunParams'?: InferenceSpecificRunParams | null;
}
/**
 * 
 * @export
 * @interface ModelInferenceCreationRequestV2Assets
 */
export interface ModelInferenceCreationRequestV2Assets {
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof ModelInferenceCreationRequestV2Assets
     */
    'model': string;
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof ModelInferenceCreationRequestV2Assets
     */
    'compute': string;
}
/**
 * information about a model-inference created based on assets.
 * @export
 * @interface ModelInferenceV2
 */
export interface ModelInferenceV2 {
    /**
     * 
     * @type {WorkloadMeta}
     * @memberof ModelInferenceV2
     */
    'meta': WorkloadMeta;
    /**
     * 
     * @type {AssetsRef}
     * @memberof ModelInferenceV2
     */
    'assets': AssetsRef;
    /**
     * 
     * @type {InferenceSpecificRunParams}
     * @memberof ModelInferenceV2
     */
    'specificRunParams'?: InferenceSpecificRunParams | null;
}
/**
 * 
 * @export
 * @interface ModelListResponse
 */
export interface ModelListResponse {
    /**
     * 
     * @type {Array<ModelAsset>}
     * @memberof ModelListResponse
     */
    'entries': Array<ModelAsset>;
}
/**
 * 
 * @export
 * @interface ModelUpdateRequest
 */
export interface ModelUpdateRequest {
    /**
     * 
     * @type {AssetUpdateRequest}
     * @memberof ModelUpdateRequest
     */
    'meta': AssetUpdateRequest;
    /**
     * 
     * @type {ModelAssetSpec}
     * @memberof ModelUpdateRequest
     */
    'spec': ModelAssetSpec;
}
/**
 * 
 * @export
 * @interface NFSAsset
 */
export interface NFSAsset {
    /**
     * 
     * @type {AssetMeta}
     * @memberof NFSAsset
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {NFSAssetSpec}
     * @memberof NFSAsset
     */
    'spec': NFSAssetSpec;
    /**
     * 
     * @type {AssetUsageInfo}
     * @memberof NFSAsset
     */
    'usedBy'?: AssetUsageInfo | null;
    /**
     * 
     * @type {UsageTimesInfo}
     * @memberof NFSAsset
     */
    'usageTimes'?: UsageTimesInfo | null;
    /**
     * 
     * @type {ComplianceInfo}
     * @memberof NFSAsset
     */
    'compliance'?: ComplianceInfo | null;
}
/**
 * 
 * @export
 * @interface NFSAssetSpec
 */
export interface NFSAssetSpec {
    /**
     * Path that is exported by the NFS server (mandatory). For more information, see [NFS](https://kubernetes.io/docs/concepts/storage/volumes#nfs).
     * @type {string}
     * @memberof NFSAssetSpec
     */
    'path'?: string | null;
    /**
     * Force the NFS export to be mounted with read-only permissions.
     * @type {boolean}
     * @memberof NFSAssetSpec
     */
    'readOnly'?: boolean | null;
    /**
     * The hostname or IP address of the NFS server. (mandatory)
     * @type {string}
     * @memberof NFSAssetSpec
     */
    'server'?: string | null;
    /**
     * The path that the NFS volume will be mounted to when in use. (mandatory)
     * @type {string}
     * @memberof NFSAssetSpec
     */
    'mountPath'?: string | null;
}
/**
 * 
 * @export
 * @interface NFSCreationRequest
 */
export interface NFSCreationRequest {
    /**
     * 
     * @type {AssetCreationRequest}
     * @memberof NFSCreationRequest
     */
    'meta': AssetCreationRequest;
    /**
     * 
     * @type {NFSAssetSpec}
     * @memberof NFSCreationRequest
     */
    'spec': NFSAssetSpec;
}
/**
 * 
 * @export
 * @interface NFSListResponse
 */
export interface NFSListResponse {
    /**
     * 
     * @type {Array<NFSAsset>}
     * @memberof NFSListResponse
     */
    'entries': Array<NFSAsset>;
}
/**
 * 
 * @export
 * @interface NFSUpdateRequest
 */
export interface NFSUpdateRequest {
    /**
     * 
     * @type {AssetUpdateRequest}
     * @memberof NFSUpdateRequest
     */
    'meta': AssetUpdateRequest;
    /**
     * 
     * @type {NFSAssetSpec}
     * @memberof NFSUpdateRequest
     */
    'spec': NFSAssetSpec;
}
/**
 * 
 * @export
 * @interface Nfs
 */
export interface Nfs {
    /**
     * Path that is exported by the NFS server (mandatory). For more information, see [NFS](https://kubernetes.io/docs/concepts/storage/volumes#nfs).
     * @type {string}
     * @memberof Nfs
     */
    'path'?: string | null;
    /**
     * Force the NFS export to be mounted with read-only permissions.
     * @type {boolean}
     * @memberof Nfs
     */
    'readOnly'?: boolean | null;
    /**
     * The hostname or IP address of the NFS server. (mandatory)
     * @type {string}
     * @memberof Nfs
     */
    'server'?: string | null;
    /**
     * The path that the NFS volume will be mounted to when in use. (mandatory)
     * @type {string}
     * @memberof Nfs
     */
    'mountPath'?: string | null;
}
/**
 * 
 * @export
 * @interface NfsInstance
 */
export interface NfsInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof NfsInstance
     */
    'name'?: string | null;
    /**
     * Path that is exported by the NFS server (mandatory). For more information, see [NFS](https://kubernetes.io/docs/concepts/storage/volumes#nfs).
     * @type {string}
     * @memberof NfsInstance
     */
    'path'?: string | null;
    /**
     * Force the NFS export to be mounted with read-only permissions.
     * @type {boolean}
     * @memberof NfsInstance
     */
    'readOnly'?: boolean | null;
    /**
     * The hostname or IP address of the NFS server. (mandatory)
     * @type {string}
     * @memberof NfsInstance
     */
    'server'?: string | null;
    /**
     * The path that the NFS volume will be mounted to when in use. (mandatory)
     * @type {string}
     * @memberof NfsInstance
     */
    'mountPath'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof NfsInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NfsRules
 */
export interface NfsRules {
    /**
     * 
     * @type {StringRules}
     * @memberof NfsRules
     */
    'path'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof NfsRules
     */
    'readOnly'?: BooleanRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof NfsRules
     */
    'server'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof NfsRules
     */
    'mountPath'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface NfssRules
 */
export interface NfssRules {
    /**
     * 
     * @type {NfsRules}
     * @memberof NfssRules
     */
    'attributes'?: NfsRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof NfssRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface NodePortInfo
 */
export interface NodePortInfo {
    /**
     * Whether the node port is provided in the specific env of the workspace. Default is false, and in this case the node port is auto generated by the system.
     * @type {boolean}
     * @memberof NodePortInfo
     */
    'isCustomPort'?: boolean;
}
/**
 * 
 * @export
 * @interface NonInferenceFlatFields
 */
export interface NonInferenceFlatFields {
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof NonInferenceFlatFields
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof NonInferenceFlatFields
     */
    'stdin'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NonInferenceSecurityFlatFields
 */
export interface NonInferenceSecurityFlatFields {
    /**
     * Allow the container running the workload and all launched processes to gain additional privileges after the workload starts. For more information consult the User Identity in Container guide at https://docs.run.ai/admin/runai-setup/config/non-root-containers/
     * @type {boolean}
     * @memberof NonInferenceSecurityFlatFields
     */
    'allowPrivilegeEscalation'?: boolean | null;
    /**
     * Whether to enable host IPC. Defaults to false.
     * @type {boolean}
     * @memberof NonInferenceSecurityFlatFields
     */
    'hostIpc'?: boolean | null;
    /**
     * Whether to enable host networking. Default to false.
     * @type {boolean}
     * @memberof NonInferenceSecurityFlatFields
     */
    'hostNetwork'?: boolean | null;
}
/**
 * Security related fields. When used in assets context, those are environment asset fields that cannot be override in the submit workload request.
 * @export
 * @interface NonInferenceSecurityNonOverridable
 */
export interface NonInferenceSecurityNonOverridable {
    /**
     * Allow the container running the workload and all launched processes to gain additional privileges after the workload starts. For more information consult the User Identity in Container guide at https://docs.run.ai/admin/runai-setup/config/non-root-containers/
     * @type {boolean}
     * @memberof NonInferenceSecurityNonOverridable
     */
    'allowPrivilegeEscalation'?: boolean | null;
    /**
     * Whether to enable host IPC. Defaults to false.
     * @type {boolean}
     * @memberof NonInferenceSecurityNonOverridable
     */
    'hostIpc'?: boolean | null;
    /**
     * Whether to enable host networking. Default to false.
     * @type {boolean}
     * @memberof NonInferenceSecurityNonOverridable
     */
    'hostNetwork'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NonInferenceStorageFields
 */
export interface NonInferenceStorageFields {
    /**
     * Set of s3 buckets to use in the workload.
     * @type {Array<S3Instance>}
     * @memberof NonInferenceStorageFields
     */
    's3'?: Array<S3Instance> | null;
}
/**
 * 
 * @export
 * @interface NonInferenceStorageFieldsRules
 */
export interface NonInferenceStorageFieldsRules {
    /**
     * 
     * @type {S3sRules}
     * @memberof NonInferenceStorageFieldsRules
     */
    's3'?: S3sRules | null;
}
/**
 * 
 * @export
 * @interface NonOverridableSpecFields
 */
export interface NonOverridableSpecFields {
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof NonOverridableSpecFields
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof NonOverridableSpecFields
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof NonOverridableSpecFields
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof NonOverridableSpecFields
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof NonOverridableSpecFields
     */
    'probes'?: Probes | null;
    /**
     * 
     * @type {UidGidSource}
     * @memberof NonOverridableSpecFields
     */
    'uidGidSource'?: UidGidSource | null;
    /**
     * Add POSIX capabilities to running containers. Defaults to the default set of capabilities granted by the container runtime.
     * @type {Array<Capability>}
     * @memberof NonOverridableSpecFields
     */
    'capabilities'?: Array<Capability> | null;
    /**
     * 
     * @type {SeccompProfileType}
     * @memberof NonOverridableSpecFields
     */
    'seccompProfileType'?: SeccompProfileType | null;
    /**
     * Force the container to run as a non-root user.
     * @type {boolean}
     * @memberof NonOverridableSpecFields
     */
    'runAsNonRoot'?: boolean | null;
    /**
     * If true, mounts the container\'s root filesystem as read-only.
     * @type {boolean}
     * @memberof NonOverridableSpecFields
     */
    'readOnlyRootFilesystem'?: boolean | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof NonOverridableSpecFields
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof NonOverridableSpecFields
     */
    'stdin'?: boolean | null;
    /**
     * Allow the container running the workload and all launched processes to gain additional privileges after the workload starts. For more information consult the User Identity in Container guide at https://docs.run.ai/admin/runai-setup/config/non-root-containers/
     * @type {boolean}
     * @memberof NonOverridableSpecFields
     */
    'allowPrivilegeEscalation'?: boolean | null;
    /**
     * Whether to enable host IPC. Defaults to false.
     * @type {boolean}
     * @memberof NonOverridableSpecFields
     */
    'hostIpc'?: boolean | null;
    /**
     * Whether to enable host networking. Default to false.
     * @type {boolean}
     * @memberof NonOverridableSpecFields
     */
    'hostNetwork'?: boolean | null;
    /**
     * List of connections that either expose ports from the container (each port is associated with a tool that the container runs), or URL\'s to be used for connecting to an external tool that is related to the action of the container (such as Weights & Biases).
     * @type {Array<Connection>}
     * @memberof NonOverridableSpecFields
     */
    'connections'?: Array<Connection>;
    /**
     * Allow specifying uid/gid as part of create workspace. This is relevant only for custom uigGidSource.
     * @type {boolean}
     * @memberof NonOverridableSpecFields
     */
    'overrideUidGidInWorkspace'?: boolean;
    /**
     * Indicates the supported routing method (host-base, path-base or agnostic)
     * @type {string}
     * @memberof NonOverridableSpecFields
     */
    'routingMethod'?: string;
}
/**
 * 
 * @export
 * @interface NonOverridableSpecFieldsAllOf
 */
export interface NonOverridableSpecFieldsAllOf {
    /**
     * List of connections that either expose ports from the container (each port is associated with a tool that the container runs), or URL\'s to be used for connecting to an external tool that is related to the action of the container (such as Weights & Biases).
     * @type {Array<Connection>}
     * @memberof NonOverridableSpecFieldsAllOf
     */
    'connections'?: Array<Connection>;
    /**
     * Allow specifying uid/gid as part of create workspace. This is relevant only for custom uigGidSource.
     * @type {boolean}
     * @memberof NonOverridableSpecFieldsAllOf
     */
    'overrideUidGidInWorkspace'?: boolean;
    /**
     * Indicates the supported routing method (host-base, path-base or agnostic)
     * @type {string}
     * @memberof NonOverridableSpecFieldsAllOf
     */
    'routingMethod'?: string;
}
/**
 * 
 * @export
 * @interface NumberRules
 */
export interface NumberRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof NumberRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory. default to false.
     * @type {boolean}
     * @memberof NumberRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable. default to true
     * @type {boolean}
     * @memberof NumberRules
     */
    'canEdit'?: boolean | null;
    /**
     * The minimum value that the field can be assigned to.
     * @type {number}
     * @memberof NumberRules
     */
    'min'?: number | null;
    /**
     * The maximum value that the field can be assigned to.
     * @type {number}
     * @memberof NumberRules
     */
    'max'?: number | null;
    /**
     * The minimal difference between two values the field can be assigned to. For example, min=2, max=3, step=0.25 implies that the values the field can hold are 2, 2.25, 2.5 and 3.
     * @type {number}
     * @memberof NumberRules
     */
    'step'?: number | null;
    /**
     * 
     * @type {DefaultFromRule}
     * @memberof NumberRules
     */
    'defaultFrom'?: DefaultFromRule | null;
}
/**
 * 
 * @export
 * @interface OptionalAssetIds
 */
export interface OptionalAssetIds {
    /**
     * Unique identifier of the asset.
     * @type {string}
     * @memberof OptionalAssetIds
     */
    'environment': string;
    /**
     * 
     * @type {string}
     * @memberof OptionalAssetIds
     */
    'compute'?: string | null;
    /**
     * 
     * @type {Array<AssetIdAndKind>}
     * @memberof OptionalAssetIds
     */
    'datasources'?: Array<AssetIdAndKind>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OptionalAssetIds
     */
    'workloadVolumes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface OverridableSpecFields
 */
export interface OverridableSpecFields {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof OverridableSpecFields
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof OverridableSpecFields
     */
    'args'?: string | null;
    /**
     * The user id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsUid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof OverridableSpecFields
     */
    'runAsUid'?: number | null;
    /**
     * The group id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsGid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof OverridableSpecFields
     */
    'runAsGid'?: number | null;
    /**
     * Comma separated list of groups that the user running the container belongs to, in addition to the group indicated by runAsGid. Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled. Using an empty string implies reverting the supplementary groups of the image.
     * @type {string}
     * @memberof OverridableSpecFields
     */
    'supplementalGroups'?: string | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariableOfAsset>}
     * @memberof OverridableSpecFields
     */
    'environmentVariables'?: Array<EnvironmentVariableOfAsset> | null;
}
/**
 * 
 * @export
 * @interface PVCAsset
 */
export interface PVCAsset {
    /**
     * 
     * @type {AssetMeta}
     * @memberof PVCAsset
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {PVCAssetSpec}
     * @memberof PVCAsset
     */
    'spec': PVCAssetSpec;
    /**
     * 
     * @type {AssetUsageInfo}
     * @memberof PVCAsset
     */
    'usedBy'?: AssetUsageInfo | null;
    /**
     * 
     * @type {UsageTimesInfo}
     * @memberof PVCAsset
     */
    'usageTimes'?: UsageTimesInfo | null;
    /**
     * 
     * @type {ComplianceInfo}
     * @memberof PVCAsset
     */
    'compliance'?: ComplianceInfo | null;
    /**
     * 
     * @type {AssetClusterStatusInfo}
     * @memberof PVCAsset
     */
    'status'?: AssetClusterStatusInfo | null;
    /**
     * 
     * @type {ClusterInfo}
     * @memberof PVCAsset
     */
    'clusterInfo'?: ClusterInfo | null;
}
/**
 * 
 * @export
 * @interface PVCAssetSpec
 */
export interface PVCAssetSpec {
    /**
     * Local path within the workspace to which the PVC bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof PVCAssetSpec
     */
    'path'?: string | null;
    /**
     * 
     * @type {ClaimInfo}
     * @memberof PVCAssetSpec
     */
    'claimInfo'?: ClaimInfo | null;
    /**
     * Verify existing PVC. PVC is assumed to exist when set to `true`. If set to `false`, the PVC will be created, if it does not exist.
     * @type {boolean}
     * @memberof PVCAssetSpec
     */
    'existingPvc'?: boolean | null;
    /**
     * Name for the PVC. Allow referencing it across workloads. If not provided, a name based on the workload name and scope will be auto-generated.
     * @type {string}
     * @memberof PVCAssetSpec
     */
    'claimName'?: string | null;
    /**
     * Permit only read access to PVC.
     * @type {boolean}
     * @memberof PVCAssetSpec
     */
    'readOnly'?: boolean | null;
    /**
     * Use `true` to set PVC to ephemeral. If set to `true`, the PVC will be deleted when the workload is stopped. Not supported for inference workloads.
     * @type {boolean}
     * @memberof PVCAssetSpec
     */
    'ephemeral'?: boolean | null;
    /**
     * use `true` to share the PVC data to all projects under the selected scope.
     * @type {boolean}
     * @memberof PVCAssetSpec
     */
    'dataSharing'?: boolean | null;
}
/**
 * 
 * @export
 * @interface PVCCreationRequest
 */
export interface PVCCreationRequest {
    /**
     * 
     * @type {AssetCreationRequest}
     * @memberof PVCCreationRequest
     */
    'meta': AssetCreationRequest;
    /**
     * 
     * @type {PVCAssetSpec}
     * @memberof PVCCreationRequest
     */
    'spec': PVCAssetSpec;
}
/**
 * 
 * @export
 * @interface PVCListResponse
 */
export interface PVCListResponse {
    /**
     * 
     * @type {Array<PVCAsset>}
     * @memberof PVCListResponse
     */
    'entries': Array<PVCAsset>;
}
/**
 * A list of pvcs statuses in the cluster
 * @export
 * @interface PVCStatusRequest
 */
export interface PVCStatusRequest {
    /**
     * List of resources which exist in the cluster and their status
     * @type {Array<PVCStatusRequestItem>}
     * @memberof PVCStatusRequest
     */
    'pvcs'?: Array<PVCStatusRequestItem>;
}
/**
 * A pvc status with its identifier in the cluster
 * @export
 * @interface PVCStatusRequestItem
 */
export interface PVCStatusRequestItem {
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof PVCStatusRequestItem
     */
    'clusterId': string;
    /**
     * The name of the pvc in the cluster
     * @type {string}
     * @memberof PVCStatusRequestItem
     */
    'claimName': string;
    /**
     * 
     * @type {PVCStatusSyncStatusInfo}
     * @memberof PVCStatusRequestItem
     */
    'statusInfo': PVCStatusSyncStatusInfo;
    /**
     * 
     * @type {Scope}
     * @memberof PVCStatusRequestItem
     */
    'scopeType': Scope;
    /**
     * The ID of the scope the asset is belong to
     * @type {string}
     * @memberof PVCStatusRequestItem
     */
    'scopeId': string;
}
/**
 * A phase and phase message of the pvc in the cluster
 * @export
 * @interface PVCStatusSyncStatusInfo
 */
export interface PVCStatusSyncStatusInfo {
    /**
     * 
     * @type {AssetStatus}
     * @memberof PVCStatusSyncStatusInfo
     */
    'status'?: AssetStatus | null;
    /**
     * An error message if something wrong happened in the cluster
     * @type {string}
     * @memberof PVCStatusSyncStatusInfo
     */
    'errorMessage'?: string;
}
/**
 * 
 * @export
 * @interface PVCSyncDetails
 */
export interface PVCSyncDetails {
    /**
     * Size is the size of the PVC.
     * @type {string}
     * @memberof PVCSyncDetails
     */
    'size': string;
    /**
     * StorageClass is the name of the StorageClass required by the claim. If not specified, the default StorageClass will be used.
     * @type {string}
     * @memberof PVCSyncDetails
     */
    'storageClass': string;
    /**
     * 
     * @type {PvcAccessModes}
     * @memberof PVCSyncDetails
     */
    'accessModes'?: PvcAccessModes | null;
    /**
     * The volume mode required by the claim, either Filesystem (default) or Block.
     * @type {string}
     * @memberof PVCSyncDetails
     */
    'volumeMode'?: PVCSyncDetailsVolumeModeEnum;
    /**
     * Whether to assume that the PVC exists. If set to true, PVC is assumed to exist. If set to false, the PVC will be create if it does not exist.
     * @type {boolean}
     * @memberof PVCSyncDetails
     */
    'existingPvc'?: boolean | null;
    /**
     * A given name for the PVC. Allowed referencing it across workspaces. ClaimName is mandatory for creating a pvc.
     * @type {string}
     * @memberof PVCSyncDetails
     */
    'claimName': string;
    /**
     * Whether the path to the PVC permits only read access.
     * @type {boolean}
     * @memberof PVCSyncDetails
     */
    'readOnly'?: boolean | null;
}

export const PVCSyncDetailsVolumeModeEnum = {
    Filesystem: 'Filesystem',
    Block: 'Block'
} as const;

export type PVCSyncDetailsVolumeModeEnum = typeof PVCSyncDetailsVolumeModeEnum[keyof typeof PVCSyncDetailsVolumeModeEnum];

/**
 * 
 * @export
 * @interface PVCToAddOrUpdate
 */
export interface PVCToAddOrUpdate {
    /**
     * 
     * @type {PVCSyncDetails}
     * @memberof PVCToAddOrUpdate
     */
    'spec': PVCSyncDetails;
    /**
     * The checksum of the asset\'s spec.
     * @type {string}
     * @memberof PVCToAddOrUpdate
     */
    'checksum': string;
}
/**
 * 
 * @export
 * @interface PVCUpdateRequest
 */
export interface PVCUpdateRequest {
    /**
     * 
     * @type {AssetUpdateRequest}
     * @memberof PVCUpdateRequest
     */
    'meta': AssetUpdateRequest;
    /**
     * 
     * @type {PvcFieldsUpdatable}
     * @memberof PVCUpdateRequest
     */
    'spec': PvcFieldsUpdatable | null;
}
/**
 * A list of updates that needs to be carried out by the cluster in order to sync its pvc assets with the control-plane.
 * @export
 * @interface PVCsSyncResponse
 */
export interface PVCsSyncResponse {
    /**
     * PVCs that need to be deleted from the cluster.
     * @type {Array<string>}
     * @memberof PVCsSyncResponse
     */
    'toDelete'?: Array<string>;
    /**
     * PVCs that needs to be added to the cluster.
     * @type {Array<PVCToAddOrUpdate>}
     * @memberof PVCsSyncResponse
     */
    'toAdd'?: Array<PVCToAddOrUpdate>;
    /**
     * PVCs that needs to be updated at the cluster.
     * @type {Array<PVCToAddOrUpdate>}
     * @memberof PVCsSyncResponse
     */
    'toUpdate'?: Array<PVCToAddOrUpdate>;
}
/**
 * 
 * @export
 * @interface ParallelismField
 */
export interface ParallelismField {
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof ParallelismField
     */
    'parallelism'?: number | null;
}
/**
 * 
 * @export
 * @interface ParallelismFieldRules
 */
export interface ParallelismFieldRules {
    /**
     * 
     * @type {IntegerRules}
     * @memberof ParallelismFieldRules
     */
    'parallelism'?: IntegerRules | null;
}
/**
 * 
 * @export
 * @interface Password
 */
export interface Password {
    /**
     * 
     * @type {AssetMeta}
     * @memberof Password
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {PasswordSpec}
     * @memberof Password
     */
    'spec': PasswordSpec;
    /**
     * 
     * @type {AssetUsageInfo}
     * @memberof Password
     */
    'usedBy'?: AssetUsageInfo | null;
    /**
     * 
     * @type {ComplianceInfo}
     * @memberof Password
     */
    'compliance'?: ComplianceInfo | null;
    /**
     * 
     * @type {AssetClusterStatusInfo}
     * @memberof Password
     */
    'status'?: AssetClusterStatusInfo | null;
    /**
     * 
     * @type {ClusterInfo}
     * @memberof Password
     */
    'clusterInfo'?: ClusterInfo | null;
}
/**
 * 
 * @export
 * @interface PasswordCreationRequest
 */
export interface PasswordCreationRequest {
    /**
     * 
     * @type {AssetCreationRequest}
     * @memberof PasswordCreationRequest
     */
    'meta': AssetCreationRequest;
    /**
     * 
     * @type {PasswordCreationSpec}
     * @memberof PasswordCreationRequest
     */
    'spec': PasswordCreationSpec;
}
/**
 * 
 * @export
 * @interface PasswordCreationSpec
 */
export interface PasswordCreationSpec {
    /**
     * optional name of existing secret in the cluster from which the user name and password should be taken. If omitted, you will have to provide those credentials in the user and password fields. The provided credentials are encrypted into the control plane database and cloned to a kubernetes secret in the cluster.
     * @type {string}
     * @memberof PasswordCreationSpec
     */
    'existingSecretName'?: string | null;
    /**
     * The name of the user, required only when not using existing secret.
     * @type {string}
     * @memberof PasswordCreationSpec
     */
    'user'?: string | null;
    /**
     * The password, required only when not using existing secret.
     * @type {string}
     * @memberof PasswordCreationSpec
     */
    'password'?: string | null;
}
/**
 * 
 * @export
 * @interface PasswordListResponse
 */
export interface PasswordListResponse {
    /**
     * 
     * @type {Array<Password>}
     * @memberof PasswordListResponse
     */
    'entries': Array<Password>;
}
/**
 * 
 * @export
 * @interface PasswordSpec
 */
export interface PasswordSpec {
    /**
     * optional name of existing secret in the cluster from which the user name and password should be taken. If omitted, you will have to provide those credentials in the user and password fields. The provided credentials are encrypted into the control plane database and cloned to a kubernetes secret in the cluster.
     * @type {string}
     * @memberof PasswordSpec
     */
    'existingSecretName'?: string | null;
    /**
     * The name of the user, required only when not using existing secret.
     * @type {string}
     * @memberof PasswordSpec
     */
    'user'?: string | null;
    /**
     * The password, required only when not using existing secret.
     * @type {string}
     * @memberof PasswordSpec
     */
    'password'?: string | null;
    /**
     * id of the encryption key which has been used to encrypt an asset\'s data.
     * @type {number}
     * @memberof PasswordSpec
     */
    'keyId': number;
}
/**
 * 
 * @export
 * @interface PasswordToAddOrUpdate
 */
export interface PasswordToAddOrUpdate {
    /**
     * The name of the asset.
     * @type {string}
     * @memberof PasswordToAddOrUpdate
     */
    'name': string;
    /**
     * 
     * @type {PasswordSpec}
     * @memberof PasswordToAddOrUpdate
     */
    'spec': PasswordSpec;
    /**
     * The checksum of the asset\'s spec.
     * @type {string}
     * @memberof PasswordToAddOrUpdate
     */
    'checksum': string;
}
/**
 * 
 * @export
 * @interface PasswordUpdateRequest
 */
export interface PasswordUpdateRequest {
    /**
     * 
     * @type {CredentialUpdateRequest}
     * @memberof PasswordUpdateRequest
     */
    'meta'?: CredentialUpdateRequest;
}
/**
 * A list of updates that needs to be carried out by the cluster in order to sync its password assets with the control-plane.
 * @export
 * @interface PasswordsSyncResponse
 */
export interface PasswordsSyncResponse {
    /**
     * Passwords that need to be deleted from the cluster.
     * @type {Array<string>}
     * @memberof PasswordsSyncResponse
     */
    'toDelete'?: Array<string>;
    /**
     * Passwords that needs to be added to the cluster.
     * @type {Array<PasswordToAddOrUpdate>}
     * @memberof PasswordsSyncResponse
     */
    'toAdd'?: Array<PasswordToAddOrUpdate>;
    /**
     * Passwords that needs to be updated at the cluster.
     * @type {Array<PasswordToAddOrUpdate>}
     * @memberof PasswordsSyncResponse
     */
    'toUpdate'?: Array<PasswordToAddOrUpdate>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Phase = {
    Creating: 'Creating',
    Initializing: 'Initializing',
    Resuming: 'Resuming',
    Pending: 'Pending',
    Deleting: 'Deleting',
    Running: 'Running',
    Updating: 'Updating',
    Stopped: 'Stopped',
    Stopping: 'Stopping',
    Degraded: 'Degraded',
    Failed: 'Failed',
    Completed: 'Completed',
    Terminating: 'Terminating',
    Unknown: 'Unknown'
} as const;

export type Phase = typeof Phase[keyof typeof Phase];


/**
 * Pod affinity scheduling rules (e.g. co-locate this workload in the same node, zone, etc. as some other workloads).
 * @export
 * @interface PodAffinity
 */
export interface PodAffinity {
    /**
     * 
     * @type {PodAffinityType}
     * @memberof PodAffinity
     */
    'type'?: PodAffinityType | null;
    /**
     * The label key to use. (mandatory)
     * @type {string}
     * @memberof PodAffinity
     */
    'key'?: string | null;
}
/**
 * 
 * @export
 * @interface PodAffinityRules
 */
export interface PodAffinityRules {
    /**
     * 
     * @type {PodAffinityTypeRules}
     * @memberof PodAffinityRules
     */
    'type'?: PodAffinityTypeRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof PodAffinityRules
     */
    'key'?: StringRules | null;
}
/**
 * The affinity type, required or preferred. (mandatory)
 * @export
 * @enum {string}
 */

export const PodAffinityType = {
    Required: 'Required',
    Preferred: 'Preferred'
} as const;

export type PodAffinityType = typeof PodAffinityType[keyof typeof PodAffinityType];


/**
 * 
 * @export
 * @interface PodAffinityTypeOptions
 */
export interface PodAffinityTypeOptions {
    /**
     * 
     * @type {Array<PodAffinityTypeOptionsOptionsInner>}
     * @memberof PodAffinityTypeOptions
     */
    'options'?: Array<PodAffinityTypeOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface PodAffinityTypeOptionsOptionsInner
 */
export interface PodAffinityTypeOptionsOptionsInner {
    /**
     * 
     * @type {PodAffinityType}
     * @memberof PodAffinityTypeOptionsOptionsInner
     */
    'value': PodAffinityType | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof PodAffinityTypeOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface PodAffinityTypeRules
 */
export interface PodAffinityTypeRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof PodAffinityTypeRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof PodAffinityTypeRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof PodAffinityTypeRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<PodAffinityTypeOptionsOptionsInner>}
     * @memberof PodAffinityTypeRules
     */
    'options'?: Array<PodAffinityTypeOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface PolicyInfo
 */
export interface PolicyInfo {
    /**
     * 
     * @type {AttributeDefaults}
     * @memberof PolicyInfo
     */
    'attributeDefaults'?: AttributeDefaults | null;
    /**
     * 
     * @type {Rules}
     * @memberof PolicyInfo
     */
    'rules'?: Rules | null;
}
/**
 * 
 * @export
 * @interface PolicyInfoAllOf
 */
export interface PolicyInfoAllOf {
    /**
     * 
     * @type {AttributeDefaults}
     * @memberof PolicyInfoAllOf
     */
    'attributeDefaults'?: AttributeDefaults | null;
}
/**
 * 
 * @export
 * @interface PolicyInfoAllOf1
 */
export interface PolicyInfoAllOf1 {
    /**
     * 
     * @type {Rules}
     * @memberof PolicyInfoAllOf1
     */
    'rules'?: Rules | null;
}
/**
 * A port for accessing the workload.
 * @export
 * @interface Port
 */
export interface Port {
    /**
     * The port that the container running the workload exposes. (mandatory)
     * @type {number}
     * @memberof Port
     */
    'container'?: number | null;
    /**
     * 
     * @type {PortServiceType}
     * @memberof Port
     */
    'serviceType'?: PortServiceType | null;
    /**
     * The external port which allows a connection to the container port. If not specified, the port will be auto-generated by the system..
     * @type {number}
     * @memberof Port
     */
    'external'?: number | null;
    /**
     * The tool type that runs on this port.
     * @type {string}
     * @memberof Port
     */
    'toolType'?: string | null;
    /**
     * A name describing the tool that runs on this port.
     * @type {string}
     * @memberof Port
     */
    'toolName'?: string | null;
    /**
     * Unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof Port
     */
    'name'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof Port
     */
    'exclude'?: boolean | null;
}
/**
 * The service type of the port (mandatory).
 * @export
 * @enum {string}
 */

export const PortServiceType = {
    LoadBalancer: 'LoadBalancer',
    NodePort: 'NodePort',
    ClusterIp: 'ClusterIP'
} as const;

export type PortServiceType = typeof PortServiceType[keyof typeof PortServiceType];


/**
 * Priority class of the workload. The default value for workspace is \'build\' and it can be changed to \'interactive-preemptible\' to allow the workload to use over-quota resources. The default value for training is \'train\' and it can be changed to \'build\' to allow the training workload to have a higher priority for in-queue scheduling and also become non-preemptive (if it\'s in deserved quota)..
 * @export
 * @enum {string}
 */

export const PriorityClass = {
    Build: 'build',
    Train: 'train',
    InteractivePreemptible: 'interactive-preemptible'
} as const;

export type PriorityClass = typeof PriorityClass[keyof typeof PriorityClass];


/**
 * 
 * @export
 * @interface PriorityClassFields
 */
export interface PriorityClassFields {
    /**
     * 
     * @type {PriorityClass}
     * @memberof PriorityClassFields
     */
    'priorityClass'?: PriorityClass | null;
}
/**
 * 
 * @export
 * @interface Probe
 */
export interface Probe {
    /**
     * Number of seconds after the container has started before liveness or readiness probes are initiated.
     * @type {number}
     * @memberof Probe
     */
    'initialDelaySeconds'?: number | null;
    /**
     * How often (in seconds) to perform the probe.
     * @type {number}
     * @memberof Probe
     */
    'periodSeconds'?: number | null;
    /**
     * Number of seconds after which the probe times out.
     * @type {number}
     * @memberof Probe
     */
    'timeoutSeconds'?: number | null;
    /**
     * Minimum consecutive successes for the probe to be considered successful after having failed.
     * @type {number}
     * @memberof Probe
     */
    'successThreshold'?: number | null;
    /**
     * When a probe fails, the number of times to try before giving up.
     * @type {number}
     * @memberof Probe
     */
    'failureThreshold'?: number | null;
    /**
     * 
     * @type {ProbeHandler}
     * @memberof Probe
     */
    'handler'?: ProbeHandler | null;
}
/**
 * The action taken to determine the health of the container. (mandatory)
 * @export
 * @interface ProbeHandler
 */
export interface ProbeHandler {
    /**
     * 
     * @type {ProbeHandlerHttpGet}
     * @memberof ProbeHandler
     */
    'httpGet'?: ProbeHandlerHttpGet;
}
/**
 * An action based on HTTP Get requests.
 * @export
 * @interface ProbeHandlerHttpGet
 */
export interface ProbeHandlerHttpGet {
    /**
     * Path to access on the HTTP server, defaults to /.
     * @type {string}
     * @memberof ProbeHandlerHttpGet
     */
    'path'?: string | null;
    /**
     * Number of the port to access on the container.
     * @type {number}
     * @memberof ProbeHandlerHttpGet
     */
    'port'?: number | null;
    /**
     * Host name to connect to, defaults to the pod IP.
     * @type {string}
     * @memberof ProbeHandlerHttpGet
     */
    'host'?: string | null;
    /**
     * 
     * @type {ProbeHandlerScheme}
     * @memberof ProbeHandlerHttpGet
     */
    'scheme'?: ProbeHandlerScheme | null;
}
/**
 * Scheme to use for connecting to the host, defaults to HTTP.
 * @export
 * @enum {string}
 */

export const ProbeHandlerScheme = {
    Http: 'HTTP',
    Https: 'HTTPS'
} as const;

export type ProbeHandlerScheme = typeof ProbeHandlerScheme[keyof typeof ProbeHandlerScheme];


/**
 * Probes are used to determine if the container is healthy and ready to accept traffic.
 * @export
 * @interface Probes
 */
export interface Probes {
    /**
     * 
     * @type {Probe}
     * @memberof Probes
     */
    'readiness'?: Probe | null;
}
/**
 * 
 * @export
 * @interface Pvc
 */
export interface Pvc {
    /**
     * Local path within the workspace to which the PVC bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof Pvc
     */
    'path'?: string | null;
    /**
     * 
     * @type {ClaimInfo}
     * @memberof Pvc
     */
    'claimInfo'?: ClaimInfo | null;
    /**
     * Verify existing PVC. PVC is assumed to exist when set to `true`. If set to `false`, the PVC will be created, if it does not exist.
     * @type {boolean}
     * @memberof Pvc
     */
    'existingPvc'?: boolean | null;
    /**
     * Name for the PVC. Allow referencing it across workloads. If not provided, a name based on the workload name and scope will be auto-generated.
     * @type {string}
     * @memberof Pvc
     */
    'claimName'?: string | null;
    /**
     * Permit only read access to PVC.
     * @type {boolean}
     * @memberof Pvc
     */
    'readOnly'?: boolean | null;
    /**
     * Use `true` to set PVC to ephemeral. If set to `true`, the PVC will be deleted when the workload is stopped. Not supported for inference workloads.
     * @type {boolean}
     * @memberof Pvc
     */
    'ephemeral'?: boolean | null;
    /**
     * use `true` to share the PVC data to all projects under the selected scope.
     * @type {boolean}
     * @memberof Pvc
     */
    'dataSharing'?: boolean | null;
}
/**
 * Requested access mode(s) for the newly created PVC.
 * @export
 * @interface PvcAccessModes
 */
export interface PvcAccessModes {
    /**
     * Requesting claim that can be mounted in read/write mode to exactly one host. This is the default access mode.
     * @type {boolean}
     * @memberof PvcAccessModes
     */
    'readWriteOnce'?: boolean | null;
    /**
     * Requesting claim that can be mounted in read-only mode to many hosts.
     * @type {boolean}
     * @memberof PvcAccessModes
     */
    'readOnlyMany'?: boolean | null;
    /**
     * Requesting claim that can be mounted in read/write mode to many hosts.
     * @type {boolean}
     * @memberof PvcAccessModes
     */
    'readWriteMany'?: boolean | null;
}
/**
 * Rules for access mode(s) for a newly created PVC.
 * @export
 * @interface PvcAccessModesRules
 */
export interface PvcAccessModesRules {
    /**
     * 
     * @type {BooleanRules}
     * @memberof PvcAccessModesRules
     */
    'readWriteOnce'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof PvcAccessModesRules
     */
    'readOnlyMany'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof PvcAccessModesRules
     */
    'readWriteMany'?: BooleanRules | null;
}
/**
 * 
 * @export
 * @interface PvcAddedAttrValue
 */
export interface PvcAddedAttrValue {
    /**
     * 
     * @type {string}
     * @memberof PvcAddedAttrValue
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof PvcAddedAttrValue
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface PvcFieldsNonUpdatable
 */
export interface PvcFieldsNonUpdatable {
    /**
     * Verify existing PVC. PVC is assumed to exist when set to `true`. If set to `false`, the PVC will be created, if it does not exist.
     * @type {boolean}
     * @memberof PvcFieldsNonUpdatable
     */
    'existingPvc'?: boolean | null;
    /**
     * Name for the PVC. Allow referencing it across workloads. If not provided, a name based on the workload name and scope will be auto-generated.
     * @type {string}
     * @memberof PvcFieldsNonUpdatable
     */
    'claimName'?: string | null;
    /**
     * Permit only read access to PVC.
     * @type {boolean}
     * @memberof PvcFieldsNonUpdatable
     */
    'readOnly'?: boolean | null;
    /**
     * Use `true` to set PVC to ephemeral. If set to `true`, the PVC will be deleted when the workload is stopped. Not supported for inference workloads.
     * @type {boolean}
     * @memberof PvcFieldsNonUpdatable
     */
    'ephemeral'?: boolean | null;
    /**
     * 
     * @type {ClaimInfo}
     * @memberof PvcFieldsNonUpdatable
     */
    'claimInfo'?: ClaimInfo | null;
    /**
     * use `true` to share the PVC data to all projects under the selected scope.
     * @type {boolean}
     * @memberof PvcFieldsNonUpdatable
     */
    'dataSharing'?: boolean | null;
}
/**
 * 
 * @export
 * @interface PvcFieldsUpdatable
 */
export interface PvcFieldsUpdatable {
    /**
     * Local path within the workspace to which the PVC bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof PvcFieldsUpdatable
     */
    'path'?: string | null;
    /**
     * 
     * @type {ClaimInfoUpdatable}
     * @memberof PvcFieldsUpdatable
     */
    'claimInfo'?: ClaimInfoUpdatable | null;
}
/**
 * 
 * @export
 * @interface PvcInstance
 */
export interface PvcInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof PvcInstance
     */
    'name'?: string | null;
    /**
     * Local path within the workspace to which the PVC bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof PvcInstance
     */
    'path'?: string | null;
    /**
     * 
     * @type {ClaimInfo}
     * @memberof PvcInstance
     */
    'claimInfo'?: ClaimInfo | null;
    /**
     * Verify existing PVC. PVC is assumed to exist when set to `true`. If set to `false`, the PVC will be created, if it does not exist.
     * @type {boolean}
     * @memberof PvcInstance
     */
    'existingPvc'?: boolean | null;
    /**
     * Name for the PVC. Allow referencing it across workloads. If not provided, a name based on the workload name and scope will be auto-generated.
     * @type {string}
     * @memberof PvcInstance
     */
    'claimName'?: string | null;
    /**
     * Permit only read access to PVC.
     * @type {boolean}
     * @memberof PvcInstance
     */
    'readOnly'?: boolean | null;
    /**
     * Use `true` to set PVC to ephemeral. If set to `true`, the PVC will be deleted when the workload is stopped. Not supported for inference workloads.
     * @type {boolean}
     * @memberof PvcInstance
     */
    'ephemeral'?: boolean | null;
    /**
     * use `true` to share the PVC data to all projects under the selected scope.
     * @type {boolean}
     * @memberof PvcInstance
     */
    'dataSharing'?: boolean | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof PvcInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface PvcRules
 */
export interface PvcRules {
    /**
     * 
     * @type {StringRules}
     * @memberof PvcRules
     */
    'claimName'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof PvcRules
     */
    'path'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof PvcRules
     */
    'readOnly'?: BooleanRules | null;
    /**
     * 
     * @type {ClaimInfoRules}
     * @memberof PvcRules
     */
    'claimInfo'?: ClaimInfoRules | null;
}
/**
 * The volume mode required by the claim. Choose Filesystem (default) or Block.
 * @export
 * @enum {string}
 */

export const PvcVolumeMode = {
    Filesystem: 'Filesystem',
    Block: 'Block'
} as const;

export type PvcVolumeMode = typeof PvcVolumeMode[keyof typeof PvcVolumeMode];


/**
 * 
 * @export
 * @interface PvcsRules
 */
export interface PvcsRules {
    /**
     * 
     * @type {PvcRules}
     * @memberof PvcsRules
     */
    'attributes'?: PvcRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof PvcsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface Registry
 */
export interface Registry {
    /**
     * 
     * @type {AssetMeta}
     * @memberof Registry
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {RegistrySpec}
     * @memberof Registry
     */
    'spec': RegistrySpec;
}
/**
 * 
 * @export
 * @interface RegistryCreationRequest
 */
export interface RegistryCreationRequest {
    /**
     * 
     * @type {AssetCreationRequest}
     * @memberof RegistryCreationRequest
     */
    'meta': AssetCreationRequest;
    /**
     * 
     * @type {RegistrySpec}
     * @memberof RegistryCreationRequest
     */
    'spec': RegistrySpec;
}
/**
 * 
 * @export
 * @interface RegistryListResponse
 */
export interface RegistryListResponse {
    /**
     * 
     * @type {Array<Registry>}
     * @memberof RegistryListResponse
     */
    'entries': Array<Registry>;
}
/**
 * 
 * @export
 * @interface RegistrySpec
 */
export interface RegistrySpec {
    /**
     * The registry base url.
     * @type {string}
     * @memberof RegistrySpec
     */
    'url': string;
    /**
     * 
     * @type {CredentialKind}
     * @memberof RegistrySpec
     */
    'credentialKind': CredentialKind;
    /**
     * The name of the user.
     * @type {string}
     * @memberof RegistrySpec
     */
    'user': string;
    /**
     * The password.
     * @type {string}
     * @memberof RegistrySpec
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface RegistryUpdateRequest
 */
export interface RegistryUpdateRequest {
    /**
     * 
     * @type {AssetUpdateRequest}
     * @memberof RegistryUpdateRequest
     */
    'meta': AssetUpdateRequest;
}
/**
 * A URL that is related to the workload. For example, a URL to an external server providing statistics or logging about the workload.
 * @export
 * @interface RelatedUrl
 */
export interface RelatedUrl {
    /**
     * The URL for connecting an external service related to the workload. (mandatory)
     * @type {string}
     * @memberof RelatedUrl
     */
    'url'?: string | null;
    /**
     * The type of service that the url provides. For example, wandb (Weights & Biases). (mandatory)
     * @type {string}
     * @memberof RelatedUrl
     */
    'type'?: string | null;
    /**
     * Unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof RelatedUrl
     */
    'name'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof RelatedUrl
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface Repositories
 */
export interface Repositories {
    /**
     * 
     * @type {Array<string>}
     * @memberof Repositories
     */
    'repositories': Array<string>;
}
/**
 * 
 * @export
 * @interface RepositoryTags
 */
export interface RepositoryTags {
    /**
     * 
     * @type {string}
     * @memberof RepositoryTags
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RepositoryTags
     */
    'tags': Array<string>;
}
/**
 * value that the agent sent to the afterUpdate query parameter.
 * @export
 * @interface RequestInfo
 */
export interface RequestInfo {
    /**
     * the value of an update counter of a data in the system.
     * @type {number}
     * @memberof RequestInfo
     */
    'afterUpdate': number;
}
/**
 * Resource parameters.
 * @export
 * @interface ResourcesFlatFields
 */
export interface ResourcesFlatFields {
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof ResourcesFlatFields
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof ResourcesFlatFields
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof ResourcesFlatFields
     */
    'podAffinity'?: PodAffinity | null;
}
/**
 * Resource related parameters.
 * @export
 * @interface ResourcesFlatFieldsRules
 */
export interface ResourcesFlatFieldsRules {
    /**
     * 
     * @type {StringRules}
     * @memberof ResourcesFlatFieldsRules
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof ResourcesFlatFieldsRules
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof ResourcesFlatFieldsRules
     */
    'podAffinity'?: PodAffinityRules | null;
}
/**
 * The lowest and highest update counts included in this bulk of updates. for example, it is possible that agent requester for afterUpdate=10 and received a bulk of four updates - 12, 13, 16, 18. in this case lowestUpdate=12, highestUpdate=18.
 * @export
 * @interface ResponseInfo
 */
export interface ResponseInfo {
    /**
     * the value of an update counter of a data in the system.
     * @type {number}
     * @memberof ResponseInfo
     */
    'lowestUpdate'?: number;
    /**
     * the value of an update counter of a data in the system.
     * @type {number}
     * @memberof ResponseInfo
     */
    'highestUpdate'?: number;
}
/**
 * Specify the restart policy of the workload pods. Default is empty, which is determine by the framework default
 * @export
 * @enum {string}
 */

export const RestartPolicy = {
    Always: 'Always',
    Never: 'Never',
    OnFailure: 'OnFailure'
} as const;

export type RestartPolicy = typeof RestartPolicy[keyof typeof RestartPolicy];


/**
 * 
 * @export
 * @interface RestartPolicyOptions
 */
export interface RestartPolicyOptions {
    /**
     * Limit the permitted values for restartPolicy to a given set of values.
     * @type {Array<RestartPolicyOptionsOptionsInner>}
     * @memberof RestartPolicyOptions
     */
    'options'?: Array<RestartPolicyOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface RestartPolicyOptionsOptionsInner
 */
export interface RestartPolicyOptionsOptionsInner {
    /**
     * 
     * @type {RestartPolicy}
     * @memberof RestartPolicyOptionsOptionsInner
     */
    'value': RestartPolicy | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof RestartPolicyOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface RestartPolicyRule
 */
export interface RestartPolicyRule {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof RestartPolicyRule
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof RestartPolicyRule
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof RestartPolicyRule
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for restartPolicy to a given set of values.
     * @type {Array<RestartPolicyOptionsOptionsInner>}
     * @memberof RestartPolicyRule
     */
    'options'?: Array<RestartPolicyOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface Rules
 */
export interface Rules {
    /**
     * 
     * @type {AssetsRules}
     * @memberof Rules
     */
    'assets'?: AssetsRules | null;
    /**
     * 
     * @type {SpecificRunParamsRules}
     * @memberof Rules
     */
    'specificRunParams'?: SpecificRunParamsRules | null;
}
/**
 * 
 * @export
 * @interface S3AccessKey
 */
export interface S3AccessKey {
    /**
     * Name of the secret containing credentials of the S3 bucket. Used for private S3 buckets.
     * @type {string}
     * @memberof S3AccessKey
     */
    'accessKeySecret'?: string | null;
    /**
     * The key to use for loading the access key id from the secret. The default is `AccessKeyId`. For more information, see [Credentials access keys](https://docs.aws.amazon.com/IAM/latest/UserGuide/id_credentials_access-keys.html).
     * @type {string}
     * @memberof S3AccessKey
     */
    'secretKeyOfAccessKeyId'?: string | null;
    /**
     * The key to use for loading the secret key from the secret. The default is `SecretKey`. For more information, see [Credentials access keys](https://docs.aws.amazon.com/IAM/latest/UserGuide/id_credentials_access-keys.html).
     * @type {string}
     * @memberof S3AccessKey
     */
    'secretKeyOfSecretKey'?: string | null;
}
/**
 * 
 * @export
 * @interface S3AccessKeyAsset
 */
export interface S3AccessKeyAsset {
    /**
     * ID of credentials asset of type access-key, for private S3 buckets.
     * @type {string}
     * @memberof S3AccessKeyAsset
     */
    'accessKeyAssetId'?: string | null;
}
/**
 * 
 * @export
 * @interface S3Asset
 */
export interface S3Asset {
    /**
     * 
     * @type {AssetMeta}
     * @memberof S3Asset
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {S3AssetSpec}
     * @memberof S3Asset
     */
    'spec': S3AssetSpec;
    /**
     * 
     * @type {AssetUsageInfo}
     * @memberof S3Asset
     */
    'usedBy'?: AssetUsageInfo | null;
    /**
     * 
     * @type {UsageTimesInfo}
     * @memberof S3Asset
     */
    'usageTimes'?: UsageTimesInfo | null;
    /**
     * 
     * @type {ComplianceInfo}
     * @memberof S3Asset
     */
    'compliance'?: ComplianceInfo | null;
    /**
     * 
     * @type {AssetClusterStatusInfo}
     * @memberof S3Asset
     */
    'status'?: AssetClusterStatusInfo | null;
}
/**
 * 
 * @export
 * @interface S3AssetSpec
 */
export interface S3AssetSpec {
    /**
     * The name of the bucket. (mandatory)
     * @type {string}
     * @memberof S3AssetSpec
     */
    'bucket'?: string | null;
    /**
     * Local path within the workspace to which the S3 bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof S3AssetSpec
     */
    'path'?: string | null;
    /**
     * The url of the S3 service provider. The default is the URL of the Amazon AWS S3 service.
     * @type {string}
     * @memberof S3AssetSpec
     */
    'url'?: string | null;
    /**
     * ID of credentials asset of type access-key, for private S3 buckets.
     * @type {string}
     * @memberof S3AssetSpec
     */
    'accessKeyAssetId'?: string | null;
}
/**
 * 
 * @export
 * @interface S3Common
 */
export interface S3Common {
    /**
     * The name of the bucket. (mandatory)
     * @type {string}
     * @memberof S3Common
     */
    'bucket'?: string | null;
    /**
     * Local path within the workspace to which the S3 bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof S3Common
     */
    'path'?: string | null;
    /**
     * The url of the S3 service provider. The default is the URL of the Amazon AWS S3 service.
     * @type {string}
     * @memberof S3Common
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface S3CreationRequest
 */
export interface S3CreationRequest {
    /**
     * 
     * @type {AssetCreationRequest}
     * @memberof S3CreationRequest
     */
    'meta': AssetCreationRequest;
    /**
     * 
     * @type {S3AssetSpec}
     * @memberof S3CreationRequest
     */
    'spec': S3AssetSpec;
}
/**
 * 
 * @export
 * @interface S3Instance
 */
export interface S3Instance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof S3Instance
     */
    'name'?: string | null;
    /**
     * The name of the bucket. (mandatory)
     * @type {string}
     * @memberof S3Instance
     */
    'bucket'?: string | null;
    /**
     * Local path within the workspace to which the S3 bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof S3Instance
     */
    'path'?: string | null;
    /**
     * The url of the S3 service provider. The default is the URL of the Amazon AWS S3 service.
     * @type {string}
     * @memberof S3Instance
     */
    'url'?: string | null;
    /**
     * Name of the secret containing credentials of the S3 bucket. Used for private S3 buckets.
     * @type {string}
     * @memberof S3Instance
     */
    'accessKeySecret'?: string | null;
    /**
     * The key to use for loading the access key id from the secret. The default is `AccessKeyId`. For more information, see [Credentials access keys](https://docs.aws.amazon.com/IAM/latest/UserGuide/id_credentials_access-keys.html).
     * @type {string}
     * @memberof S3Instance
     */
    'secretKeyOfAccessKeyId'?: string | null;
    /**
     * The key to use for loading the secret key from the secret. The default is `SecretKey`. For more information, see [Credentials access keys](https://docs.aws.amazon.com/IAM/latest/UserGuide/id_credentials_access-keys.html).
     * @type {string}
     * @memberof S3Instance
     */
    'secretKeyOfSecretKey'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof S3Instance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface S3ListResponse
 */
export interface S3ListResponse {
    /**
     * 
     * @type {Array<S3Asset>}
     * @memberof S3ListResponse
     */
    'entries': Array<S3Asset>;
}
/**
 * 
 * @export
 * @interface S3Rules
 */
export interface S3Rules {
    /**
     * 
     * @type {StringRules}
     * @memberof S3Rules
     */
    'bucket'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof S3Rules
     */
    'path'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof S3Rules
     */
    'url'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface S3UpdateRequest
 */
export interface S3UpdateRequest {
    /**
     * 
     * @type {AssetUpdateRequest}
     * @memberof S3UpdateRequest
     */
    'meta': AssetUpdateRequest;
    /**
     * 
     * @type {S3AssetSpec}
     * @memberof S3UpdateRequest
     */
    'spec': S3AssetSpec;
}
/**
 * 
 * @export
 * @interface S3sRules
 */
export interface S3sRules {
    /**
     * 
     * @type {S3Rules}
     * @memberof S3sRules
     */
    'attributes'?: S3Rules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof S3sRules
     */
    'instances'?: ItemRules | null;
}
/**
 * The scope in which an asset can be used. The highest scope, system, is intended for internal purposes only.
 * @export
 * @enum {string}
 */

export const Scope = {
    System: 'system',
    Tenant: 'tenant',
    Cluster: 'cluster',
    Department: 'department',
    Project: 'project'
} as const;

export type Scope = typeof Scope[keyof typeof Scope];


/**
 * 
 * @export
 * @enum {string}
 */

export const ScopeType = {
    System: 'system',
    Tenant: 'tenant',
    Cluster: 'cluster',
    Department: 'department',
    Project: 'project'
} as const;

export type ScopeType = typeof ScopeType[keyof typeof ScopeType];


/**
 * Indicates which kind of seccomp profile will be applied to the container. The options are a. `RuntimeDefault` - the container runtime default profile should be used. b. `Unconfined` - no profile should be applied. c. `Localhost` is not yet supported by Run:ai.
 * @export
 * @enum {string}
 */

export const SeccompProfileType = {
    RuntimeDefault: 'RuntimeDefault',
    Unconfined: 'Unconfined',
    Localhost: 'Localhost'
} as const;

export type SeccompProfileType = typeof SeccompProfileType[keyof typeof SeccompProfileType];


/**
 * 
 * @export
 * @interface Secret
 */
export interface Secret {
    /**
     * Local path within the workspace to which the Secret will be mapped to. (mandatory)
     * @type {string}
     * @memberof Secret
     */
    'mountPath'?: string | null;
    /**
     * The name of the Secret resource. (mandatory)
     * @type {string}
     * @memberof Secret
     */
    'secret'?: string | null;
}
/**
 * 
 * @export
 * @interface SecretAsset
 */
export interface SecretAsset {
    /**
     * 
     * @type {AssetMeta}
     * @memberof SecretAsset
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {SecretAssetSpec}
     * @memberof SecretAsset
     */
    'spec': SecretAssetSpec;
    /**
     * 
     * @type {AssetUsageInfo}
     * @memberof SecretAsset
     */
    'usedBy'?: AssetUsageInfo | null;
    /**
     * 
     * @type {UsageTimesInfo}
     * @memberof SecretAsset
     */
    'usageTimes'?: UsageTimesInfo | null;
    /**
     * 
     * @type {ComplianceInfo}
     * @memberof SecretAsset
     */
    'compliance'?: ComplianceInfo | null;
    /**
     * 
     * @type {AssetClusterStatusInfo}
     * @memberof SecretAsset
     */
    'status'?: AssetClusterStatusInfo | null;
}
/**
 * 
 * @export
 * @interface SecretAssetCreationRequest
 */
export interface SecretAssetCreationRequest {
    /**
     * 
     * @type {AssetCreationRequest}
     * @memberof SecretAssetCreationRequest
     */
    'meta': AssetCreationRequest;
    /**
     * 
     * @type {SecretAssetSpec}
     * @memberof SecretAssetCreationRequest
     */
    'spec': SecretAssetSpec;
}
/**
 * 
 * @export
 * @interface SecretAssetListResponse
 */
export interface SecretAssetListResponse {
    /**
     * 
     * @type {Array<SecretAsset>}
     * @memberof SecretAssetListResponse
     */
    'entries': Array<SecretAsset>;
}
/**
 * 
 * @export
 * @interface SecretAssetSpec
 */
export interface SecretAssetSpec {
    /**
     * ID of credentials asset (mandatory)
     * @type {string}
     * @memberof SecretAssetSpec
     */
    'credentialAssetId'?: string | null;
    /**
     * Local path within the workspace to which the Secret will be mapped to (mandatory)
     * @type {string}
     * @memberof SecretAssetSpec
     */
    'mountPath'?: string | null;
}
/**
 * 
 * @export
 * @interface SecretAssetSpecAllOf
 */
export interface SecretAssetSpecAllOf {
    /**
     * Local path within the workspace to which the Secret will be mapped to (mandatory)
     * @type {string}
     * @memberof SecretAssetSpecAllOf
     */
    'mountPath'?: string | null;
}
/**
 * 
 * @export
 * @interface SecretAssetUpdateRequest
 */
export interface SecretAssetUpdateRequest {
    /**
     * 
     * @type {AssetUpdateRequest}
     * @memberof SecretAssetUpdateRequest
     */
    'meta': AssetUpdateRequest;
}
/**
 * 
 * @export
 * @interface SecretFieldsNonUpdatable
 */
export interface SecretFieldsNonUpdatable {
    /**
     * The name of the Secret resource. (mandatory)
     * @type {string}
     * @memberof SecretFieldsNonUpdatable
     */
    'secret'?: string | null;
}
/**
 * 
 * @export
 * @interface SecretFieldsUpdatable
 */
export interface SecretFieldsUpdatable {
    /**
     * Local path within the workspace to which the Secret will be mapped to. (mandatory)
     * @type {string}
     * @memberof SecretFieldsUpdatable
     */
    'mountPath'?: string | null;
}
/**
 * 
 * @export
 * @interface SecretInstance
 */
export interface SecretInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof SecretInstance
     */
    'name'?: string | null;
    /**
     * Local path within the workspace to which the Secret will be mapped to. (mandatory)
     * @type {string}
     * @memberof SecretInstance
     */
    'mountPath'?: string | null;
    /**
     * The name of the Secret resource. (mandatory)
     * @type {string}
     * @memberof SecretInstance
     */
    'secret'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof SecretInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface SecretRules
 */
export interface SecretRules {
    /**
     * 
     * @type {StringRules}
     * @memberof SecretRules
     */
    'secret'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SecretRules
     */
    'mountPath'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface SecretsRules
 */
export interface SecretsRules {
    /**
     * 
     * @type {SecretRules}
     * @memberof SecretsRules
     */
    'attributes'?: SecretRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof SecretsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface Security
 */
export interface Security {
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof Security
     */
    'security'?: SecurityFlatFields | null;
}
/**
 * 
 * @export
 * @interface SecurityFlatFields
 */
export interface SecurityFlatFields {
    /**
     * 
     * @type {UidGidSource}
     * @memberof SecurityFlatFields
     */
    'uidGidSource'?: UidGidSource | null;
    /**
     * Add POSIX capabilities to running containers. Defaults to the default set of capabilities granted by the container runtime.
     * @type {Array<Capability>}
     * @memberof SecurityFlatFields
     */
    'capabilities'?: Array<Capability> | null;
    /**
     * 
     * @type {SeccompProfileType}
     * @memberof SecurityFlatFields
     */
    'seccompProfileType'?: SeccompProfileType | null;
    /**
     * Force the container to run as a non-root user.
     * @type {boolean}
     * @memberof SecurityFlatFields
     */
    'runAsNonRoot'?: boolean | null;
    /**
     * If true, mounts the container\'s root filesystem as read-only.
     * @type {boolean}
     * @memberof SecurityFlatFields
     */
    'readOnlyRootFilesystem'?: boolean | null;
    /**
     * The user id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsUid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof SecurityFlatFields
     */
    'runAsUid'?: number | null;
    /**
     * The group id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsGid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof SecurityFlatFields
     */
    'runAsGid'?: number | null;
    /**
     * Comma separated list of groups that the user running the container belongs to, in addition to the group indicated by runAsGid. Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled. Using an empty string implies reverting the supplementary groups of the image.
     * @type {string}
     * @memberof SecurityFlatFields
     */
    'supplementalGroups'?: string | null;
    /**
     * Allow the container running the workload and all launched processes to gain additional privileges after the workload starts. For more information consult the User Identity in Container guide at https://docs.run.ai/admin/runai-setup/config/non-root-containers/
     * @type {boolean}
     * @memberof SecurityFlatFields
     */
    'allowPrivilegeEscalation'?: boolean | null;
    /**
     * Whether to enable host IPC. Defaults to false.
     * @type {boolean}
     * @memberof SecurityFlatFields
     */
    'hostIpc'?: boolean | null;
    /**
     * Whether to enable host networking. Default to false.
     * @type {boolean}
     * @memberof SecurityFlatFields
     */
    'hostNetwork'?: boolean | null;
}
/**
 * A port for accessing the inference service
 * @export
 * @interface ServingPort
 */
export interface ServingPort {
    /**
     * The port that the container running the inference service exposes (mandatory).
     * @type {number}
     * @memberof ServingPort
     */
    'container'?: number | null;
    /**
     * 
     * @type {ServingPortProtocol}
     * @memberof ServingPort
     */
    'protocol'?: ServingPortProtocol | null;
    /**
     * 
     * @type {ServingPortAccessAuthorizationTypeEnum}
     * @memberof ServingPort
     */
    'authorizationType'?: ServingPortAccessAuthorizationTypeEnum | null;
    /**
     * List of users that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ServingPort
     */
    'authorizedUsers'?: Array<string> | null;
    /**
     * List of groups that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ServingPort
     */
    'authorizedGroups'?: Array<string> | null;
    /**
     * Configure the serving port URL to be available only on the cluster-local network, and not externally. Defaults to false
     * @type {boolean}
     * @memberof ServingPort
     */
    'clusterLocalAccessOnly'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ServingPortAccess
 */
export interface ServingPortAccess {
    /**
     * 
     * @type {ServingPortAccessAuthorizationTypeEnum}
     * @memberof ServingPortAccess
     */
    'authorizationType'?: ServingPortAccessAuthorizationTypeEnum | null;
    /**
     * List of users that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ServingPortAccess
     */
    'authorizedUsers'?: Array<string> | null;
    /**
     * List of groups that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ServingPortAccess
     */
    'authorizedGroups'?: Array<string> | null;
    /**
     * Configure the serving port URL to be available only on the cluster-local network, and not externally. Defaults to false
     * @type {boolean}
     * @memberof ServingPortAccess
     */
    'clusterLocalAccessOnly'?: boolean | null;
}
/**
 * The authorization type for serving port URL access. Defaults to public, which means no authorization is required. If set to authenticatedUsers, only authenticated Run:ai users are allowed to access the URL. If set to authorizedUsersOrGroups, only users or groups specified in authorizedUsers or authorizedGroups are allowed to access the URL.
 * @export
 * @enum {string}
 */

export const ServingPortAccessAuthorizationTypeEnum = {
    Public: 'public',
    AuthenticatedUsers: 'authenticatedUsers',
    AuthorizedUsersOrGroups: 'authorizedUsersOrGroups'
} as const;

export type ServingPortAccessAuthorizationTypeEnum = typeof ServingPortAccessAuthorizationTypeEnum[keyof typeof ServingPortAccessAuthorizationTypeEnum];


/**
 * 
 * @export
 * @interface ServingPortContainerAndProtocol
 */
export interface ServingPortContainerAndProtocol {
    /**
     * The port that the container running the inference service exposes (mandatory).
     * @type {number}
     * @memberof ServingPortContainerAndProtocol
     */
    'container'?: number | null;
    /**
     * 
     * @type {ServingPortProtocol}
     * @memberof ServingPortContainerAndProtocol
     */
    'protocol'?: ServingPortProtocol | null;
}
/**
 * 
 * @export
 * @interface ServingPortInfo
 */
export interface ServingPortInfo {
    /**
     * 
     * @type {string}
     * @memberof ServingPortInfo
     */
    'protocol'?: ServingPortInfoProtocolEnum;
}

export const ServingPortInfoProtocolEnum = {
    Grpc: 'grpc',
    Http: 'http'
} as const;

export type ServingPortInfoProtocolEnum = typeof ServingPortInfoProtocolEnum[keyof typeof ServingPortInfoProtocolEnum];

/**
 * The protocol used by the port, defaults to http
 * @export
 * @enum {string}
 */

export const ServingPortProtocol = {
    Http: 'http',
    Grpc: 'grpc'
} as const;

export type ServingPortProtocol = typeof ServingPortProtocol[keyof typeof ServingPortProtocol];


/**
 * 
 * @export
 * @interface ServingPortProtocolOptions
 */
export interface ServingPortProtocolOptions {
    /**
     * 
     * @type {Array<ServingPortProtocolOptionsOptionsInner>}
     * @memberof ServingPortProtocolOptions
     */
    'options'?: Array<ServingPortProtocolOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface ServingPortProtocolOptionsOptionsInner
 */
export interface ServingPortProtocolOptionsOptionsInner {
    /**
     * 
     * @type {ServingPortProtocol}
     * @memberof ServingPortProtocolOptionsOptionsInner
     */
    'value': ServingPortProtocol | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof ServingPortProtocolOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface ServingPortProtocolRules
 */
export interface ServingPortProtocolRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof ServingPortProtocolRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof ServingPortProtocolRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof ServingPortProtocolRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<ServingPortProtocolOptionsOptionsInner>}
     * @memberof ServingPortProtocolRules
     */
    'options'?: Array<ServingPortProtocolOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface ServingPortRules
 */
export interface ServingPortRules {
    /**
     * 
     * @type {IntegerRules}
     * @memberof ServingPortRules
     */
    'container'?: IntegerRules | null;
    /**
     * 
     * @type {ServingPortProtocolRules}
     * @memberof ServingPortRules
     */
    'protocol'?: ServingPortProtocolRules | null;
}
/**
 * This field is used by the system along with effective rules, in order to specify the org unit from which this effective rule has been derived. It should be left empty when sending apply policy requests.
 * @export
 * @interface SourceOfRule
 */
export interface SourceOfRule {
    /**
     * 
     * @type {ScopeType}
     * @memberof SourceOfRule
     */
    'scope': ScopeType;
    /**
     * The id of the project.
     * @type {number}
     * @memberof SourceOfRule
     */
    'projectId'?: number | null;
    /**
     * The id of the department.
     * @type {string}
     * @memberof SourceOfRule
     */
    'departmentId'?: string | null;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof SourceOfRule
     */
    'clusterId'?: string | null;
    /**
     * source of this rule is the fallback policy
     * @type {boolean}
     * @memberof SourceOfRule
     */
    'isFallback'?: boolean;
}
/**
 * 
 * @export
 * @interface SpecificRunAutoScaling
 */
export interface SpecificRunAutoScaling {
    /**
     * 
     * @type {SpecificRunAutoScalingAutoScaling}
     * @memberof SpecificRunAutoScaling
     */
    'autoScaling'?: SpecificRunAutoScalingAutoScaling | null;
}
/**
 * 
 * @export
 * @interface SpecificRunAutoScalingAutoScaling
 */
export interface SpecificRunAutoScalingAutoScaling {
    /**
     * The percentage of metric threshold value to use for autoscaling. Defaults to 70. Applicable only with the \'throughput\' and \'concurrency\' metrics
     * @type {number}
     * @memberof SpecificRunAutoScalingAutoScaling
     */
    'metricThresholdPercentage'?: number | null;
    /**
     * The minimum number of replicas for autoscaling. Defaults to 1. Use 0 to allow scale-to-zero
     * @type {number}
     * @memberof SpecificRunAutoScalingAutoScaling
     */
    'minReplicas'?: number | null;
    /**
     * The maximum number of replicas for autoscaling. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof SpecificRunAutoScalingAutoScaling
     */
    'maxReplicas'?: number | null;
    /**
     * The number of replicas to run when initializing the workload for the first time. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof SpecificRunAutoScalingAutoScaling
     */
    'initialReplicas'?: number | null;
    /**
     * The number of replicas to run when scaling-up from zero. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof SpecificRunAutoScalingAutoScaling
     */
    'activationReplicas'?: number | null;
    /**
     * The maximum number of requests allowed to flow to a single replica at any time. 0 means no limit
     * @type {number}
     * @memberof SpecificRunAutoScalingAutoScaling
     */
    'concurrencyHardLimit'?: number | null;
    /**
     * The minimum amount of time (in seconds) that the last replica will remain active after a scale-to-zero decision. Defaults to 0. Available only if minReplicas is set to 0
     * @type {number}
     * @memberof SpecificRunAutoScalingAutoScaling
     */
    'scaleToZeroRetentionSeconds'?: number | null;
    /**
     * The minimum amount of time (in seconds) that a replica will remain active after a scale-down decision
     * @type {number}
     * @memberof SpecificRunAutoScalingAutoScaling
     */
    'scaleDownDelaySeconds'?: number | null;
    /**
     * The maximum amount of time (in seconds) to wait for the container to become ready
     * @type {number}
     * @memberof SpecificRunAutoScalingAutoScaling
     */
    'initializationTimeoutSeconds'?: number | null;
    /**
     * The metric to use for autoscaling. Mandatory if minReplicas < maxReplicas, except for the special case where minReplicas is set to 0 and maxReplicas is set to 1, as in this case autoscaling decisions are made according to network activity rather than metrics. Use one of the built-in metrics of \'throughput\', \'concurrency\' or \'latency\', or any other available custom metric. Only the \'throughput\' and \'concurrency\' metrics support scale-to-zero
     * @type {string}
     * @memberof SpecificRunAutoScalingAutoScaling
     */
    'thresholdMetric'?: string | null;
    /**
     * The threshold value to use with the specified metric for autoscaling
     * @type {number}
     * @memberof SpecificRunAutoScalingAutoScaling
     */
    'thresholdValue'?: number | null;
}
/**
 * 
 * @export
 * @interface SpecificRunConnectionInfo
 */
export interface SpecificRunConnectionInfo {
    /**
     * Unique identifier of the connection. Will be used to correlate between the information given here and the information provided for the connection in the environment asset.
     * @type {string}
     * @memberof SpecificRunConnectionInfo
     */
    'name'?: string;
    /**
     * Port number of the host that will be connected with the container port. Required if and only if isCustomPort is set to true in the environment asset.
     * @type {number}
     * @memberof SpecificRunConnectionInfo
     */
    'nodePort'?: number | null;
    /**
     * URL to associated with the container port. Required if and only if isCustomExternalUrl is set to true in the environment asset.
     * @type {string}
     * @memberof SpecificRunConnectionInfo
     */
    'externalUrl'?: string | null;
    /**
     * Specifies the emails of those users that are allowed to access the connection. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof SpecificRunConnectionInfo
     */
    'authorizedUsers'?: Array<string> | null;
    /**
     * Specifies the names of those groups that are allowed to access the connection. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof SpecificRunConnectionInfo
     */
    'authorizedGroups'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface SpecificRunConnections
 */
export interface SpecificRunConnections {
    /**
     * 
     * @type {Array<SpecificRunConnectionInfo>}
     * @memberof SpecificRunConnections
     */
    'connections'?: Array<SpecificRunConnectionInfo> | null;
}
/**
 * The information needed for creating az template - a set of assets and an optional set of specific environment parameters.
 * @export
 * @interface SpecificRunCreationFields
 */
export interface SpecificRunCreationFields {
    /**
     * 
     * @type {AssetsIds}
     * @memberof SpecificRunCreationFields
     */
    'assets': AssetsIds;
    /**
     * 
     * @type {SpecificRunParams}
     * @memberof SpecificRunCreationFields
     */
    'specificEnv'?: SpecificRunParams | null;
}
/**
 * Information about the set of assets which comprises a workspace, training or template, and an optional set of specific run parameters.
 * @export
 * @interface SpecificRunInfoFields
 */
export interface SpecificRunInfoFields {
    /**
     * 
     * @type {AssetsRef}
     * @memberof SpecificRunInfoFields
     */
    'assets': AssetsRef;
    /**
     * 
     * @type {SpecificRunParams}
     * @memberof SpecificRunInfoFields
     */
    'specificEnv'?: SpecificRunParams | null;
    /**
     * 
     * @type {InfoDistributed}
     * @memberof SpecificRunInfoFields
     */
    'distributed'?: InfoDistributed | null;
}
/**
 * 
 * @export
 * @interface SpecificRunMetricFields
 */
export interface SpecificRunMetricFields {
    /**
     * The metric to use for autoscaling. Mandatory if minReplicas < maxReplicas, except for the special case where minReplicas is set to 0 and maxReplicas is set to 1, as in this case autoscaling decisions are made according to network activity rather than metrics. Use one of the built-in metrics of \'throughput\', \'concurrency\' or \'latency\', or any other available custom metric. Only the \'throughput\' and \'concurrency\' metrics support scale-to-zero
     * @type {string}
     * @memberof SpecificRunMetricFields
     */
    'thresholdMetric'?: string | null;
    /**
     * The threshold value to use with the specified metric for autoscaling
     * @type {number}
     * @memberof SpecificRunMetricFields
     */
    'thresholdValue'?: number | null;
}
/**
 * 
 * @export
 * @interface SpecificRunParamAttrDefaults
 */
export interface SpecificRunParamAttrDefaults {
    /**
     * 
     * @type {Toleration}
     * @memberof SpecificRunParamAttrDefaults
     */
    'tolerations'?: Toleration | null;
}
/**
 * Parameters which apply to a specific workload. They complement the information gathered from the assets comprising the workload. 
 * @export
 * @interface SpecificRunParams
 */
export interface SpecificRunParams {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof SpecificRunParams
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof SpecificRunParams
     */
    'args'?: string | null;
    /**
     * The user id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsUid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof SpecificRunParams
     */
    'runAsUid'?: number | null;
    /**
     * The group id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsGid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof SpecificRunParams
     */
    'runAsGid'?: number | null;
    /**
     * Comma separated list of groups that the user running the container belongs to, in addition to the group indicated by runAsGid. Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled. Using an empty string implies reverting the supplementary groups of the image.
     * @type {string}
     * @memberof SpecificRunParams
     */
    'supplementalGroups'?: string | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariableOfAsset>}
     * @memberof SpecificRunParams
     */
    'environmentVariables'?: Array<EnvironmentVariableOfAsset> | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof SpecificRunParams
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof SpecificRunParams
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof SpecificRunParams
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof SpecificRunParams
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof SpecificRunParams
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof SpecificRunParams
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof SpecificRunParams
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof SpecificRunParams
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof SpecificRunParams
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof SpecificRunParams
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof SpecificRunParams
     */
    'tolerations'?: Array<Toleration> | null;
    /**
     * 
     * @type {Array<SpecificRunConnectionInfo>}
     * @memberof SpecificRunParams
     */
    'connections'?: Array<SpecificRunConnectionInfo> | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof SpecificRunParams
     */
    'completions'?: number | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof SpecificRunParams
     */
    'parallelism'?: number | null;
    /**
     * Whether to allow the workload to exceed the quota of the project.
     * @type {boolean}
     * @memberof SpecificRunParams
     */
    'allowOverQuota'?: boolean | null;
    /**
     * 
     * @type {SpecificRunAutoScalingAutoScaling}
     * @memberof SpecificRunParams
     */
    'autoScaling'?: SpecificRunAutoScalingAutoScaling | null;
    /**
     * 
     * @type {SpecificRunServingPortAccessServingPortAccess}
     * @memberof SpecificRunParams
     */
    'servingPortAccess'?: SpecificRunServingPortAccessServingPortAccess | null;
}
/**
 * 
 * @export
 * @interface SpecificRunParamsCommon
 */
export interface SpecificRunParamsCommon {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof SpecificRunParamsCommon
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof SpecificRunParamsCommon
     */
    'args'?: string | null;
    /**
     * The user id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsUid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof SpecificRunParamsCommon
     */
    'runAsUid'?: number | null;
    /**
     * The group id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsGid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof SpecificRunParamsCommon
     */
    'runAsGid'?: number | null;
    /**
     * Comma separated list of groups that the user running the container belongs to, in addition to the group indicated by runAsGid. Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled. Using an empty string implies reverting the supplementary groups of the image.
     * @type {string}
     * @memberof SpecificRunParamsCommon
     */
    'supplementalGroups'?: string | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariableOfAsset>}
     * @memberof SpecificRunParamsCommon
     */
    'environmentVariables'?: Array<EnvironmentVariableOfAsset> | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof SpecificRunParamsCommon
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof SpecificRunParamsCommon
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof SpecificRunParamsCommon
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof SpecificRunParamsCommon
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof SpecificRunParamsCommon
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof SpecificRunParamsCommon
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof SpecificRunParamsCommon
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof SpecificRunParamsCommon
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof SpecificRunParamsCommon
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof SpecificRunParamsCommon
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof SpecificRunParamsCommon
     */
    'tolerations'?: Array<Toleration> | null;
    /**
     * 
     * @type {Array<SpecificRunConnectionInfo>}
     * @memberof SpecificRunParamsCommon
     */
    'connections'?: Array<SpecificRunConnectionInfo> | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof SpecificRunParamsCommon
     */
    'completions'?: number | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof SpecificRunParamsCommon
     */
    'parallelism'?: number | null;
}
/**
 * 
 * @export
 * @interface SpecificRunParamsCommonRules
 */
export interface SpecificRunParamsCommonRules {
    /**
     * 
     * @type {StringRules}
     * @memberof SpecificRunParamsCommonRules
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SpecificRunParamsCommonRules
     */
    'args'?: StringRules | null;
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof SpecificRunParamsCommonRules
     */
    'runAsUid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof SpecificRunParamsCommonRules
     */
    'runAsGid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SpecificRunParamsCommonRules
     */
    'supplementalGroups'?: StringRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof SpecificRunParamsCommonRules
     */
    'environmentVariables'?: InstancesRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SpecificRunParamsCommonRules
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof SpecificRunParamsCommonRules
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof SpecificRunParamsCommonRules
     */
    'podAffinity'?: PodAffinityRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SpecificRunParamsCommonRules
     */
    'terminateAfterPreemption'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SpecificRunParamsCommonRules
     */
    'autoDeletionTimeAfterCompletionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SpecificRunParamsCommonRules
     */
    'terminationGracePeriodSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SpecificRunParamsCommonRules
     */
    'backoffLimit'?: IntegerRules | null;
    /**
     * 
     * @type {RestartPolicyRule}
     * @memberof SpecificRunParamsCommonRules
     */
    'restartPolicy'?: RestartPolicyRule | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof SpecificRunParamsCommonRules
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof SpecificRunParamsCommonRules
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof SpecificRunParamsCommonRules
     */
    'tolerations'?: TolerationsRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SpecificRunParamsCommonRules
     */
    'parallelism'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SpecificRunParamsCommonRules
     */
    'completions'?: IntegerRules | null;
}
/**
 * Rules which apply to specific workload.
 * @export
 * @interface SpecificRunParamsRules
 */
export interface SpecificRunParamsRules {
    /**
     * 
     * @type {StringRules}
     * @memberof SpecificRunParamsRules
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SpecificRunParamsRules
     */
    'args'?: StringRules | null;
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof SpecificRunParamsRules
     */
    'runAsUid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof SpecificRunParamsRules
     */
    'runAsGid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SpecificRunParamsRules
     */
    'supplementalGroups'?: StringRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof SpecificRunParamsRules
     */
    'environmentVariables'?: InstancesRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SpecificRunParamsRules
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof SpecificRunParamsRules
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof SpecificRunParamsRules
     */
    'podAffinity'?: PodAffinityRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SpecificRunParamsRules
     */
    'terminateAfterPreemption'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SpecificRunParamsRules
     */
    'autoDeletionTimeAfterCompletionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SpecificRunParamsRules
     */
    'terminationGracePeriodSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SpecificRunParamsRules
     */
    'backoffLimit'?: IntegerRules | null;
    /**
     * 
     * @type {RestartPolicyRule}
     * @memberof SpecificRunParamsRules
     */
    'restartPolicy'?: RestartPolicyRule | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof SpecificRunParamsRules
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof SpecificRunParamsRules
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof SpecificRunParamsRules
     */
    'tolerations'?: TolerationsRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SpecificRunParamsRules
     */
    'parallelism'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SpecificRunParamsRules
     */
    'completions'?: IntegerRules | null;
    /**
     * 
     * @type {ServingPortRules}
     * @memberof SpecificRunParamsRules
     */
    'servingPort'?: ServingPortRules | null;
    /**
     * 
     * @type {AutoScalingRules}
     * @memberof SpecificRunParamsRules
     */
    'autoscaling'?: AutoScalingRules | null;
}
/**
 * 
 * @export
 * @interface SpecificRunServingPortAccess
 */
export interface SpecificRunServingPortAccess {
    /**
     * 
     * @type {SpecificRunServingPortAccessServingPortAccess}
     * @memberof SpecificRunServingPortAccess
     */
    'servingPortAccess'?: SpecificRunServingPortAccessServingPortAccess | null;
}
/**
 * 
 * @export
 * @interface SpecificRunServingPortAccessServingPortAccess
 */
export interface SpecificRunServingPortAccessServingPortAccess {
    /**
     * 
     * @type {ServingPortAccessAuthorizationTypeEnum}
     * @memberof SpecificRunServingPortAccessServingPortAccess
     */
    'authorizationType'?: ServingPortAccessAuthorizationTypeEnum | null;
    /**
     * List of users that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof SpecificRunServingPortAccessServingPortAccess
     */
    'authorizedUsers'?: Array<string> | null;
    /**
     * List of groups that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof SpecificRunServingPortAccessServingPortAccess
     */
    'authorizedGroups'?: Array<string> | null;
    /**
     * Configure the serving port URL to be available only on the cluster-local network, and not externally. Defaults to false
     * @type {boolean}
     * @memberof SpecificRunServingPortAccessServingPortAccess
     */
    'clusterLocalAccessOnly'?: boolean | null;
}
/**
 * 
 * @export
 * @interface Storage
 */
export interface Storage {
    /**
     * 
     * @type {StorageFields}
     * @memberof Storage
     */
    'storage'?: StorageFields | null;
}
/**
 * 
 * @export
 * @interface StorageFields
 */
export interface StorageFields {
    /**
     * Set of data volumes to use in the workload.
     * @type {Array<DataVolumeInstance>}
     * @memberof StorageFields
     */
    'dataVolume'?: Array<DataVolumeInstance> | null;
    /**
     * Set of pvc persistent volume claims to use in the workload.
     * @type {Array<PvcInstance>}
     * @memberof StorageFields
     */
    'pvc'?: Array<PvcInstance> | null;
    /**
     * Set of host paths to use in the workload.
     * @type {Array<HostPathInstance>}
     * @memberof StorageFields
     */
    'hostPath'?: Array<HostPathInstance> | null;
    /**
     * Set of nfs volumes to use in the workload.
     * @type {Array<NfsInstance>}
     * @memberof StorageFields
     */
    'nfs'?: Array<NfsInstance> | null;
    /**
     * Set of git repositories to use in the workload.
     * @type {Array<GitInstance>}
     * @memberof StorageFields
     */
    'git'?: Array<GitInstance> | null;
    /**
     * Set of config map volumes to use in the workload
     * @type {Array<ConfigMapInstance>}
     * @memberof StorageFields
     */
    'configMapVolume'?: Array<ConfigMapInstance> | null;
    /**
     * Set of secret volumes to use in the workload
     * @type {Array<SecretInstance>}
     * @memberof StorageFields
     */
    'secretVolume'?: Array<SecretInstance> | null;
    /**
     * Set of s3 buckets to use in the workload.
     * @type {Array<S3Instance>}
     * @memberof StorageFields
     */
    's3'?: Array<S3Instance> | null;
}
/**
 * 
 * @export
 * @interface StorageFieldsRules
 */
export interface StorageFieldsRules {
    /**
     * 
     * @type {DataVolumesRules}
     * @memberof StorageFieldsRules
     */
    'dataVolume'?: DataVolumesRules | null;
    /**
     * 
     * @type {PvcsRules}
     * @memberof StorageFieldsRules
     */
    'pvc'?: PvcsRules | null;
    /**
     * 
     * @type {HostPathsRules}
     * @memberof StorageFieldsRules
     */
    'hostPath'?: HostPathsRules | null;
    /**
     * 
     * @type {NfssRules}
     * @memberof StorageFieldsRules
     */
    'nfs'?: NfssRules | null;
    /**
     * 
     * @type {GitsRules}
     * @memberof StorageFieldsRules
     */
    'git'?: GitsRules | null;
    /**
     * 
     * @type {ConfigMapsRules}
     * @memberof StorageFieldsRules
     */
    'configMapVolume'?: ConfigMapsRules | null;
    /**
     * 
     * @type {SecretsRules}
     * @memberof StorageFieldsRules
     */
    'secretVolume'?: SecretsRules | null;
    /**
     * 
     * @type {S3sRules}
     * @memberof StorageFieldsRules
     */
    's3'?: S3sRules | null;
}
/**
 * 
 * @export
 * @interface StorageInstanceName
 */
export interface StorageInstanceName {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof StorageInstanceName
     */
    'name'?: string | null;
}
/**
 * One of the values that the field can be assigned to, when options police is applied on the field.
 * @export
 * @interface StringOption
 */
export interface StringOption {
    /**
     * The value that the field should hold
     * @type {string}
     * @memberof StringOption
     */
    'value': string;
    /**
     * Textual description of the value. to be used by user interface applications.
     * @type {string}
     * @memberof StringOption
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface StringRules
 */
export interface StringRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof StringRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof StringRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof StringRules
     */
    'canEdit'?: boolean | null;
    /**
     * Set of options that the value of the field must be chosen from.
     * @type {Array<StringOption>}
     * @memberof StringRules
     */
    'options'?: Array<StringOption> | null;
}
/**
 * 
 * @export
 * @interface StringRulesCommon
 */
export interface StringRulesCommon {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof StringRulesCommon
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof StringRulesCommon
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof StringRulesCommon
     */
    'canEdit'?: boolean | null;
}
/**
 * 
 * @export
 * @interface StringRulesOptions
 */
export interface StringRulesOptions {
    /**
     * Set of options that the value of the field must be chosen from.
     * @type {Array<StringOption>}
     * @memberof StringRulesOptions
     */
    'options'?: Array<StringOption> | null;
}
/**
 * 
 * @export
 * @interface SubmissionError
 */
export interface SubmissionError {
    /**
     * 
     * @type {number}
     * @memberof SubmissionError
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SubmissionError
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionError
     */
    'details'?: string;
    /**
     * 
     * @type {Array<ComplianceIssuesComplianceIssuesInner>}
     * @memberof SubmissionError
     */
    'complianceIssues'?: Array<ComplianceIssuesComplianceIssuesInner>;
}
/**
 * 
 * @export
 * @interface SupersetSpec
 */
export interface SupersetSpec {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof SupersetSpec
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof SupersetSpec
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof SupersetSpec
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof SupersetSpec
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof SupersetSpec
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof SupersetSpec
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof SupersetSpec
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof SupersetSpec
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof SupersetSpec
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof SupersetSpec
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof SupersetSpec
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof SupersetSpec
     */
    'stdin'?: boolean | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariable>}
     * @memberof SupersetSpec
     */
    'environmentVariables'?: Array<EnvironmentVariable> | null;
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof SupersetSpec
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof SupersetSpec
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof SupersetSpec
     */
    'tolerations'?: Array<Toleration> | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof SupersetSpec
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof SupersetSpec
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof SupersetSpec
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof SupersetSpec
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof SupersetSpec
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * Set of container ports that the workload exposes.
     * @type {Array<Port>}
     * @memberof SupersetSpec
     */
    'ports'?: Array<Port> | null;
    /**
     * Set of container ports that the workload exposes via URLs.
     * @type {Array<ExposedUrl>}
     * @memberof SupersetSpec
     */
    'exposedUrls'?: Array<ExposedUrl> | null;
    /**
     * Set of URLs that are related to the workload.
     * @type {Array<RelatedUrl>}
     * @memberof SupersetSpec
     */
    'relatedUrls'?: Array<RelatedUrl> | null;
    /**
     * 
     * @type {PriorityClass}
     * @memberof SupersetSpec
     */
    'priorityClass'?: PriorityClass | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof SupersetSpec
     */
    'completions'?: number | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof SupersetSpec
     */
    'parallelism'?: number | null;
    /**
     * the number of workers that will be allocated for running the workload.
     * @type {number}
     * @memberof SupersetSpec
     */
    'numWorkers'?: number | null;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof SupersetSpec
     */
    'distributedFramework'?: DistributedFramework | null;
    /**
     * Specifies the number of slots per worker used in hostfile. Defaults to 1. (applicable only for MPI)
     * @type {number}
     * @memberof SupersetSpec
     */
    'slotsPerWorker'?: number | null;
    /**
     * Specifies the directory where SSH keys are mounted. (applicable only for MPI)
     * @type {string}
     * @memberof SupersetSpec
     */
    'sshAuthMountPath'?: string | null;
    /**
     * the lower limit for the number of worker pods to which the training job can scale down. (applicable only for PyTorch)
     * @type {number}
     * @memberof SupersetSpec
     */
    'minReplicas'?: number | null;
    /**
     * the upper limit for the number of worker pods that can be set by the autoscaler. Cannot be smaller than MinReplicas. (applicable only for PyTorch)
     * @type {number}
     * @memberof SupersetSpec
     */
    'maxReplicas'?: number | null;
    /**
     * 
     * @type {DistributedCleanPodPolicy}
     * @memberof SupersetSpec
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicy | null;
    /**
     * 
     * @type {ServingPort}
     * @memberof SupersetSpec
     */
    'servingPort'?: ServingPort | null;
    /**
     * 
     * @type {AutoScaling}
     * @memberof SupersetSpec
     */
    'autoscaling'?: AutoScaling | null;
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof SupersetSpec
     */
    'security'?: SecurityFlatFields | null;
    /**
     * 
     * @type {ComputeFields}
     * @memberof SupersetSpec
     */
    'compute'?: ComputeFields | null;
    /**
     * 
     * @type {StorageFields}
     * @memberof SupersetSpec
     */
    'storage'?: StorageFields | null;
}
/**
 * Information about control-plane changes of sync related assets.
 * @export
 * @interface SyncInfoResponse
 */
export interface SyncInfoResponse {
    /**
     * 
     * @type {Array<SyncInfoResponseItem>}
     * @memberof SyncInfoResponse
     */
    'changes'?: Array<SyncInfoResponseItem>;
}
/**
 * Information about control-plane changes of sync related assets of a given project.
 * @export
 * @interface SyncInfoResponseItem
 */
export interface SyncInfoResponseItem {
    /**
     * The name of the project in which the assets reside. If empty - tenant scoped assets.
     * @type {string}
     * @memberof SyncInfoResponseItem
     */
    'projectName'?: string;
    /**
     * 
     * @type {number}
     * @memberof SyncInfoResponseItem
     */
    'secondsFromLatestChange': number;
}
/**
 * Information about control-plane changes of sync related assets of a given project.
 * @export
 * @interface SyncInfoResponseItemV2
 */
export interface SyncInfoResponseItemV2 {
    /**
     * 
     * @type {Scope}
     * @memberof SyncInfoResponseItemV2
     */
    'scope'?: Scope;
    /**
     * the id of the scope resource, empty for tenant scope, the id of the department for department scope and the project name for project scope.
     * @type {string}
     * @memberof SyncInfoResponseItemV2
     */
    'scopeResourceId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SyncInfoResponseItemV2
     */
    'secondsFromLatestChange': number;
}
/**
 * Information about control-plane changes of sync related assets.
 * @export
 * @interface SyncInfoResponseV2
 */
export interface SyncInfoResponseV2 {
    /**
     * 
     * @type {Array<SyncInfoResponseItemV2>}
     * @memberof SyncInfoResponseV2
     */
    'changes'?: Array<SyncInfoResponseItemV2>;
}
/**
 * A list of all the assets of a given kind that exist in a project.
 * @export
 * @interface SyncRequest
 */
export interface SyncRequest {
    /**
     * The id of the cluster. If empty - tenant scoped assets.
     * @type {string}
     * @memberof SyncRequest
     */
    'clusterId'?: string;
    /**
     * The name of the project in which the assets reside. If empty - tenant scoped assets.
     * @type {string}
     * @memberof SyncRequest
     */
    'projectName'?: string;
    /**
     * List of the assets which exist in the cluster
     * @type {Array<AssetNameAndChecksum>}
     * @memberof SyncRequest
     */
    'assets'?: Array<AssetNameAndChecksum>;
}
/**
 * A list of all the assets of a given kind that exist in a given scope with a specific scope resource id
 * @export
 * @interface SyncRequestV2
 */
export interface SyncRequestV2 {
    /**
     * The id of the cluster. If empty - tenant scoped assets.
     * @type {string}
     * @memberof SyncRequestV2
     */
    'clusterId'?: string;
    /**
     * 
     * @type {Scope}
     * @memberof SyncRequestV2
     */
    'scope'?: Scope;
    /**
     * the id of the scope resource, empty for tenant scope, the id of the department for department scope and the project name for project scope.
     * @type {string}
     * @memberof SyncRequestV2
     */
    'scopeResourceId'?: string;
    /**
     * List of the assets which exist in the cluster
     * @type {Array<AssetNameAndChecksum>}
     * @memberof SyncRequestV2
     */
    'assets'?: Array<AssetNameAndChecksum>;
}
/**
 * the highest update count that was assigned to the data being synchronized. for example, it is possible that the agent sent afterUpdate=12 and received a bulk containing only four updates (13, 15, 18, 19) but in the system there is already update 21 which was not included in this bulk and can be received in the following bulk.
 * @export
 * @interface SystemInfo
 */
export interface SystemInfo {
    /**
     * the value of an update counter of a data in the system.
     * @type {number}
     * @memberof SystemInfo
     */
    'highestUpdate'?: number;
}
/**
 * Toleration details.
 * @export
 * @interface Toleration
 */
export interface Toleration {
    /**
     * The name of the toleration.
     * @type {string}
     * @memberof Toleration
     */
    'name'?: string | null;
    /**
     * 
     * @type {TolerationOperator}
     * @memberof Toleration
     */
    'operator'?: TolerationOperator | null;
    /**
     * The taint key that the toleration applies to. (mandatory)
     * @type {string}
     * @memberof Toleration
     */
    'key'?: string | null;
    /**
     * The taint value the toleration matches to. Mandatory if operator is Exists, forbidden otherwise.
     * @type {string}
     * @memberof Toleration
     */
    'value'?: string | null;
    /**
     * 
     * @type {TolerationEffect}
     * @memberof Toleration
     */
    'effect'?: TolerationEffect | null;
    /**
     * The period of time the toleration tolerates the taint. Valid only if effect is NoExecute. taint.
     * @type {number}
     * @memberof Toleration
     */
    'seconds'?: number | null;
    /**
     * Use \'true\' in case the label is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof Toleration
     */
    'exclude'?: boolean | null;
}
/**
 * The taint effect to match. (mandatory)
 * @export
 * @enum {string}
 */

export const TolerationEffect = {
    NoSchedule: 'NoSchedule',
    NoExecute: 'NoExecute',
    PreferNoSchedule: 'PreferNoSchedule',
    Any: 'Any'
} as const;

export type TolerationEffect = typeof TolerationEffect[keyof typeof TolerationEffect];


/**
 * 
 * @export
 * @interface TolerationEffectOptions
 */
export interface TolerationEffectOptions {
    /**
     * Limit the permitted values for imagePullPolicy to a given set of values.
     * @type {Array<TolerationEffectOptionsOptionsInner>}
     * @memberof TolerationEffectOptions
     */
    'options'?: Array<TolerationEffectOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface TolerationEffectOptionsOptionsInner
 */
export interface TolerationEffectOptionsOptionsInner {
    /**
     * 
     * @type {TolerationEffect}
     * @memberof TolerationEffectOptionsOptionsInner
     */
    'value': TolerationEffect | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof TolerationEffectOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface TolerationEffectRules
 */
export interface TolerationEffectRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof TolerationEffectRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof TolerationEffectRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof TolerationEffectRules
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for imagePullPolicy to a given set of values.
     * @type {Array<TolerationEffectOptionsOptionsInner>}
     * @memberof TolerationEffectRules
     */
    'options'?: Array<TolerationEffectOptionsOptionsInner> | null;
}
/**
 * A key\'s relationship to the value. Equal uses key and value. Exists is equivalent to wildcard for value, so that a workload can tolerate all taints of a particular category. (mandatory)
 * @export
 * @enum {string}
 */

export const TolerationOperator = {
    Equal: 'Equal',
    Exists: 'Exists'
} as const;

export type TolerationOperator = typeof TolerationOperator[keyof typeof TolerationOperator];


/**
 * 
 * @export
 * @interface TolerationOperatorOptions
 */
export interface TolerationOperatorOptions {
    /**
     * Limit the permitted values for imagePullPolicy to a given set of values.
     * @type {Array<TolerationOperatorOptionsOptionsInner>}
     * @memberof TolerationOperatorOptions
     */
    'options'?: Array<TolerationOperatorOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface TolerationOperatorOptionsOptionsInner
 */
export interface TolerationOperatorOptionsOptionsInner {
    /**
     * 
     * @type {TolerationOperator}
     * @memberof TolerationOperatorOptionsOptionsInner
     */
    'value': TolerationOperator | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof TolerationOperatorOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface TolerationOperatorRules
 */
export interface TolerationOperatorRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof TolerationOperatorRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof TolerationOperatorRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof TolerationOperatorRules
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for imagePullPolicy to a given set of values.
     * @type {Array<TolerationOperatorOptionsOptionsInner>}
     * @memberof TolerationOperatorRules
     */
    'options'?: Array<TolerationOperatorOptionsOptionsInner> | null;
}
/**
 * Toleration details.
 * @export
 * @interface TolerationRules
 */
export interface TolerationRules {
    /**
     * 
     * @type {TolerationOperatorRules}
     * @memberof TolerationRules
     */
    'operator'?: TolerationOperatorRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof TolerationRules
     */
    'key'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof TolerationRules
     */
    'value'?: StringRules | null;
    /**
     * 
     * @type {TolerationEffectRules}
     * @memberof TolerationRules
     */
    'effect'?: TolerationEffectRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof TolerationRules
     */
    'seconds'?: IntegerRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof TolerationRules
     */
    'exclude'?: BooleanRules | null;
}
/**
 * 
 * @export
 * @interface TolerationsField
 */
export interface TolerationsField {
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof TolerationsField
     */
    'tolerations'?: Array<Toleration> | null;
}
/**
 * 
 * @export
 * @interface TolerationsFieldRules
 */
export interface TolerationsFieldRules {
    /**
     * 
     * @type {TolerationsRules}
     * @memberof TolerationsFieldRules
     */
    'tolerations'?: TolerationsRules | null;
}
/**
 * 
 * @export
 * @interface TolerationsRules
 */
export interface TolerationsRules {
    /**
     * 
     * @type {TolerationRules}
     * @memberof TolerationsRules
     */
    'attributes'?: TolerationRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof TolerationsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * Super set of Internal and External tool types.
 * @export
 * @enum {string}
 */

export const ToolType = {
    JupyterNotebook: 'jupyter-notebook',
    Pycharm: 'pycharm',
    VisualStudioCode: 'visual-studio-code',
    Tensorboard: 'tensorboard',
    Rstudio: 'rstudio',
    Mlflow: 'mlflow',
    Custom: 'custom',
    Wandb: 'wandb',
    Matlab: 'matlab',
    Comet: 'comet',
    ChatbotUi: 'chatbot-ui'
} as const;

export type ToolType = typeof ToolType[keyof typeof ToolType];


/**
 * 
 * @export
 * @interface Training
 */
export interface Training {
    /**
     * 
     * @type {WorkloadMetaV1}
     * @memberof Training
     */
    'meta': WorkloadMetaV1;
    /**
     * 
     * @type {SpecificRunInfoFields}
     * @memberof Training
     */
    'spec': SpecificRunInfoFields;
    /**
     * A training workload ready for submission at the cluster. Further details at https://github.com/run-ai/runai/runai-cluster/tree/master/workload-controller/config/crd\"
     * @type {object}
     * @memberof Training
     */
    'workload'?: object;
    /**
     * 
     * @type {DisplayedJob}
     * @memberof Training
     */
    'job'?: DisplayedJob;
}
/**
 * Request to submit a training from a set of assets and an optional set of specific run parameters.
 * @export
 * @interface TrainingCreationRequestV2
 */
export interface TrainingCreationRequestV2 {
    /**
     * 
     * @type {WorkloadCreationMeta}
     * @memberof TrainingCreationRequestV2
     */
    'meta'?: WorkloadCreationMeta;
    /**
     * 
     * @type {AssetsIds}
     * @memberof TrainingCreationRequestV2
     */
    'assets'?: AssetsIds;
    /**
     * 
     * @type {TrainingSpecificRunParams}
     * @memberof TrainingCreationRequestV2
     */
    'specificRunParams'?: TrainingSpecificRunParams | null;
    /**
     * 
     * @type {DistributedParams}
     * @memberof TrainingCreationRequestV2
     */
    'distributed'?: DistributedParams | null;
}
/**
 * 
 * @export
 * @interface TrainingFields
 */
export interface TrainingFields {
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof TrainingFields
     */
    'completions'?: number | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof TrainingFields
     */
    'parallelism'?: number | null;
}
/**
 * 
 * @export
 * @interface TrainingListResponse
 */
export interface TrainingListResponse {
    /**
     * 
     * @type {Array<Training>}
     * @memberof TrainingListResponse
     */
    'entries': Array<Training>;
}
/**
 * 
 * @export
 * @interface TrainingSpecificRunParams
 */
export interface TrainingSpecificRunParams {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof TrainingSpecificRunParams
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof TrainingSpecificRunParams
     */
    'args'?: string | null;
    /**
     * The user id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsUid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof TrainingSpecificRunParams
     */
    'runAsUid'?: number | null;
    /**
     * The group id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsGid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof TrainingSpecificRunParams
     */
    'runAsGid'?: number | null;
    /**
     * Comma separated list of groups that the user running the container belongs to, in addition to the group indicated by runAsGid. Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled. Using an empty string implies reverting the supplementary groups of the image.
     * @type {string}
     * @memberof TrainingSpecificRunParams
     */
    'supplementalGroups'?: string | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariableOfAsset>}
     * @memberof TrainingSpecificRunParams
     */
    'environmentVariables'?: Array<EnvironmentVariableOfAsset> | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof TrainingSpecificRunParams
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof TrainingSpecificRunParams
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof TrainingSpecificRunParams
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof TrainingSpecificRunParams
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof TrainingSpecificRunParams
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof TrainingSpecificRunParams
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof TrainingSpecificRunParams
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof TrainingSpecificRunParams
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof TrainingSpecificRunParams
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof TrainingSpecificRunParams
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof TrainingSpecificRunParams
     */
    'tolerations'?: Array<Toleration> | null;
    /**
     * 
     * @type {Array<SpecificRunConnectionInfo>}
     * @memberof TrainingSpecificRunParams
     */
    'connections'?: Array<SpecificRunConnectionInfo> | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof TrainingSpecificRunParams
     */
    'completions'?: number | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof TrainingSpecificRunParams
     */
    'parallelism'?: number | null;
    /**
     * Whether to allow the workload to exceed the quota of the project.
     * @type {boolean}
     * @memberof TrainingSpecificRunParams
     */
    'allowOverQuota'?: boolean | null;
}
/**
 * information about a training created based on assets.
 * @export
 * @interface TrainingV2
 */
export interface TrainingV2 {
    /**
     * 
     * @type {WorkloadMeta}
     * @memberof TrainingV2
     */
    'meta': WorkloadMeta;
    /**
     * 
     * @type {AssetsRef}
     * @memberof TrainingV2
     */
    'assets': AssetsRef;
    /**
     * 
     * @type {TrainingSpecificRunParams}
     * @memberof TrainingV2
     */
    'specificRunParams'?: TrainingSpecificRunParams | null;
    /**
     * 
     * @type {PolicyInfo}
     * @memberof TrainingV2
     */
    'policyInfo'?: PolicyInfo | null;
    /**
     * 
     * @type {DistributedData}
     * @memberof TrainingV2
     */
    'distributed'?: DistributedData | null;
}
/**
 * Indicate the way to determine the user and group ids of the container. The options are a. `fromTheImage` - user and group ids are determined by the docker image that the container runs. this is the default option. b. `custom` - user and group ids can be specified in the environment asset and/or the workspace creation request. c. `idpToken` - user and group ids are determined according to the identity provider (idp) access token. This option is intended for internal use of the environment UI form. For more information, see [User Identity](https://docs.run.ai/latest/admin/runai-setup/config/non-root-containers/).
 * @export
 * @enum {string}
 */

export const UidGidSource = {
    FromTheImage: 'fromTheImage',
    FromIdpToken: 'fromIdpToken',
    Custom: 'custom'
} as const;

export type UidGidSource = typeof UidGidSource[keyof typeof UidGidSource];


/**
 * Details about times the asset has been used by workloads, etc.
 * @export
 * @interface UsageTimesInfo
 */
export interface UsageTimesInfo {
    /**
     * The time at which the asset were last used by a workload of given type and project. This field requires complyToProject and complyToWorkload types flags of the API, to specify the workload type and project id.
     * @type {string}
     * @memberof UsageTimesInfo
     */
    'lastUsedByWorkload'?: string | null;
}
/**
 * A list of all the assets of a given kind that was marked for deletion
 * @export
 * @interface ValidateSyncRequest
 */
export interface ValidateSyncRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidateSyncRequest
     */
    'clusterId': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateSyncRequest
     */
    'projectId': string;
    /**
     * 
     * @type {AssetKind}
     * @memberof ValidateSyncRequest
     */
    'assetKind': AssetKind;
    /**
     * List of the assets which was marked for deletion
     * @type {Array<string>}
     * @memberof ValidateSyncRequest
     */
    'assetNames': Array<string>;
}
/**
 * List of asset names that have been validated for deletion
 * @export
 * @interface ValidateSyncResponse
 */
export interface ValidateSyncResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidateSyncResponse
     */
    'validatedNames': Array<string>;
}
/**
 * 
 * @export
 * @interface WorkloadCreationMeta
 */
export interface WorkloadCreationMeta {
    /**
     * The name of the workload.
     * @type {string}
     * @memberof WorkloadCreationMeta
     */
    'name': string;
    /**
     * When true, the requested name will be treated as a prefix. The final name of the workload will be composed of the name followed by a random set of characters.
     * @type {boolean}
     * @memberof WorkloadCreationMeta
     */
    'useGivenNameAsPrefix'?: boolean;
    /**
     * The id of the project.
     * @type {string}
     * @memberof WorkloadCreationMeta
     */
    'projectId': string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof WorkloadCreationMeta
     */
    'clusterId': string;
    /**
     * A unique ID of the template.
     * @type {string}
     * @memberof WorkloadCreationMeta
     */
    'templateId'?: string | null;
}
/**
 * Request to create a workload from a set of assets and an optional set of specific env parameters.
 * @export
 * @interface WorkloadCreationRequest
 */
export interface WorkloadCreationRequest {
    /**
     * The name of the workload.
     * @type {string}
     * @memberof WorkloadCreationRequest
     */
    'name': string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof WorkloadCreationRequest
     */
    'clusterId': string;
    /**
     * The id of the project.
     * @type {number}
     * @memberof WorkloadCreationRequest
     */
    'projectId': number;
    /**
     * Namespace of the project in which the workload should be created.
     * @type {string}
     * @memberof WorkloadCreationRequest
     */
    'namespace': string;
    /**
     * 
     * @type {AssetsIds}
     * @memberof WorkloadCreationRequest
     */
    'assets': AssetsIds;
    /**
     * 
     * @type {SpecificRunParams}
     * @memberof WorkloadCreationRequest
     */
    'specificEnv'?: SpecificRunParams | null;
    /**
     * 
     * @type {Distributed}
     * @memberof WorkloadCreationRequest
     */
    'distributed'?: Distributed | null;
}
/**
 * The desired phase of the workload.
 * @export
 * @enum {string}
 */

export const WorkloadDesiredPhase = {
    Running: 'Running',
    Stopped: 'Stopped',
    Deleted: 'Deleted'
} as const;

export type WorkloadDesiredPhase = typeof WorkloadDesiredPhase[keyof typeof WorkloadDesiredPhase];


/**
 * 
 * @export
 * @interface WorkloadMeta
 */
export interface WorkloadMeta {
    /**
     * The name of the workload.
     * @type {string}
     * @memberof WorkloadMeta
     */
    'name': string;
    /**
     * The name as was requested for the workload. If useGivenNameAsPrefix, in the creation request, is false, name and requestedName should be identical. Otherwise, name should be composed of requestedName followed by a suffix of random characters.
     * @type {string}
     * @memberof WorkloadMeta
     */
    'requestedName': string;
    /**
     * A unique ID of the workload.
     * @type {string}
     * @memberof WorkloadMeta
     */
    'workloadId': string;
    /**
     * The id of the project.
     * @type {string}
     * @memberof WorkloadMeta
     */
    'projectId': string;
    /**
     * The id of the department.
     * @type {string}
     * @memberof WorkloadMeta
     */
    'departmentId'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof WorkloadMeta
     */
    'clusterId': string;
    /**
     * The user who created the workload
     * @type {string}
     * @memberof WorkloadMeta
     */
    'createdBy': string;
    /**
     * The creation time of the workload.
     * @type {string}
     * @memberof WorkloadMeta
     */
    'createdAt': string;
    /**
     * The deletion time of the workload.
     * @type {string}
     * @memberof WorkloadMeta
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {WorkloadDesiredPhase}
     * @memberof WorkloadMeta
     */
    'desiredPhase': WorkloadDesiredPhase;
    /**
     * 
     * @type {Phase}
     * @memberof WorkloadMeta
     */
    'actualPhase'?: Phase;
}
/**
 * Metadata of the workspace and training.
 * @export
 * @interface WorkloadMetaV1
 */
export interface WorkloadMetaV1 {
    /**
     * A unique ID of the workload.
     * @type {string}
     * @memberof WorkloadMetaV1
     */
    'id': string;
    /**
     * The id of the tenant.
     * @type {number}
     * @memberof WorkloadMetaV1
     */
    'tenantId': number;
    /**
     * The id of the project.
     * @type {number}
     * @memberof WorkloadMetaV1
     */
    'projectId': number;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof WorkloadMetaV1
     */
    'clusterId': string;
    /**
     * The name of the workload.
     * @type {string}
     * @memberof WorkloadMetaV1
     */
    'name': string;
    /**
     * 
     * @type {WorkloadState}
     * @memberof WorkloadMetaV1
     */
    'desiredState': WorkloadState;
    /**
     * 
     * @type {WorkloadState}
     * @memberof WorkloadMetaV1
     */
    'currentState': WorkloadState;
    /**
     * The user who created the workspace or training.
     * @type {string}
     * @memberof WorkloadMetaV1
     */
    'createdBy': string;
    /**
     * The recent user who updated the workspace or training.
     * @type {string}
     * @memberof WorkloadMetaV1
     */
    'updatedBy': string;
}
/**
 * Id, name and status of a workspace or training
 * @export
 * @interface WorkloadRefAndStatus
 */
export interface WorkloadRefAndStatus {
    /**
     * A unique ID of the workload.
     * @type {string}
     * @memberof WorkloadRefAndStatus
     */
    'id': string;
    /**
     * The name of the workload.
     * @type {string}
     * @memberof WorkloadRefAndStatus
     */
    'name': string;
    /**
     * The status of the workspace or training.
     * @type {string}
     * @memberof WorkloadRefAndStatus
     */
    'status'?: string;
}
/**
 * Reflects the status of the workload created for a workspace or a training. It does not reflect the status of the job created from the workload.
 * @export
 * @enum {string}
 */

export const WorkloadState = {
    Empty: '',
    Submitted: 'Submitted',
    Failed: 'Failed'
} as const;

export type WorkloadState = typeof WorkloadState[keyof typeof WorkloadState];


/**
 * 
 * @export
 * @interface WorkloadSupportedTypes
 */
export interface WorkloadSupportedTypes {
    /**
     * Is inference a supported workload type.
     * @type {boolean}
     * @memberof WorkloadSupportedTypes
     */
    'inference'?: boolean | null;
    /**
     * Is workspace a supported workload type.
     * @type {boolean}
     * @memberof WorkloadSupportedTypes
     */
    'workspace'?: boolean | null;
    /**
     * Is training a supported workload type.
     * @type {boolean}
     * @memberof WorkloadSupportedTypes
     */
    'training'?: boolean | null;
    /**
     * Is distributed a supported workload type.
     * @type {boolean}
     * @memberof WorkloadSupportedTypes
     */
    'distributed'?: boolean | null;
    /**
     * The distributed training framework used in the workload.
     * @type {string}
     * @memberof WorkloadSupportedTypes
     */
    'distFramework'?: WorkloadSupportedTypesDistFrameworkEnum;
}

export const WorkloadSupportedTypesDistFrameworkEnum = {
    Mpi: 'MPI',
    PyTorch: 'PyTorch',
    Tf: 'TF',
    XgBoost: 'XGBoost'
} as const;

export type WorkloadSupportedTypesDistFrameworkEnum = typeof WorkloadSupportedTypesDistFrameworkEnum[keyof typeof WorkloadSupportedTypesDistFrameworkEnum];

/**
 * 
 * @export
 * @interface WorkloadTemplate
 */
export interface WorkloadTemplate {
    /**
     * 
     * @type {AssetMeta}
     * @memberof WorkloadTemplate
     */
    'meta': AssetMeta;
    /**
     * 
     * @type {SpecificRunInfoFields}
     * @memberof WorkloadTemplate
     */
    'spec': SpecificRunInfoFields;
}
/**
 * 
 * @export
 * @interface WorkloadTemplateCreationRequest
 */
export interface WorkloadTemplateCreationRequest {
    /**
     * 
     * @type {AssetCreationRequest}
     * @memberof WorkloadTemplateCreationRequest
     */
    'meta': AssetCreationRequest;
    /**
     * 
     * @type {SpecificRunCreationFields}
     * @memberof WorkloadTemplateCreationRequest
     */
    'spec': SpecificRunCreationFields;
}
/**
 * 
 * @export
 * @interface WorkloadTemplateListResponse
 */
export interface WorkloadTemplateListResponse {
    /**
     * 
     * @type {Array<WorkloadTemplate>}
     * @memberof WorkloadTemplateListResponse
     */
    'entries': Array<WorkloadTemplate>;
}
/**
 * 
 * @export
 * @interface WorkloadTemplateUpdateRequest
 */
export interface WorkloadTemplateUpdateRequest {
    /**
     * 
     * @type {AssetUpdateRequest}
     * @memberof WorkloadTemplateUpdateRequest
     */
    'meta': AssetUpdateRequest;
    /**
     * 
     * @type {SpecificRunCreationFields}
     * @memberof WorkloadTemplateUpdateRequest
     */
    'spec': SpecificRunCreationFields;
}
/**
 * the type of workload
 * @export
 * @enum {string}
 */

export const WorkloadType = {
    Workspace: 'Workspace',
    Training: 'Training',
    Distributed: 'Distributed',
    Inference: 'Inference'
} as const;

export type WorkloadType = typeof WorkloadType[keyof typeof WorkloadType];


/**
 * 
 * @export
 * @interface Workspace
 */
export interface Workspace {
    /**
     * 
     * @type {WorkloadMetaV1}
     * @memberof Workspace
     */
    'meta': WorkloadMetaV1;
    /**
     * 
     * @type {SpecificRunInfoFields}
     * @memberof Workspace
     */
    'spec': SpecificRunInfoFields;
    /**
     * An interactive workload ready for submission at the cluster. Further details at https://github.com/run-ai/runai/runai-cluster/tree/master/workload-controller/config/crd\"
     * @type {object}
     * @memberof Workspace
     */
    'workload'?: object;
    /**
     * 
     * @type {DisplayedJob}
     * @memberof Workspace
     */
    'job'?: DisplayedJob;
}
/**
 * Request to submit a workspace from a set of assets and an optional set of specific run parameters.
 * @export
 * @interface WorkspaceCreationRequestV2
 */
export interface WorkspaceCreationRequestV2 {
    /**
     * 
     * @type {WorkloadCreationMeta}
     * @memberof WorkspaceCreationRequestV2
     */
    'meta': WorkloadCreationMeta;
    /**
     * 
     * @type {AssetsIds}
     * @memberof WorkspaceCreationRequestV2
     */
    'assets': AssetsIds;
    /**
     * 
     * @type {WorkspaceSpecificRunParams}
     * @memberof WorkspaceCreationRequestV2
     */
    'specificRunParams'?: WorkspaceSpecificRunParams | null;
}
/**
 * 
 * @export
 * @interface WorkspaceListResponse
 */
export interface WorkspaceListResponse {
    /**
     * 
     * @type {Array<Workspace>}
     * @memberof WorkspaceListResponse
     */
    'entries': Array<Workspace>;
}
/**
 * 
 * @export
 * @interface WorkspaceSpecificRunParams
 */
export interface WorkspaceSpecificRunParams {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof WorkspaceSpecificRunParams
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof WorkspaceSpecificRunParams
     */
    'args'?: string | null;
    /**
     * The user id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsUid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof WorkspaceSpecificRunParams
     */
    'runAsUid'?: number | null;
    /**
     * The group id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsGid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof WorkspaceSpecificRunParams
     */
    'runAsGid'?: number | null;
    /**
     * Comma separated list of groups that the user running the container belongs to, in addition to the group indicated by runAsGid. Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled. Using an empty string implies reverting the supplementary groups of the image.
     * @type {string}
     * @memberof WorkspaceSpecificRunParams
     */
    'supplementalGroups'?: string | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariableOfAsset>}
     * @memberof WorkspaceSpecificRunParams
     */
    'environmentVariables'?: Array<EnvironmentVariableOfAsset> | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof WorkspaceSpecificRunParams
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof WorkspaceSpecificRunParams
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof WorkspaceSpecificRunParams
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof WorkspaceSpecificRunParams
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof WorkspaceSpecificRunParams
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof WorkspaceSpecificRunParams
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof WorkspaceSpecificRunParams
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof WorkspaceSpecificRunParams
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof WorkspaceSpecificRunParams
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof WorkspaceSpecificRunParams
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof WorkspaceSpecificRunParams
     */
    'tolerations'?: Array<Toleration> | null;
    /**
     * 
     * @type {Array<SpecificRunConnectionInfo>}
     * @memberof WorkspaceSpecificRunParams
     */
    'connections'?: Array<SpecificRunConnectionInfo> | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof WorkspaceSpecificRunParams
     */
    'completions'?: number | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof WorkspaceSpecificRunParams
     */
    'parallelism'?: number | null;
    /**
     * Whether to allow the workload to exceed the quota of the project.
     * @type {boolean}
     * @memberof WorkspaceSpecificRunParams
     */
    'allowOverQuota'?: boolean | null;
}
/**
 * information about a workspace created based on assets.
 * @export
 * @interface WorkspaceV2
 */
export interface WorkspaceV2 {
    /**
     * 
     * @type {WorkloadMeta}
     * @memberof WorkspaceV2
     */
    'meta': WorkloadMeta;
    /**
     * 
     * @type {AssetsRef}
     * @memberof WorkspaceV2
     */
    'assets': AssetsRef;
    /**
     * 
     * @type {WorkspaceSpecificRunParams}
     * @memberof WorkspaceV2
     */
    'specificRunParams'?: WorkspaceSpecificRunParams | null;
    /**
     * 
     * @type {PolicyInfo}
     * @memberof WorkspaceV2
     */
    'policyInfo'?: PolicyInfo | null;
}

/**
 * AssetsApi - axios parameter creator
 * @export
 */
export const AssetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Used by workloads-service for the unified API
         * @summary Request the flat representation of an asset
         * @param {AssetFlatRequest} assetFlatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAssetFlatFormat: async (assetFlatRequest: AssetFlatRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetFlatRequest' is not null or undefined
            assertParamExists('requestAssetFlatFormat', 'assetFlatRequest', assetFlatRequest)
            const localVarPath = `/api/v1/asset/flat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetFlatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssetsApi - functional programming interface
 * @export
 */
export const AssetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssetsApiAxiosParamCreator(configuration)
    return {
        /**
         * Used by workloads-service for the unified API
         * @summary Request the flat representation of an asset
         * @param {AssetFlatRequest} assetFlatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestAssetFlatFormat(assetFlatRequest: AssetFlatRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetFlatResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestAssetFlatFormat(assetFlatRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AssetsApi - factory interface
 * @export
 */
export const AssetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssetsApiFp(configuration)
    return {
        /**
         * Used by workloads-service for the unified API
         * @summary Request the flat representation of an asset
         * @param {AssetFlatRequest} assetFlatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAssetFlatFormat(assetFlatRequest: AssetFlatRequest, options?: any): AxiosPromise<AssetFlatResponse> {
            return localVarFp.requestAssetFlatFormat(assetFlatRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssetsApi - object-oriented interface
 * @export
 * @class AssetsApi
 * @extends {BaseAPI}
 */
export class AssetsApi extends BaseAPI {
    /**
     * Used by workloads-service for the unified API
     * @summary Request the flat representation of an asset
     * @param {AssetFlatRequest} assetFlatRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApi
     */
    public requestAssetFlatFormat(assetFlatRequest: AssetFlatRequest, options?: AxiosRequestConfig) {
        return AssetsApiFp(this.configuration).requestAssetFlatFormat(assetFlatRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ComputeApi - axios parameter creator
 * @export
 */
export const ComputeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Use to create a compute asset.
         * @summary Create compute asset.
         * @param {ComputeCreationRequest} [computeCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComputeAsset: async (computeCreationRequest?: ComputeCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/compute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(computeCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete a compute asset, by id.
         * @summary Delete a compute asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComputeAssetById: async (assetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deleteComputeAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/compute/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to retrieve the details of a compute asset by id.
         * @summary Retrieve a compute asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComputeAssetById: async (assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getComputeAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/compute/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to retrieve a list of compute assets.
         * @summary List compute assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listComputeAssets: async (name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/compute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to update the details of a compute asset by id.
         * @summary Update a compute asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {ComputeUpdateRequest} [computeUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComputeAssetById: async (assetId: string, computeUpdateRequest?: ComputeUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('updateComputeAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/compute/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(computeUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComputeApi - functional programming interface
 * @export
 */
export const ComputeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComputeApiAxiosParamCreator(configuration)
    return {
        /**
         * Use to create a compute asset.
         * @summary Create compute asset.
         * @param {ComputeCreationRequest} [computeCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComputeAsset(computeCreationRequest?: ComputeCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComputeAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComputeAsset(computeCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete a compute asset, by id.
         * @summary Delete a compute asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteComputeAssetById(assetId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteComputeAssetById(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to retrieve the details of a compute asset by id.
         * @summary Retrieve a compute asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComputeAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComputeAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComputeAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to retrieve a list of compute assets.
         * @summary List compute assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listComputeAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComputeListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listComputeAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to update the details of a compute asset by id.
         * @summary Update a compute asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {ComputeUpdateRequest} [computeUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateComputeAssetById(assetId: string, computeUpdateRequest?: ComputeUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComputeAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateComputeAssetById(assetId, computeUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComputeApi - factory interface
 * @export
 */
export const ComputeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComputeApiFp(configuration)
    return {
        /**
         * Use to create a compute asset.
         * @summary Create compute asset.
         * @param {ComputeCreationRequest} [computeCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComputeAsset(computeCreationRequest?: ComputeCreationRequest, options?: any): AxiosPromise<ComputeAsset> {
            return localVarFp.createComputeAsset(computeCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete a compute asset, by id.
         * @summary Delete a compute asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComputeAssetById(assetId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteComputeAssetById(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to retrieve the details of a compute asset by id.
         * @summary Retrieve a compute asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComputeAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<ComputeAsset> {
            return localVarFp.getComputeAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to retrieve a list of compute assets.
         * @summary List compute assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listComputeAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<ComputeListResponse> {
            return localVarFp.listComputeAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to update the details of a compute asset by id.
         * @summary Update a compute asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {ComputeUpdateRequest} [computeUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComputeAssetById(assetId: string, computeUpdateRequest?: ComputeUpdateRequest, options?: any): AxiosPromise<ComputeAsset> {
            return localVarFp.updateComputeAssetById(assetId, computeUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComputeApi - object-oriented interface
 * @export
 * @class ComputeApi
 * @extends {BaseAPI}
 */
export class ComputeApi extends BaseAPI {
    /**
     * Use to create a compute asset.
     * @summary Create compute asset.
     * @param {ComputeCreationRequest} [computeCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComputeApi
     */
    public createComputeAsset(computeCreationRequest?: ComputeCreationRequest, options?: AxiosRequestConfig) {
        return ComputeApiFp(this.configuration).createComputeAsset(computeCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete a compute asset, by id.
     * @summary Delete a compute asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComputeApi
     */
    public deleteComputeAssetById(assetId: string, options?: AxiosRequestConfig) {
        return ComputeApiFp(this.configuration).deleteComputeAssetById(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to retrieve the details of a compute asset by id.
     * @summary Retrieve a compute asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComputeApi
     */
    public getComputeAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return ComputeApiFp(this.configuration).getComputeAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to retrieve a list of compute assets.
     * @summary List compute assets.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComputeApi
     */
    public listComputeAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return ComputeApiFp(this.configuration).listComputeAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to update the details of a compute asset by id.
     * @summary Update a compute asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {ComputeUpdateRequest} [computeUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComputeApi
     */
    public updateComputeAssetById(assetId: string, computeUpdateRequest?: ComputeUpdateRequest, options?: AxiosRequestConfig) {
        return ComputeApiFp(this.configuration).updateComputeAssetById(assetId, computeUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ConfigMapApi - axios parameter creator
 * @export
 */
export const ConfigMapApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Use to create a ConfigMap datasource asset.
         * @summary Create a ConfigMap datasource asset.
         * @param {ConfigMapCreationRequest} [configMapCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConfigMapAsset: async (configMapCreationRequest?: ConfigMapCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/datasource/config-map`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configMapCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete a ConfigMap datasource asset by id.
         * @summary Delete a ConfigMap asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConfigMapAssetById: async (assetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deleteConfigMapAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/config-map/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of ConfigMap datasource asset by id.
         * @summary Get a ConfigMap asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigMapAssetById: async (assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getConfigMapAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/config-map/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of ConfigMap datasource assets.
         * @summary List ConfigMap datasource assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConfigMapAssets: async (name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/datasource/config-map`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }

            if (assetIds !== undefined) {
                localVarQueryParameter['assetIds'] = assetIds;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to update the details of a ConfigMap datasource asset by id.
         * @summary Update a ConfigMap asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {ConfigMapUpdateRequest} [configMapUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfigMapAssetById: async (assetId: string, configMapUpdateRequest?: ConfigMapUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('updateConfigMapAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/config-map/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configMapUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigMapApi - functional programming interface
 * @export
 */
export const ConfigMapApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigMapApiAxiosParamCreator(configuration)
    return {
        /**
         * Use to create a ConfigMap datasource asset.
         * @summary Create a ConfigMap datasource asset.
         * @param {ConfigMapCreationRequest} [configMapCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConfigMapAsset(configMapCreationRequest?: ConfigMapCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfigMapAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConfigMapAsset(configMapCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete a ConfigMap datasource asset by id.
         * @summary Delete a ConfigMap asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConfigMapAssetById(assetId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConfigMapAssetById(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the details of ConfigMap datasource asset by id.
         * @summary Get a ConfigMap asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfigMapAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfigMapAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfigMapAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of ConfigMap datasource assets.
         * @summary List ConfigMap datasource assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConfigMapAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfigMapListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConfigMapAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to update the details of a ConfigMap datasource asset by id.
         * @summary Update a ConfigMap asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {ConfigMapUpdateRequest} [configMapUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConfigMapAssetById(assetId: string, configMapUpdateRequest?: ConfigMapUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfigMapAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConfigMapAssetById(assetId, configMapUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConfigMapApi - factory interface
 * @export
 */
export const ConfigMapApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigMapApiFp(configuration)
    return {
        /**
         * Use to create a ConfigMap datasource asset.
         * @summary Create a ConfigMap datasource asset.
         * @param {ConfigMapCreationRequest} [configMapCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConfigMapAsset(configMapCreationRequest?: ConfigMapCreationRequest, options?: any): AxiosPromise<ConfigMapAsset> {
            return localVarFp.createConfigMapAsset(configMapCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete a ConfigMap datasource asset by id.
         * @summary Delete a ConfigMap asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConfigMapAssetById(assetId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteConfigMapAssetById(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of ConfigMap datasource asset by id.
         * @summary Get a ConfigMap asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigMapAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<ConfigMapAsset> {
            return localVarFp.getConfigMapAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of ConfigMap datasource assets.
         * @summary List ConfigMap datasource assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConfigMapAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<ConfigMapListResponse> {
            return localVarFp.listConfigMapAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to update the details of a ConfigMap datasource asset by id.
         * @summary Update a ConfigMap asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {ConfigMapUpdateRequest} [configMapUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfigMapAssetById(assetId: string, configMapUpdateRequest?: ConfigMapUpdateRequest, options?: any): AxiosPromise<ConfigMapAsset> {
            return localVarFp.updateConfigMapAssetById(assetId, configMapUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigMapApi - object-oriented interface
 * @export
 * @class ConfigMapApi
 * @extends {BaseAPI}
 */
export class ConfigMapApi extends BaseAPI {
    /**
     * Use to create a ConfigMap datasource asset.
     * @summary Create a ConfigMap datasource asset.
     * @param {ConfigMapCreationRequest} [configMapCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigMapApi
     */
    public createConfigMapAsset(configMapCreationRequest?: ConfigMapCreationRequest, options?: AxiosRequestConfig) {
        return ConfigMapApiFp(this.configuration).createConfigMapAsset(configMapCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete a ConfigMap datasource asset by id.
     * @summary Delete a ConfigMap asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigMapApi
     */
    public deleteConfigMapAssetById(assetId: string, options?: AxiosRequestConfig) {
        return ConfigMapApiFp(this.configuration).deleteConfigMapAssetById(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of ConfigMap datasource asset by id.
     * @summary Get a ConfigMap asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigMapApi
     */
    public getConfigMapAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return ConfigMapApiFp(this.configuration).getConfigMapAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of ConfigMap datasource assets.
     * @summary List ConfigMap datasource assets.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigMapApi
     */
    public listConfigMapAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return ConfigMapApiFp(this.configuration).listConfigMapAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to update the details of a ConfigMap datasource asset by id.
     * @summary Update a ConfigMap asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {ConfigMapUpdateRequest} [configMapUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigMapApi
     */
    public updateConfigMapAssetById(assetId: string, configMapUpdateRequest?: ConfigMapUpdateRequest, options?: AxiosRequestConfig) {
        return ConfigMapApiFp(this.configuration).updateConfigMapAssetById(assetId, configMapUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CredentialsApi - axios parameter creator
 * @export
 */
export const CredentialsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Use to create an S3-compatible access key credential.
         * @summary Create an access key.
         * @param {AccessKeyCreationRequest} accessKeyCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessKey: async (accessKeyCreationRequest: AccessKeyCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessKeyCreationRequest' is not null or undefined
            assertParamExists('createAccessKey', 'accessKeyCreationRequest', accessKeyCreationRequest)
            const localVarPath = `/api/v1/asset/credentials/access-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accessKeyCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to create a docker registry credential containing userid, password and url.
         * @summary Create a docker registry credential.
         * @param {DockerRegistryCreationRequest} dockerRegistryCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDockerRegistry: async (dockerRegistryCreationRequest: DockerRegistryCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dockerRegistryCreationRequest' is not null or undefined
            assertParamExists('createDockerRegistry', 'dockerRegistryCreationRequest', dockerRegistryCreationRequest)
            const localVarPath = `/api/v1/asset/credentials/docker-registry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dockerRegistryCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to create a generic-secret asset.
         * @summary Create a generic-secret.
         * @param {GenericSecretCreationRequest} genericSecretCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGenericSecret: async (genericSecretCreationRequest: GenericSecretCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'genericSecretCreationRequest' is not null or undefined
            assertParamExists('createGenericSecret', 'genericSecretCreationRequest', genericSecretCreationRequest)
            const localVarPath = `/api/v1/asset/credentials/generic-secret`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(genericSecretCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to create a userid / password credential.
         * @summary Create a userid / password credential.
         * @param {PasswordCreationRequest} passwordCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPassword: async (passwordCreationRequest: PasswordCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordCreationRequest' is not null or undefined
            assertParamExists('createPassword', 'passwordCreationRequest', passwordCreationRequest)
            const localVarPath = `/api/v1/asset/credentials/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete an S3-compatible access key credential by id.
         * @summary Delete an access key.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccessKey: async (assetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deleteAccessKey', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/credentials/access-key/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to deletes a docker registry credential by id.
         * @summary Delete a docker registry credential.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDockerRegistry: async (assetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deleteDockerRegistry', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/credentials/docker-registry/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete a generic-secret asset, by id.
         * @summary Delete a generic-secret.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGenericSecret: async (assetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deleteGenericSecret', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/credentials/generic-secret/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Udse to delete a password credential by id.
         * @summary Delete a password asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePassword: async (assetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deletePassword', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/credentials/password/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to retrieve the details of an S3-compatible access key credential by id.
         * @summary Get an access key.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessKeyById: async (assetId: string, usageInfo?: boolean, statusInfo?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getAccessKeyById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/credentials/access-key/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to retrieve the details of a docker registry credential by id.
         * @summary Get a docker registry credential.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDockerRegistryById: async (assetId: string, usageInfo?: boolean, statusInfo?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getDockerRegistryById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/credentials/docker-registry/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the details of a generic-secret asset, by id.
         * @summary Get a generic-secret.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGenericSecretById: async (assetId: string, usageInfo?: boolean, statusInfo?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getGenericSecretById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/credentials/generic-secret/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to retrieve the details of a userid / password credential asset by id.
         * @summary Get a userid / password credential.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordById: async (assetId: string, usageInfo?: boolean, statusInfo?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getPasswordById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/credentials/password/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to retrieve a list of S3-compatible access key credentials.
         * @summary List access keys.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessKeys: async (name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/credentials/access-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to retrieve a list of all existing credentials.
         * @summary List credentials.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCredentialsAssets: async (name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/credentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to retrieve a list of docker registry credentials.
         * @summary List docker registry credentials.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDockerRegistries: async (name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/credentials/docker-registry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of generic-secret assets.
         * @summary List generic-secrets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGenericSecret: async (name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/credentials/generic-secret`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to retrieve a list of password credentials.
         * @summary List password credentials.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPasswords: async (name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/credentials/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to update the details of an S3-compatible access key credential by id.
         * @summary Update an access key.
         * @param {string} assetId Unique identifier of the asset.
         * @param {AccessKeyUpdateRequest} accessKeyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccessKey: async (assetId: string, accessKeyUpdateRequest: AccessKeyUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('updateAccessKey', 'assetId', assetId)
            // verify required parameter 'accessKeyUpdateRequest' is not null or undefined
            assertParamExists('updateAccessKey', 'accessKeyUpdateRequest', accessKeyUpdateRequest)
            const localVarPath = `/api/v1/asset/credentials/access-key/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accessKeyUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to updates the details of a docker registry credentials by id.
         * @summary Update a docker registry credential.
         * @param {string} assetId Unique identifier of the asset.
         * @param {DockerRegistryUpdateRequest} dockerRegistryUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDockerRegistry: async (assetId: string, dockerRegistryUpdateRequest: DockerRegistryUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('updateDockerRegistry', 'assetId', assetId)
            // verify required parameter 'dockerRegistryUpdateRequest' is not null or undefined
            assertParamExists('updateDockerRegistry', 'dockerRegistryUpdateRequest', dockerRegistryUpdateRequest)
            const localVarPath = `/api/v1/asset/credentials/docker-registry/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dockerRegistryUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the details of a generic-secret asset, by id.
         * @summary Update a generic-secret.
         * @param {string} assetId Unique identifier of the asset.
         * @param {GenericSecretUpdateRequest} genericSecretUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGenericSecret: async (assetId: string, genericSecretUpdateRequest: GenericSecretUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('updateGenericSecret', 'assetId', assetId)
            // verify required parameter 'genericSecretUpdateRequest' is not null or undefined
            assertParamExists('updateGenericSecret', 'genericSecretUpdateRequest', genericSecretUpdateRequest)
            const localVarPath = `/api/v1/asset/credentials/generic-secret/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(genericSecretUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to Update the details of a password credential by id.
         * @summary Update a password credential.
         * @param {string} assetId Unique identifier of the asset.
         * @param {PasswordUpdateRequest} passwordUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: async (assetId: string, passwordUpdateRequest: PasswordUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('updatePassword', 'assetId', assetId)
            // verify required parameter 'passwordUpdateRequest' is not null or undefined
            assertParamExists('updatePassword', 'passwordUpdateRequest', passwordUpdateRequest)
            const localVarPath = `/api/v1/asset/credentials/password/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CredentialsApi - functional programming interface
 * @export
 */
export const CredentialsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CredentialsApiAxiosParamCreator(configuration)
    return {
        /**
         * Use to create an S3-compatible access key credential.
         * @summary Create an access key.
         * @param {AccessKeyCreationRequest} accessKeyCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccessKey(accessKeyCreationRequest: AccessKeyCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessKey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccessKey(accessKeyCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to create a docker registry credential containing userid, password and url.
         * @summary Create a docker registry credential.
         * @param {DockerRegistryCreationRequest} dockerRegistryCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDockerRegistry(dockerRegistryCreationRequest: DockerRegistryCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DockerRegistry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDockerRegistry(dockerRegistryCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to create a generic-secret asset.
         * @summary Create a generic-secret.
         * @param {GenericSecretCreationRequest} genericSecretCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGenericSecret(genericSecretCreationRequest: GenericSecretCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericSecret>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGenericSecret(genericSecretCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to create a userid / password credential.
         * @summary Create a userid / password credential.
         * @param {PasswordCreationRequest} passwordCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPassword(passwordCreationRequest: PasswordCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Password>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPassword(passwordCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete an S3-compatible access key credential by id.
         * @summary Delete an access key.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccessKey(assetId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccessKey(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to deletes a docker registry credential by id.
         * @summary Delete a docker registry credential.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDockerRegistry(assetId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDockerRegistry(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete a generic-secret asset, by id.
         * @summary Delete a generic-secret.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGenericSecret(assetId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGenericSecret(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Udse to delete a password credential by id.
         * @summary Delete a password asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePassword(assetId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePassword(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to retrieve the details of an S3-compatible access key credential by id.
         * @summary Get an access key.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessKeyById(assetId: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessKey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessKeyById(assetId, usageInfo, statusInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to retrieve the details of a docker registry credential by id.
         * @summary Get a docker registry credential.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDockerRegistryById(assetId: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DockerRegistry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDockerRegistryById(assetId, usageInfo, statusInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the details of a generic-secret asset, by id.
         * @summary Get a generic-secret.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGenericSecretById(assetId: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericSecret>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGenericSecretById(assetId, usageInfo, statusInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to retrieve the details of a userid / password credential asset by id.
         * @summary Get a userid / password credential.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPasswordById(assetId: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Password>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPasswordById(assetId, usageInfo, statusInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to retrieve a list of S3-compatible access key credentials.
         * @summary List access keys.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccessKeys(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessKeyListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccessKeys(name, scope, projectId, departmentId, clusterId, usageInfo, statusInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to retrieve a list of all existing credentials.
         * @summary List credentials.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCredentialsAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CredentialsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCredentialsAssets(name, scope, projectId, departmentId, clusterId, usageInfo, statusInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to retrieve a list of docker registry credentials.
         * @summary List docker registry credentials.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDockerRegistries(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DockerRegistryListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDockerRegistries(name, scope, projectId, departmentId, clusterId, usageInfo, statusInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of generic-secret assets.
         * @summary List generic-secrets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGenericSecret(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericSecretListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGenericSecret(name, scope, projectId, departmentId, clusterId, usageInfo, statusInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to retrieve a list of password credentials.
         * @summary List password credentials.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPasswords(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPasswords(name, scope, projectId, departmentId, clusterId, usageInfo, statusInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to update the details of an S3-compatible access key credential by id.
         * @summary Update an access key.
         * @param {string} assetId Unique identifier of the asset.
         * @param {AccessKeyUpdateRequest} accessKeyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccessKey(assetId: string, accessKeyUpdateRequest: AccessKeyUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessKey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccessKey(assetId, accessKeyUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to updates the details of a docker registry credentials by id.
         * @summary Update a docker registry credential.
         * @param {string} assetId Unique identifier of the asset.
         * @param {DockerRegistryUpdateRequest} dockerRegistryUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDockerRegistry(assetId: string, dockerRegistryUpdateRequest: DockerRegistryUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DockerRegistry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDockerRegistry(assetId, dockerRegistryUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the details of a generic-secret asset, by id.
         * @summary Update a generic-secret.
         * @param {string} assetId Unique identifier of the asset.
         * @param {GenericSecretUpdateRequest} genericSecretUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGenericSecret(assetId: string, genericSecretUpdateRequest: GenericSecretUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericSecret>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGenericSecret(assetId, genericSecretUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to Update the details of a password credential by id.
         * @summary Update a password credential.
         * @param {string} assetId Unique identifier of the asset.
         * @param {PasswordUpdateRequest} passwordUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePassword(assetId: string, passwordUpdateRequest: PasswordUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Password>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePassword(assetId, passwordUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CredentialsApi - factory interface
 * @export
 */
export const CredentialsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CredentialsApiFp(configuration)
    return {
        /**
         * Use to create an S3-compatible access key credential.
         * @summary Create an access key.
         * @param {AccessKeyCreationRequest} accessKeyCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessKey(accessKeyCreationRequest: AccessKeyCreationRequest, options?: any): AxiosPromise<AccessKey> {
            return localVarFp.createAccessKey(accessKeyCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to create a docker registry credential containing userid, password and url.
         * @summary Create a docker registry credential.
         * @param {DockerRegistryCreationRequest} dockerRegistryCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDockerRegistry(dockerRegistryCreationRequest: DockerRegistryCreationRequest, options?: any): AxiosPromise<DockerRegistry> {
            return localVarFp.createDockerRegistry(dockerRegistryCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to create a generic-secret asset.
         * @summary Create a generic-secret.
         * @param {GenericSecretCreationRequest} genericSecretCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGenericSecret(genericSecretCreationRequest: GenericSecretCreationRequest, options?: any): AxiosPromise<GenericSecret> {
            return localVarFp.createGenericSecret(genericSecretCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to create a userid / password credential.
         * @summary Create a userid / password credential.
         * @param {PasswordCreationRequest} passwordCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPassword(passwordCreationRequest: PasswordCreationRequest, options?: any): AxiosPromise<Password> {
            return localVarFp.createPassword(passwordCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete an S3-compatible access key credential by id.
         * @summary Delete an access key.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccessKey(assetId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteAccessKey(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to deletes a docker registry credential by id.
         * @summary Delete a docker registry credential.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDockerRegistry(assetId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteDockerRegistry(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete a generic-secret asset, by id.
         * @summary Delete a generic-secret.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGenericSecret(assetId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteGenericSecret(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Udse to delete a password credential by id.
         * @summary Delete a password asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePassword(assetId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deletePassword(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to retrieve the details of an S3-compatible access key credential by id.
         * @summary Get an access key.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessKeyById(assetId: string, usageInfo?: boolean, statusInfo?: boolean, options?: any): AxiosPromise<AccessKey> {
            return localVarFp.getAccessKeyById(assetId, usageInfo, statusInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to retrieve the details of a docker registry credential by id.
         * @summary Get a docker registry credential.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDockerRegistryById(assetId: string, usageInfo?: boolean, statusInfo?: boolean, options?: any): AxiosPromise<DockerRegistry> {
            return localVarFp.getDockerRegistryById(assetId, usageInfo, statusInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the details of a generic-secret asset, by id.
         * @summary Get a generic-secret.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGenericSecretById(assetId: string, usageInfo?: boolean, statusInfo?: boolean, options?: any): AxiosPromise<GenericSecret> {
            return localVarFp.getGenericSecretById(assetId, usageInfo, statusInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to retrieve the details of a userid / password credential asset by id.
         * @summary Get a userid / password credential.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordById(assetId: string, usageInfo?: boolean, statusInfo?: boolean, options?: any): AxiosPromise<Password> {
            return localVarFp.getPasswordById(assetId, usageInfo, statusInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to retrieve a list of S3-compatible access key credentials.
         * @summary List access keys.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccessKeys(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options?: any): AxiosPromise<AccessKeyListResponse> {
            return localVarFp.listAccessKeys(name, scope, projectId, departmentId, clusterId, usageInfo, statusInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to retrieve a list of all existing credentials.
         * @summary List credentials.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCredentialsAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options?: any): AxiosPromise<CredentialsListResponse> {
            return localVarFp.listCredentialsAssets(name, scope, projectId, departmentId, clusterId, usageInfo, statusInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to retrieve a list of docker registry credentials.
         * @summary List docker registry credentials.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDockerRegistries(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options?: any): AxiosPromise<DockerRegistryListResponse> {
            return localVarFp.listDockerRegistries(name, scope, projectId, departmentId, clusterId, usageInfo, statusInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of generic-secret assets.
         * @summary List generic-secrets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGenericSecret(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options?: any): AxiosPromise<GenericSecretListResponse> {
            return localVarFp.listGenericSecret(name, scope, projectId, departmentId, clusterId, usageInfo, statusInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to retrieve a list of password credentials.
         * @summary List password credentials.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPasswords(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options?: any): AxiosPromise<PasswordListResponse> {
            return localVarFp.listPasswords(name, scope, projectId, departmentId, clusterId, usageInfo, statusInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to update the details of an S3-compatible access key credential by id.
         * @summary Update an access key.
         * @param {string} assetId Unique identifier of the asset.
         * @param {AccessKeyUpdateRequest} accessKeyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccessKey(assetId: string, accessKeyUpdateRequest: AccessKeyUpdateRequest, options?: any): AxiosPromise<AccessKey> {
            return localVarFp.updateAccessKey(assetId, accessKeyUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to updates the details of a docker registry credentials by id.
         * @summary Update a docker registry credential.
         * @param {string} assetId Unique identifier of the asset.
         * @param {DockerRegistryUpdateRequest} dockerRegistryUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDockerRegistry(assetId: string, dockerRegistryUpdateRequest: DockerRegistryUpdateRequest, options?: any): AxiosPromise<DockerRegistry> {
            return localVarFp.updateDockerRegistry(assetId, dockerRegistryUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the details of a generic-secret asset, by id.
         * @summary Update a generic-secret.
         * @param {string} assetId Unique identifier of the asset.
         * @param {GenericSecretUpdateRequest} genericSecretUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGenericSecret(assetId: string, genericSecretUpdateRequest: GenericSecretUpdateRequest, options?: any): AxiosPromise<GenericSecret> {
            return localVarFp.updateGenericSecret(assetId, genericSecretUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to Update the details of a password credential by id.
         * @summary Update a password credential.
         * @param {string} assetId Unique identifier of the asset.
         * @param {PasswordUpdateRequest} passwordUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword(assetId: string, passwordUpdateRequest: PasswordUpdateRequest, options?: any): AxiosPromise<Password> {
            return localVarFp.updatePassword(assetId, passwordUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CredentialsApi - object-oriented interface
 * @export
 * @class CredentialsApi
 * @extends {BaseAPI}
 */
export class CredentialsApi extends BaseAPI {
    /**
     * Use to create an S3-compatible access key credential.
     * @summary Create an access key.
     * @param {AccessKeyCreationRequest} accessKeyCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public createAccessKey(accessKeyCreationRequest: AccessKeyCreationRequest, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).createAccessKey(accessKeyCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to create a docker registry credential containing userid, password and url.
     * @summary Create a docker registry credential.
     * @param {DockerRegistryCreationRequest} dockerRegistryCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public createDockerRegistry(dockerRegistryCreationRequest: DockerRegistryCreationRequest, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).createDockerRegistry(dockerRegistryCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to create a generic-secret asset.
     * @summary Create a generic-secret.
     * @param {GenericSecretCreationRequest} genericSecretCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public createGenericSecret(genericSecretCreationRequest: GenericSecretCreationRequest, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).createGenericSecret(genericSecretCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to create a userid / password credential.
     * @summary Create a userid / password credential.
     * @param {PasswordCreationRequest} passwordCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public createPassword(passwordCreationRequest: PasswordCreationRequest, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).createPassword(passwordCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete an S3-compatible access key credential by id.
     * @summary Delete an access key.
     * @param {string} assetId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public deleteAccessKey(assetId: string, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).deleteAccessKey(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to deletes a docker registry credential by id.
     * @summary Delete a docker registry credential.
     * @param {string} assetId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public deleteDockerRegistry(assetId: string, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).deleteDockerRegistry(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete a generic-secret asset, by id.
     * @summary Delete a generic-secret.
     * @param {string} assetId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public deleteGenericSecret(assetId: string, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).deleteGenericSecret(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Udse to delete a password credential by id.
     * @summary Delete a password asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public deletePassword(assetId: string, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).deletePassword(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to retrieve the details of an S3-compatible access key credential by id.
     * @summary Get an access key.
     * @param {string} assetId Unique identifier of the asset.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public getAccessKeyById(assetId: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).getAccessKeyById(assetId, usageInfo, statusInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to retrieve the details of a docker registry credential by id.
     * @summary Get a docker registry credential.
     * @param {string} assetId Unique identifier of the asset.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public getDockerRegistryById(assetId: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).getDockerRegistryById(assetId, usageInfo, statusInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the details of a generic-secret asset, by id.
     * @summary Get a generic-secret.
     * @param {string} assetId Unique identifier of the asset.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public getGenericSecretById(assetId: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).getGenericSecretById(assetId, usageInfo, statusInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to retrieve the details of a userid / password credential asset by id.
     * @summary Get a userid / password credential.
     * @param {string} assetId Unique identifier of the asset.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public getPasswordById(assetId: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).getPasswordById(assetId, usageInfo, statusInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to retrieve a list of S3-compatible access key credentials.
     * @summary List access keys.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public listAccessKeys(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).listAccessKeys(name, scope, projectId, departmentId, clusterId, usageInfo, statusInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to retrieve a list of all existing credentials.
     * @summary List credentials.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public listCredentialsAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).listCredentialsAssets(name, scope, projectId, departmentId, clusterId, usageInfo, statusInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to retrieve a list of docker registry credentials.
     * @summary List docker registry credentials.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public listDockerRegistries(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).listDockerRegistries(name, scope, projectId, departmentId, clusterId, usageInfo, statusInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of generic-secret assets.
     * @summary List generic-secrets.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public listGenericSecret(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).listGenericSecret(name, scope, projectId, departmentId, clusterId, usageInfo, statusInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to retrieve a list of password credentials.
     * @summary List password credentials.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public listPasswords(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, statusInfo?: boolean, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).listPasswords(name, scope, projectId, departmentId, clusterId, usageInfo, statusInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to update the details of an S3-compatible access key credential by id.
     * @summary Update an access key.
     * @param {string} assetId Unique identifier of the asset.
     * @param {AccessKeyUpdateRequest} accessKeyUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public updateAccessKey(assetId: string, accessKeyUpdateRequest: AccessKeyUpdateRequest, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).updateAccessKey(assetId, accessKeyUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to updates the details of a docker registry credentials by id.
     * @summary Update a docker registry credential.
     * @param {string} assetId Unique identifier of the asset.
     * @param {DockerRegistryUpdateRequest} dockerRegistryUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public updateDockerRegistry(assetId: string, dockerRegistryUpdateRequest: DockerRegistryUpdateRequest, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).updateDockerRegistry(assetId, dockerRegistryUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the details of a generic-secret asset, by id.
     * @summary Update a generic-secret.
     * @param {string} assetId Unique identifier of the asset.
     * @param {GenericSecretUpdateRequest} genericSecretUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public updateGenericSecret(assetId: string, genericSecretUpdateRequest: GenericSecretUpdateRequest, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).updateGenericSecret(assetId, genericSecretUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to Update the details of a password credential by id.
     * @summary Update a password credential.
     * @param {string} assetId Unique identifier of the asset.
     * @param {PasswordUpdateRequest} passwordUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CredentialsApi
     */
    public updatePassword(assetId: string, passwordUpdateRequest: PasswordUpdateRequest, options?: AxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).updatePassword(assetId, passwordUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DatasourcesApi - axios parameter creator
 * @export
 */
export const DatasourcesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Placeholder.
         * @param {AssetMeta} assetMeta 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDatasourceAsset: async (assetMeta: AssetMeta, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetMeta' is not null or undefined
            assertParamExists('createDatasourceAsset', 'assetMeta', assetMeta)
            const localVarPath = `/api/v1/asset/datasource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetMeta, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a combined list of data-sources.
         * @summary List datasource assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {boolean} [dataVolumes] Whether the query should include data volumes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDatasourceAssets: async (name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', dataVolumes?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/datasource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }

            if (assetIds !== undefined) {
                localVarQueryParameter['assetIds'] = assetIds;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }

            if (dataVolumes !== undefined) {
                localVarQueryParameter['dataVolumes'] = dataVolumes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DatasourcesApi - functional programming interface
 * @export
 */
export const DatasourcesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DatasourcesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Placeholder.
         * @param {AssetMeta} assetMeta 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDatasourceAsset(assetMeta: AssetMeta, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDatasourceAsset(assetMeta, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a combined list of data-sources.
         * @summary List datasource assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {boolean} [dataVolumes] Whether the query should include data volumes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDatasourceAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', dataVolumes?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasourceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDatasourceAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, dataVolumes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DatasourcesApi - factory interface
 * @export
 */
export const DatasourcesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DatasourcesApiFp(configuration)
    return {
        /**
         * 
         * @summary Placeholder.
         * @param {AssetMeta} assetMeta 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDatasourceAsset(assetMeta: AssetMeta, options?: any): AxiosPromise<void> {
            return localVarFp.createDatasourceAsset(assetMeta, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a combined list of data-sources.
         * @summary List datasource assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {boolean} [dataVolumes] Whether the query should include data volumes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDatasourceAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', dataVolumes?: boolean, options?: any): AxiosPromise<DatasourceListResponse> {
            return localVarFp.listDatasourceAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, dataVolumes, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DatasourcesApi - object-oriented interface
 * @export
 * @class DatasourcesApi
 * @extends {BaseAPI}
 */
export class DatasourcesApi extends BaseAPI {
    /**
     * 
     * @summary Placeholder.
     * @param {AssetMeta} assetMeta 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApi
     */
    public createDatasourceAsset(assetMeta: AssetMeta, options?: AxiosRequestConfig) {
        return DatasourcesApiFp(this.configuration).createDatasourceAsset(assetMeta, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a combined list of data-sources.
     * @summary List datasource assets.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {boolean} [dataVolumes] Whether the query should include data volumes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApi
     */
    public listDatasourceAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', dataVolumes?: boolean, options?: AxiosRequestConfig) {
        return DatasourcesApiFp(this.configuration).listDatasourceAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, dataVolumes, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EnvironmentApi - axios parameter creator
 * @export
 */
export const EnvironmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Use to create an environment asset.
         * @summary Create an environment asset.
         * @param {EnvironmentCreationRequest} [environmentCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnvironmentAsset: async (environmentCreationRequest?: EnvironmentCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/environment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(environmentCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete an environment asset by id.
         * @summary Delete an environment asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnvironmentAssetById: async (assetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deleteEnvironmentAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/environment/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to retrieve the details of environment asset by id.
         * @summary Get an environment asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnvironmentAssetById: async (assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', statusInfo?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getEnvironmentAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/environment/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to retrieve a list of environment assets.
         * @summary List environment assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {string} [distributedFramework] Filter results to workload of type distributed and distributedFramework.
         * @param {boolean} [isDistributed] Filter results to workload of type distributed.
         * @param {boolean} [isTraining] Filter results to workload of type training.
         * @param {boolean} [isWorkspace] Filter results to workload of type workspace.
         * @param {boolean} [isInference] Filter results to workload of type inference.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {boolean} [includeDescendants] Whether the query should include asset from all nested layers within the specified entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEnvironmentAssets: async (name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', distributedFramework?: string, isDistributed?: boolean, isTraining?: boolean, isWorkspace?: boolean, isInference?: boolean, complyToReplicaType?: 'Worker' | 'Master', statusInfo?: boolean, includeDescendants?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/environment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (distributedFramework !== undefined) {
                localVarQueryParameter['distributedFramework'] = distributedFramework;
            }

            if (isDistributed !== undefined) {
                localVarQueryParameter['isDistributed'] = isDistributed;
            }

            if (isTraining !== undefined) {
                localVarQueryParameter['isTraining'] = isTraining;
            }

            if (isWorkspace !== undefined) {
                localVarQueryParameter['isWorkspace'] = isWorkspace;
            }

            if (isInference !== undefined) {
                localVarQueryParameter['isInference'] = isInference;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }

            if (includeDescendants !== undefined) {
                localVarQueryParameter['includeDescendants'] = includeDescendants;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to update the details of environment asset by id.
         * @summary Update an environment asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {EnvironmentUpdateRequest} [environmentUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnvironmentAssetById: async (assetId: string, environmentUpdateRequest?: EnvironmentUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('updateEnvironmentAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/environment/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(environmentUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnvironmentApi - functional programming interface
 * @export
 */
export const EnvironmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnvironmentApiAxiosParamCreator(configuration)
    return {
        /**
         * Use to create an environment asset.
         * @summary Create an environment asset.
         * @param {EnvironmentCreationRequest} [environmentCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEnvironmentAsset(environmentCreationRequest?: EnvironmentCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvironmentAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEnvironmentAsset(environmentCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete an environment asset by id.
         * @summary Delete an environment asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEnvironmentAssetById(assetId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEnvironmentAssetById(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to retrieve the details of environment asset by id.
         * @summary Get an environment asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnvironmentAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', statusInfo?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvironmentAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnvironmentAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, statusInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to retrieve a list of environment assets.
         * @summary List environment assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {string} [distributedFramework] Filter results to workload of type distributed and distributedFramework.
         * @param {boolean} [isDistributed] Filter results to workload of type distributed.
         * @param {boolean} [isTraining] Filter results to workload of type training.
         * @param {boolean} [isWorkspace] Filter results to workload of type workspace.
         * @param {boolean} [isInference] Filter results to workload of type inference.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {boolean} [includeDescendants] Whether the query should include asset from all nested layers within the specified entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEnvironmentAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', distributedFramework?: string, isDistributed?: boolean, isTraining?: boolean, isWorkspace?: boolean, isInference?: boolean, complyToReplicaType?: 'Worker' | 'Master', statusInfo?: boolean, includeDescendants?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvironmentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEnvironmentAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, distributedFramework, isDistributed, isTraining, isWorkspace, isInference, complyToReplicaType, statusInfo, includeDescendants, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to update the details of environment asset by id.
         * @summary Update an environment asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {EnvironmentUpdateRequest} [environmentUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEnvironmentAssetById(assetId: string, environmentUpdateRequest?: EnvironmentUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvironmentAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEnvironmentAssetById(assetId, environmentUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EnvironmentApi - factory interface
 * @export
 */
export const EnvironmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnvironmentApiFp(configuration)
    return {
        /**
         * Use to create an environment asset.
         * @summary Create an environment asset.
         * @param {EnvironmentCreationRequest} [environmentCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnvironmentAsset(environmentCreationRequest?: EnvironmentCreationRequest, options?: any): AxiosPromise<EnvironmentAsset> {
            return localVarFp.createEnvironmentAsset(environmentCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete an environment asset by id.
         * @summary Delete an environment asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnvironmentAssetById(assetId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteEnvironmentAssetById(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to retrieve the details of environment asset by id.
         * @summary Get an environment asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnvironmentAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', statusInfo?: boolean, options?: any): AxiosPromise<EnvironmentAsset> {
            return localVarFp.getEnvironmentAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, statusInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to retrieve a list of environment assets.
         * @summary List environment assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {string} [distributedFramework] Filter results to workload of type distributed and distributedFramework.
         * @param {boolean} [isDistributed] Filter results to workload of type distributed.
         * @param {boolean} [isTraining] Filter results to workload of type training.
         * @param {boolean} [isWorkspace] Filter results to workload of type workspace.
         * @param {boolean} [isInference] Filter results to workload of type inference.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {boolean} [includeDescendants] Whether the query should include asset from all nested layers within the specified entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEnvironmentAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', distributedFramework?: string, isDistributed?: boolean, isTraining?: boolean, isWorkspace?: boolean, isInference?: boolean, complyToReplicaType?: 'Worker' | 'Master', statusInfo?: boolean, includeDescendants?: boolean, options?: any): AxiosPromise<EnvironmentListResponse> {
            return localVarFp.listEnvironmentAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, distributedFramework, isDistributed, isTraining, isWorkspace, isInference, complyToReplicaType, statusInfo, includeDescendants, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to update the details of environment asset by id.
         * @summary Update an environment asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {EnvironmentUpdateRequest} [environmentUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnvironmentAssetById(assetId: string, environmentUpdateRequest?: EnvironmentUpdateRequest, options?: any): AxiosPromise<EnvironmentAsset> {
            return localVarFp.updateEnvironmentAssetById(assetId, environmentUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnvironmentApi - object-oriented interface
 * @export
 * @class EnvironmentApi
 * @extends {BaseAPI}
 */
export class EnvironmentApi extends BaseAPI {
    /**
     * Use to create an environment asset.
     * @summary Create an environment asset.
     * @param {EnvironmentCreationRequest} [environmentCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentApi
     */
    public createEnvironmentAsset(environmentCreationRequest?: EnvironmentCreationRequest, options?: AxiosRequestConfig) {
        return EnvironmentApiFp(this.configuration).createEnvironmentAsset(environmentCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete an environment asset by id.
     * @summary Delete an environment asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentApi
     */
    public deleteEnvironmentAssetById(assetId: string, options?: AxiosRequestConfig) {
        return EnvironmentApiFp(this.configuration).deleteEnvironmentAssetById(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to retrieve the details of environment asset by id.
     * @summary Get an environment asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentApi
     */
    public getEnvironmentAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', statusInfo?: boolean, options?: AxiosRequestConfig) {
        return EnvironmentApiFp(this.configuration).getEnvironmentAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, statusInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to retrieve a list of environment assets.
     * @summary List environment assets.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {string} [distributedFramework] Filter results to workload of type distributed and distributedFramework.
     * @param {boolean} [isDistributed] Filter results to workload of type distributed.
     * @param {boolean} [isTraining] Filter results to workload of type training.
     * @param {boolean} [isWorkspace] Filter results to workload of type workspace.
     * @param {boolean} [isInference] Filter results to workload of type inference.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {boolean} [includeDescendants] Whether the query should include asset from all nested layers within the specified entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentApi
     */
    public listEnvironmentAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', distributedFramework?: string, isDistributed?: boolean, isTraining?: boolean, isWorkspace?: boolean, isInference?: boolean, complyToReplicaType?: 'Worker' | 'Master', statusInfo?: boolean, includeDescendants?: boolean, options?: AxiosRequestConfig) {
        return EnvironmentApiFp(this.configuration).listEnvironmentAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, distributedFramework, isDistributed, isTraining, isWorkspace, isInference, complyToReplicaType, statusInfo, includeDescendants, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to update the details of environment asset by id.
     * @summary Update an environment asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {EnvironmentUpdateRequest} [environmentUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentApi
     */
    public updateEnvironmentAssetById(assetId: string, environmentUpdateRequest?: EnvironmentUpdateRequest, options?: AxiosRequestConfig) {
        return EnvironmentApiFp(this.configuration).updateEnvironmentAssetById(assetId, environmentUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GitApi - axios parameter creator
 * @export
 */
export const GitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Use to create a a Git datasource asset.
         * @summary Create a Git asset.
         * @param {GitCreationRequest} [gitCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGitAsset: async (gitCreationRequest?: GitCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/datasource/git`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gitCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete a Git datasource asset by id.
         * @summary Delete a Git asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGitAssetById: async (assetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deleteGitAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/git/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to retrieve the details of a Git datasource asset by id.
         * @summary Get a Git asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGitAssetById: async (assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getGitAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/git/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of Git datasource assets.
         * @summary List Git assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGitAssets: async (name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/datasource/git`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }

            if (assetIds !== undefined) {
                localVarQueryParameter['assetIds'] = assetIds;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to update the details of Git datasource asset by id.
         * @summary Update a Git asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {GitUpdateRequest} [gitUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGitAssetById: async (assetId: string, gitUpdateRequest?: GitUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('updateGitAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/git/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gitUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GitApi - functional programming interface
 * @export
 */
export const GitApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GitApiAxiosParamCreator(configuration)
    return {
        /**
         * Use to create a a Git datasource asset.
         * @summary Create a Git asset.
         * @param {GitCreationRequest} [gitCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGitAsset(gitCreationRequest?: GitCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GitAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGitAsset(gitCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete a Git datasource asset by id.
         * @summary Delete a Git asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGitAssetById(assetId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGitAssetById(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to retrieve the details of a Git datasource asset by id.
         * @summary Get a Git asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGitAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GitAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGitAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of Git datasource assets.
         * @summary List Git assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGitAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GitListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGitAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to update the details of Git datasource asset by id.
         * @summary Update a Git asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {GitUpdateRequest} [gitUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGitAssetById(assetId: string, gitUpdateRequest?: GitUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GitAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGitAssetById(assetId, gitUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GitApi - factory interface
 * @export
 */
export const GitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GitApiFp(configuration)
    return {
        /**
         * Use to create a a Git datasource asset.
         * @summary Create a Git asset.
         * @param {GitCreationRequest} [gitCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGitAsset(gitCreationRequest?: GitCreationRequest, options?: any): AxiosPromise<GitAsset> {
            return localVarFp.createGitAsset(gitCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete a Git datasource asset by id.
         * @summary Delete a Git asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGitAssetById(assetId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteGitAssetById(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to retrieve the details of a Git datasource asset by id.
         * @summary Get a Git asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGitAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<GitAsset> {
            return localVarFp.getGitAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of Git datasource assets.
         * @summary List Git assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGitAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<GitListResponse> {
            return localVarFp.listGitAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to update the details of Git datasource asset by id.
         * @summary Update a Git asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {GitUpdateRequest} [gitUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGitAssetById(assetId: string, gitUpdateRequest?: GitUpdateRequest, options?: any): AxiosPromise<GitAsset> {
            return localVarFp.updateGitAssetById(assetId, gitUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GitApi - object-oriented interface
 * @export
 * @class GitApi
 * @extends {BaseAPI}
 */
export class GitApi extends BaseAPI {
    /**
     * Use to create a a Git datasource asset.
     * @summary Create a Git asset.
     * @param {GitCreationRequest} [gitCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GitApi
     */
    public createGitAsset(gitCreationRequest?: GitCreationRequest, options?: AxiosRequestConfig) {
        return GitApiFp(this.configuration).createGitAsset(gitCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete a Git datasource asset by id.
     * @summary Delete a Git asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GitApi
     */
    public deleteGitAssetById(assetId: string, options?: AxiosRequestConfig) {
        return GitApiFp(this.configuration).deleteGitAssetById(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to retrieve the details of a Git datasource asset by id.
     * @summary Get a Git asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GitApi
     */
    public getGitAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return GitApiFp(this.configuration).getGitAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of Git datasource assets.
     * @summary List Git assets.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GitApi
     */
    public listGitAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return GitApiFp(this.configuration).listGitAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to update the details of Git datasource asset by id.
     * @summary Update a Git asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {GitUpdateRequest} [gitUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GitApi
     */
    public updateGitAssetById(assetId: string, gitUpdateRequest?: GitUpdateRequest, options?: AxiosRequestConfig) {
        return GitApiFp(this.configuration).updateGitAssetById(assetId, gitUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HostPathApi - axios parameter creator
 * @export
 */
export const HostPathApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Use to create a hostPath datasource asset.
         * @summary Create a host path asset.
         * @param {HostPathCreationRequest} hostPathCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHostPath: async (hostPathCreationRequest: HostPathCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hostPathCreationRequest' is not null or undefined
            assertParamExists('createHostPath', 'hostPathCreationRequest', hostPathCreationRequest)
            const localVarPath = `/api/v1/asset/datasource/host-path`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hostPathCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete a hostPath datasource asset by id.
         * @summary Delete a hostPath asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHostPathById: async (assetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deleteHostPathById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/host-path/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to retrieve the details of a hostPath datasource by id.
         * @summary Get a hostPath asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHostPathById: async (assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getHostPathById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/host-path/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of hostPath datasource assets.
         * @summary List host path assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHostPathAssets: async (name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/datasource/host-path`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (assetIds !== undefined) {
                localVarQueryParameter['assetIds'] = assetIds;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to update the details of a hostPath datasource by id.
         * @summary Update a hostPath asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {HostPathUpdateRequest} hostPathUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHostPathById: async (assetId: string, hostPathUpdateRequest: HostPathUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('updateHostPathById', 'assetId', assetId)
            // verify required parameter 'hostPathUpdateRequest' is not null or undefined
            assertParamExists('updateHostPathById', 'hostPathUpdateRequest', hostPathUpdateRequest)
            const localVarPath = `/api/v1/asset/datasource/host-path/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hostPathUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HostPathApi - functional programming interface
 * @export
 */
export const HostPathApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HostPathApiAxiosParamCreator(configuration)
    return {
        /**
         * Use to create a hostPath datasource asset.
         * @summary Create a host path asset.
         * @param {HostPathCreationRequest} hostPathCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHostPath(hostPathCreationRequest: HostPathCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HostPathAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHostPath(hostPathCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete a hostPath datasource asset by id.
         * @summary Delete a hostPath asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteHostPathById(assetId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHostPathById(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to retrieve the details of a hostPath datasource by id.
         * @summary Get a hostPath asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHostPathById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HostPathAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHostPathById(assetId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of hostPath datasource assets.
         * @summary List host path assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listHostPathAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HostPathListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listHostPathAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, assetIds, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to update the details of a hostPath datasource by id.
         * @summary Update a hostPath asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {HostPathUpdateRequest} hostPathUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHostPathById(assetId: string, hostPathUpdateRequest: HostPathUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HostPathAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHostPathById(assetId, hostPathUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HostPathApi - factory interface
 * @export
 */
export const HostPathApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HostPathApiFp(configuration)
    return {
        /**
         * Use to create a hostPath datasource asset.
         * @summary Create a host path asset.
         * @param {HostPathCreationRequest} hostPathCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHostPath(hostPathCreationRequest: HostPathCreationRequest, options?: any): AxiosPromise<HostPathAsset> {
            return localVarFp.createHostPath(hostPathCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete a hostPath datasource asset by id.
         * @summary Delete a hostPath asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHostPathById(assetId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteHostPathById(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to retrieve the details of a hostPath datasource by id.
         * @summary Get a hostPath asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHostPathById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<HostPathAsset> {
            return localVarFp.getHostPathById(assetId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of hostPath datasource assets.
         * @summary List host path assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHostPathAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<HostPathListResponse> {
            return localVarFp.listHostPathAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, assetIds, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to update the details of a hostPath datasource by id.
         * @summary Update a hostPath asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {HostPathUpdateRequest} hostPathUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHostPathById(assetId: string, hostPathUpdateRequest: HostPathUpdateRequest, options?: any): AxiosPromise<HostPathAsset> {
            return localVarFp.updateHostPathById(assetId, hostPathUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HostPathApi - object-oriented interface
 * @export
 * @class HostPathApi
 * @extends {BaseAPI}
 */
export class HostPathApi extends BaseAPI {
    /**
     * Use to create a hostPath datasource asset.
     * @summary Create a host path asset.
     * @param {HostPathCreationRequest} hostPathCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HostPathApi
     */
    public createHostPath(hostPathCreationRequest: HostPathCreationRequest, options?: AxiosRequestConfig) {
        return HostPathApiFp(this.configuration).createHostPath(hostPathCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete a hostPath datasource asset by id.
     * @summary Delete a hostPath asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HostPathApi
     */
    public deleteHostPathById(assetId: string, options?: AxiosRequestConfig) {
        return HostPathApiFp(this.configuration).deleteHostPathById(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to retrieve the details of a hostPath datasource by id.
     * @summary Get a hostPath asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HostPathApi
     */
    public getHostPathById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return HostPathApiFp(this.configuration).getHostPathById(assetId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of hostPath datasource assets.
     * @summary List host path assets.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HostPathApi
     */
    public listHostPathAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return HostPathApiFp(this.configuration).listHostPathAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, assetIds, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to update the details of a hostPath datasource by id.
     * @summary Update a hostPath asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {HostPathUpdateRequest} hostPathUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HostPathApi
     */
    public updateHostPathById(assetId: string, hostPathUpdateRequest: HostPathUpdateRequest, options?: AxiosRequestConfig) {
        return HostPathApiFp(this.configuration).updateHostPathById(assetId, hostPathUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InferencesApi - axios parameter creator
 * @export
 */
export const InferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates an inference workload from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create inference workload.
         * @param {WorkloadCreationRequest} [workloadCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInference: async (workloadCreationRequest?: WorkloadCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/inference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workloadCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates an inference from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create an inference - assets based.
         * @param {InferenceCreationRequestV2} [inferenceCreationRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInferenceV2: async (inferenceCreationRequestV2?: InferenceCreationRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/inference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inferenceCreationRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete inference workload leftover from backend, by id.
         * @summary Delete an inference workload.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInferenceById: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('deleteInferenceById', 'workloadId', workloadId)
            const localVarPath = `/api/v1/inference/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves various information of a given Hugging Face model.
         * @summary Get info of a Hugging Face model.
         * @param {HuggingFaceModelInfoRequest} [huggingFaceModelInfoRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHuggingFaceModelInfo: async (huggingFaceModelInfoRequest?: HuggingFaceModelInfoRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/huggingface-model/info-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(huggingFaceModelInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves various information of a given Hugging Face model.
         * @summary Get info of a Hugging Face model.
         * @param {HuggingFaceModelInfoRequestV2} [huggingFaceModelInfoRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHuggingFaceModelInfoV2: async (huggingFaceModelInfoRequestV2?: HuggingFaceModelInfoRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/huggingface-model/info-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(huggingFaceModelInfoRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the data of an inference, i.e. its set of assets and specific env.
         * @summary Get inference content.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferenceById: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getInferenceById', 'workloadId', workloadId)
            const localVarPath = `/api/v1/inference/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the data of a training, i.e. its set of assets and specific env.
         * @summary Get inference data - assets based.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferenceByIdV2: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getInferenceByIdV2', 'workloadId', workloadId)
            const localVarPath = `/api/v2/inference/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get combined policy and specificRunParams data for workload creation form
         * @summary Get merged inference workload
         * @param {string} [projectId] The id of the project
         * @param {string} [workloadId] The id of the workload
         * @param {string} [templateId] The id of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferenceMerged: async (projectId?: string, workloadId?: string, templateId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/inference/merged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (workloadId !== undefined) {
                localVarQueryParameter['workloadId'] = workloadId;
            }

            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InferencesApi - functional programming interface
 * @export
 */
export const InferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates an inference workload from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create inference workload.
         * @param {WorkloadCreationRequest} [workloadCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInference(workloadCreationRequest?: WorkloadCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Inference>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInference(workloadCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates an inference from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create an inference - assets based.
         * @param {InferenceCreationRequestV2} [inferenceCreationRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInferenceV2(inferenceCreationRequestV2?: InferenceCreationRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InferenceV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInferenceV2(inferenceCreationRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete inference workload leftover from backend, by id.
         * @summary Delete an inference workload.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInferenceById(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInferenceById(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves various information of a given Hugging Face model.
         * @summary Get info of a Hugging Face model.
         * @param {HuggingFaceModelInfoRequest} [huggingFaceModelInfoRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHuggingFaceModelInfo(huggingFaceModelInfoRequest?: HuggingFaceModelInfoRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HuggingFaceModelInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHuggingFaceModelInfo(huggingFaceModelInfoRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves various information of a given Hugging Face model.
         * @summary Get info of a Hugging Face model.
         * @param {HuggingFaceModelInfoRequestV2} [huggingFaceModelInfoRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHuggingFaceModelInfoV2(huggingFaceModelInfoRequestV2?: HuggingFaceModelInfoRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HuggingFaceModelInfoV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHuggingFaceModelInfoV2(huggingFaceModelInfoRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the data of an inference, i.e. its set of assets and specific env.
         * @summary Get inference content.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInferenceById(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Inference>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInferenceById(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the data of a training, i.e. its set of assets and specific env.
         * @summary Get inference data - assets based.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInferenceByIdV2(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InferenceV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInferenceByIdV2(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get combined policy and specificRunParams data for workload creation form
         * @summary Get merged inference workload
         * @param {string} [projectId] The id of the project
         * @param {string} [workloadId] The id of the workload
         * @param {string} [templateId] The id of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInferenceMerged(projectId?: string, workloadId?: string, templateId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InferenceV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInferenceMerged(projectId, workloadId, templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InferencesApi - factory interface
 * @export
 */
export const InferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InferencesApiFp(configuration)
    return {
        /**
         * Creates an inference workload from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create inference workload.
         * @param {WorkloadCreationRequest} [workloadCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInference(workloadCreationRequest?: WorkloadCreationRequest, options?: any): AxiosPromise<Inference> {
            return localVarFp.createInference(workloadCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates an inference from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create an inference - assets based.
         * @param {InferenceCreationRequestV2} [inferenceCreationRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInferenceV2(inferenceCreationRequestV2?: InferenceCreationRequestV2, options?: any): AxiosPromise<InferenceV2> {
            return localVarFp.createInferenceV2(inferenceCreationRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete inference workload leftover from backend, by id.
         * @summary Delete an inference workload.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInferenceById(workloadId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteInferenceById(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves various information of a given Hugging Face model.
         * @summary Get info of a Hugging Face model.
         * @param {HuggingFaceModelInfoRequest} [huggingFaceModelInfoRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHuggingFaceModelInfo(huggingFaceModelInfoRequest?: HuggingFaceModelInfoRequest, options?: any): AxiosPromise<HuggingFaceModelInfo> {
            return localVarFp.getHuggingFaceModelInfo(huggingFaceModelInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves various information of a given Hugging Face model.
         * @summary Get info of a Hugging Face model.
         * @param {HuggingFaceModelInfoRequestV2} [huggingFaceModelInfoRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHuggingFaceModelInfoV2(huggingFaceModelInfoRequestV2?: HuggingFaceModelInfoRequestV2, options?: any): AxiosPromise<HuggingFaceModelInfoV2> {
            return localVarFp.getHuggingFaceModelInfoV2(huggingFaceModelInfoRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the data of an inference, i.e. its set of assets and specific env.
         * @summary Get inference content.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferenceById(workloadId: string, options?: any): AxiosPromise<Inference> {
            return localVarFp.getInferenceById(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the data of a training, i.e. its set of assets and specific env.
         * @summary Get inference data - assets based.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferenceByIdV2(workloadId: string, options?: any): AxiosPromise<InferenceV2> {
            return localVarFp.getInferenceByIdV2(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get combined policy and specificRunParams data for workload creation form
         * @summary Get merged inference workload
         * @param {string} [projectId] The id of the project
         * @param {string} [workloadId] The id of the workload
         * @param {string} [templateId] The id of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferenceMerged(projectId?: string, workloadId?: string, templateId?: string, options?: any): AxiosPromise<InferenceV2> {
            return localVarFp.getInferenceMerged(projectId, workloadId, templateId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InferencesApi - object-oriented interface
 * @export
 * @class InferencesApi
 * @extends {BaseAPI}
 */
export class InferencesApi extends BaseAPI {
    /**
     * Creates an inference workload from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
     * @summary Create inference workload.
     * @param {WorkloadCreationRequest} [workloadCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InferencesApi
     */
    public createInference(workloadCreationRequest?: WorkloadCreationRequest, options?: AxiosRequestConfig) {
        return InferencesApiFp(this.configuration).createInference(workloadCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates an inference from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
     * @summary Create an inference - assets based.
     * @param {InferenceCreationRequestV2} [inferenceCreationRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InferencesApi
     */
    public createInferenceV2(inferenceCreationRequestV2?: InferenceCreationRequestV2, options?: AxiosRequestConfig) {
        return InferencesApiFp(this.configuration).createInferenceV2(inferenceCreationRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete inference workload leftover from backend, by id.
     * @summary Delete an inference workload.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InferencesApi
     */
    public deleteInferenceById(workloadId: string, options?: AxiosRequestConfig) {
        return InferencesApiFp(this.configuration).deleteInferenceById(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves various information of a given Hugging Face model.
     * @summary Get info of a Hugging Face model.
     * @param {HuggingFaceModelInfoRequest} [huggingFaceModelInfoRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InferencesApi
     */
    public getHuggingFaceModelInfo(huggingFaceModelInfoRequest?: HuggingFaceModelInfoRequest, options?: AxiosRequestConfig) {
        return InferencesApiFp(this.configuration).getHuggingFaceModelInfo(huggingFaceModelInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves various information of a given Hugging Face model.
     * @summary Get info of a Hugging Face model.
     * @param {HuggingFaceModelInfoRequestV2} [huggingFaceModelInfoRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InferencesApi
     */
    public getHuggingFaceModelInfoV2(huggingFaceModelInfoRequestV2?: HuggingFaceModelInfoRequestV2, options?: AxiosRequestConfig) {
        return InferencesApiFp(this.configuration).getHuggingFaceModelInfoV2(huggingFaceModelInfoRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the data of an inference, i.e. its set of assets and specific env.
     * @summary Get inference content.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InferencesApi
     */
    public getInferenceById(workloadId: string, options?: AxiosRequestConfig) {
        return InferencesApiFp(this.configuration).getInferenceById(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the data of a training, i.e. its set of assets and specific env.
     * @summary Get inference data - assets based.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InferencesApi
     */
    public getInferenceByIdV2(workloadId: string, options?: AxiosRequestConfig) {
        return InferencesApiFp(this.configuration).getInferenceByIdV2(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get combined policy and specificRunParams data for workload creation form
     * @summary Get merged inference workload
     * @param {string} [projectId] The id of the project
     * @param {string} [workloadId] The id of the workload
     * @param {string} [templateId] The id of the template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InferencesApi
     */
    public getInferenceMerged(projectId?: string, workloadId?: string, templateId?: string, options?: AxiosRequestConfig) {
        return InferencesApiFp(this.configuration).getInferenceMerged(projectId, workloadId, templateId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ModelApi - axios parameter creator
 * @export
 */
export const ModelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a model asset.
         * @summary Create model asset.
         * @param {ModelCreationRequest} [modelCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModelAsset: async (modelCreationRequest?: ModelCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/model`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modelCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes model asset, by id.
         * @summary Delete model asset.
         * @param {string} modelId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteModelAssetById: async (modelId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('deleteModelAssetById', 'modelId', modelId)
            const localVarPath = `/api/v1/asset/model/{ModelId}`
                .replace(`{${"ModelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the details of model asset, by id.
         * @summary Get model asset.
         * @param {string} modelId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModelAssetById: async (modelId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('getModelAssetById', 'modelId', modelId)
            const localVarPath = `/api/v1/asset/model/{ModelId}`
                .replace(`{${"ModelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of model assets.
         * @summary List model assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {string} [environmentId] The id of the environment to which the asset belongs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listModelAssets: async (name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', environmentId?: string, complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/model`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (environmentId !== undefined) {
                localVarQueryParameter['environmentId'] = environmentId;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the details of model asset, by id.
         * @summary Update model asset.
         * @param {string} modelId Unique identifier of the asset.
         * @param {ModelUpdateRequest} [modelUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModelAssetById: async (modelId: string, modelUpdateRequest?: ModelUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('updateModelAssetById', 'modelId', modelId)
            const localVarPath = `/api/v1/asset/model/{ModelId}`
                .replace(`{${"ModelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modelUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModelApi - functional programming interface
 * @export
 */
export const ModelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModelApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a model asset.
         * @summary Create model asset.
         * @param {ModelCreationRequest} [modelCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createModelAsset(modelCreationRequest?: ModelCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createModelAsset(modelCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes model asset, by id.
         * @summary Delete model asset.
         * @param {string} modelId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteModelAssetById(modelId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteModelAssetById(modelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the details of model asset, by id.
         * @summary Get model asset.
         * @param {string} modelId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModelAssetById(modelId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModelAssetById(modelId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of model assets.
         * @summary List model assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {string} [environmentId] The id of the environment to which the asset belongs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listModelAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', environmentId?: string, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listModelAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, environmentId, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the details of model asset, by id.
         * @summary Update model asset.
         * @param {string} modelId Unique identifier of the asset.
         * @param {ModelUpdateRequest} [modelUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateModelAssetById(modelId: string, modelUpdateRequest?: ModelUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateModelAssetById(modelId, modelUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ModelApi - factory interface
 * @export
 */
export const ModelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModelApiFp(configuration)
    return {
        /**
         * Creates a model asset.
         * @summary Create model asset.
         * @param {ModelCreationRequest} [modelCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModelAsset(modelCreationRequest?: ModelCreationRequest, options?: any): AxiosPromise<ModelAsset> {
            return localVarFp.createModelAsset(modelCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes model asset, by id.
         * @summary Delete model asset.
         * @param {string} modelId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteModelAssetById(modelId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteModelAssetById(modelId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the details of model asset, by id.
         * @summary Get model asset.
         * @param {string} modelId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModelAssetById(modelId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<ModelAsset> {
            return localVarFp.getModelAssetById(modelId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of model assets.
         * @summary List model assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {string} [environmentId] The id of the environment to which the asset belongs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listModelAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', environmentId?: string, complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<ModelListResponse> {
            return localVarFp.listModelAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, environmentId, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the details of model asset, by id.
         * @summary Update model asset.
         * @param {string} modelId Unique identifier of the asset.
         * @param {ModelUpdateRequest} [modelUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModelAssetById(modelId: string, modelUpdateRequest?: ModelUpdateRequest, options?: any): AxiosPromise<ModelAsset> {
            return localVarFp.updateModelAssetById(modelId, modelUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ModelApi - object-oriented interface
 * @export
 * @class ModelApi
 * @extends {BaseAPI}
 */
export class ModelApi extends BaseAPI {
    /**
     * Creates a model asset.
     * @summary Create model asset.
     * @param {ModelCreationRequest} [modelCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelApi
     */
    public createModelAsset(modelCreationRequest?: ModelCreationRequest, options?: AxiosRequestConfig) {
        return ModelApiFp(this.configuration).createModelAsset(modelCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes model asset, by id.
     * @summary Delete model asset.
     * @param {string} modelId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelApi
     */
    public deleteModelAssetById(modelId: string, options?: AxiosRequestConfig) {
        return ModelApiFp(this.configuration).deleteModelAssetById(modelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the details of model asset, by id.
     * @summary Get model asset.
     * @param {string} modelId Unique identifier of the asset.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelApi
     */
    public getModelAssetById(modelId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return ModelApiFp(this.configuration).getModelAssetById(modelId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of model assets.
     * @summary List model assets.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {string} [environmentId] The id of the environment to which the asset belongs.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelApi
     */
    public listModelAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', environmentId?: string, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return ModelApiFp(this.configuration).listModelAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, environmentId, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the details of model asset, by id.
     * @summary Update model asset.
     * @param {string} modelId Unique identifier of the asset.
     * @param {ModelUpdateRequest} [modelUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelApi
     */
    public updateModelAssetById(modelId: string, modelUpdateRequest?: ModelUpdateRequest, options?: AxiosRequestConfig) {
        return ModelApiFp(this.configuration).updateModelAssetById(modelId, modelUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ModelInferenceApi - axios parameter creator
 * @export
 */
export const ModelInferenceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a model-inference workload from a given set of assets. The set must include one model and one compute asset.
         * @summary Create model-inference.
         * @param {ModelInferenceCreationRequest} [modelInferenceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModelInference: async (modelInferenceCreationRequest?: ModelInferenceCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/model-inference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modelInferenceCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a model-inference from a given set of assets. The set must include one model asset and one compute asset.
         * @summary Create a model-inference
         * @param {ModelInferenceCreationRequestV2} [modelInferenceCreationRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModelInferenceV2: async (modelInferenceCreationRequestV2?: ModelInferenceCreationRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/model-inference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modelInferenceCreationRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModelInferenceApi - functional programming interface
 * @export
 */
export const ModelInferenceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModelInferenceApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a model-inference workload from a given set of assets. The set must include one model and one compute asset.
         * @summary Create model-inference.
         * @param {ModelInferenceCreationRequest} [modelInferenceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createModelInference(modelInferenceCreationRequest?: ModelInferenceCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelInference>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createModelInference(modelInferenceCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a model-inference from a given set of assets. The set must include one model asset and one compute asset.
         * @summary Create a model-inference
         * @param {ModelInferenceCreationRequestV2} [modelInferenceCreationRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createModelInferenceV2(modelInferenceCreationRequestV2?: ModelInferenceCreationRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelInferenceV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createModelInferenceV2(modelInferenceCreationRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ModelInferenceApi - factory interface
 * @export
 */
export const ModelInferenceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModelInferenceApiFp(configuration)
    return {
        /**
         * Creates a model-inference workload from a given set of assets. The set must include one model and one compute asset.
         * @summary Create model-inference.
         * @param {ModelInferenceCreationRequest} [modelInferenceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModelInference(modelInferenceCreationRequest?: ModelInferenceCreationRequest, options?: any): AxiosPromise<ModelInference> {
            return localVarFp.createModelInference(modelInferenceCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a model-inference from a given set of assets. The set must include one model asset and one compute asset.
         * @summary Create a model-inference
         * @param {ModelInferenceCreationRequestV2} [modelInferenceCreationRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createModelInferenceV2(modelInferenceCreationRequestV2?: ModelInferenceCreationRequestV2, options?: any): AxiosPromise<ModelInferenceV2> {
            return localVarFp.createModelInferenceV2(modelInferenceCreationRequestV2, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ModelInferenceApi - object-oriented interface
 * @export
 * @class ModelInferenceApi
 * @extends {BaseAPI}
 */
export class ModelInferenceApi extends BaseAPI {
    /**
     * Creates a model-inference workload from a given set of assets. The set must include one model and one compute asset.
     * @summary Create model-inference.
     * @param {ModelInferenceCreationRequest} [modelInferenceCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelInferenceApi
     */
    public createModelInference(modelInferenceCreationRequest?: ModelInferenceCreationRequest, options?: AxiosRequestConfig) {
        return ModelInferenceApiFp(this.configuration).createModelInference(modelInferenceCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a model-inference from a given set of assets. The set must include one model asset and one compute asset.
     * @summary Create a model-inference
     * @param {ModelInferenceCreationRequestV2} [modelInferenceCreationRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelInferenceApi
     */
    public createModelInferenceV2(modelInferenceCreationRequestV2?: ModelInferenceCreationRequestV2, options?: AxiosRequestConfig) {
        return ModelInferenceApiFp(this.configuration).createModelInferenceV2(modelInferenceCreationRequestV2, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NFSApi - axios parameter creator
 * @export
 */
export const NFSApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Use to create an NFS datasource asset.
         * @summary Create an NFS asset.
         * @param {NFSCreationRequest} [nFSCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNfsAsset: async (nFSCreationRequest?: NFSCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/datasource/nfs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nFSCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete an NFS datasource asset by id.
         * @summary Delete an NFS asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNfsAssetById: async (assetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deleteNfsAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/nfs/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to retrieve the details of NFS datasource asset by id.
         * @summary Get an NFS asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNfsAssetById: async (assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getNfsAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/nfs/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of NFS datasource assets.
         * @summary List NFS assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNfsAssets: async (name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/datasource/nfs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (assetIds !== undefined) {
                localVarQueryParameter['assetIds'] = assetIds;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to update the details of NFS datasource asset by id.
         * @summary Update an NFS asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {NFSUpdateRequest} [nFSUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNfsAssetById: async (assetId: string, nFSUpdateRequest?: NFSUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('updateNfsAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/nfs/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nFSUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NFSApi - functional programming interface
 * @export
 */
export const NFSApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NFSApiAxiosParamCreator(configuration)
    return {
        /**
         * Use to create an NFS datasource asset.
         * @summary Create an NFS asset.
         * @param {NFSCreationRequest} [nFSCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNfsAsset(nFSCreationRequest?: NFSCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3Asset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNfsAsset(nFSCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete an NFS datasource asset by id.
         * @summary Delete an NFS asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNfsAssetById(assetId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNfsAssetById(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to retrieve the details of NFS datasource asset by id.
         * @summary Get an NFS asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNfsAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NFSAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNfsAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of NFS datasource assets.
         * @summary List NFS assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNfsAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NFSListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNfsAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, assetIds, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to update the details of NFS datasource asset by id.
         * @summary Update an NFS asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {NFSUpdateRequest} [nFSUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNfsAssetById(assetId: string, nFSUpdateRequest?: NFSUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NFSAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNfsAssetById(assetId, nFSUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NFSApi - factory interface
 * @export
 */
export const NFSApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NFSApiFp(configuration)
    return {
        /**
         * Use to create an NFS datasource asset.
         * @summary Create an NFS asset.
         * @param {NFSCreationRequest} [nFSCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNfsAsset(nFSCreationRequest?: NFSCreationRequest, options?: any): AxiosPromise<S3Asset> {
            return localVarFp.createNfsAsset(nFSCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete an NFS datasource asset by id.
         * @summary Delete an NFS asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNfsAssetById(assetId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteNfsAssetById(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to retrieve the details of NFS datasource asset by id.
         * @summary Get an NFS asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNfsAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<NFSAsset> {
            return localVarFp.getNfsAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of NFS datasource assets.
         * @summary List NFS assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNfsAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<NFSListResponse> {
            return localVarFp.listNfsAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, assetIds, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to update the details of NFS datasource asset by id.
         * @summary Update an NFS asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {NFSUpdateRequest} [nFSUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNfsAssetById(assetId: string, nFSUpdateRequest?: NFSUpdateRequest, options?: any): AxiosPromise<NFSAsset> {
            return localVarFp.updateNfsAssetById(assetId, nFSUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NFSApi - object-oriented interface
 * @export
 * @class NFSApi
 * @extends {BaseAPI}
 */
export class NFSApi extends BaseAPI {
    /**
     * Use to create an NFS datasource asset.
     * @summary Create an NFS asset.
     * @param {NFSCreationRequest} [nFSCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NFSApi
     */
    public createNfsAsset(nFSCreationRequest?: NFSCreationRequest, options?: AxiosRequestConfig) {
        return NFSApiFp(this.configuration).createNfsAsset(nFSCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete an NFS datasource asset by id.
     * @summary Delete an NFS asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NFSApi
     */
    public deleteNfsAssetById(assetId: string, options?: AxiosRequestConfig) {
        return NFSApiFp(this.configuration).deleteNfsAssetById(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to retrieve the details of NFS datasource asset by id.
     * @summary Get an NFS asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NFSApi
     */
    public getNfsAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return NFSApiFp(this.configuration).getNfsAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of NFS datasource assets.
     * @summary List NFS assets.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NFSApi
     */
    public listNfsAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return NFSApiFp(this.configuration).listNfsAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, assetIds, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to update the details of NFS datasource asset by id.
     * @summary Update an NFS asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {NFSUpdateRequest} [nFSUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NFSApi
     */
    public updateNfsAssetById(assetId: string, nFSUpdateRequest?: NFSUpdateRequest, options?: AxiosRequestConfig) {
        return NFSApiFp(this.configuration).updateNfsAssetById(assetId, nFSUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PVCApi - axios parameter creator
 * @export
 */
export const PVCApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Use to create a PVC datasource asset.
         * @summary Create a PVC asset.
         * @param {PVCCreationRequest} [pVCCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPvcAsset: async (pVCCreationRequest?: PVCCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/datasource/pvc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pVCCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete a PVC datasource asset by id.
         * @summary Delete a PVC asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePvcAssetById: async (assetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deletePvcAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/pvc/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of a PVC datasource asset by id.
         * @summary Get a PVC asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPvcAssetById: async (assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getPvcAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/pvc/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of PVC datasource assets.
         * @summary List PVC assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPvcAssets: async (name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/datasource/pvc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }

            if (assetIds !== undefined) {
                localVarQueryParameter['assetIds'] = assetIds;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to update the details of a PVC datasource asset by id.
         * @summary Update a PVC asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {PVCUpdateRequest} [pVCUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePvcAssetById: async (assetId: string, pVCUpdateRequest?: PVCUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('updatePvcAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/pvc/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pVCUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PVCApi - functional programming interface
 * @export
 */
export const PVCApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PVCApiAxiosParamCreator(configuration)
    return {
        /**
         * Use to create a PVC datasource asset.
         * @summary Create a PVC asset.
         * @param {PVCCreationRequest} [pVCCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPvcAsset(pVCCreationRequest?: PVCCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PVCAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPvcAsset(pVCCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete a PVC datasource asset by id.
         * @summary Delete a PVC asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePvcAssetById(assetId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePvcAssetById(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the details of a PVC datasource asset by id.
         * @summary Get a PVC asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPvcAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PVCAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPvcAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a list of PVC datasource assets.
         * @summary List PVC assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPvcAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PVCListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPvcAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to update the details of a PVC datasource asset by id.
         * @summary Update a PVC asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {PVCUpdateRequest} [pVCUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePvcAssetById(assetId: string, pVCUpdateRequest?: PVCUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PVCAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePvcAssetById(assetId, pVCUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PVCApi - factory interface
 * @export
 */
export const PVCApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PVCApiFp(configuration)
    return {
        /**
         * Use to create a PVC datasource asset.
         * @summary Create a PVC asset.
         * @param {PVCCreationRequest} [pVCCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPvcAsset(pVCCreationRequest?: PVCCreationRequest, options?: any): AxiosPromise<PVCAsset> {
            return localVarFp.createPvcAsset(pVCCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete a PVC datasource asset by id.
         * @summary Delete a PVC asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePvcAssetById(assetId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deletePvcAssetById(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of a PVC datasource asset by id.
         * @summary Get a PVC asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPvcAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<PVCAsset> {
            return localVarFp.getPvcAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of PVC datasource assets.
         * @summary List PVC assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPvcAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<PVCListResponse> {
            return localVarFp.listPvcAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to update the details of a PVC datasource asset by id.
         * @summary Update a PVC asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {PVCUpdateRequest} [pVCUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePvcAssetById(assetId: string, pVCUpdateRequest?: PVCUpdateRequest, options?: any): AxiosPromise<PVCAsset> {
            return localVarFp.updatePvcAssetById(assetId, pVCUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PVCApi - object-oriented interface
 * @export
 * @class PVCApi
 * @extends {BaseAPI}
 */
export class PVCApi extends BaseAPI {
    /**
     * Use to create a PVC datasource asset.
     * @summary Create a PVC asset.
     * @param {PVCCreationRequest} [pVCCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PVCApi
     */
    public createPvcAsset(pVCCreationRequest?: PVCCreationRequest, options?: AxiosRequestConfig) {
        return PVCApiFp(this.configuration).createPvcAsset(pVCCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete a PVC datasource asset by id.
     * @summary Delete a PVC asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PVCApi
     */
    public deletePvcAssetById(assetId: string, options?: AxiosRequestConfig) {
        return PVCApiFp(this.configuration).deletePvcAssetById(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of a PVC datasource asset by id.
     * @summary Get a PVC asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PVCApi
     */
    public getPvcAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return PVCApiFp(this.configuration).getPvcAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of PVC datasource assets.
     * @summary List PVC assets.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PVCApi
     */
    public listPvcAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return PVCApiFp(this.configuration).listPvcAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to update the details of a PVC datasource asset by id.
     * @summary Update a PVC asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {PVCUpdateRequest} [pVCUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PVCApi
     */
    public updatePvcAssetById(assetId: string, pVCUpdateRequest?: PVCUpdateRequest, options?: AxiosRequestConfig) {
        return PVCApiFp(this.configuration).updatePvcAssetById(assetId, pVCUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RegistryApi - axios parameter creator
 * @export
 */
export const RegistryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Use to create a registry asset containing a registry base url and credentials.
         * @summary Create a registry asset.
         * @param {RegistryCreationRequest} registryCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistry: async (registryCreationRequest: RegistryCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registryCreationRequest' is not null or undefined
            assertParamExists('createRegistry', 'registryCreationRequest', registryCreationRequest)
            const localVarPath = `/api/v1/asset/registries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registryCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete a registry asset containing registry base url and credentials by id.
         * @summary Delete a registry asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRegistry: async (assetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deleteRegistry', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/registries/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a registry asset by id.
         * @summary Get a registry.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistryById: async (assetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getRegistryById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/registries/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of repositories from a registry asset.
         * @summary Get the repositories in the registry.
         * @param {string} assetId Unique identifier of the asset.
         * @param {string} [searchName] Filter results that contains searchName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepositories: async (assetId: string, searchName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getRepositories', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/registries/{AssetId}/repositories`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchName !== undefined) {
                localVarQueryParameter['searchName'] = searchName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of repository tags from a repository asset.
         * @summary Get the repositories tags in the registry.
         * @param {string} assetId Unique identifier of the asset.
         * @param {string} repository The repository name that its tags are requested.
         * @param {string} [searchName] Filter results that contains searchName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepositoryTags: async (assetId: string, repository: string, searchName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getRepositoryTags', 'assetId', assetId)
            // verify required parameter 'repository' is not null or undefined
            assertParamExists('getRepositoryTags', 'repository', repository)
            const localVarPath = `/api/v1/asset/registries/{AssetId}/repositories/tags`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (repository !== undefined) {
                localVarQueryParameter['repository'] = repository;
            }

            if (searchName !== undefined) {
                localVarQueryParameter['searchName'] = searchName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of registries assets.
         * @summary Get registries.
         * @param {string} [name] Filter results by name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegistries: async (name?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/registries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to update a registry asset containing registry base url and credentials by id.
         * @summary Update a registry asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {RegistryUpdateRequest} registryUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRegistry: async (assetId: string, registryUpdateRequest: RegistryUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('updateRegistry', 'assetId', assetId)
            // verify required parameter 'registryUpdateRequest' is not null or undefined
            assertParamExists('updateRegistry', 'registryUpdateRequest', registryUpdateRequest)
            const localVarPath = `/api/v1/asset/registries/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registryUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistryApi - functional programming interface
 * @export
 */
export const RegistryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegistryApiAxiosParamCreator(configuration)
    return {
        /**
         * Use to create a registry asset containing a registry base url and credentials.
         * @summary Create a registry asset.
         * @param {RegistryCreationRequest} registryCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRegistry(registryCreationRequest: RegistryCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Registry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRegistry(registryCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete a registry asset containing registry base url and credentials by id.
         * @summary Delete a registry asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRegistry(assetId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRegistry(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a registry asset by id.
         * @summary Get a registry.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistryById(assetId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Registry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistryById(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of repositories from a registry asset.
         * @summary Get the repositories in the registry.
         * @param {string} assetId Unique identifier of the asset.
         * @param {string} [searchName] Filter results that contains searchName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRepositories(assetId: string, searchName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Repositories>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRepositories(assetId, searchName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of repository tags from a repository asset.
         * @summary Get the repositories tags in the registry.
         * @param {string} assetId Unique identifier of the asset.
         * @param {string} repository The repository name that its tags are requested.
         * @param {string} [searchName] Filter results that contains searchName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRepositoryTags(assetId: string, repository: string, searchName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepositoryTags>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRepositoryTags(assetId, repository, searchName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of registries assets.
         * @summary Get registries.
         * @param {string} [name] Filter results by name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRegistries(name?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistryListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRegistries(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to update a registry asset containing registry base url and credentials by id.
         * @summary Update a registry asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {RegistryUpdateRequest} registryUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRegistry(assetId: string, registryUpdateRequest: RegistryUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Registry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRegistry(assetId, registryUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegistryApi - factory interface
 * @export
 */
export const RegistryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegistryApiFp(configuration)
    return {
        /**
         * Use to create a registry asset containing a registry base url and credentials.
         * @summary Create a registry asset.
         * @param {RegistryCreationRequest} registryCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistry(registryCreationRequest: RegistryCreationRequest, options?: any): AxiosPromise<Registry> {
            return localVarFp.createRegistry(registryCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete a registry asset containing registry base url and credentials by id.
         * @summary Delete a registry asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRegistry(assetId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRegistry(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a registry asset by id.
         * @summary Get a registry.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistryById(assetId: string, options?: any): AxiosPromise<Registry> {
            return localVarFp.getRegistryById(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of repositories from a registry asset.
         * @summary Get the repositories in the registry.
         * @param {string} assetId Unique identifier of the asset.
         * @param {string} [searchName] Filter results that contains searchName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepositories(assetId: string, searchName?: string, options?: any): AxiosPromise<Repositories> {
            return localVarFp.getRepositories(assetId, searchName, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of repository tags from a repository asset.
         * @summary Get the repositories tags in the registry.
         * @param {string} assetId Unique identifier of the asset.
         * @param {string} repository The repository name that its tags are requested.
         * @param {string} [searchName] Filter results that contains searchName.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepositoryTags(assetId: string, repository: string, searchName?: string, options?: any): AxiosPromise<RepositoryTags> {
            return localVarFp.getRepositoryTags(assetId, repository, searchName, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of registries assets.
         * @summary Get registries.
         * @param {string} [name] Filter results by name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegistries(name?: string, options?: any): AxiosPromise<RegistryListResponse> {
            return localVarFp.listRegistries(name, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to update a registry asset containing registry base url and credentials by id.
         * @summary Update a registry asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {RegistryUpdateRequest} registryUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRegistry(assetId: string, registryUpdateRequest: RegistryUpdateRequest, options?: any): AxiosPromise<Registry> {
            return localVarFp.updateRegistry(assetId, registryUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegistryApi - object-oriented interface
 * @export
 * @class RegistryApi
 * @extends {BaseAPI}
 */
export class RegistryApi extends BaseAPI {
    /**
     * Use to create a registry asset containing a registry base url and credentials.
     * @summary Create a registry asset.
     * @param {RegistryCreationRequest} registryCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistryApi
     */
    public createRegistry(registryCreationRequest: RegistryCreationRequest, options?: AxiosRequestConfig) {
        return RegistryApiFp(this.configuration).createRegistry(registryCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete a registry asset containing registry base url and credentials by id.
     * @summary Delete a registry asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistryApi
     */
    public deleteRegistry(assetId: string, options?: AxiosRequestConfig) {
        return RegistryApiFp(this.configuration).deleteRegistry(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a registry asset by id.
     * @summary Get a registry.
     * @param {string} assetId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistryApi
     */
    public getRegistryById(assetId: string, options?: AxiosRequestConfig) {
        return RegistryApiFp(this.configuration).getRegistryById(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of repositories from a registry asset.
     * @summary Get the repositories in the registry.
     * @param {string} assetId Unique identifier of the asset.
     * @param {string} [searchName] Filter results that contains searchName.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistryApi
     */
    public getRepositories(assetId: string, searchName?: string, options?: AxiosRequestConfig) {
        return RegistryApiFp(this.configuration).getRepositories(assetId, searchName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of repository tags from a repository asset.
     * @summary Get the repositories tags in the registry.
     * @param {string} assetId Unique identifier of the asset.
     * @param {string} repository The repository name that its tags are requested.
     * @param {string} [searchName] Filter results that contains searchName.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistryApi
     */
    public getRepositoryTags(assetId: string, repository: string, searchName?: string, options?: AxiosRequestConfig) {
        return RegistryApiFp(this.configuration).getRepositoryTags(assetId, repository, searchName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of registries assets.
     * @summary Get registries.
     * @param {string} [name] Filter results by name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistryApi
     */
    public listRegistries(name?: string, options?: AxiosRequestConfig) {
        return RegistryApiFp(this.configuration).listRegistries(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to update a registry asset containing registry base url and credentials by id.
     * @summary Update a registry asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {RegistryUpdateRequest} registryUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistryApi
     */
    public updateRegistry(assetId: string, registryUpdateRequest: RegistryUpdateRequest, options?: AxiosRequestConfig) {
        return RegistryApiFp(this.configuration).updateRegistry(assetId, registryUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * S3Api - axios parameter creator
 * @export
 */
export const S3ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Use to create an S3 compatible datasource asset.
         * @summary Create an S3 asset.
         * @param {S3CreationRequest} [s3CreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createS3Asset: async (s3CreationRequest?: S3CreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/datasource/s3`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(s3CreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete an S3 compatible datasource asset by id.
         * @summary Delete an S3 asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteS3AssetById: async (assetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deleteS3AssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/s3/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of S3 compatible datasource asset by id.
         * @summary Get an S3 asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getS3AssetById: async (assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getS3AssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/s3/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of S3 compatible datasource assets.
         * @summary List S3 assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listS3Assets: async (name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/datasource/s3`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }

            if (assetIds !== undefined) {
                localVarQueryParameter['assetIds'] = assetIds;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to update the details of an S3 compatible datasource asset by id.
         * @summary Update an S3 asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {S3UpdateRequest} [s3UpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateS3AssetById: async (assetId: string, s3UpdateRequest?: S3UpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('updateS3AssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/s3/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(s3UpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * S3Api - functional programming interface
 * @export
 */
export const S3ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = S3ApiAxiosParamCreator(configuration)
    return {
        /**
         * Use to create an S3 compatible datasource asset.
         * @summary Create an S3 asset.
         * @param {S3CreationRequest} [s3CreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createS3Asset(s3CreationRequest?: S3CreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3Asset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createS3Asset(s3CreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete an S3 compatible datasource asset by id.
         * @summary Delete an S3 asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteS3AssetById(assetId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteS3AssetById(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the details of S3 compatible datasource asset by id.
         * @summary Get an S3 asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getS3AssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3Asset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getS3AssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of S3 compatible datasource assets.
         * @summary List S3 assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listS3Assets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3ListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listS3Assets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to update the details of an S3 compatible datasource asset by id.
         * @summary Update an S3 asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {S3UpdateRequest} [s3UpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateS3AssetById(assetId: string, s3UpdateRequest?: S3UpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3Asset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateS3AssetById(assetId, s3UpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * S3Api - factory interface
 * @export
 */
export const S3ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = S3ApiFp(configuration)
    return {
        /**
         * Use to create an S3 compatible datasource asset.
         * @summary Create an S3 asset.
         * @param {S3CreationRequest} [s3CreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createS3Asset(s3CreationRequest?: S3CreationRequest, options?: any): AxiosPromise<S3Asset> {
            return localVarFp.createS3Asset(s3CreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete an S3 compatible datasource asset by id.
         * @summary Delete an S3 asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteS3AssetById(assetId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteS3AssetById(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of S3 compatible datasource asset by id.
         * @summary Get an S3 asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getS3AssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<S3Asset> {
            return localVarFp.getS3AssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of S3 compatible datasource assets.
         * @summary List S3 assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listS3Assets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<S3ListResponse> {
            return localVarFp.listS3Assets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to update the details of an S3 compatible datasource asset by id.
         * @summary Update an S3 asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {S3UpdateRequest} [s3UpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateS3AssetById(assetId: string, s3UpdateRequest?: S3UpdateRequest, options?: any): AxiosPromise<S3Asset> {
            return localVarFp.updateS3AssetById(assetId, s3UpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * S3Api - object-oriented interface
 * @export
 * @class S3Api
 * @extends {BaseAPI}
 */
export class S3Api extends BaseAPI {
    /**
     * Use to create an S3 compatible datasource asset.
     * @summary Create an S3 asset.
     * @param {S3CreationRequest} [s3CreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof S3Api
     */
    public createS3Asset(s3CreationRequest?: S3CreationRequest, options?: AxiosRequestConfig) {
        return S3ApiFp(this.configuration).createS3Asset(s3CreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete an S3 compatible datasource asset by id.
     * @summary Delete an S3 asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof S3Api
     */
    public deleteS3AssetById(assetId: string, options?: AxiosRequestConfig) {
        return S3ApiFp(this.configuration).deleteS3AssetById(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of S3 compatible datasource asset by id.
     * @summary Get an S3 asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof S3Api
     */
    public getS3AssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return S3ApiFp(this.configuration).getS3AssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of S3 compatible datasource assets.
     * @summary List S3 assets.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof S3Api
     */
    public listS3Assets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return S3ApiFp(this.configuration).listS3Assets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to update the details of an S3 compatible datasource asset by id.
     * @summary Update an S3 asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {S3UpdateRequest} [s3UpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof S3Api
     */
    public updateS3AssetById(assetId: string, s3UpdateRequest?: S3UpdateRequest, options?: AxiosRequestConfig) {
        return S3ApiFp(this.configuration).updateS3AssetById(assetId, s3UpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SecretApi - axios parameter creator
 * @export
 */
export const SecretApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Use to create a Secret datasource asset.
         * @summary Create a Secret datasource asset.
         * @param {SecretAssetCreationRequest} [secretAssetCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecretAsset: async (secretAssetCreationRequest?: SecretAssetCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/datasource/secrets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(secretAssetCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete a Secret datasource asset by id.
         * @summary Delete a Secret asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSecretAssetById: async (assetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deleteSecretAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/secrets/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of Secret datasource asset by id.
         * @summary Get a Secret asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecretAssetById: async (assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getSecretAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/secrets/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of Secret datasource assets.
         * @summary List Secret datasource assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSecretAssets: async (name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/datasource/secrets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (usageInfo !== undefined) {
                localVarQueryParameter['usageInfo'] = usageInfo;
            }

            if (complyToProject !== undefined) {
                localVarQueryParameter['complyToProject'] = complyToProject;
            }

            if (complyToWorkloadType !== undefined) {
                localVarQueryParameter['complyToWorkloadType'] = complyToWorkloadType;
            }

            if (statusInfo !== undefined) {
                localVarQueryParameter['statusInfo'] = statusInfo;
            }

            if (assetIds !== undefined) {
                localVarQueryParameter['assetIds'] = assetIds;
            }

            if (complyToReplicaType !== undefined) {
                localVarQueryParameter['complyToReplicaType'] = complyToReplicaType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to update the details of a Secret datasource asset by id.
         * @summary Update a Secret asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {SecretAssetUpdateRequest} [secretAssetUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSecretAssetById: async (assetId: string, secretAssetUpdateRequest?: SecretAssetUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('updateSecretAssetById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/datasource/secrets/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(secretAssetUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SecretApi - functional programming interface
 * @export
 */
export const SecretApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SecretApiAxiosParamCreator(configuration)
    return {
        /**
         * Use to create a Secret datasource asset.
         * @summary Create a Secret datasource asset.
         * @param {SecretAssetCreationRequest} [secretAssetCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSecretAsset(secretAssetCreationRequest?: SecretAssetCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecretAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSecretAsset(secretAssetCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete a Secret datasource asset by id.
         * @summary Delete a Secret asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSecretAssetById(assetId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSecretAssetById(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the details of Secret datasource asset by id.
         * @summary Get a Secret asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSecretAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecretAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSecretAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of Secret datasource assets.
         * @summary List Secret datasource assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSecretAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecretAssetListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSecretAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to update the details of a Secret datasource asset by id.
         * @summary Update a Secret asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {SecretAssetUpdateRequest} [secretAssetUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSecretAssetById(assetId: string, secretAssetUpdateRequest?: SecretAssetUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecretAsset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSecretAssetById(assetId, secretAssetUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SecretApi - factory interface
 * @export
 */
export const SecretApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SecretApiFp(configuration)
    return {
        /**
         * Use to create a Secret datasource asset.
         * @summary Create a Secret datasource asset.
         * @param {SecretAssetCreationRequest} [secretAssetCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecretAsset(secretAssetCreationRequest?: SecretAssetCreationRequest, options?: any): AxiosPromise<SecretAsset> {
            return localVarFp.createSecretAsset(secretAssetCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete a Secret datasource asset by id.
         * @summary Delete a Secret asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSecretAssetById(assetId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteSecretAssetById(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of Secret datasource asset by id.
         * @summary Get a Secret asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecretAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<SecretAsset> {
            return localVarFp.getSecretAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of Secret datasource assets.
         * @summary List Secret datasource assets.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
         * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
         * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
         * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
         * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSecretAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: any): AxiosPromise<SecretAssetListResponse> {
            return localVarFp.listSecretAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to update the details of a Secret datasource asset by id.
         * @summary Update a Secret asset.
         * @param {string} assetId Unique identifier of the asset.
         * @param {SecretAssetUpdateRequest} [secretAssetUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSecretAssetById(assetId: string, secretAssetUpdateRequest?: SecretAssetUpdateRequest, options?: any): AxiosPromise<SecretAsset> {
            return localVarFp.updateSecretAssetById(assetId, secretAssetUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SecretApi - object-oriented interface
 * @export
 * @class SecretApi
 * @extends {BaseAPI}
 */
export class SecretApi extends BaseAPI {
    /**
     * Use to create a Secret datasource asset.
     * @summary Create a Secret datasource asset.
     * @param {SecretAssetCreationRequest} [secretAssetCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecretApi
     */
    public createSecretAsset(secretAssetCreationRequest?: SecretAssetCreationRequest, options?: AxiosRequestConfig) {
        return SecretApiFp(this.configuration).createSecretAsset(secretAssetCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete a Secret datasource asset by id.
     * @summary Delete a Secret asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecretApi
     */
    public deleteSecretAssetById(assetId: string, options?: AxiosRequestConfig) {
        return SecretApiFp(this.configuration).deleteSecretAssetById(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of Secret datasource asset by id.
     * @summary Get a Secret asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecretApi
     */
    public getSecretAssetById(assetId: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return SecretApiFp(this.configuration).getSecretAssetById(assetId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of Secret datasource assets.
     * @summary List Secret datasource assets.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {boolean} [usageInfo] Whether the query should include asset usage information as part of the response.
     * @param {number} [complyToProject] Include workload creation compliance information of an asset, for a given project, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {'Workspace' | 'Training' | 'Distributed' | 'Inference'} [complyToWorkloadType] Include workload creation compliance information of an asset, for a given workload type, as part of the response. To check compliance, you need to provide both project id and workload type.
     * @param {boolean} [statusInfo] Whether the query should include asset status information as part of the response.
     * @param {string} [assetIds] Filter results by the ids of the assets. Provided value should be a comma separated string of UUIDs.
     * @param {'Worker' | 'Master'} [complyToReplicaType] Include workload creation compliance information of an asset, for a given replica type, as part of the response. To check compliance, you need to provide both project id and workload type. For distributed, replica type should be provided as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecretApi
     */
    public listSecretAssets(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, usageInfo?: boolean, complyToProject?: number, complyToWorkloadType?: 'Workspace' | 'Training' | 'Distributed' | 'Inference', statusInfo?: boolean, assetIds?: string, complyToReplicaType?: 'Worker' | 'Master', options?: AxiosRequestConfig) {
        return SecretApiFp(this.configuration).listSecretAssets(name, scope, projectId, departmentId, clusterId, usageInfo, complyToProject, complyToWorkloadType, statusInfo, assetIds, complyToReplicaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to update the details of a Secret datasource asset by id.
     * @summary Update a Secret asset.
     * @param {string} assetId Unique identifier of the asset.
     * @param {SecretAssetUpdateRequest} [secretAssetUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecretApi
     */
    public updateSecretAssetById(assetId: string, secretAssetUpdateRequest?: SecretAssetUpdateRequest, options?: AxiosRequestConfig) {
        return SecretApiFp(this.configuration).updateSecretAssetById(assetId, secretAssetUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SynchronizationApi - axios parameter creator
 * @export
 */
export const SynchronizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns summary information about changes of access key assets at the control plane.
         * @summary Get access keys sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessKeySyncInfo: async (clusterId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/sync/credentials/access-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns summary information about changes of access key assets at the control plane.
         * @summary Get access keys sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessKeySyncInfoV2: async (clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/asset/sync/credentials/access-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allow cluster to request a list of updates that needs to be synced to the cluster and to send success/failure about the result of previous sync.
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        credentialsSyncUpdates: async (clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('credentialsSyncUpdates', 'clusterId', clusterId)
            const localVarPath = `/api/v1/asset/credentials/updates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clusterSyncReport, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allow cluster to request a list of updates that needs to be synced to the cluster and to send success/failure about the result of previous sync.
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasourceSyncUpdates: async (clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('datasourceSyncUpdates', 'clusterId', clusterId)
            const localVarPath = `/api/v1/asset/datasource/updates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clusterSyncReport, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns summary information about changes of docker registry credentials assets at the control plane.
         * @summary Get docker registry sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockerRegistrySyncInfo: async (clusterId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/sync/credentials/docker-registry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns summary information about changes of docker registry credentials assets at the control plane.
         * @summary Get docker registry sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockerRegistrySyncInfoV2: async (clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/asset/sync/credentials/docker-registry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns summary information about changes of generic secret assets at the control plane.
         * @summary Get generic secrets sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericSecretSyncInfo: async (clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/asset/sync/credentials/generic-secret`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of assets.
         * @summary List assets by their ids
         * @param {string} id comma seperated list of asset ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssetsById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listAssetsById', 'id', id)
            const localVarPath = `/api/v1/asset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns summary information about changes of password assets at the control plane.
         * @summary Get passwords sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordSyncInfo: async (clusterId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/sync/credentials/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns summary information about changes of password assets at the control plane.
         * @summary Get passwords sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordSyncInfoV2: async (clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/asset/sync/credentials/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns summary information about changes of pvc assets at the control plane.
         * @summary Get pvcs sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pvcSyncInfo: async (clusterId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/sync/storage/pvc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns summary information about changes of pvc assets at the control plane.
         * @summary Get pvcs sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pvcSyncInfoV2: async (clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/asset/sync/storage/pvc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Informs the backend about existing access key assets as stored in the cluster, in order to synchronize them with the access key assets at the control-plane.
         * @summary Sync access key assets.
         * @param {SyncRequest} [syncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAccessKeys: async (syncRequest?: SyncRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/sync/credentials/access-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Informs the backend about existing access key assets as stored in the cluster, in order to synchronize them with the access key assets at the control-plane.
         * @summary Sync access key assets.
         * @param {SyncRequestV2} [syncRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAccessKeysV2: async (syncRequestV2?: SyncRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/asset/sync/credentials/access-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Informs the backend about existing docker registry secrets as stored in the cluster, in order to synchronize them with the docker registry assets at the control-plane.
         * @summary Sync docker registry credentials assets.
         * @param {SyncRequest} [syncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDockerRegistry: async (syncRequest?: SyncRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/sync/credentials/docker-registry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Informs the backend about existing docker registry secrets as stored in the cluster, in order to synchronize them with the docker registry assets at the control-plane.
         * @summary Sync docker registry credentials assets.
         * @param {SyncRequestV2} [syncRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDockerRegistryV2: async (syncRequestV2?: SyncRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/asset/sync/credentials/docker-registry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Informs the backend about existing generic secret assets as stored in the cluster, in order to synchronize them with the generic secret assets at the control-plane.
         * @summary Sync generic secret assets.
         * @param {SyncRequestV2} [syncRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGenericSecret: async (syncRequestV2?: SyncRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/asset/sync/credentials/generic-secret`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Informs the backend about existing password assets as stored in the cluster, in order to synchronize them with the password assets at the control-plane.
         * @summary Sync password assets.
         * @param {SyncRequest} [syncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPasswords: async (syncRequest?: SyncRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/sync/credentials/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Informs the backend about existing password assets as stored in the cluster, in order to synchronize them with the password assets at the control-plane.
         * @summary Sync password assets.
         * @param {SyncRequestV2} [syncRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPasswordsV2: async (syncRequestV2?: SyncRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/asset/sync/credentials/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Informs the backend about existing pvc assets as stored in the cluster, in order to synchronize them with the pvc assets at the control-plane.
         * @summary Sync pvc assets.
         * @param {SyncRequest} [syncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPvcs: async (syncRequest?: SyncRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/sync/storage/pvc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Informs the backend about existing pvc assets status according to status in cluster.
         * @summary Sync pvc assets status.
         * @param {string} clusterUuid The Universally Unique Identifier (UUID) of the cluster.
         * @param {PVCStatusRequest} [pVCStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPvcsStatus: async (clusterUuid: string, pVCStatusRequest?: PVCStatusRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterUuid' is not null or undefined
            assertParamExists('syncPvcsStatus', 'clusterUuid', clusterUuid)
            const localVarPath = `/api/v2/asset/sync/storage/pvc/{clusterUuid}/status`
                .replace(`{${"clusterUuid"}}`, encodeURIComponent(String(clusterUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pVCStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Informs the backend about existing pvc assets as stored in the cluster, in order to synchronize them with the pvc assets at the control-plane.
         * @summary Sync pvc assets.
         * @param {SyncRequestV2} [syncRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPvcsV2: async (syncRequestV2?: SyncRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/asset/sync/storage/pvc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validating deletion of project-scoped assets before actually deleting the resources from the cluster.
         * @summary Validate assets sync.
         * @param {ValidateSyncRequest} [validateSyncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncValidate: async (validateSyncRequest?: ValidateSyncRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/sync/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateSyncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SynchronizationApi - functional programming interface
 * @export
 */
export const SynchronizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SynchronizationApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns summary information about changes of access key assets at the control plane.
         * @summary Get access keys sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accessKeySyncInfo(clusterId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accessKeySyncInfo(clusterId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns summary information about changes of access key assets at the control plane.
         * @summary Get access keys sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accessKeySyncInfoV2(clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncInfoResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accessKeySyncInfoV2(clusterId, scope, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Allow cluster to request a list of updates that needs to be synced to the cluster and to send success/failure about the result of previous sync.
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async credentialsSyncUpdates(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CredentialsUpdatesResp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.credentialsSyncUpdates(clusterId, after, clusterSyncReport, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Allow cluster to request a list of updates that needs to be synced to the cluster and to send success/failure about the result of previous sync.
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async datasourceSyncUpdates(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasourceUpdatesResp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.datasourceSyncUpdates(clusterId, after, clusterSyncReport, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns summary information about changes of docker registry credentials assets at the control plane.
         * @summary Get docker registry sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dockerRegistrySyncInfo(clusterId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dockerRegistrySyncInfo(clusterId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns summary information about changes of docker registry credentials assets at the control plane.
         * @summary Get docker registry sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dockerRegistrySyncInfoV2(clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncInfoResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dockerRegistrySyncInfoV2(clusterId, scope, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns summary information about changes of generic secret assets at the control plane.
         * @summary Get generic secrets sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genericSecretSyncInfo(clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncInfoResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.genericSecretSyncInfo(clusterId, scope, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of assets.
         * @summary List assets by their ids
         * @param {string} id comma seperated list of asset ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAssetsById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetListByIdsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAssetsById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns summary information about changes of password assets at the control plane.
         * @summary Get passwords sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordSyncInfo(clusterId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.passwordSyncInfo(clusterId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns summary information about changes of password assets at the control plane.
         * @summary Get passwords sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordSyncInfoV2(clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncInfoResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.passwordSyncInfoV2(clusterId, scope, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns summary information about changes of pvc assets at the control plane.
         * @summary Get pvcs sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pvcSyncInfo(clusterId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pvcSyncInfo(clusterId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns summary information about changes of pvc assets at the control plane.
         * @summary Get pvcs sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pvcSyncInfoV2(clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncInfoResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pvcSyncInfoV2(clusterId, scope, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Informs the backend about existing access key assets as stored in the cluster, in order to synchronize them with the access key assets at the control-plane.
         * @summary Sync access key assets.
         * @param {SyncRequest} [syncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncAccessKeys(syncRequest?: SyncRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessKeysSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncAccessKeys(syncRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Informs the backend about existing access key assets as stored in the cluster, in order to synchronize them with the access key assets at the control-plane.
         * @summary Sync access key assets.
         * @param {SyncRequestV2} [syncRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncAccessKeysV2(syncRequestV2?: SyncRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessKeysSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncAccessKeysV2(syncRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Informs the backend about existing docker registry secrets as stored in the cluster, in order to synchronize them with the docker registry assets at the control-plane.
         * @summary Sync docker registry credentials assets.
         * @param {SyncRequest} [syncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncDockerRegistry(syncRequest?: SyncRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DockerRegistrySyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncDockerRegistry(syncRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Informs the backend about existing docker registry secrets as stored in the cluster, in order to synchronize them with the docker registry assets at the control-plane.
         * @summary Sync docker registry credentials assets.
         * @param {SyncRequestV2} [syncRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncDockerRegistryV2(syncRequestV2?: SyncRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DockerRegistrySyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncDockerRegistryV2(syncRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Informs the backend about existing generic secret assets as stored in the cluster, in order to synchronize them with the generic secret assets at the control-plane.
         * @summary Sync generic secret assets.
         * @param {SyncRequestV2} [syncRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncGenericSecret(syncRequestV2?: SyncRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericSecretSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncGenericSecret(syncRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Informs the backend about existing password assets as stored in the cluster, in order to synchronize them with the password assets at the control-plane.
         * @summary Sync password assets.
         * @param {SyncRequest} [syncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncPasswords(syncRequest?: SyncRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordsSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncPasswords(syncRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Informs the backend about existing password assets as stored in the cluster, in order to synchronize them with the password assets at the control-plane.
         * @summary Sync password assets.
         * @param {SyncRequestV2} [syncRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncPasswordsV2(syncRequestV2?: SyncRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordsSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncPasswordsV2(syncRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Informs the backend about existing pvc assets as stored in the cluster, in order to synchronize them with the pvc assets at the control-plane.
         * @summary Sync pvc assets.
         * @param {SyncRequest} [syncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncPvcs(syncRequest?: SyncRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PVCsSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncPvcs(syncRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Informs the backend about existing pvc assets status according to status in cluster.
         * @summary Sync pvc assets status.
         * @param {string} clusterUuid The Universally Unique Identifier (UUID) of the cluster.
         * @param {PVCStatusRequest} [pVCStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncPvcsStatus(clusterUuid: string, pVCStatusRequest?: PVCStatusRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncPvcsStatus(clusterUuid, pVCStatusRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Informs the backend about existing pvc assets as stored in the cluster, in order to synchronize them with the pvc assets at the control-plane.
         * @summary Sync pvc assets.
         * @param {SyncRequestV2} [syncRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncPvcsV2(syncRequestV2?: SyncRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PVCsSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncPvcsV2(syncRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Validating deletion of project-scoped assets before actually deleting the resources from the cluster.
         * @summary Validate assets sync.
         * @param {ValidateSyncRequest} [validateSyncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncValidate(validateSyncRequest?: ValidateSyncRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncValidate(validateSyncRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SynchronizationApi - factory interface
 * @export
 */
export const SynchronizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SynchronizationApiFp(configuration)
    return {
        /**
         * Returns summary information about changes of access key assets at the control plane.
         * @summary Get access keys sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessKeySyncInfo(clusterId?: string, options?: any): AxiosPromise<SyncInfoResponse> {
            return localVarFp.accessKeySyncInfo(clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns summary information about changes of access key assets at the control plane.
         * @summary Get access keys sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessKeySyncInfoV2(clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options?: any): AxiosPromise<SyncInfoResponseV2> {
            return localVarFp.accessKeySyncInfoV2(clusterId, scope, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allow cluster to request a list of updates that needs to be synced to the cluster and to send success/failure about the result of previous sync.
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        credentialsSyncUpdates(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: any): AxiosPromise<CredentialsUpdatesResp> {
            return localVarFp.credentialsSyncUpdates(clusterId, after, clusterSyncReport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allow cluster to request a list of updates that needs to be synced to the cluster and to send success/failure about the result of previous sync.
         * @param {string} clusterId The id of the cluster
         * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasourceSyncUpdates(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: any): AxiosPromise<DatasourceUpdatesResp> {
            return localVarFp.datasourceSyncUpdates(clusterId, after, clusterSyncReport, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns summary information about changes of docker registry credentials assets at the control plane.
         * @summary Get docker registry sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockerRegistrySyncInfo(clusterId?: string, options?: any): AxiosPromise<SyncInfoResponse> {
            return localVarFp.dockerRegistrySyncInfo(clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns summary information about changes of docker registry credentials assets at the control plane.
         * @summary Get docker registry sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dockerRegistrySyncInfoV2(clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options?: any): AxiosPromise<SyncInfoResponseV2> {
            return localVarFp.dockerRegistrySyncInfoV2(clusterId, scope, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns summary information about changes of generic secret assets at the control plane.
         * @summary Get generic secrets sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericSecretSyncInfo(clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options?: any): AxiosPromise<SyncInfoResponseV2> {
            return localVarFp.genericSecretSyncInfo(clusterId, scope, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of assets.
         * @summary List assets by their ids
         * @param {string} id comma seperated list of asset ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssetsById(id: string, options?: any): AxiosPromise<AssetListByIdsResponse> {
            return localVarFp.listAssetsById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns summary information about changes of password assets at the control plane.
         * @summary Get passwords sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordSyncInfo(clusterId?: string, options?: any): AxiosPromise<SyncInfoResponse> {
            return localVarFp.passwordSyncInfo(clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns summary information about changes of password assets at the control plane.
         * @summary Get passwords sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordSyncInfoV2(clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options?: any): AxiosPromise<SyncInfoResponseV2> {
            return localVarFp.passwordSyncInfoV2(clusterId, scope, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns summary information about changes of pvc assets at the control plane.
         * @summary Get pvcs sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pvcSyncInfo(clusterId?: string, options?: any): AxiosPromise<SyncInfoResponse> {
            return localVarFp.pvcSyncInfo(clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns summary information about changes of pvc assets at the control plane.
         * @summary Get pvcs sync info.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pvcSyncInfoV2(clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options?: any): AxiosPromise<SyncInfoResponseV2> {
            return localVarFp.pvcSyncInfoV2(clusterId, scope, options).then((request) => request(axios, basePath));
        },
        /**
         * Informs the backend about existing access key assets as stored in the cluster, in order to synchronize them with the access key assets at the control-plane.
         * @summary Sync access key assets.
         * @param {SyncRequest} [syncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAccessKeys(syncRequest?: SyncRequest, options?: any): AxiosPromise<AccessKeysSyncResponse> {
            return localVarFp.syncAccessKeys(syncRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Informs the backend about existing access key assets as stored in the cluster, in order to synchronize them with the access key assets at the control-plane.
         * @summary Sync access key assets.
         * @param {SyncRequestV2} [syncRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAccessKeysV2(syncRequestV2?: SyncRequestV2, options?: any): AxiosPromise<AccessKeysSyncResponse> {
            return localVarFp.syncAccessKeysV2(syncRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Informs the backend about existing docker registry secrets as stored in the cluster, in order to synchronize them with the docker registry assets at the control-plane.
         * @summary Sync docker registry credentials assets.
         * @param {SyncRequest} [syncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDockerRegistry(syncRequest?: SyncRequest, options?: any): AxiosPromise<DockerRegistrySyncResponse> {
            return localVarFp.syncDockerRegistry(syncRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Informs the backend about existing docker registry secrets as stored in the cluster, in order to synchronize them with the docker registry assets at the control-plane.
         * @summary Sync docker registry credentials assets.
         * @param {SyncRequestV2} [syncRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDockerRegistryV2(syncRequestV2?: SyncRequestV2, options?: any): AxiosPromise<DockerRegistrySyncResponse> {
            return localVarFp.syncDockerRegistryV2(syncRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Informs the backend about existing generic secret assets as stored in the cluster, in order to synchronize them with the generic secret assets at the control-plane.
         * @summary Sync generic secret assets.
         * @param {SyncRequestV2} [syncRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGenericSecret(syncRequestV2?: SyncRequestV2, options?: any): AxiosPromise<GenericSecretSyncResponse> {
            return localVarFp.syncGenericSecret(syncRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Informs the backend about existing password assets as stored in the cluster, in order to synchronize them with the password assets at the control-plane.
         * @summary Sync password assets.
         * @param {SyncRequest} [syncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPasswords(syncRequest?: SyncRequest, options?: any): AxiosPromise<PasswordsSyncResponse> {
            return localVarFp.syncPasswords(syncRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Informs the backend about existing password assets as stored in the cluster, in order to synchronize them with the password assets at the control-plane.
         * @summary Sync password assets.
         * @param {SyncRequestV2} [syncRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPasswordsV2(syncRequestV2?: SyncRequestV2, options?: any): AxiosPromise<PasswordsSyncResponse> {
            return localVarFp.syncPasswordsV2(syncRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Informs the backend about existing pvc assets as stored in the cluster, in order to synchronize them with the pvc assets at the control-plane.
         * @summary Sync pvc assets.
         * @param {SyncRequest} [syncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPvcs(syncRequest?: SyncRequest, options?: any): AxiosPromise<PVCsSyncResponse> {
            return localVarFp.syncPvcs(syncRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Informs the backend about existing pvc assets status according to status in cluster.
         * @summary Sync pvc assets status.
         * @param {string} clusterUuid The Universally Unique Identifier (UUID) of the cluster.
         * @param {PVCStatusRequest} [pVCStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPvcsStatus(clusterUuid: string, pVCStatusRequest?: PVCStatusRequest, options?: any): AxiosPromise<void> {
            return localVarFp.syncPvcsStatus(clusterUuid, pVCStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Informs the backend about existing pvc assets as stored in the cluster, in order to synchronize them with the pvc assets at the control-plane.
         * @summary Sync pvc assets.
         * @param {SyncRequestV2} [syncRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPvcsV2(syncRequestV2?: SyncRequestV2, options?: any): AxiosPromise<PVCsSyncResponse> {
            return localVarFp.syncPvcsV2(syncRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Validating deletion of project-scoped assets before actually deleting the resources from the cluster.
         * @summary Validate assets sync.
         * @param {ValidateSyncRequest} [validateSyncRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncValidate(validateSyncRequest?: ValidateSyncRequest, options?: any): AxiosPromise<ValidateSyncResponse> {
            return localVarFp.syncValidate(validateSyncRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SynchronizationApi - object-oriented interface
 * @export
 * @class SynchronizationApi
 * @extends {BaseAPI}
 */
export class SynchronizationApi extends BaseAPI {
    /**
     * Returns summary information about changes of access key assets at the control plane.
     * @summary Get access keys sync info.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public accessKeySyncInfo(clusterId?: string, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).accessKeySyncInfo(clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns summary information about changes of access key assets at the control plane.
     * @summary Get access keys sync info.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public accessKeySyncInfoV2(clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).accessKeySyncInfoV2(clusterId, scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allow cluster to request a list of updates that needs to be synced to the cluster and to send success/failure about the result of previous sync.
     * @param {string} clusterId The id of the cluster
     * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
     * @param {ClusterSyncReport} [clusterSyncReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public credentialsSyncUpdates(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).credentialsSyncUpdates(clusterId, after, clusterSyncReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allow cluster to request a list of updates that needs to be synced to the cluster and to send success/failure about the result of previous sync.
     * @param {string} clusterId The id of the cluster
     * @param {number} [after] search for updates with update counter greater than the value passed for this parameter
     * @param {ClusterSyncReport} [clusterSyncReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public datasourceSyncUpdates(clusterId: string, after?: number, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).datasourceSyncUpdates(clusterId, after, clusterSyncReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns summary information about changes of docker registry credentials assets at the control plane.
     * @summary Get docker registry sync info.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public dockerRegistrySyncInfo(clusterId?: string, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).dockerRegistrySyncInfo(clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns summary information about changes of docker registry credentials assets at the control plane.
     * @summary Get docker registry sync info.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public dockerRegistrySyncInfoV2(clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).dockerRegistrySyncInfoV2(clusterId, scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns summary information about changes of generic secret assets at the control plane.
     * @summary Get generic secrets sync info.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public genericSecretSyncInfo(clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).genericSecretSyncInfo(clusterId, scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of assets.
     * @summary List assets by their ids
     * @param {string} id comma seperated list of asset ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public listAssetsById(id: string, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).listAssetsById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns summary information about changes of password assets at the control plane.
     * @summary Get passwords sync info.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public passwordSyncInfo(clusterId?: string, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).passwordSyncInfo(clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns summary information about changes of password assets at the control plane.
     * @summary Get passwords sync info.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public passwordSyncInfoV2(clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).passwordSyncInfoV2(clusterId, scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns summary information about changes of pvc assets at the control plane.
     * @summary Get pvcs sync info.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public pvcSyncInfo(clusterId?: string, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).pvcSyncInfo(clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns summary information about changes of pvc assets at the control plane.
     * @summary Get pvcs sync info.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {'tenant' | 'cluster' | 'department' | 'project'} [scope] the scope level of the asset. If empty - tenant scoped assets.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public pvcSyncInfoV2(clusterId?: string, scope?: 'tenant' | 'cluster' | 'department' | 'project', options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).pvcSyncInfoV2(clusterId, scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Informs the backend about existing access key assets as stored in the cluster, in order to synchronize them with the access key assets at the control-plane.
     * @summary Sync access key assets.
     * @param {SyncRequest} [syncRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncAccessKeys(syncRequest?: SyncRequest, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncAccessKeys(syncRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Informs the backend about existing access key assets as stored in the cluster, in order to synchronize them with the access key assets at the control-plane.
     * @summary Sync access key assets.
     * @param {SyncRequestV2} [syncRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncAccessKeysV2(syncRequestV2?: SyncRequestV2, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncAccessKeysV2(syncRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Informs the backend about existing docker registry secrets as stored in the cluster, in order to synchronize them with the docker registry assets at the control-plane.
     * @summary Sync docker registry credentials assets.
     * @param {SyncRequest} [syncRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncDockerRegistry(syncRequest?: SyncRequest, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncDockerRegistry(syncRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Informs the backend about existing docker registry secrets as stored in the cluster, in order to synchronize them with the docker registry assets at the control-plane.
     * @summary Sync docker registry credentials assets.
     * @param {SyncRequestV2} [syncRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncDockerRegistryV2(syncRequestV2?: SyncRequestV2, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncDockerRegistryV2(syncRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Informs the backend about existing generic secret assets as stored in the cluster, in order to synchronize them with the generic secret assets at the control-plane.
     * @summary Sync generic secret assets.
     * @param {SyncRequestV2} [syncRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncGenericSecret(syncRequestV2?: SyncRequestV2, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncGenericSecret(syncRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Informs the backend about existing password assets as stored in the cluster, in order to synchronize them with the password assets at the control-plane.
     * @summary Sync password assets.
     * @param {SyncRequest} [syncRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncPasswords(syncRequest?: SyncRequest, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncPasswords(syncRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Informs the backend about existing password assets as stored in the cluster, in order to synchronize them with the password assets at the control-plane.
     * @summary Sync password assets.
     * @param {SyncRequestV2} [syncRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncPasswordsV2(syncRequestV2?: SyncRequestV2, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncPasswordsV2(syncRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Informs the backend about existing pvc assets as stored in the cluster, in order to synchronize them with the pvc assets at the control-plane.
     * @summary Sync pvc assets.
     * @param {SyncRequest} [syncRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncPvcs(syncRequest?: SyncRequest, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncPvcs(syncRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Informs the backend about existing pvc assets status according to status in cluster.
     * @summary Sync pvc assets status.
     * @param {string} clusterUuid The Universally Unique Identifier (UUID) of the cluster.
     * @param {PVCStatusRequest} [pVCStatusRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncPvcsStatus(clusterUuid: string, pVCStatusRequest?: PVCStatusRequest, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncPvcsStatus(clusterUuid, pVCStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Informs the backend about existing pvc assets as stored in the cluster, in order to synchronize them with the pvc assets at the control-plane.
     * @summary Sync pvc assets.
     * @param {SyncRequestV2} [syncRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncPvcsV2(syncRequestV2?: SyncRequestV2, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncPvcsV2(syncRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validating deletion of project-scoped assets before actually deleting the resources from the cluster.
     * @summary Validate assets sync.
     * @param {ValidateSyncRequest} [validateSyncRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynchronizationApi
     */
    public syncValidate(validateSyncRequest?: ValidateSyncRequest, options?: AxiosRequestConfig) {
        return SynchronizationApiFp(this.configuration).syncValidate(validateSyncRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TemplateApi - axios parameter creator
 * @export
 */
export const TemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Use to create a template.
         * @summary Create a template.
         * @param {WorkloadTemplateCreationRequest} [workloadTemplateCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplate: async (workloadTemplateCreationRequest?: WorkloadTemplateCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/workload-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workloadTemplateCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete a template by id.
         * @summary Delete a template.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplateById: async (assetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('deleteTemplateById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/workload-template/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of a template by id.
         * @summary Get a template.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateById: async (assetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('getTemplateById', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/workload-template/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of templates.
         * @summary List templates.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {string} [distributedFramework] Filter results to workload of type distributed and distributedFramework.
         * @param {boolean} [isDistributed] Filter results to workload of type distributed.
         * @param {boolean} [isTraining] Filter results to workload of type training.
         * @param {boolean} [isWorkspace] Filter results to workload of type workspace.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates: async (name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, distributedFramework?: string, isDistributed?: boolean, isTraining?: boolean, isWorkspace?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/workload-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (distributedFramework !== undefined) {
                localVarQueryParameter['distributedFramework'] = distributedFramework;
            }

            if (isDistributed !== undefined) {
                localVarQueryParameter['isDistributed'] = isDistributed;
            }

            if (isTraining !== undefined) {
                localVarQueryParameter['isTraining'] = isTraining;
            }

            if (isWorkspace !== undefined) {
                localVarQueryParameter['isWorkspace'] = isWorkspace;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to update the details of a template by id.
         * @summary Update a template.
         * @param {string} assetId Unique identifier of the asset.
         * @param {WorkloadTemplateUpdateRequest} [workloadTemplateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplate: async (assetId: string, workloadTemplateUpdateRequest?: WorkloadTemplateUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assetId' is not null or undefined
            assertParamExists('updateTemplate', 'assetId', assetId)
            const localVarPath = `/api/v1/asset/workload-template/{AssetId}`
                .replace(`{${"AssetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workloadTemplateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TemplateApi - functional programming interface
 * @export
 */
export const TemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * Use to create a template.
         * @summary Create a template.
         * @param {WorkloadTemplateCreationRequest} [workloadTemplateCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTemplate(workloadTemplateCreationRequest?: WorkloadTemplateCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTemplate(workloadTemplateCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete a template by id.
         * @summary Delete a template.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTemplateById(assetId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTemplateById(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the details of a template by id.
         * @summary Get a template.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplateById(assetId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplateById(assetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of templates.
         * @summary List templates.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {string} [distributedFramework] Filter results to workload of type distributed and distributedFramework.
         * @param {boolean} [isDistributed] Filter results to workload of type distributed.
         * @param {boolean} [isTraining] Filter results to workload of type training.
         * @param {boolean} [isWorkspace] Filter results to workload of type workspace.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTemplates(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, distributedFramework?: string, isDistributed?: boolean, isTraining?: boolean, isWorkspace?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadTemplateListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTemplates(name, scope, projectId, departmentId, clusterId, distributedFramework, isDistributed, isTraining, isWorkspace, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to update the details of a template by id.
         * @summary Update a template.
         * @param {string} assetId Unique identifier of the asset.
         * @param {WorkloadTemplateUpdateRequest} [workloadTemplateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTemplate(assetId: string, workloadTemplateUpdateRequest?: WorkloadTemplateUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTemplate(assetId, workloadTemplateUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TemplateApi - factory interface
 * @export
 */
export const TemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TemplateApiFp(configuration)
    return {
        /**
         * Use to create a template.
         * @summary Create a template.
         * @param {WorkloadTemplateCreationRequest} [workloadTemplateCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplate(workloadTemplateCreationRequest?: WorkloadTemplateCreationRequest, options?: any): AxiosPromise<WorkloadTemplate> {
            return localVarFp.createTemplate(workloadTemplateCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete a template by id.
         * @summary Delete a template.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplateById(assetId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteTemplateById(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of a template by id.
         * @summary Get a template.
         * @param {string} assetId Unique identifier of the asset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateById(assetId: string, options?: any): AxiosPromise<WorkloadTemplate> {
            return localVarFp.getTemplateById(assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of templates.
         * @summary List templates.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {string} [distributedFramework] Filter results to workload of type distributed and distributedFramework.
         * @param {boolean} [isDistributed] Filter results to workload of type distributed.
         * @param {boolean} [isTraining] Filter results to workload of type training.
         * @param {boolean} [isWorkspace] Filter results to workload of type workspace.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, distributedFramework?: string, isDistributed?: boolean, isTraining?: boolean, isWorkspace?: boolean, options?: any): AxiosPromise<WorkloadTemplateListResponse> {
            return localVarFp.listTemplates(name, scope, projectId, departmentId, clusterId, distributedFramework, isDistributed, isTraining, isWorkspace, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to update the details of a template by id.
         * @summary Update a template.
         * @param {string} assetId Unique identifier of the asset.
         * @param {WorkloadTemplateUpdateRequest} [workloadTemplateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplate(assetId: string, workloadTemplateUpdateRequest?: WorkloadTemplateUpdateRequest, options?: any): AxiosPromise<WorkloadTemplate> {
            return localVarFp.updateTemplate(assetId, workloadTemplateUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TemplateApi - object-oriented interface
 * @export
 * @class TemplateApi
 * @extends {BaseAPI}
 */
export class TemplateApi extends BaseAPI {
    /**
     * Use to create a template.
     * @summary Create a template.
     * @param {WorkloadTemplateCreationRequest} [workloadTemplateCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    public createTemplate(workloadTemplateCreationRequest?: WorkloadTemplateCreationRequest, options?: AxiosRequestConfig) {
        return TemplateApiFp(this.configuration).createTemplate(workloadTemplateCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete a template by id.
     * @summary Delete a template.
     * @param {string} assetId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    public deleteTemplateById(assetId: string, options?: AxiosRequestConfig) {
        return TemplateApiFp(this.configuration).deleteTemplateById(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of a template by id.
     * @summary Get a template.
     * @param {string} assetId Unique identifier of the asset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    public getTemplateById(assetId: string, options?: AxiosRequestConfig) {
        return TemplateApiFp(this.configuration).getTemplateById(assetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of templates.
     * @summary List templates.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {string} [distributedFramework] Filter results to workload of type distributed and distributedFramework.
     * @param {boolean} [isDistributed] Filter results to workload of type distributed.
     * @param {boolean} [isTraining] Filter results to workload of type training.
     * @param {boolean} [isWorkspace] Filter results to workload of type workspace.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    public listTemplates(name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, distributedFramework?: string, isDistributed?: boolean, isTraining?: boolean, isWorkspace?: boolean, options?: AxiosRequestConfig) {
        return TemplateApiFp(this.configuration).listTemplates(name, scope, projectId, departmentId, clusterId, distributedFramework, isDistributed, isTraining, isWorkspace, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to update the details of a template by id.
     * @summary Update a template.
     * @param {string} assetId Unique identifier of the asset.
     * @param {WorkloadTemplateUpdateRequest} [workloadTemplateUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    public updateTemplate(assetId: string, workloadTemplateUpdateRequest?: WorkloadTemplateUpdateRequest, options?: AxiosRequestConfig) {
        return TemplateApiFp(this.configuration).updateTemplate(assetId, workloadTemplateUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TrainingsApi - axios parameter creator
 * @export
 */
export const TrainingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a training workload from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create training workload.
         * @param {WorkloadCreationRequest} [workloadCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTraining: async (workloadCreationRequest?: WorkloadCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/training`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workloadCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a training from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create a training - assets based [Experimental]
         * @param {TrainingCreationRequestV2} [trainingCreationRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrainingV2: async (trainingCreationRequestV2?: TrainingCreationRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/training`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trainingCreationRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the content of the training, i.e. its set of assets and specific env.
         * @summary Get training data - assets based. [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingByIdV2: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getTrainingByIdV2', 'workloadId', workloadId)
            const localVarPath = `/api/v2/training/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get combined policy and workload data for training creation form
         * @summary Get merged training
         * @param {string} [projectId] The id of the project
         * @param {string} [workloadId] The id of the workload
         * @param {string} [templateId] The id of the template
         * @param {boolean} [isDistributed] Filter results to workload of type distributed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingMerged: async (projectId?: string, workloadId?: string, templateId?: string, isDistributed?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/training/merged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (workloadId !== undefined) {
                localVarQueryParameter['workloadId'] = workloadId;
            }

            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }

            if (isDistributed !== undefined) {
                localVarQueryParameter['isDistributed'] = isDistributed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List training in the cluster
         * @param {string} clusterUuid The Universally Unique Identifier (UUID) of the cluster.
         * @param {string} [nodeId] Unique identifier of the node.
         * @param {string} [filter] 
         * @param {string} [sortBy] Order of the results.
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {number} [from] Start the response from a given number of result. Used along with \&#39;limit\&#39; to retrieve the results paginated.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listTrainings: async (clusterUuid: string, nodeId?: string, filter?: string, sortBy?: string, sortDirection?: 'ASC' | 'DESC', from?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterUuid' is not null or undefined
            assertParamExists('listTrainings', 'clusterUuid', clusterUuid)
            const localVarPath = `/v1/k8s/clusters/{clusterUuid}/trainings`
                .replace(`{${"clusterUuid"}}`, encodeURIComponent(String(clusterUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrainingsApi - functional programming interface
 * @export
 */
export const TrainingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrainingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a training workload from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create training workload.
         * @param {WorkloadCreationRequest} [workloadCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTraining(workloadCreationRequest?: WorkloadCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Training>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTraining(workloadCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a training from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create a training - assets based [Experimental]
         * @param {TrainingCreationRequestV2} [trainingCreationRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTrainingV2(trainingCreationRequestV2?: TrainingCreationRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTrainingV2(trainingCreationRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the content of the training, i.e. its set of assets and specific env.
         * @summary Get training data - assets based. [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrainingByIdV2(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrainingByIdV2(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get combined policy and workload data for training creation form
         * @summary Get merged training
         * @param {string} [projectId] The id of the project
         * @param {string} [workloadId] The id of the workload
         * @param {string} [templateId] The id of the template
         * @param {boolean} [isDistributed] Filter results to workload of type distributed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrainingMerged(projectId?: string, workloadId?: string, templateId?: string, isDistributed?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrainingMerged(projectId, workloadId, templateId, isDistributed, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List training in the cluster
         * @param {string} clusterUuid The Universally Unique Identifier (UUID) of the cluster.
         * @param {string} [nodeId] Unique identifier of the node.
         * @param {string} [filter] 
         * @param {string} [sortBy] Order of the results.
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {number} [from] Start the response from a given number of result. Used along with \&#39;limit\&#39; to retrieve the results paginated.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async listTrainings(clusterUuid: string, nodeId?: string, filter?: string, sortBy?: string, sortDirection?: 'ASC' | 'DESC', from?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTrainings(clusterUuid, nodeId, filter, sortBy, sortDirection, from, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrainingsApi - factory interface
 * @export
 */
export const TrainingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrainingsApiFp(configuration)
    return {
        /**
         * Creates a training workload from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create training workload.
         * @param {WorkloadCreationRequest} [workloadCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTraining(workloadCreationRequest?: WorkloadCreationRequest, options?: any): AxiosPromise<Training> {
            return localVarFp.createTraining(workloadCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a training from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create a training - assets based [Experimental]
         * @param {TrainingCreationRequestV2} [trainingCreationRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrainingV2(trainingCreationRequestV2?: TrainingCreationRequestV2, options?: any): AxiosPromise<TrainingV2> {
            return localVarFp.createTrainingV2(trainingCreationRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the content of the training, i.e. its set of assets and specific env.
         * @summary Get training data - assets based. [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingByIdV2(workloadId: string, options?: any): AxiosPromise<TrainingV2> {
            return localVarFp.getTrainingByIdV2(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get combined policy and workload data for training creation form
         * @summary Get merged training
         * @param {string} [projectId] The id of the project
         * @param {string} [workloadId] The id of the workload
         * @param {string} [templateId] The id of the template
         * @param {boolean} [isDistributed] Filter results to workload of type distributed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingMerged(projectId?: string, workloadId?: string, templateId?: string, isDistributed?: boolean, options?: any): AxiosPromise<TrainingV2> {
            return localVarFp.getTrainingMerged(projectId, workloadId, templateId, isDistributed, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List training in the cluster
         * @param {string} clusterUuid The Universally Unique Identifier (UUID) of the cluster.
         * @param {string} [nodeId] Unique identifier of the node.
         * @param {string} [filter] 
         * @param {string} [sortBy] Order of the results.
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {number} [from] Start the response from a given number of result. Used along with \&#39;limit\&#39; to retrieve the results paginated.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listTrainings(clusterUuid: string, nodeId?: string, filter?: string, sortBy?: string, sortDirection?: 'ASC' | 'DESC', from?: number, limit?: number, options?: any): AxiosPromise<TrainingListResponse> {
            return localVarFp.listTrainings(clusterUuid, nodeId, filter, sortBy, sortDirection, from, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrainingsApi - object-oriented interface
 * @export
 * @class TrainingsApi
 * @extends {BaseAPI}
 */
export class TrainingsApi extends BaseAPI {
    /**
     * Creates a training workload from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
     * @summary Create training workload.
     * @param {WorkloadCreationRequest} [workloadCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingsApi
     */
    public createTraining(workloadCreationRequest?: WorkloadCreationRequest, options?: AxiosRequestConfig) {
        return TrainingsApiFp(this.configuration).createTraining(workloadCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a training from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
     * @summary Create a training - assets based [Experimental]
     * @param {TrainingCreationRequestV2} [trainingCreationRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingsApi
     */
    public createTrainingV2(trainingCreationRequestV2?: TrainingCreationRequestV2, options?: AxiosRequestConfig) {
        return TrainingsApiFp(this.configuration).createTrainingV2(trainingCreationRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the content of the training, i.e. its set of assets and specific env.
     * @summary Get training data - assets based. [Experimental]
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingsApi
     */
    public getTrainingByIdV2(workloadId: string, options?: AxiosRequestConfig) {
        return TrainingsApiFp(this.configuration).getTrainingByIdV2(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get combined policy and workload data for training creation form
     * @summary Get merged training
     * @param {string} [projectId] The id of the project
     * @param {string} [workloadId] The id of the workload
     * @param {string} [templateId] The id of the template
     * @param {boolean} [isDistributed] Filter results to workload of type distributed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingsApi
     */
    public getTrainingMerged(projectId?: string, workloadId?: string, templateId?: string, isDistributed?: boolean, options?: AxiosRequestConfig) {
        return TrainingsApiFp(this.configuration).getTrainingMerged(projectId, workloadId, templateId, isDistributed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List training in the cluster
     * @param {string} clusterUuid The Universally Unique Identifier (UUID) of the cluster.
     * @param {string} [nodeId] Unique identifier of the node.
     * @param {string} [filter] 
     * @param {string} [sortBy] Order of the results.
     * @param {'ASC' | 'DESC'} [sortDirection] 
     * @param {number} [from] Start the response from a given number of result. Used along with \&#39;limit\&#39; to retrieve the results paginated.
     * @param {number} [limit] The maximum number of entries to return.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TrainingsApi
     */
    public listTrainings(clusterUuid: string, nodeId?: string, filter?: string, sortBy?: string, sortDirection?: 'ASC' | 'DESC', from?: number, limit?: number, options?: AxiosRequestConfig) {
        return TrainingsApiFp(this.configuration).listTrainings(clusterUuid, nodeId, filter, sortBy, sortDirection, from, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WorkloadApi - axios parameter creator
 * @export
 */
export const WorkloadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Check if a given asset name creates naming conflicts under the given scope. Returns conflict (409) in case the name is not available, or 204 (no content) if it is ok.
         * @summary Asset name conflict validation
         * @param {string} kind Filter results by asset kind.
         * @param {string} assetName the name of the asset
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scopeType The resource scope type to filter by.
         * @param {string} [scopeId] The id of the cluster, department or project, depending on the scope type.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assetNameConflictValidation: async (kind: string, assetName: string, scopeType: 'tenant' | 'cluster' | 'department' | 'project', scopeId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kind' is not null or undefined
            assertParamExists('assetNameConflictValidation', 'kind', kind)
            // verify required parameter 'assetName' is not null or undefined
            assertParamExists('assetNameConflictValidation', 'assetName', assetName)
            // verify required parameter 'scopeType' is not null or undefined
            assertParamExists('assetNameConflictValidation', 'scopeType', scopeType)
            const localVarPath = `/api/v1/asset/name-availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (assetName !== undefined) {
                localVarQueryParameter['assetName'] = assetName;
            }

            if (scopeType !== undefined) {
                localVarQueryParameter['scopeType'] = scopeType;
            }

            if (scopeId !== undefined) {
                localVarQueryParameter['scopeId'] = scopeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkloadApi - functional programming interface
 * @export
 */
export const WorkloadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkloadApiAxiosParamCreator(configuration)
    return {
        /**
         * Check if a given asset name creates naming conflicts under the given scope. Returns conflict (409) in case the name is not available, or 204 (no content) if it is ok.
         * @summary Asset name conflict validation
         * @param {string} kind Filter results by asset kind.
         * @param {string} assetName the name of the asset
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scopeType The resource scope type to filter by.
         * @param {string} [scopeId] The id of the cluster, department or project, depending on the scope type.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async assetNameConflictValidation(kind: string, assetName: string, scopeType: 'tenant' | 'cluster' | 'department' | 'project', scopeId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetNameConflictValidation(kind, assetName, scopeType, scopeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkloadApi - factory interface
 * @export
 */
export const WorkloadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkloadApiFp(configuration)
    return {
        /**
         * Check if a given asset name creates naming conflicts under the given scope. Returns conflict (409) in case the name is not available, or 204 (no content) if it is ok.
         * @summary Asset name conflict validation
         * @param {string} kind Filter results by asset kind.
         * @param {string} assetName the name of the asset
         * @param {'tenant' | 'cluster' | 'department' | 'project'} scopeType The resource scope type to filter by.
         * @param {string} [scopeId] The id of the cluster, department or project, depending on the scope type.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assetNameConflictValidation(kind: string, assetName: string, scopeType: 'tenant' | 'cluster' | 'department' | 'project', scopeId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.assetNameConflictValidation(kind, assetName, scopeType, scopeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkloadApi - object-oriented interface
 * @export
 * @class WorkloadApi
 * @extends {BaseAPI}
 */
export class WorkloadApi extends BaseAPI {
    /**
     * Check if a given asset name creates naming conflicts under the given scope. Returns conflict (409) in case the name is not available, or 204 (no content) if it is ok.
     * @summary Asset name conflict validation
     * @param {string} kind Filter results by asset kind.
     * @param {string} assetName the name of the asset
     * @param {'tenant' | 'cluster' | 'department' | 'project'} scopeType The resource scope type to filter by.
     * @param {string} [scopeId] The id of the cluster, department or project, depending on the scope type.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof WorkloadApi
     */
    public assetNameConflictValidation(kind: string, assetName: string, scopeType: 'tenant' | 'cluster' | 'department' | 'project', scopeId?: string, options?: AxiosRequestConfig) {
        return WorkloadApiFp(this.configuration).assetNameConflictValidation(kind, assetName, scopeType, scopeId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WorkspacesApi - axios parameter creator
 * @export
 */
export const WorkspacesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the number of assets that match a given set of filters.
         * @summary Count assets.
         * @param {string} [kind] Request results for specific asset kind.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        countAssets: async (kind?: string, name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/asset/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a workspace from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create workspace.
         * @param {WorkloadCreationRequest} [workloadCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkspace: async (workloadCreationRequest?: WorkloadCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workspace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workloadCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a workspace from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create a workspace - assets based [Experimental]
         * @param {WorkspaceCreationRequestV2} [workspaceCreationRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkspaceV2: async (workspaceCreationRequestV2?: WorkspaceCreationRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/workspace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workspaceCreationRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the data of a training, i.e. its set of assets and specific env.
         * @summary Get workspace data - assets based [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceByIdV2: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getWorkspaceByIdV2', 'workloadId', workloadId)
            const localVarPath = `/api/v2/workspace/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get combined policy and specificRunParams data for workload creation form
         * @summary Get merged workspace
         * @param {string} [projectId] The id of the project
         * @param {string} [workloadId] The id of the workload
         * @param {string} [templateId] The id of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceMerged: async (projectId?: string, workloadId?: string, templateId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/workspace/merged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (workloadId !== undefined) {
                localVarQueryParameter['workloadId'] = workloadId;
            }

            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List workspaces in the cluster
         * @param {string} clusterUuid The Universally Unique Identifier (UUID) of the cluster.
         * @param {string} [nodeId] Unique identifier of the node.
         * @param {string} [filter] 
         * @param {string} [sortBy] Order of the results.
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {number} [from] Start the response from a given number of result. Used along with \&#39;limit\&#39; to retrieve the results paginated.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listWorkspaces: async (clusterUuid: string, nodeId?: string, filter?: string, sortBy?: string, sortDirection?: 'ASC' | 'DESC', from?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterUuid' is not null or undefined
            assertParamExists('listWorkspaces', 'clusterUuid', clusterUuid)
            const localVarPath = `/v1/k8s/clusters/{clusterUuid}/workspaces`
                .replace(`{${"clusterUuid"}}`, encodeURIComponent(String(clusterUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkspacesApi - functional programming interface
 * @export
 */
export const WorkspacesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkspacesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the number of assets that match a given set of filters.
         * @summary Count assets.
         * @param {string} [kind] Request results for specific asset kind.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async countAssets(kind?: string, name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countAssets(kind, name, scope, projectId, departmentId, clusterId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a workspace from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create workspace.
         * @param {WorkloadCreationRequest} [workloadCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkspace(workloadCreationRequest?: WorkloadCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Workspace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkspace(workloadCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a workspace from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create a workspace - assets based [Experimental]
         * @param {WorkspaceCreationRequestV2} [workspaceCreationRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkspaceV2(workspaceCreationRequestV2?: WorkspaceCreationRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkspaceV2(workspaceCreationRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the data of a training, i.e. its set of assets and specific env.
         * @summary Get workspace data - assets based [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspaceByIdV2(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspaceByIdV2(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get combined policy and specificRunParams data for workload creation form
         * @summary Get merged workspace
         * @param {string} [projectId] The id of the project
         * @param {string} [workloadId] The id of the workload
         * @param {string} [templateId] The id of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspaceMerged(projectId?: string, workloadId?: string, templateId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspaceMerged(projectId, workloadId, templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List workspaces in the cluster
         * @param {string} clusterUuid The Universally Unique Identifier (UUID) of the cluster.
         * @param {string} [nodeId] Unique identifier of the node.
         * @param {string} [filter] 
         * @param {string} [sortBy] Order of the results.
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {number} [from] Start the response from a given number of result. Used along with \&#39;limit\&#39; to retrieve the results paginated.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async listWorkspaces(clusterUuid: string, nodeId?: string, filter?: string, sortBy?: string, sortDirection?: 'ASC' | 'DESC', from?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkspaces(clusterUuid, nodeId, filter, sortBy, sortDirection, from, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkspacesApi - factory interface
 * @export
 */
export const WorkspacesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkspacesApiFp(configuration)
    return {
        /**
         * Returns the number of assets that match a given set of filters.
         * @summary Count assets.
         * @param {string} [kind] Request results for specific asset kind.
         * @param {string} [name] Filter results by name.
         * @param {string} [scope] Filter results by scope.
         * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
         * @param {string} [departmentId] Filter using the department id.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        countAssets(kind?: string, name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, options?: any): AxiosPromise<AssetCountResponse> {
            return localVarFp.countAssets(kind, name, scope, projectId, departmentId, clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a workspace from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create workspace.
         * @param {WorkloadCreationRequest} [workloadCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkspace(workloadCreationRequest?: WorkloadCreationRequest, options?: any): AxiosPromise<Workspace> {
            return localVarFp.createWorkspace(workloadCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a workspace from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
         * @summary Create a workspace - assets based [Experimental]
         * @param {WorkspaceCreationRequestV2} [workspaceCreationRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkspaceV2(workspaceCreationRequestV2?: WorkspaceCreationRequestV2, options?: any): AxiosPromise<WorkspaceV2> {
            return localVarFp.createWorkspaceV2(workspaceCreationRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the data of a training, i.e. its set of assets and specific env.
         * @summary Get workspace data - assets based [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceByIdV2(workloadId: string, options?: any): AxiosPromise<WorkspaceV2> {
            return localVarFp.getWorkspaceByIdV2(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get combined policy and specificRunParams data for workload creation form
         * @summary Get merged workspace
         * @param {string} [projectId] The id of the project
         * @param {string} [workloadId] The id of the workload
         * @param {string} [templateId] The id of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceMerged(projectId?: string, workloadId?: string, templateId?: string, options?: any): AxiosPromise<WorkspaceV2> {
            return localVarFp.getWorkspaceMerged(projectId, workloadId, templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List workspaces in the cluster
         * @param {string} clusterUuid The Universally Unique Identifier (UUID) of the cluster.
         * @param {string} [nodeId] Unique identifier of the node.
         * @param {string} [filter] 
         * @param {string} [sortBy] Order of the results.
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {number} [from] Start the response from a given number of result. Used along with \&#39;limit\&#39; to retrieve the results paginated.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listWorkspaces(clusterUuid: string, nodeId?: string, filter?: string, sortBy?: string, sortDirection?: 'ASC' | 'DESC', from?: number, limit?: number, options?: any): AxiosPromise<WorkspaceListResponse> {
            return localVarFp.listWorkspaces(clusterUuid, nodeId, filter, sortBy, sortDirection, from, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkspacesApi - object-oriented interface
 * @export
 * @class WorkspacesApi
 * @extends {BaseAPI}
 */
export class WorkspacesApi extends BaseAPI {
    /**
     * Returns the number of assets that match a given set of filters.
     * @summary Count assets.
     * @param {string} [kind] Request results for specific asset kind.
     * @param {string} [name] Filter results by name.
     * @param {string} [scope] Filter results by scope.
     * @param {number} [projectId] Filter results by project id. if scope filter is project, only assets from the specific project will be included in the response. otherwise, the response will include both project, department, cluster and tenant assets.
     * @param {string} [departmentId] Filter using the department id.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public countAssets(kind?: string, name?: string, scope?: string, projectId?: number, departmentId?: string, clusterId?: string, options?: AxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).countAssets(kind, name, scope, projectId, departmentId, clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a workspace from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
     * @summary Create workspace.
     * @param {WorkloadCreationRequest} [workloadCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public createWorkspace(workloadCreationRequest?: WorkloadCreationRequest, options?: AxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).createWorkspace(workloadCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a workspace from a given set of assets. The set must include one environment asset and can include one compute asset and multiple datasource assets.
     * @summary Create a workspace - assets based [Experimental]
     * @param {WorkspaceCreationRequestV2} [workspaceCreationRequestV2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public createWorkspaceV2(workspaceCreationRequestV2?: WorkspaceCreationRequestV2, options?: AxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).createWorkspaceV2(workspaceCreationRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the data of a training, i.e. its set of assets and specific env.
     * @summary Get workspace data - assets based [Experimental]
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public getWorkspaceByIdV2(workloadId: string, options?: AxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).getWorkspaceByIdV2(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get combined policy and specificRunParams data for workload creation form
     * @summary Get merged workspace
     * @param {string} [projectId] The id of the project
     * @param {string} [workloadId] The id of the workload
     * @param {string} [templateId] The id of the template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public getWorkspaceMerged(projectId?: string, workloadId?: string, templateId?: string, options?: AxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).getWorkspaceMerged(projectId, workloadId, templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List workspaces in the cluster
     * @param {string} clusterUuid The Universally Unique Identifier (UUID) of the cluster.
     * @param {string} [nodeId] Unique identifier of the node.
     * @param {string} [filter] 
     * @param {string} [sortBy] Order of the results.
     * @param {'ASC' | 'DESC'} [sortDirection] 
     * @param {number} [from] Start the response from a given number of result. Used along with \&#39;limit\&#39; to retrieve the results paginated.
     * @param {number} [limit] The maximum number of entries to return.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public listWorkspaces(clusterUuid: string, nodeId?: string, filter?: string, sortBy?: string, sortDirection?: 'ASC' | 'DESC', from?: number, limit?: number, options?: AxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).listWorkspaces(clusterUuid, nodeId, filter, sortBy, sortDirection, from, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


